angular.module("bm.core.setup.templates", ["core-setup/client-billing/client-detail-billing.html", "core-setup/client-billing/document-delivery-component/client-billing-document-delivery-component.html", "core-setup/client-engagements/client-engagement-detail.html", "core-setup/client-fixed-fee-billing-templates/client-fixed-fee-billing-template-detail.html", "core-setup/client-project-quick-add/client-project-quick-add.html", "core-setup/clients/details/companyhouse/client-detail-companies-house.html", "core-setup/clients/details/custom-fields/client-detail-custom-fields.html", "core-setup/clients/details/document-delivery/client-detail-document-delivery.html", "core-setup/clients/details/general/client-detail-general.html", "core-setup/clients/details/hmrc/client-detail-hmrc-ng.html", "core-setup/clients/details/integration/client-detail-integration.html", "core-setup/clients/details/onbalance/client-detail-onbalance.html", "core-setup/clients/details/onbalance/request-prior-data-dialog.2js.html", "core-setup/clients/details/security/client-detail-security-v2.html", "core-setup/clients/details/security/client-detail-security.html", "core-setup/clients/details/vat/client-detail-vat.html", "core-setup/clients/list/client-list-related-contacts-grid-template.html", "core-setup/common/contact-editor/contact-editor-address-default.html", "core-setup/common/contact-editor/contact-editor-address-nl.html", "core-setup/common/contact-editor/contact-editor-confidentiality-dialog.html", "core-setup/common/contact-editor/contact-editor-existing-contact-button.html", "core-setup/common/contact-editor/contact-editor.html", "core-setup/common/contact-selector-dialog/contact-selector-dialog.html", "core-setup/common/display-as-dialog/display-as-dialog.html", "core-setup/common/periods-js/periods-js.html", "core-setup/common/periods-ng/periods-ng.html", "core-setup/common/setup-detail/setup-detail.html", "core-setup/common/setup-relationships/setup-relationships-confirm-reset.html", "core-setup/common/setup-relationships/setup-relationships-detail-general.html", "core-setup/common/setup-relationships/setup-relationships-detail-representative.html", "core-setup/common/setup-relationships/setup-relationships-detail.html", "core-setup/common/setup-relationships/setup-relationships-edit-message.component.html", "core-setup/common/setup-relationships/setup-relationships-list-related-contacts-grid-template.html", "core-setup/common/setup-relationships/setup-relationships.html", "core-setup/common/tr-user-registration/tr-user-registration-email.html", "core-setup/common/tr-user-registration/tr-user-registration.html", "core-setup/conflict-resolution/conflict-resolution.html", "core-setup/conflict-resolution/migration-records-created-matched.html", "core-setup/conflict-resolution/migration-records-error.html", "core-setup/conflict-resolution/migration-results.html", "core-setup/conflict-resolution/migration-summary.html", "core-setup/contacts/details/general/contact-detail-general.html", "core-setup/contacts/details/integration/contact-detail-integration.html", "core-setup/contacts/details/security/contact-clients-detail-security.html", "core-setup/contacts/details/security/contact-detail-security.html", "core-setup/contacts/details/vat/contact-detail-vat.html", "core-setup/contacts/list/contact-list-related-contacts-grid-template.html", "core-setup/documents/practice-documents.html", "core-setup/edit-multiple/edit-multiple-folders/edit-multiple-folders.html", "core-setup/edit-multiple/edit-multiple-general/edit-multiple-general.html", "core-setup/edit-multiple/edit-multiple-onvio-access/edit-multiple-onvio-access.html", "core-setup/edit-multiple/edit-multiple-templates/edit-multiple-templates.html", "core-setup/edit-multiple/edit-multiple.html", "core-setup/employees/details/general/employee-detail-general.html", "core-setup/employees/details/rates/employee-detail-rates.html", "core-setup/employees/details/roles/employee-detail-roles-preparer.html", "core-setup/employees/details/roles/employee-detail-roles.html", "core-setup/employees/details/security/employee-detail-security.html", "core-setup/employees/directives/employee-rate-directive.html", "core-setup/firm/firm-detail-billing.html", "core-setup/firm/firm-detail-ca-tax.html", "core-setup/firm/firm-detail-document-delivery.html", "core-setup/firm/firm-detail-general.html", "core-setup/firm/firm-detail-preferences.html", "core-setup/firm/firm-detail-tax-ng.html", "core-setup/firm/firm-detail-uk-hmrc-detail-ng.html", "core-setup/firm/firm-detail-uk-hmrc-list-ng.html", "core-setup/firm/firm-detail.html", "core-setup/fixed-fee-billing-templates/fixed-fee-billing-template-detail.html", "core-setup/migration-results/detail/practiceCS/practice-cs-migration-results.html", "core-setup/migration-results/list/migration-results-list.html", "core-setup/notes/notes-v2.html", "core-setup/notes/notes.html", "core-setup/notes/project-notes.html", "core-setup/offices/office-detail.html", "core-setup/permission-groups/permission-groups-detail.html", "core-setup/permission-groups/permission-groups.html", "core-setup/project-list-component/app-timer-start.html", "core-setup/project-list-component/project-list.html", "core-setup/project-list-component/project-tasks-dialog.html", "core-setup/project-list-component/task-list.html", "core-setup/project-templates/project-template-detail-recurrence.html", "core-setup/project-templates/project-template-detail-time-and-billing.html", "core-setup/project-templates/project-template-detail.html", "core-setup/project-templates/project-template-import.html", "core-setup/related-contacts-list/related-contacts-list.html", "core-setup/schedule-item-generation/schedule-item-project-generation-options.html", "core-setup/schedule-item-series/schedule-item-series-detail.html", "core-setup/schedule-items/core-project-task.html", "core-setup/schedule-items/core-projects.html", "core-setup/schedule-items/core-tasks.html", "core-setup/schedule-items/periods-on-projects-fields/periods-on-projects-fields.html", "core-setup/schedule-items/schedule-item-client-list.html", "core-setup/schedule-items/schedule-item-detail-documents.html", "core-setup/schedule-items/schedule-item-detail-general-v2.html", "core-setup/schedule-items/schedule-item-detail-general.html", "core-setup/schedule-items/schedule-item-detail-recurrence.html", "core-setup/schedule-items/schedule-item-detail-time-and-billing.html", "core-setup/schedule-items/schedule-item-detail-ws-compat.html", "core-setup/schedule-items/schedule-item-detail.html", "core-setup/schedule-items/schedule-item-list.html", "core-setup/schedule-items/schedule-item-setup-application-fields-V2/schedule-item-setup-application-fields.html", "core-setup/schedule-items/schedule-item-setup-application-fields/schedule-item-setup-application-fields.html", "core-setup/schedule-items/schedule-task-generation-options/schedule-task-generation-options.html", "core-setup/setup-assistant/setup-assistant-staff.html", "core-setup/task-templates/task-template-detail.html", "core-setup/tasks/task-detail-estimated-hours-grid.html", "core-setup/tasks/task-detail.html", "core-setup/tasks/task-list.html", "core-setup/test-aotf/test-aotf-detail.component.html", "core-setup/test-aotf/test-aotf-master.component.html", "core-setup/uk-tax/hmrc-firm-uk-contact-data-component/firm-uk-contact-data-component.html"]);

angular.module("core-setup/client-billing/client-detail-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/client-billing/client-detail-billing.html",
    "<!-- Billing -->\n" +
    "<h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Client.Detail.Billing' | translate}}</h2>\n" +
    "<div bm-if-has-license=\"TimeAndBilling.BillToParent\">\n" +
    "    <div class=\"row\" ng-show=\"!vm.hideBillingGroups\">\n" +
    "        <!-- Bill To Parent Client -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"billToClient\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.BillToClient' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'billToClient')\"\n" +
    "            class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"clients#active\"\n" +
    "                                name=\"billToClient\"\n" +
    "                                list-style=\"basic\"\n" +
    "                                ng-model=\"vm.data.billToClient\"\n" +
    "                                required=\"true\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bmp-detail-view-default-focus=\"vm.data\" bmp-if-firm-permission=\"OnvioSetup.ClientBilling\">\n" +
    "    <!-- Invoice Format for New Clients -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"invoiceCompanyLayoutOption\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.InvoiceCompanyLayoutOption' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceCompanyLayoutOption' )\"\n" +
    "         class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "         <bmp-select-combo list=\"report-definition#invoice\"\n" +
    "                                name=\"invoiceCompanyLayoutOption\"\n" +
    "                                list-style=\"basic\"\n" +
    "                                ng-model=\"vm.data.invoiceCompanyLayoutOption\"\n" +
    "                                required=\"true\">\n" +
    "         </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "    <!-- Statement Format for New Clients -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"statementCompanyLayoutOption\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.StatementCompanyLayoutOption' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'statementCompanyLayoutOption')\"\n" +
    "         class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "         <bmp-select-combo list=\"report-definition#statement\"\n" +
    "                                name=\"statementCompanyLayoutOption\"\n" +
    "                                list-style=\"basic\"\n" +
    "                                ng-model=\"vm.data.statementCompanyLayoutOption\"\n" +
    "                                required=\"true\">\n" +
    "         </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "    <div ng-if=\"vm.showTaxGroup(vm.data)\">\n" +
    "        <!-- Tax Group -->\n" +
    "        <div bm-if-has-license=\"TimeAndBilling.Invoicing\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.TaxGroupId' | translate}}\"\n" +
    "                data-bmp-data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroupId')\"\n" +
    "                class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                list-style=\"basic\"\n" +
    "                                name=\"taxgroup\"\n" +
    "                                ng-model=\"vm.data.$taxGroup\" provider=\"vm.indirectTaxProvider\">\n" +
    "                </bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bmp-if-firm-permission=\"OnvioSetup.ClientBilling\">\n" +
    "    <!-- Days until invoice -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"daysUntilInvoiceIsDue\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.DaysUntilInvoiceIsDue' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'daysUntilInvoiceDue' )\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <div class=\"input-group\">\n" +
    "            <span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"999999\"\n" +
    "                       name=\"daysUntilInvoiceIsDue\"\n" +
    "                       ng-model=\"vm.data.daysUntilInvoiceIsDue\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"0\"\n" +
    "                       aria-label=\"{{'Core.Captions.ClientBilling.DaysUntilInvoiceIsDue' | translate}}\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.ClientBilling.DaysUntilInvoiceIsDue\" />\n" +
    "            </span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"vm.data\">\n" +
    "    <!-- Late Fee -->\n" +
    "    <div bmp-if-firm-permission=\"TimeAndBilling.Billing\"\n" +
    "         data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"lateFeeTemplates\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.LateFeeTemplate' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'lateFeeTemplate' )\"\n" +
    "         class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "         <bmp-select-combo  id=\"lateFeeTemplates\"\n" +
    "                                list=\"late-fee-templates\"\n" +
    "                                name=\"lateFeeTemplates\"\n" +
    "                                ng-model=\"vm.data.lateFeeTemplate\">\n" +
    "         </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bmp-if-firm-permission=\"OnvioSetup.ClientBilling\">\n" +
    "    <!-- Billing Instructions -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"billingInstructions\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ClientBilling.BillingInstructions' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'billingInstructions')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <textarea rows=\"3\" id=\"billingInstructions\" name=\"billingInstructions\"\n" +
    "                  class=\"form-control\"\n" +
    "                  data-ng-model=\"vm.data.billingInstructions\"\n" +
    "                  data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/client-billing/document-delivery-component/client-billing-document-delivery-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/client-billing/document-delivery-component/client-billing-document-delivery-component.html",
    "<!--TODO- MEJM - Eventually, html from client-billing-document-delivery-controller should be moved here once we can support\n" +
    " switching contexts in the Document Delivery tab. Right now, this file is not used.-->\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-8\">\n" +
    "        <table class=\"bm-timeAndExpense-up-hide-skip-table bmp-user-preferences-table bento-flex-grid wj-content\">\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                    <th rowspan=\"2\" scope=\"col\" class=\"wj-header wj-cell\"></th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DeliveryMethod' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DownloadFile' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.Email' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.OnvioDocuments' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Invoices' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesDownloadFile\" name=\"invoicesDownloadFile\" data-qe-id=\"invoicesDownloadFile\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryInvoiceToFile\" />\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesEmail\" name=\"invoicesEmail\" data-qe-id=\"invoicesEmail\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryInvoiceToEmail\" />\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesOnvioDocuments\" name=\"invoicesOnvioDocuments\" data-qe-id=\"invoicesOnvioDocuments\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryInvoiceToStorage\" />\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Statements' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsDownloadFile\" name=\"statementsDownloadFile\" data-qe-id=\"statementsDownloadFile\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryStatementToFile\" />\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsEmail\" name=\"statementsEmail\" data-qe-id=\"statementsEmail\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryStatementToEmail\" />\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsOnvioDocuments\" name=\"statementsOnvioDocuments\" data-qe-id=\"statementsOnvioDocuments\" type=\"checkbox\" ng-model=\"$ctrl.data.documentDeliveryStatementToStorage\" />\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/client-engagements/client-engagement-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/client-engagements/client-engagement-detail.html",
    "<!--\n" +
    "    vm is SetupListDetailController\n" +
    "    vm.data is ClientEngagementV2Dto\n" +
    "    vm.detail is IDetailVm\n" +
    "    vm.domainModel is ClientEngagementDomainModel\n" +
    "\n" +
    "    ClientEngagementV2Dto {\n" +
    "        engagementTemplate (NamedReferenceDto): The engagement template,\n" +
    "        client (NamedReferenceDto): Client for the engagement,\n" +
    "        name (string): A description of this engagement,\n" +
    "        office (NamedReferenceDto, optional): The office for the engagement from /api/core/v1/companies/{companyId}/offices,\n" +
    "        category (NamedReferenceDto, optional): The engagement category from /api/core/v1/companies/{companyId}/engagement-categories,\n" +
    "        biller (NamedReferenceDto, optional): The biller employee,\n" +
    "        reviewer (NamedReferenceDto, optional): The reviewer employee,\n" +
    "        manager (NamedReferenceDto, optional): The manager employee,\n" +
    "        status (NamedReferenceDto): See /api/core/v1/engagement-statuses for values.,\n" +
    "        invoiceDescription (string, optional): User-specified description that will be available for inclusion on invoices and reports,\n" +
    "        generalLedgerAccount (string, optional): Called GL account by analysts and users. Defines the GL Account to which this engagement will be exported,\n" +
    "        rateType (NamedReferenceDto): The rate information associate with this item. Can be either \"None\", \"Fixed rate\", or \"Staff rate\",\n" +
    "        fixedRate (string, optional): The fixed rate amount Required when RateType is \"Fixed Rate\",\n" +
    "        employeeRateDescription (NamedReferenceDto, optional): An employee rate description from /api/core/v1/companies/{companyId}/employee-rate-descriptions,\n" +
    "        markupFactor (string): A markup/down factor for this engagement that will be used to alter the calculated value,\n" +
    "        surchargeMethod (NamedReferenceDto): Values can be \"No surcharge\", \"Based on Activity\", \"Fixed amount\",\n" +
    "        surchargeAmount (string, optional): Surchage amount for type \"Fixed amount\" EngagementSurchargeMethod==FixedAmount Required when surchargeMethod is \"Fixed amount\",\n" +
    "        id (string, optional): A globally unique string used to reference the object. This value is assigned by the server and ignored (if present) on Posts.,\n" +
    "        apiVersion (string, optional): Represents the desired version of the service API in a request, and the version of the service API that's served in the response.,\n" +
    "        lang (string, optional): Indicates the language of the rest of the properties in this object.,\n" +
    "        created (string, optional): Indicates the item creation date/time (RFC 3339).,\n" +
    "        updated (string, optional): Indicates the last date/time (RFC 3339) the item was updated.\n" +
    "}\n" +
    "    -->\n" +
    "<div class=\"row\">\n" +
    "    <!-- Engagement Template -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplate\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.EngagementTemplate' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'engagementTemplate')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-select-combo list=\"engagement-templates\"\n" +
    "                          name=\"engagementTemplate\"\n" +
    "                          ng-model=\"vm.data.engagementTemplate\"\n" +
    "                          on-change=\"vm.generateData({clientId: vm.detailContext.id, engagementTemplateId: vm.data.engagementTemplate.id})\"\n" +
    "                          ng-required=\"true\"\n" +
    "                          ng-readonly=\"vm.data.engagementTemplate.id\"\n" +
    "                          custom-template=\"true\">\n" +
    "        </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Name-->\n" +
    "    <!-- /* i18nextract */'Core.Captions.Engagement.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplateName\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Name' | translate | bmRequiredMark}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"engagementTemplateName\"\n" +
    "               name=\"engagementTemplateName\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-required=\"true\"\n" +
    "               data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\"\n" +
    "               data-ng-model=\"vm.data.name\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "               data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Invoice Description-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementTemplateInvoiceDescription\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.InvoiceDescription' | translate }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <textarea rows=\"3\"\n" +
    "                  id=\"engagementTemplateInvoiceDescription\"\n" +
    "                  name=\"engagementTemplateInvoiceDescription\"\n" +
    "                  class=\"form-control\"\n" +
    "                  data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\"\n" +
    "                  data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                  data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'invoiceDescription')\"\n" +
    "                  data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Status -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"status\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Status' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(data, 'status')\"\n" +
    "         class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "        <bmp-enum-radio-button-group name=\"status\"\n" +
    "                                 ng-model=\"vm.data.status\"\n" +
    "                                 data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                 enum=\"engagement-statuses\"\n" +
    "                                 data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "        </bmp-enum-radio-button-group>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "    <!-- GL Account -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"generalLedgerAccount\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.GeneralLedgerAccount' | translate }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               id=\"generalLedgerAccount\"\n" +
    "               name=\"generalLedgerAccount\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\"\n" +
    "               data-ng-model=\"vm.data.generalLedgerAccount\"\n" +
    "               data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'generalLedgerAccount')\"\n" +
    "               data-fef-maxlength=\"60\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Groupings header static text -->\n" +
    "    <!--TODO: Nishant has duplicated the Onvio.Setup.Activities.ActivityDetail.GroupingsSectionHeader\n" +
    "    after talking to Keith. The EngagementTemplate will eventually move here and we will avoid the duplication.\n" +
    "    Moreover I think we should move the Groupings heading under Bluemoon.Practice.Common-->\n" +
    "    <h3 class=\"col-md-6\">{{'Bluemoon.Core.Setup.Activities.ActivityDetail.GroupingsSectionHeader' | translate }}</h3>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Engagement Category -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"engagementCategory\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.Category' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'category')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "        <bmp-select-combo list=\"engagement-categories\"\n" +
    "                          name=\"engagementCategory\"\n" +
    "                          ng-model=\"vm.data.category\"\n" +
    "                          data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "        </bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Office -->\n" +
    "    <div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"office\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Office.ClassOne' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'office')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"offices\"\n" +
    "                              name=\"office\"\n" +
    "                              ng-model=\"vm.data.office\"\n" +
    "                              data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Biller -->\n" +
    "    <div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"biller\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.BillerGroup' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'biller')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\"\n" +
    "                              name=\"biller\"\n" +
    "                              ng-model=\"vm.data.biller\"\n" +
    "                              data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Reviewer -->\n" +
    "    <div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"reviewer\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.ReviewerGroup' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'reviewer')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\"\n" +
    "                              name=\"reviewer\"\n" +
    "                              ng-model=\"vm.data.reviewer\"\n" +
    "                              data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Manager -->\n" +
    "    <div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"manager\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.EngagementTemplate.ManagerGroup' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'manager')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\"\n" +
    "                              name=\"manager\"\n" +
    "                              ng-model=\"vm.data.manager\"\n" +
    "                              data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!--Rates header static text-->\n" +
    "    <h3 class=\"col-md-6\">{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.RatesSectionHeader' | translate }}</h3>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!--Rate-->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"rateType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.RateType' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'rateType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "\n" +
    "        <div data-toggle=\"buttons-checkbox\">\n" +
    "            <div>\n" +
    "                <!--No Rate radio-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"NORATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\"\n" +
    "                            data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <!--Fixed Rate radio button-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"FIXEDRATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\"\n" +
    "                            data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <!--Employee Rate radio button-->\n" +
    "                <bmp-enum-radio enum=\"rate-types\"\n" +
    "                            name=\"rateType\"\n" +
    "                            value=\"EMPLOYEERATE\"\n" +
    "                            ng-model=\"vm.data.rateType\"\n" +
    "                            ng-change=\"vm.domainModel.onRateTypeChanged(vm.data)\"\n" +
    "                            data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                </bmp-enum-radio>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyEmployeeRateDescription(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"rateType\"\n" +
    "             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.StaffRate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'rateType')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "\n" +
    "            <!--Employee Rate radio button's Employee Rate Description selector-->\n" +
    "            <bmp-select-combo list=\"employee-rate-descriptions\"\n" +
    "                              list-style=\"basic\"\n" +
    "                              name=\"employeeRateDescription\"\n" +
    "                              ng-model=\"vm.data.employeeRateDescription\"\n" +
    "                              data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "            </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.showFixedRate(vm.data)\">\n" +
    "        <!-- Fixed Rate -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"fixedRate\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.ClientEngagement.FixedRate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'fixedRate')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   class=\"form-control input-lg\"\n" +
    "                   data-ng-model=\"vm.data.fixedRate\"\n" +
    "                   data-bmp-clear-value=\"0\"\n" +
    "                   data-bmp-big-number=\"'c2'\"\n" +
    "                   bm-format-on-blur=\"\"\n" +
    "                   data-bmp-big-number-range-validator\n" +
    "                   min=\"0\"\n" +
    "                   max=\"9999999\"\n" +
    "                   data-bmp-control-group-field=\"Core.Captions.ClientEngagement.FixedRate\"\n" +
    "                   data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Markup/down factor -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"markupFactor\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Engagement.MarkupFactor' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'markupFactor')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "               class=\"form-control input-lg\"\n" +
    "               data-ng-model=\"vm.data.markupFactor\"\n" +
    "               data-bmp-clear-value=\"1\"\n" +
    "               data-bmp-big-number=\"'n4'\"\n" +
    "               bm-format-on-blur=\"\"\n" +
    "               data-bmp-big-number-range-validator\n" +
    "               min=\"0.0001\"\n" +
    "               max=\"99.9999\"\n" +
    "               aria-label=\"{{'Core.Captions.Engagement.MarkupFactor' | translate}}\"\n" +
    "               data-bmp-control-group-field=\"Core.Captions.Engagement.MarkupFactor\"\n" +
    "               data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "    <div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "        <div ng-if=\"vm.domainModel.showTaxGroup()\">\n" +
    "            <!-- Tax Group -->\n" +
    "            <div bm-if-perm-some=\"['TimeAndBilling.AssessServiceCharges','TimeAndBilling.Billing','TimeAndBilling.PrintStatements','TimeAndBilling.ReceiptAndAdjustment','TimeAndBilling.ReviewInvoices','TimeAndBilling.TimeAndExpense']\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Engagement.TaxGroupId' | translate}}\"\n" +
    "                    data-bmp- data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroup')\"\n" +
    "                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    name=\"taxgroup\"\n" +
    "                                    ng-model=\"vm.data.$taxGroup\" provider=\"vm.domainModel.indirectTaxProvider\"\n" +
    "                                    data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "    <div class=\"row\">\n" +
    "        <!--Surcharge header static text-->\n" +
    "        <h3 class=\"col-md-6\">{{'Bluemoon.Core.Setup.EngagementTemplates.Common.EngagementTemplateDetail.SurchargeSectionHeader' | translate }}</h3>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!--Surcharge Method-->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"surchargeMethod\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Engagement.SurchargeMethod' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'surchargeMethod')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "\n" +
    "            <div data-toggle=\"buttons-checkbox\">\n" +
    "                <div>\n" +
    "                    <!--Based on Activity radio button-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"BASEDONACTIVITY\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\"\n" +
    "                                data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <!--Flat Amount radio-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"FIXEDAMOUNT\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\"\n" +
    "                                ng-change=\"vm.domainModel.onFixedSurchargeChanged(vm.data)\"\n" +
    "                                data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <!--None radio button-->\n" +
    "                    <bmp-enum-radio enum=\"engagement-surcharge-methods\"\n" +
    "                                name=\"surchargeMethod\"\n" +
    "                                value=\"NOSURCHARGE\"\n" +
    "                                ng-model=\"vm.data.surchargeMethod\"\n" +
    "                                data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\">\n" +
    "                    </bmp-enum-radio>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-show=\"vm.domainModel.showFixedSurcharge(vm.data)\">\n" +
    "            <!-- Flat amount surcharge -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"surchargeAmount\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Enums.EngagementSurchargeMethod.FIXEDAMOUNT' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'surchargeAmount')\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                <input autocomplete=\"off\" type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.surchargeAmount\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'c2'\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    min=\"0\"\n" +
    "                    max=\"9999999.99\"\n" +
    "                    data-bmp-control-group-field=\"Core.Enums.EngagementSurchargeMethod.FIXEDAMOUNT\"\n" +
    "                    data-ng-disabled=\"vm.domainModel.shouldDisableClientEngagementFields(vm.data)\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "  <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("core-setup/client-fixed-fee-billing-templates/client-fixed-fee-billing-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/client-fixed-fee-billing-templates/client-fixed-fee-billing-template-detail.html",
    "<!--Fixed Fee Template-->\n" +
    "<div class=\"row\" ng-if=\"vm.domainModel.isSingleModeActive(vm.data)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"fixedFeeBillingTemplate\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.ClientFixedFeeBillingTemplate.FixedFeeTemplate' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'fixedFeeTemplate')\"\n" +
    "        class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "        <bmp-select-combo list=\"fixed-fee-billing-templates\"\n" +
    "            list-style=\"basic\"\n" +
    "            name=\"fixedFeeBillingTemplate\"\n" +
    "            data-qe-id=\"fixedFeeBillingTemplate\"\n" +
    "            ng-model=\"vm.data.$fixedFeeTemplate\"\n" +
    "            on-change=\"vm.updateLabelName()\"></bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"!vm.domainModel.isSingleModeActive(vm.data)\">\n" +
    "    <!-- /* i18nextract */'Core.Captions.ClientFixedFeeBillingTemplate.FixedFeeTemplate' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"fixedFeeBillingTemplate\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.ClientFixedFeeBillingTemplate.FixedFeeTemplate' | translate | bmRequiredMark}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'fixedFeeTemplate')\"\n" +
    "        class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "        <bmp-select-combo list=\"fixed-fee-billing-templates\"\n" +
    "            list-style=\"basic\"\n" +
    "            name=\"fixedFeeBillingTemplate\"\n" +
    "            data-qe-id=\"fixedFeeBillingTemplate\"\n" +
    "            ng-model=\"vm.data.$fixedFeeTemplate\"\n" +
    "            required=\"true\"\n" +
    "            on-change=\"vm.updateLabelName()\"\n" +
    "            data-ng-disabled=\"vm.data.fixedFeeTemplate.id\"></bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Level -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.Level' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'level')\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-enum-radio-group enum=\"fixed-fee-billing-template-level\"\n" +
    "                name=\"level\"\n" +
    "                data-qe-id=\"level\"\n" +
    "                ng-model=\"vm.data.$level\">\n" +
    "            </bmp-enum-radio-group>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <fieldset class=\"well bm-well\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Frequency -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"frequency\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.Frequency' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'frequency')\"\n" +
    "                class=\"col-md-3 col-sm-3 col-xs-5\">\n" +
    "                <bmp-enum-combo enum=\"fixed-fee-billing-template-frequency\"\n" +
    "                    name=\"frequency\"\n" +
    "                    data-qe-id=\"frequency\"\n" +
    "                    ng-model=\"vm.data.frequency\"\n" +
    "                    required=\"true\">\n" +
    "                </bmp-enum-combo>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"vm.domainModel.showClientAmount(vm.data)\">\n" +
    "                <!--Client Amount-->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"fixedFeeBillingTemplateClientAmount\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.ClientAmount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'clientAmount')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-6 pull-right\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                        id=\"clientAmount\"\n" +
    "                        name=\"clientAmount\"\n" +
    "                        data-qe-id=\"clientAmount\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.clientAmount\"\n" +
    "                        data-ng-disabled=\"vm.domainModel.disableClientAmountField(vm.data)\"\n" +
    "                        data-bmp-clear-value=\"0\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        min=\"0\"\n" +
    "                        max=\"9999999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- List of Engagement Template edit controls -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingEngagementTemplateAmounts\" class=\"col-md-8 col-sm-10 col-xs-12\"></div>\n" +
    "            <div ng-if=\"vm.domainModel.showEngagementAmounts(vm.data)\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 pull-right\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{ 'Core.Captions.Engagement.ClassOther' | translate }}\">\n" +
    "                            <div bento-multiselect-overlay\n" +
    "                                revert-selections-on-dismissal=\"true\"\n" +
    "                                ng-model=\"vm.data.$engagementMultiselectDataSelected\"\n" +
    "                                list-data=\"vm.data.$engagementMultiselectData\"\n" +
    "                                select-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectEngagements' | translate }}\"\n" +
    "                                edit-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectEngagements' | translate }}\"\n" +
    "                                class=\"setup-bento-multiselect-overlay\"\n" +
    "                                data-qe-id=\"bm-fixedFeeBillingTemplateDetail-engagementTemplate-multiselect\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.data.$engagementMultiselectDataSelected.length > 0\">\n" +
    "                            <table class=\"fixed-fee-template-table bento-flex-grid wj-content\">\n" +
    "                                <tr class=\"wj-colheaders\">\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.EngagementTemplate.Code' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.FixedFeeEngagementAmountCommon.EngagementTemplate' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header text-right\">{{ 'Core.Captions.FixedFeeEngagementAmountCommon.Amount' | translate }}</th>\n" +
    "                                </tr>\n" +
    "                                <tr data-ng-repeat=\"fixedFeeEngagementAmount in vm.data.$engagementMultiselectDataSelected\">\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeEngagementAmount.data.engagementTemplate.code }}</td>\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeEngagementAmount.data.engagementTemplate.name }}</td>\n" +
    "                                    <td class=\"wj-cell\">\n" +
    "                                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                                            data-bmp-big-number=\"'c2'\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            data-bmp-clear-value=\"0\"\n" +
    "                                            id=\"engagementAmount_{{$index}}\"\n" +
    "                                            name=\"engagementAmount_{{$index}}\"\n" +
    "                                            aria-label=\"Engagement Amount {{$index}}\"\n" +
    "                                            class=\"form-control input-lg text-right\"\n" +
    "                                            data-ng-model=\"fixedFeeEngagementAmount.data.amount\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableEngagementAmountField(vm.data, fixedFeeEngagementAmount.data)\"\n" +
    "                                            bmp-field-error=\"Core.Captions.FixedFeeEngagementAmountCommon.Amount\"\n" +
    "                                            data-bmp-big-number-range-validator\n" +
    "                                            min=\"0\"\n" +
    "                                            max=\"9999999.99\"/>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- List of Project Template edit controls -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingProjectTemplateAmounts\" class=\"col-md-8 col-sm-10 col-xs-12\"></div>\n" +
    "            <div ng-if=\"vm.domainModel.showProjectAmounts(vm.data)\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 pull-right\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{ 'Core.Captions.Project.ClassOther' | translate }}\">\n" +
    "                            <div bento-multiselect-overlay\n" +
    "                                revert-selections-on-dismissal=\"true\"\n" +
    "                                ng-model=\"vm.data.$projectMultiselectDataSelected\"\n" +
    "                                list-data=\"vm.data.$projectMultiselectData\"\n" +
    "                                select-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectProjects' | translate }}\"\n" +
    "                                edit-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectProjects' | translate }}\"\n" +
    "                                class=\"setup-bento-multiselect-overlay\"\n" +
    "                                data-qe-id=\"bm-fixedFeeBillingTemplateDetail-projectTemplate-multiselect\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.data.$projectMultiselectDataSelected.length > 0\">\n" +
    "                            <table class=\"fixed-fee-template-table bento-flex-grid wj-content\">\n" +
    "                                <tr class=\"wj-colheaders\">\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.ProjectTemplate.Code' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.FixedFeeProjectAmountCommon.ProjectTemplate' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header text-right\" >{{ 'Core.Captions.FixedFeeProjectAmountCommon.Amount' | translate }}</th>\n" +
    "                                </tr>\n" +
    "                                <tr data-ng-repeat=\"fixedFeeProjectAmount in vm.data.$projectMultiselectDataSelected\">\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeProjectAmount.data.projectTemplate.code }}</td>\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeProjectAmount.data.projectTemplate.name }}</td>\n" +
    "                                    <td class=\"wj-cell\">\n" +
    "                                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                                            data-bmp-big-number=\"'c2'\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            data-bmp-clear-value=\"0\"\n" +
    "                                            id=\"projectAmount_{{$index}}\"\n" +
    "                                            name=\"projectAmount_{{$index}}\"\n" +
    "                                            class=\"form-control input-lg  text-right\"\n" +
    "                                            data-ng-model=\"fixedFeeProjectAmount.data.amount\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableProjectAmountField(vm.data, fixedFeeProjectAmount.data)\"\n" +
    "                                            bmp-field-error=\"Core.Captions.FixedFeeProjectAmountCommon.Amount\"\n" +
    "                                            data-bmp-big-number-range-validator\n" +
    "                                            min=\"0\"\n" +
    "                                            max=\"9999999.99\"/>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <fieldset class=\"well bm-well inner-well\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Template Type -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.TemplateType' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'templateType')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                    <bmp-enum-radio-group enum=\"fixed-fee-billing-template-type\"\n" +
    "                        name=\"templateType\"\n" +
    "                        data-qe-id=\"templateType\"\n" +
    "                        ng-model=\"vm.data.$templateType\"\n" +
    "                        required=\"true\">\n" +
    "                    </bmp-enum-radio-group>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Staff -->\n" +
    "                <div class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"employee\"\n" +
    "\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Employee.ClassOne' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'employee')\"\n" +
    "                        class=\"col-md-6 col-sm-6 col-xs-12 pull-right\">\n" +
    "                        <bmp-select-combo list=\"staff#active\"\n" +
    "                            name=\"employee\"\n" +
    "                            data-qe-id=\"employee\"\n" +
    "                            ng-model=\"vm.data.employee\"\n" +
    "                            data-ng-disabled=\"vm.domainModel.disableEmployeeField(vm.data)\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Activity -->\n" +
    "                <div class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"activity\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Activity.ClassOne' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activity')\"\n" +
    "                        class=\"col-md-6 col-sm-6 col-xs-12 pull-right\">\n" +
    "                        <bmp-select-combo list=\"activities#active\"\n" +
    "                            name=\"activity\"\n" +
    "                            data-qe-id=\"activity\"\n" +
    "                            ng-model=\"vm.data.activity\"\n" +
    "                            data-ng-disabled=\"vm.domainModel.disableActivityField(vm.data)\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- HHTC Article -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingHelpArticleSection\" bento-busy-loader-size=\"small\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <fieldset class=\"well bm-well inner-well\">\n" +
    "                            <div data-ng-repeat=\"templateTypeArticle in vm.domainModel.hhtcArticles\">\n" +
    "                                <div ng-if=\"templateTypeArticle.id === vm.data.$templateType.id\">\n" +
    "                                    <h1>{{ templateTypeArticle.header }}</h1>\n" +
    "                                    <p>{{ templateTypeArticle.content }}</p>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </fieldset>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </fieldset>\n" +
    "    </fieldset>\n" +
    "\n" +
    "</div>");
}]);

angular.module("core-setup/client-project-quick-add/client-project-quick-add.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/client-project-quick-add/client-project-quick-add.html",
    "<div class='row setup-client-project-quick-add' bento-busy-loader=\"vm.isLoading\">\n" +
    "\n" +
    "    <!-- CLIENT side -->\n" +
    "\n" +
    "    <div class=\"client-side col-xs-12 col-md-6\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <h2 data-ng-if=\"vm.detail.isNew\">{{'Bluemoon.Core.Setup.Clients.Detail.AddClient' | translate}}</h2>\n" +
    "                <h2 data-ng-if=\"!vm.detail.isNew\">{{'Core.Captions.ScheduleItem.Client' | translate}}</h2>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <div bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "                    <div ng-if=\"vm.data.$clientType.id === 'NEW'\">\n" +
    "                        <a style=\"float:right; margin-top: 15px; margin-bottom: 10px;\" data-qe-id=\"view-client-setup\"\n" +
    "                        ng-click=\"vm.domainModel.openClientAotf(vm.data, vm.$scope)\">{{'Bluemoon.Core.Setup.ClientProjectQuickAdd.ViewFullClientSetup' | translate}}</a>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Client type (new or exisiting) -->\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"clientType\"\n" +
    "                 data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ClientProjectQuickAdd.ClientType' | translate}}\"\n" +
    "                 data-ng-if=\"vm.data.$clientType.id !== 'READONLY'\"\n" +
    "                 class=\"col-md-12\">\n" +
    "                <bmp-radio-button-group id=\"clientType\"\n" +
    "                                        name=\"clientType\"\n" +
    "                                        data-qe-id=\"client-type\"\n" +
    "                                        class=\"bmp-btn-group-active\"\n" +
    "                                        data-ng-model=\"vm.data.$clientType\"\n" +
    "                                        data-ng-change=\"vm.domainModel.clientTypeChanged(vm.data)\"\n" +
    "                                        data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                        data-bmp-radio-button-group-options=\"vm.domainModel.clientTypeOptions\"\n" +
    "                                        ng-disabled=\"vm.isLoading\"></bmp-radio-button-group>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Client -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.Client' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"client\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Client' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'client')\"\n" +
    "                    data-ng-if=\"vm.data.$clientType.id === 'EXISTING'\"\n" +
    "                    class=\"col-xs-12\">\n" +
    "                <bmp-select-combo list=\"clients#active\"\n" +
    "                                    name=\"client\"\n" +
    "                                    data-qe-id=\"client-name\"\n" +
    "                                    ng-model=\"vm.data.$client\"\n" +
    "                                    ng-required=\"'true'\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "            <!-- Code/ID -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.Client.Code' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"code\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.Client.Code' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.client, 'code')\"\n" +
    "                data-ng-if=\"vm.data.$clientType.id === 'NEW'\"\n" +
    "                class=\"col-xs-12\">\n" +
    "                <input autocomplete=\"off\"\n" +
    "                    type=\"text\"\n" +
    "                    id=\"code\"\n" +
    "                    data-qe-id=\"client-code\"\n" +
    "                    name=\"code\"\n" +
    "                    class=\"form-control\"\n" +
    "                    data-ng-model=\"vm.data.client.code\"\n" +
    "                    data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                    data-ng-required=\"true\"\n" +
    "                    data-ng-change=\"vm.detail.clearErrorFor(vm.data.client, 'code')\"\n" +
    "                    data-bmp-entity-code=\"\"\n" +
    "                    data-bmp-entity-code-id=\"vm.client.id\"\n" +
    "                    data-bmp-entity-code-type=\"clients\"\n" +
    "                    data-bm-focus-on-link=\"\"\n" +
    "                    data-bm-focus-on-event=\"'bm.core.setup.common.contactSelectedEvent'\"\n" +
    "                    data-fef-maxlength=\"20\"></div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Contact editor -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\"\n" +
    "                data-onvio-contact-editor=\"vm.data.client.primaryContactExpanded\"\n" +
    "                contact-name-validation-service=\"vm.domainModel.contactNameValidationService\"\n" +
    "                data-onvio-contact-editor-parent-form=\"clientForm\"\n" +
    "                data-onvio-contact-editor-is-related-to-a-client=\"true\"\n" +
    "                data-onvio-contact-editor-valid-entity-types=\"vm.data.$entityOptions\"\n" +
    "                data-onvio-contact-editor-entity-types=\"vm.data.$entityTypes\"\n" +
    "                data-onvio-contact-editor-display-as-rule-changed=\"vm.domainModel.onDisplayAsRuleChanged(vm.data)\"\n" +
    "                data-onvio-contact-editor-exclude-client-contacts=\"true\"\n" +
    "                data-onvio-contact-editor-show-confidentiality=\"true\"\n" +
    "                data-onvio-contact-editor-disable-confidentiality=\"vm.inWorkspaceModal\"\n" +
    "                data-onvio-contact-editor-entity-type-changed=\"vm.domainModel.onEntityTypeChanged(vm.data)\"\n" +
    "                data-onvio-contact-editor-quick-add=\"true\"\n" +
    "                data-onvio-contact-editor-quick-add-existing=\"vm.data.$clientType.id !== 'NEW'\"\n" +
    "                data-onvio-contact-editor-analytics-context=\"'setup_clientDetail_general'\"\n" +
    "                onvio-contact-editor-is-loading=\"vm.isLoading\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- PROJECT side -->\n" +
    "\n" +
    "    <div class=\"project-side col-xs-12 col-md-6\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <h2 data-ng-if=\"vm.detail.isNew\">{{'Bluemoon.Core.Setup.Project.Detail.Add' | translate}}</h2>\n" +
    "                <h2 data-ng-if=\"!vm.detail.isNew\">{{'Core.Captions.ScheduleItem.Project' | translate}}</h2>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <div bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "                    <a style=\"float:right; margin-top: 15px; margin-bottom: 10px;\" data-qe-id=\"view-project-setup\"\n" +
    "                    ng-click=\"vm.domainModel.viewFullProjectSetupClick(vm.data, vm.detail, vm.$scope)\">{{'Bluemoon.Core.Setup.ClientProjectQuickAdd.ViewFullProjectSetup' | translate}}</a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Project Template -->\n" +
    "        <div class=\"row\" data-ng-if=\"vm.domainModel.showProjectTemplate(vm.data)\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"projectTemplate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ProjectTemplate' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'projectTemplate')\"\n" +
    "                    class=\"col-xs-12\">\n" +
    "                <bmp-select-combo list=\"project-templates\"\n" +
    "                                name=\"projectTemplate\"\n" +
    "                                data-qe-id=\"project-template\"\n" +
    "                                ng-model=\"vm.data.project.$projectTemplate\"\n" +
    "                                ng-readonly=\"vm.data.project.id\"\n" +
    "                                filter=\"vm.domainModel.optionalFilterByApplication(vm.getUrlParam('application') || vm.appRouting.getCurrentApplicationInstant())\"\n" +
    "                                ng-required=\"true\" aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"vm.data.$clientType.id === 'EXISTING'\">\n" +
    "            <!-- For Contact -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.ForContact' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"forContact\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ForContact' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'forContact')\"\n" +
    "                    class=\"col-xs-12\">\n" +
    "                <bmp-select-combo name=\"forContact\"\n" +
    "                                    list=\"related-contacts\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    context=\"vm.data.project.client.contactId\"\n" +
    "                                    custom-items=\"[vm.data.project.forContact]\"\n" +
    "                                    ng-model=\"vm.data.project.$forContact\"\n" +
    "                                    ng-required=\"true\"\n" +
    "                                    ng-disabled=\"vm.isLoading || !vm.data.project.projectTemplate.id || !vm.data.project.client.id\"></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "                <!-- Name -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"name\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' | translate | bmRequiredMark}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'name')\"\n" +
    "                        class=\"col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" id=\"name\" name=\"name\"\n" +
    "                            data-qe-id=\"project-name\"\n" +
    "                            class=\"form-control\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-disabled=\"vm.domainModel.disableProjectFields(vm.data)\"\n" +
    "                            ng-model=\"vm.data.project.$name\"\n" +
    "                            data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <schedule-item-setup-application-fields data=\"vm.data.project\" ng-disabled=\"vm.domainModel.disableProjectFields(vm.data)\"></schedule-item-setup-application-fields>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <periods-on-projects-fields project=\"vm.data.project\"></periods-on-projects-fields>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Current due & original due dates -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"currentDueDateExclusive\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.CurrentDueDateExclusive' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'currentDueDateExclusive')\"\n" +
    "                    class=\"col-sm-6 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper name=\"currentDueDateExclusive\"\n" +
    "                                                data-qe-id=\"due-date\"\n" +
    "                                                ng-disabled=\"vm.domainModel.disableProjectFields(vm.data)\"\n" +
    "                                                ng-required=\"true\"\n" +
    "                                                ng-model=\"vm.data.project.$currentDueDateExclusive\"></bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/clients/details/companyhouse/client-detail-companies-house.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/companyhouse/client-detail-companies-house.html",
    "<ng-form name=\"companiesHouseForm\">\n" +
    "    <lib-uk-secretarial-companies-house [clientid]=\"vm.id\" (save-data-complete)=\"vm.saveCompleted($event)\"\n" +
    "    [save-data-to-angular]=\"vm.saveDataToAngular\" (form-dirty)=\"vm.formDirty($event)\"></lib-uk-secretarial-companies-house>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("core-setup/clients/details/custom-fields/client-detail-custom-fields.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/custom-fields/client-detail-custom-fields.html",
    "<ng-form name=\"customFields\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <bmc-form-elements uniqueref={{vm.detailContext.id}} filters = {{vm.filters}} category={{vm.category}}></bmc-form-elements>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/clients/details/document-delivery/client-detail-document-delivery.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/document-delivery/client-detail-document-delivery.html",
    "<h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.DocumentDelivery' | translate}}</h2>\n" +
    "\n" +
    "<!--<bm-client-billing-document-delivery contact-id=\"vm.id\"></bm-client-billing-document-delivery>-->\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-8\">\n" +
    "        <table class=\"bm-timeAndExpense-up-hide-skip-table time-and-billing-document-delivery-table bento-flex-grid wj-content\">\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th rowspan=\"2\" scope=\"col\" class=\"wj-header wj-cell\"></th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DeliveryMethod' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DownloadFile' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.Email' | translate}}</th>\n" +
    "                <th ng-if=\"vm.connectedToStripe\" scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.ClientCenter' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.OnvioDocuments' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Invoices' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesDownloadFile\"  name=\"invoicesDownloadFile\" data-qe-id=\"invoicesDownloadFile\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToFile\"\n" +
    "                    aria-labelledby=\"invoicesDownloadFileLabel\"/>\n" +
    "                    <label for=\"invoicesDownloadFile\" id=\"invoicesDownloadFileLabel\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryInvoiceToFile' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesEmail\" name=\"invoicesEmail\" data-qe-id=\"invoicesEmail\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToEmail\" ng-change=\"vm.onEmailChange()\"\n" +
    "                    aria-labelledby=\"invoicesEmailLabel\" />\n" +
    "                    <label id=\"invoicesEmailLabel\" for=\"invoicesEmail\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryInvoiceToEmail' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td ng-if=\"vm.connectedToStripe\" class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesClientCenter\" name=\"invoicesClientCenter\" data-qe-id=\"invoicesClientCenter\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToClientCenter\"\n" +
    "                    aria-labelledby=\"invoicesClientCenterLabel\" />\n" +
    "                    <label id=\"invoicesClientCenterLabel\" for=\"invoicesClientCenter\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryInvoiceToClientCenter' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesOnvioDocuments\" name=\"invoicesOnvioDocuments\" data-qe-id=\"invoicesOnvioDocuments\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToStorage\"\n" +
    "                    aria-labelledby=\"invoicesOnvioDocumentsLabel\" />\n" +
    "                    <label id=\"invoicesOnvioDocumentsLabel\" for=\"invoicesOnvioDocuments\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryInvoiceToStorage' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr bm-if-has-license=\"TimeAndBilling.PrintStatements\">\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Statements' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsDownloadFile\" name=\"statementsDownloadFile\" data-qe-id=\"statementsDownloadFile\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToFile\"\n" +
    "                    aria-labelledby=\"statementsDownloadFileLabel\"  />\n" +
    "                    <label id=\"statementsDownloadFileLabel\" for=\"statementsDownloadFile\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryStatementToFile' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsEmail\" name=\"statementsEmail\" data-qe-id=\"statementsEmail\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToEmail\" ng-change=\"vm.onEmailChange()\"\n" +
    "                    aria-labelledby=\"statementsEmailLabel\"  />\n" +
    "                    <label id=\"statementsEmailLabel\" for=\"statementsEmail\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryStatementToEmail' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td ng-if=\"vm.connectedToStripe\" class=\"wj-cell\">\n" +
    "                    <input id=\"statementsClientCenter\" aria-labelledby=\"statementsClientCenterLabel\"  name=\"statementsClientCenter\" data-qe-id=\"statementsClientCenter\" type=\"checkbox\" disabled=\"true\" />\n" +
    "                    <label id=\"statementsClientCenterLabel\" for=\"statementsClientCenter\" class=\"sr-only\" aria-label=\"Statements Client Center\"></label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsOnvioDocuments\" name=\"statementsOnvioDocuments\" data-qe-id=\"statementsOnvioDocuments\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToStorage\"\n" +
    "                    aria-labelledby=\"statementsOnvioDocumentsLabel\"  />\n" +
    "                    <label id=\"statementsOnvioDocumentsLabel\" for=\"statementsOnvioDocuments\" class=\"sr-only\">{{'Core.Captions.ClientBilling.DocumentDeliveryStatementToStorage' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"bento-alert-container\" ng-if=\"vm.emailError\">\n" +
    "    <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\">{{'Bluemoon.Core.Setup.DocumentDelivery.MissingEmailWarning' | translate}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"bento-alert-container\" ng-if=\"vm.emailPresent\">\n" +
    "    <div class=\"alert bento-alert alert-info\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\">{{vm.validEmailTranslated}}</span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/clients/details/general/client-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/general/client-detail-general.html",
    "<div ng-hide=\"vm.isLoading\">\n" +
    "    <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.General' | translate}}</h2>\n" +
    "\n" +
    "    <div class=\"row\"\n" +
    "         ng-show=\"!vm.detail.isLoadingData()\">\n" +
    "        <!-- Code/ID -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.Client.Code' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"code\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Client.Code' | translate | bmRequiredMark}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'code')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\"\n" +
    "                   type=\"text\"\n" +
    "                   id=\"code\"\n" +
    "                   data-qe-id=\"code\"\n" +
    "                   name=\"code\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"vm.data.code\"\n" +
    "                   data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                   data-ng-required=\"true\"\n" +
    "                   data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'code')\"\n" +
    "                   data-bmp-entity-code=\"\"\n" +
    "                   data-bmp-entity-code-id=\"vm.id\"\n" +
    "                   data-bmp-entity-code-type=\"clients\"\n" +
    "                   data-bm-focus-on-link=\"\"\n" +
    "                   data-bm-focus-on-event=\"'bm.core.setup.common.contactSelectedEvent'\"\n" +
    "                   data-fef-maxlength=\"20\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Contact editor -->\n" +
    "    <div data-onvio-contact-editor=\"vm.data.primaryContactExpanded\"\n" +
    "         contact-name-validation-service=\"vm.contactNameValidationService\"\n" +
    "         data-onvio-contact-editor-parent-form=\"clientForm\"\n" +
    "         data-onvio-contact-editor-is-related-to-a-client=\"true\"\n" +
    "         data-onvio-contact-editor-contact-selected=\"vm.onContactSelected()\"\n" +
    "         data-onvio-contact-editor-valid-entity-types=\"vm.entityOptions\"\n" +
    "         data-onvio-contact-editor-entity-types=\"vm.entityTypes\"\n" +
    "         data-onvio-contact-editor-uk-contact-data=\"vm.ukContactData\"\n" +
    "         data-onvio-contact-editor-display-as-rule-changed=\"vm.onDisplayAsRuleChanged()\"\n" +
    "         data-onvio-contact-editor-exclude-client-contacts=\"true\"\n" +
    "         data-onvio-contact-editor-show-confidentiality=\"true\"\n" +
    "         data-onvio-contact-editor-disable-confidentiality=\"vm.inWorkspaceModal\"\n" +
    "         data-onvio-contact-editor-entity-type-changed=\"vm.onEntityTypeChanged()\"\n" +
    "         data-onvio-contact-editor-analytics-context=\"'setup_clientDetail_general'\"\n" +
    "         onvio-contact-editor-is-loading=\"vm.isLoading\"\n" +
    "         is-open-from-client-detail=\"true\"\n" +
    "         data-onvio-contact-editor-data=\"vm.data\"\n" +
    "         data-onvio-contact-editor-before-save=\"vm.beforeSave()\"\n" +
    "         data-onvio-contact-editor-save-promise=\"vm.savePromise()\"\n" +
    "         data-onvio-contact-editor-load-data-promise=vm.loadDataPromise()>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Groupings -->\n" +
    "    <div class=\"row\"\n" +
    "         data-ng-if=\"vm.data.clientMainExpanded\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\"\n" +
    "                data-translate=\"Bluemoon.Core.Setup.Clients.ClientDetail.GroupingsSectionHeader\"></h3>\n" +
    "\n" +
    "            <!-- Office -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"office\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.Office' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'office')\"\n" +
    "                     class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"offices\"\n" +
    "                                      name=\"office\"\n" +
    "                                      ng-model=\"vm.data.clientMainExpanded.office\"\n" +
    "                                      aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Current Partner -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"currentPartner\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientPartner.ClassOne' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.partnerHistoryValidationMessage()\"\n" +
    "                     class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"staff#active\"\n" +
    "                                      name=\"currentPartner\"\n" +
    "                                      ng-model=\"vm.data.clientMainExpanded.$partner\"\n" +
    "                                      aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Show/Hide partner history-->\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <a href=\"\"\n" +
    "                       id=\"clientPartnerShowHideHistory\"\n" +
    "                       data-qe-id=\"clientPartnerShowHideHistory-button\"\n" +
    "                       class=\"btn btn-link setup-common-contact-editor-showhide-details-link\"\n" +
    "                       ng-click=\"vm.togglePartnerHistory()\">\n" +
    "                        {{vm.showHidePartnerHistoryLabel()}}\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Partner History -->\n" +
    "            <div class=\"row\"\n" +
    "                 ng-if=\"vm.partnerHistoryVisible\">\n" +
    "                <div class=\"col-md-6 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"well bm-well\"\n" +
    "                         style=\"padding-top:0px;padding-bottom:0px;\">\n" +
    "                        <h3>{{'Bluemoon.Core.Setup.Clients.ClientDetail.ClientPartnerHistory' | translate}}</h3>\n" +
    "                        <div style=\"overflow-x:visible;overflow-y:visible;margin-bottom:25px;\"\n" +
    "                             data-qe-id=\"partnerHistory-grid\">\n" +
    "                            <bmp-toolbar toolbar-buttons=\"vm.partnerHistoryToolbar\"\n" +
    "                                context-items=\"vm.selectedPartners()\"\n" +
    "                                has-column-picker=\"false\"\n" +
    "                                has-search=\"false\"></bmp-toolbar>\n" +
    "\n" +
    "                            <table class=\"bento-flex-grid no-footer setup-client-partner-history-grid\"\n" +
    "                                   style=\"width:100%\"\n" +
    "                                   ng-show=\"vm.showPartnerHistoryTable()\">\n" +
    "                                <thead>\n" +
    "                                    <tr>\n" +
    "                                        <th class=\"wj-cell wj-header\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:25px;white-space:nowrap; background: #f9fafb !important;border-left: 0 !important;\">\n" +
    "                                            <input autocomplete=\"off\"\n" +
    "                                                   type=\"checkbox\"\n" +
    "                                                   class=\"form-input\"\n" +
    "                                                   data-qe-id=\"selector-all\"\n" +
    "                                                   data-ng-model=\"vm.partnerHistorySelectionHeaderChecked\"\n" +
    "                                                   data-ng-change=\"vm.partnerHistorySelectionHeaderCheckedChanged()\" />\n" +
    "                                        </th>\n" +
    "                                        <th class=\"wj-cell wj-header\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"\n" +
    "                                            data-qe-id=\"effectiveDate-header\">{{'Core.Captions.ClientPartner.DateEffective' | translate}}</th>\n" +
    "                                        <th class=\"wj-cell wj-header\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;width:100%;\"\n" +
    "\n" +
    "                                            data-qe-id=\"partner-header\">{{'Core.Captions.ClientPartner.Employee' | translate}}</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr data-ng-repeat=\"partner in vm.data.clientMainExpanded.partners\"\n" +
    "                                        ng-form=\"{{'partnerHistory_' + $index.toString()}}\">\n" +
    "                                        <td class=\"wj-cell\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:25px;white-space:nowrap;background: #f9fafb !important;border-left: 0 !important;\">\n" +
    "                                            <div class=\"form-group\"\n" +
    "                                                 style=\"margin-bottom:0px;\">\n" +
    "                                                <input autocomplete=\"off\"\n" +
    "                                                       type=\"checkbox\"\n" +
    "                                                       class=\"form-input\"\n" +
    "                                                       data-qe-id=\"selector_KEY__{{$index}}\"\n" +
    "                                                       data-ng-model=\"partner.$selected\" />\n" +
    "                                            </div>\n" +
    "                                        </td>\n" +
    "                                        <td class=\"wj-cell\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                            <div class=\"form-group\"\n" +
    "                                                 style=\"margin-right:15px;margin-bottom:0px;width:100%\">\n" +
    "                                                <bmp-bento-datepicker-wrapper name=\"effectiveDate_KEY__{{$index}}\"\n" +
    "                                                                              ng-model=\"partner.dateEffective\"\n" +
    "                                                                              ng-change=\"vm.onEffectiveDateChanged(partner)\"\n" +
    "                                                                              ng-class=\"{'has-error': partner.$hasError}\">\n" +
    "                                                </bmp-bento-datepicker-wrapper>\n" +
    "                                            </div>\n" +
    "                                        </td>\n" +
    "                                        <td class=\"wj-cell\"\n" +
    "                                            style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;width:100%\">\n" +
    "                                            <div class=\"form-group\"\n" +
    "                                                 style=\"margin-right:15px;margin-bottom:0px;\">\n" +
    "                                                <bmp-select-combo list=\"staff\"\n" +
    "                                                                  name=\"partner_KEY__{{$index}}\"\n" +
    "                                                                  ng-model=\"partner.$employee\"></bmp-select-combo>\n" +
    "                                            </div>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                            <uib-alert type=\"danger\"\n" +
    "                                       ng-show=\"vm.showHistoryError()\"\n" +
    "                                       data-qe-id=\"partnerHistory-error\">{{vm.partnerHistoryValidationMessage()}}</uib-alert>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "\n" +
    "                <!-- Manager -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"managerEmployee\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.ManagerEmployee' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'managerEmployee')\"\n" +
    "                     class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"staff#active\"\n" +
    "                                      name=\"managerEmployee\"\n" +
    "                                      ng-model=\"vm.data.clientMainExpanded.managerEmployee\"\n" +
    "                                      aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Associate -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"associateEmployee\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.AssociateEmployee' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'associateEmployee')\"\n" +
    "                     class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"staff#active\"\n" +
    "                                      name=\"associateEmployee\"\n" +
    "                                      ng-model=\"vm.data.clientMainExpanded.associateEmployee\"\n" +
    "                                      aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Client Information-->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\"\n" +
    "                data-translate=\"Bluemoon.Core.Setup.Clients.ClientDetail.ClientInformationSectionHeader\"></h3>\n" +
    "            <!-- Status -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"status\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.Status' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(data.clientMainExpanded, 'status')\"\n" +
    "                     class=\"col-md-12\">\n" +
    "                    <bmp-radio-button-group id=\"status\"\n" +
    "                                            name=\"status\"\n" +
    "                                            data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                            data-ng-model=\"vm.data.clientMainExpanded.status\"\n" +
    "                                            data-ng-change=\"vm.onStatusChanged()\"\n" +
    "                                            data-bmp-radio-button-group-options=\"vm.statusOptions\"></bmp-radio-button-group>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Class -->\n" +
    "            <div class=\"row\"\n" +
    "                 data-ng-if=\"vm.data.clientMainExpanded\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"class\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.Class' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'class')\"\n" +
    "                     class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-enum-combo enum=\"custom\"\n" +
    "                                    name=\"class\"\n" +
    "                                    ng-model=\"vm.data.clientMainExpanded.class\"\n" +
    "                                    required=\"true\"\n" +
    "                                    custom-items=\"vm.classTypes\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\"\n" +
    "                 data-ng-if=\"vm.data.clientMainExpanded\">\n" +
    "                <!-- Start Date -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"dateOpened\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.DateOpened' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'dateOpened')\"\n" +
    "                     class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper ng-model=\"vm.data.clientMainExpanded.dateOpened\"\n" +
    "                                                  id=\"dateOpened\"\n" +
    "                                                  name=\"dateOpened\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Left Date -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"dateLeft\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.ClientMain.DateLeft' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.clientMainExpanded, 'dateLeft')\"\n" +
    "                     class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper ng-model=\"vm.data.clientMainExpanded.dateLeft\"\n" +
    "                                                  ng-change=\"vm.onLeftDateChanged()\"\n" +
    "                                                  id=\"dateLeft\"\n" +
    "                                                  name=\"dateLeft\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3  data-ng-if=\"vm.data.primaryContactExpanded.id && vm.data.primaryContactExpanded.id !== 'new'\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "        <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.primaryContactExpanded.id\" [entity-name]=\"vm.data.primaryContactExpanded.displayAs\">\n" +
    "        </bmcn-notes>\n" +
    "    </h3>\n" +
    "  <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/clients/details/hmrc/client-detail-hmrc-ng.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/hmrc/client-detail-hmrc-ng.html",
    "<hmrc-agent-authorisation\n" +
    "    [client-id]=\"vm.id\"\n" +
    "    (show-error)=\"vm.showError($event)\"\n" +
    "    (change-tab)=\"vm.changeTab($event)\"\n" +
    "    [active-tab]=\"vm.activeTab\"\n" +
    "    (tab-change)=\"vm.changeUrlWithoutReloadingState($event)\">\n" +
    "</hmrc-agent-authorisation>");
}]);

angular.module("core-setup/clients/details/integration/client-detail-integration.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/integration/client-detail-integration.html",
    "<div class=\"ng-bento\">\n" +
    "    <div bento-busy-loader=\"!vm.data\"></div>\n" +
    "    <bmei-external-integration ng-if=\"vm.data.primaryContact.id\" client-id={{vm.data.id}} owner-id={{vm.data.primaryContact.id}} client-entity-type-id={{vm.data.primaryContactExpanded.entityType.id}} [show-contact-dropdown]=\"true\"></bmei-external-integration>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/clients/details/onbalance/client-detail-onbalance.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/onbalance/client-detail-onbalance.html",
    "<ng-form name=\"onbalanceForm\">\n" +
    "    <!-- Bento-Alert -->\n" +
    "    <bento-alert bento-alert-object=\"vm.disconnectAlert\"></bento-alert>\n" +
    "    <!-- Bento-Alert -->\n" +
    "    <bento-alert bento-alert-object=\"vm.cancelInvitationAlert\"></bento-alert>\n" +
    "    <!-- Bento-Alert -->\n" +
    "    <bento-alert bento-alert-object=\"vm.requestPriorDataAlert\"></bento-alert>\n" +
    "\n" +
    "    <h2 class=\"no-top-margin\" translate=\"Bluemoon.Core.Setup.OnbalanceAccess\" ng-if=\"!vm.isARCountryCode\"></h2>\n" +
    "\n" +
    "    <div>\n" +
    "        <div ng-if=\"!vm.isARCountryCode\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- No link has been established -->\n" +
    "                <div class=\"col-xs-12\" ng-if=\"!vm.data.isLinked\" translate=\"Bluemoon.Core.Setup.Onbalance.InviteSummary\"></div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"vm.isUKCountryCode\">\n" +
    "                <div class=\"row\">\n" +
    "\n" +
    "                    <div class=\"col-md-4 client-onbalance-related-contact\">\n" +
    "                        <ob-related-contact-combobox ng-if=\"vm.displayRelatedContactsCombo\" ng-model=\"vm.dialogData\" on-change=\"vm.onContactChange(item)\" company-id=\"vm.data.parentCompanyId\" client-id=\"vm.data.clientId\"></ob-related-contact-combobox>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- OnBalance Plan Input -->\n" +
    "            <div>\n" +
    "                <div ng-if=\"vm.showOnbalanceLinkingOptions()\" class=\"row\">\n" +
    "                    <div class=\"col-md-4\">\n" +
    "                        <ob-plan-combobox ng-model=\"vm.data.onbalancePlan\"></ob-plan-combobox>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div ng-if=\"vm.showOnbalanceLinkingOptions()\" class=\"row\" style=\"margin-top: 30px;\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"onbalance-emailAddress\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Onbalance.EmailAddress' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.errorFor(vm.data, 'emailAddress')\">\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-md-4 col-sm-4 col-xs-4\">\n" +
    "                                <!-- Email address input -->\n" +
    "                                <input autocomplete=\"off\" type=\"text\" class=\"form-control\"\n" +
    "                                    id=\"onbalance-emailAddress\" name=\"onbalance-emailAddress\"\n" +
    "                                    qe-id=\"onbalance-emailaddress\"\n" +
    "                                    ng-model=\"vm.data.clientEmailAddress\"\n" +
    "                                    ng-readonly=\"vm.sendingInvite\"\n" +
    "                                    ng-disabled=\"!vm.data.isLoaded\"\n" +
    "                                    fef-maxlength=\"250\"\n" +
    "                                    blue-moon-email-validation />\n" +
    "                            </div>\n" +
    "                            <div class=\"col-md-4 col-sm-4 col-xs-8 client-onbalance-invitation-buttons\">\n" +
    "                                <!-- Invite button -->\n" +
    "                                <button type=\"submit\" class=\"btn btn-primary client-onbalance-btn-send-invitation\" ng-click=\"vm.sendInviteNow()\" ng-disabled=\"!vm.canSendInviteNow()\">{{vm.sendInviteButtonText()}}</button>\n" +
    "                                <!-- Cancel Invitation button -->\n" +
    "                                <button ng-if=\"vm.data.isInvited\" type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.cancelInvitation()\">{{ 'Bluemoon.Core.Setup.Onbalance.CancelInvitation.ButtonText' | translate }}</button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- The Onvio client is linked to the OnBalance company -->\n" +
    "            <div class=\"row\" ng-if=\"vm.data.isLinked\" style=\"margin-bottom: 30px;\">\n" +
    "                <div class=\"col-md-10\">\n" +
    "                    <h4><i class=\"bento-icon-save-outlined\" style=\"color: green;\"></i> <span translate=\"Bluemoon.Core.Setup.Onbalance.LinkSuccess\"></span></h4>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"col-md-6 col-sm-12 col-xs-12\">\n" +
    "                    <div bm-if-has-access=\"OnBalance.AccountantView\" class=\"setup-clients-onbalance-inline-div\">\n" +
    "                        <div ng-if=\"vm.isUKCountryCode\">\n" +
    "                            <!-- OpenOnbalance button -->\n" +
    "                            <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.openOnBalanceClient()\" ng-disabled = \"vm.isOBButtonLoading\">\n" +
    "                            <span> {{ 'Bluemoon.Core.Setup.Onbalance.OpenOnbalance' | translate }} </span>\n" +
    "                            <i class=\"bento-icon-newtab\"> </i>\n" +
    "                            </button>\n" +
    "                            <!-- Request prior data button -->\n" +
    "                            <button type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.openRequestPriorDataDialog()\">{{ 'Bluemoon.Core.Setup.Onbalance.RequestPriorData' | translate }}</button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div bm-if-not-perm=\"Onbalance.UKSelfEmployedLink\" class=\"setup-clients-onbalance-inline-div\">\n" +
    "                        <!-- Disconnect button -->\n" +
    "                        <button type=\"submit\" ng-class=\"{'btn btn-default':vm.isUKCountryCode,'btn btn-primary':!vm.isUKCountryCode}\" ng-click=\"vm.disconnectOnbalanceClient()\">{{ 'Bluemoon.Core.Setup.Onbalance.ClientUnlink.Disconnect' | translate }}</button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- The Onbalance company has been invited -->\n" +
    "            <div ng-show=\"vm.data.isInvited && !vm.data.isLinked\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-8\">\n" +
    "                        <div class=\"alert alert-info\" style=\"margin-top: 10px;\">\n" +
    "                            <p>{{ 'Bluemoon.Core.Setup.Onbalance.InviteSent' | translate: { email: vm.data.emailAddress, date: vm.data.inviteSentDate } }}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-10\">\n" +
    "                        <h4 translate=\"Bluemoon.Core.Setup.Onbalance.WhatNextTitle\"></h4>\n" +
    "                        <p><small translate=\"Bluemoon.Core.Setup.Onbalance.WhatNextBody\"></small></p>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"ar-onbalance-card\" ng-if=\"vm.isARCountryCode\">\n" +
    "            <h4 class=\"ar-onbalance-card-header\">{{ 'Bluemoon.Core.Setup.Onbalance.AR.Benefit' | translate }}</h4>\n" +
    "            <div class=\"ar-onbalance-card-body\">\n" +
    "                <p class=\"card-text\" translate=\"Bluemoon.Core.Setup.Onbalance.AR.Licenses\"></p>\n" +
    "                <p class=\"card-text\" translate=\"Bluemoon.Core.Setup.Onbalance.AR.Migrated\"></p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- License Summary is shown for linked and unlink clients -->\n" +
    "        <h3>{{'Bluemoon.Core.Setup.Onbalance.LicenseSummary' | translate}}</h3>\n" +
    "        <div class=\"well bm-well\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "                            <p>{{ 'Bluemoon.Core.Setup.Onbalance.LicenseSummary.PurchasedLicenses' | translate }}</p>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-4 col-sm-4 col-xs-4\">\n" +
    "                            <p class=\"text-right\">{{ vm.data.purchasedLicenses }}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "                            <p>{{ 'Bluemoon.Core.Setup.Onbalance.LicenseSummary.RegisteredLicenses' | translate }}</p>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-4 col-sm-4 col-xs-4\">\n" +
    "                            <p class=\"text-right\">{{ vm.data.registeredLicenses }}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "                            <p>{{ 'Bluemoon.Core.Setup.Onbalance.LicenseSummary.OutstandingInvitations' | translate }}</p>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-4 col-sm-4 col-xs-4\">\n" +
    "                            <p class=\"text-right\">{{ vm.data.outstandingInvitations }}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <hr class=\"bm-section-divider\" ng-if=\"!vm.isARCountryCode\" />\n" +
    "                    <div class=\"row\" ng-if=\"!vm.isARCountryCode\">\n" +
    "                        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "                            <p>{{ 'Bluemoon.Core.Setup.Onbalance.LicenseSummary.AvailableLicenses' | translate }}</p>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-4 col-sm-4 col-xs-4\">\n" +
    "                            <p class=\"text-right\">{{ vm.data.availableInvitations }}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/clients/details/onbalance/request-prior-data-dialog.2js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/onbalance/request-prior-data-dialog.2js.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button type=\"button\" class=\"close\" aria-hidden=\"true\" data-ng-click=\"vm.onClose()\">\n" +
    "            <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        {{'Bluemoon.Core.Setup.OnbalanceAccess.RequestPriorDataDialog.HeaderText' | translate: { contactName: vm.contactName} }}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div ng-form name=\"requestPriorDataModalForm\" bento-busy-loader=\"vm.isLoadingData\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12 form-group\">\n" +
    "                    <label class=\"control-label inline\">\n" +
    "                        {{'Bluemoon.Core.Setup.OnbalanceAccess.RequestPriorDataDialog.Info' | translate}}\n" +
    "                        </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6 form-group\">\n" +
    "                    <label class=\"control-label inline\" for=\"selectedFinancialYear\">\n" +
    "                        {{'Bluemoon.Core.Setup.OnbalanceAccess.RequestPriorDataDialog.SelectFinancialYearLabel' | translate}}\n" +
    "                    </label>\n" +
    "                    <div bento-combobox\n" +
    "                        get-data=\"vm.getFinancialYears()\" label-name=\"label\"\n" +
    "                        data-ng-model=\"vm.selectedFinancialYear\"\n" +
    "                        placeholder=\"Select\"\n" +
    "                        searchable=\"false\"\n" +
    "                        controller=\"financialYearController\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button class=\"btn btn-primary\" data-ng-disabled=\"!vm.isFinancialYearSelected() || vm.isLoadingData\" data-ng-click=\"vm.onRequest()\">{{'Bluemoon.Core.Setup.OnbalanceAccess.RequestPriorDataDialog.Actions.Request' | translate}}</button>\n" +
    "        <button class=\"btn btn-default\" data-ng-click=\"vm.onCancel()\">{{'Bluemoon.Core.Setup.OnbalanceAccess.RequestPriorDataDialog.Actions.Cancel' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/clients/details/security/client-detail-security-v2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/security/client-detail-security-v2.html",
    "<h3 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.ClientCenterAccess' | translate}}</h3>\n" +
    "\n" +
    "<ng-form name=\"securityV2Form\"\n" +
    "         ng-show=\"vm.data.related.length > 0 && vm.displayAccess\"\n" +
    "         bmp-detail-view-default-focus=\"vm.data\">\n" +
    "\n" +
    "    <!-- Search -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <div class=\"pull-right\">\n" +
    "                    <label class=\"sr-only\"\n" +
    "                           for=\"repeaterSearch\">{{'Bluemoon.Practice.Common.Label.Search' | translate}}</label>\n" +
    "                    <input autocomplete=\"off\"\n" +
    "                           id=\"repeaterSearch\"\n" +
    "                           class=\"form-control\"\n" +
    "                           bento-reset=\"\"\n" +
    "                           ng-model=\"vm.repeaterSearchTerm\"\n" +
    "                           ng-change=\"vm.updateItems()\"\n" +
    "                           placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    <br />\n" +
    "    <div class=\"client-security-panel\">\n" +
    "\n" +
    "        <!-- Header -->\n" +
    "        <div class=\"client-security-panel-heading\">\n" +
    "            <div class=\"row\">\n" +
    "                <div ng-class=\"{'col-md-8': vm.showTaxCenterColumn, 'col-sm-8': vm.showTaxCenterColumn, 'col-xs-6': vm.showTaxCenterColumn, 'col-md-10': !vm.showTaxCenterColumn, 'col-sm-10': !vm.showTaxCenterColumn, 'col-xs-9': !vm.showTaxCenterColumn}\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.ClientCenterToggle\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggle\"\n" +
    "                     ng-if=\"vm.showTaxCenterColumn && !vm.displayVNextStrings\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggleVNext\"\n" +
    "                     ng-if=\"vm.showTaxCenterColumn && vm.displayVNextStrings\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <span ng-repeat=\"access in vm.filteredItems\">\n" +
    "\n" +
    "            <!-- Item heading -->\n" +
    "            <div class=\"client-security-panel-group\">\n" +
    "                <div class=\"row\">\n" +
    "                    <!-- Name -->\n" +
    "                    <div ng-class=\"{'col-md-8': vm.showTaxCenterColumn, 'col-sm-8': vm.showTaxCenterColumn, 'col-xs-6': vm.showTaxCenterColumn, 'col-md-10': !vm.showTaxCenterColumn, 'col-sm-10': !vm.showTaxCenterColumn, 'col-xs-9': !vm.showTaxCenterColumn}\">{{access.contact.displayAs}}\n" +
    "                        <span ng-show=\"access.relationship && access.relationship.length > 0\">({{access.relationship}})</span>\n" +
    "                        <br />\n" +
    "                        <span class=\"details\"\n" +
    "                              ng-show=\"access.contact.userId || access.isGranularClientCenterEnabled\">\n" +
    "                            <i class=\"bento-icon-checkmark success\"\n" +
    "                               ng-show=\"access.contact.userId\"></i>\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.ClientCenterRegistered\"\n" +
    "                                  ng-show=\"access.contact.userId\"></span>\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.ClientCenterNotRegistered\"\n" +
    "                                  ng-show=\"!access.contact.userId && access.isGranularClientCenterEnabled\"></span> |\n" +
    "                            <!-- Show/Hide details -->\n" +
    "                            <a ng-click=\"vm.repeaterItemToggle(access)\"\n" +
    "                               ng-show=\"!access.$expanded\">\n" +
    "                                {{'Bluemoon.Core.Setup.ShowDetails' | translate }}\n" +
    "                                <i class=\"glyphicon glyphicon-chevron-right\"></i>\n" +
    "                            </a>\n" +
    "                            <a ng-click=\"vm.repeaterItemToggle(access)\"\n" +
    "                               ng-show=\"access.$expanded\">\n" +
    "                                {{'Bluemoon.Core.Setup.HideDetails' | translate }}\n" +
    "                                <i class=\"glyphicon glyphicon-chevron-left\"></i>\n" +
    "                            </a>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                    <!-- Client center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.isGranularClientCenterEnabled\"></div>\n" +
    "                    </div>\n" +
    "                    <!-- Tax center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                         ng-if=\"vm.showTaxCenterColumn\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.isTaxCenterEnabled\"></div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- Item body -->\n" +
    "            <div class=\"client-security-panel-body\"\n" +
    "                 uib-collapse=\"!access.$expanded\">\n" +
    "\n" +
    "                <!-- Contact registration information -->\n" +
    "                <tr-user-registration ng-if=\"access.contact\"\n" +
    "                                      id=\"registration_KEY__{{::$index}}\"\n" +
    "                                      data-tr-user-registration-display-email=\"true\"\n" +
    "                                      data-tr-user-registration-client=\"true\"\n" +
    "                                      data-tr-user-registration-contact=\"access.contact\"\n" +
    "                                      data-tr-user-registration-center-access=\"access\"\n" +
    "                                      data-tr-user-registration-entity-types=\"vm.entityTypes\"\n" +
    "                                      hide-toggle=\"true\">\n" +
    "                </tr-user-registration>\n" +
    "\n" +
    "            </div>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- No results -->\n" +
    "    <div class=\"row\"\n" +
    "         ng-if=\"vm.filteredItems.length == 0\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12 text-center\">\n" +
    "            <h4>\n" +
    "                <small translate=\"Bluemoon.Practice.Common.List.NoResults\"></small>\n" +
    "            </h4>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</ng-form>\n" +
    "\n" +
    "<div class=\"row\"\n" +
    "     ng-if=\"vm.data.related.length === 0\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"alert alert-info\">\n" +
    "            <span translate=\"Bluemoon.Core.Setup.ClientCenterAccess.NoRelationships\"></span>\n" +
    "            <a ui-sref=\"setupClientDetail.relationships.detail\"\n" +
    "               translate=\"Bluemoon.Core.Setup.ClientCenterAccess.AddRelationship\"></a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"bento-alert-container\" ng-if=\"!vm.displayAccess\">\n" +
    "    <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\" translate=\"Bluemoon.Core.Setup.Common.PreviewMode.Warning\"></span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/clients/details/security/client-detail-security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/security/client-detail-security.html",
    "<h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.ClientCenterAccess' | translate}}</h2>\n" +
    "\n" +
    "<ng-form name=\"securityForm\"\n" +
    "         ng-show=\"vm.data.related.length > 0 && vm.displayAccess\"\n" +
    "         bmp-detail-view-default-focus=\"vm.data\">\n" +
    "\n" +
    "    <!-- Search -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <div class=\"pull-right\">\n" +
    "                <label class=\"sr-only\"\n" +
    "                       for=\"repeaterSearch\">{{'Bluemoon.Practice.Common.Label.Search' | translate}}</label>\n" +
    "                <input autocomplete=\"off\"\n" +
    "                       id=\"repeaterSearch\"\n" +
    "                       class=\"form-control\"\n" +
    "                       bento-reset=\"\"\n" +
    "                       ng-model=\"vm.repeaterSearchTerm\"\n" +
    "                       ng-change=\"vm.updateItems()\"\n" +
    "                       placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br />\n" +
    "\n" +
    "    <div class=\"client-security-panel\">\n" +
    "\n" +
    "        <!-- Header -->\n" +
    "        <div class=\"client-security-panel-heading\">\n" +
    "            <div class=\"row\">\n" +
    "                <div ng-class=\"{'col-md-8': vm.showTaxCenterColumn, 'col-sm-8': vm.showTaxCenterColumn, 'col-xs-6': vm.showTaxCenterColumn, 'col-md-10': !vm.showTaxCenterColumn, 'col-sm-10': !vm.showTaxCenterColumn, 'col-xs-9': !vm.showTaxCenterColumn}\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.ClientCenterToggle\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggle\"\n" +
    "                     ng-if=\"vm.showTaxCenterColumn && !vm.displayVNextStrings\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggleVNext\"\n" +
    "                     ng-if=\"vm.showTaxCenterColumn && vm.displayVNextStrings\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <span ng-repeat=\"access in vm.filteredItems\">\n" +
    "\n" +
    "            <!-- Item heading -->\n" +
    "            <div class=\"client-security-panel-group\">\n" +
    "                <div class=\"row\">\n" +
    "                    <!-- Name -->\n" +
    "                    <div ng-class=\"{'col-md-8': vm.showTaxCenterColumn, 'col-sm-8': vm.showTaxCenterColumn, 'col-xs-6': vm.showTaxCenterColumn, 'col-md-10': !vm.showTaxCenterColumn, 'col-sm-10': !vm.showTaxCenterColumn, 'col-xs-9': !vm.showTaxCenterColumn}\">{{access.contact.displayAs}}\n" +
    "                        <span ng-show=\"access.relationship && access.relationship.length > 0\">({{access.relationship}})</span>\n" +
    "                        <br />\n" +
    "                        <span class=\"details\"\n" +
    "                              ng-show=\"access.contact.userId || access.contact.isClientCenterEnabled\">\n" +
    "                            <i class=\"bento-icon-checkmark success\"\n" +
    "                               ng-show=\"access.contact.userId\"></i>\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.ClientCenterRegistered\"\n" +
    "                                  ng-show=\"access.contact.userId\"></span>\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.ClientCenterNotRegistered\"\n" +
    "                                  ng-show=\"!access.contact.userId && access.contact.isClientCenterEnabled\"></span> |\n" +
    "                            <!-- Show/Hide details -->\n" +
    "                            <a ng-click=\"vm.repeaterItemToggle(access)\"\n" +
    "                               ng-show=\"!access.$expanded\">\n" +
    "                                {{'Bluemoon.Core.Setup.ShowDetails' | translate }}\n" +
    "                                <i class=\"glyphicon glyphicon-chevron-right\"></i>\n" +
    "                            </a>\n" +
    "                            <a ng-click=\"vm.repeaterItemToggle(access)\"\n" +
    "                               ng-show=\"access.$expanded\">\n" +
    "                                {{'Bluemoon.Core.Setup.HideDetails' | translate }}\n" +
    "                                <i class=\"glyphicon glyphicon-chevron-left\"></i>\n" +
    "                            </a>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                    <!-- Client center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\" ng-class=\"{isDisabled : vm.checkDisabled(access)}\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.contact.isClientCenterEnabled\"></div>\n" +
    "                    </div>\n" +
    "                    <!-- Tax center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                         ng-if=\"vm.showTaxCenterColumn\" ng-class=\"{isDisabled : vm.checkDisabled(access)}\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.isTaxCenterEnabled\"></div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <!-- Item body -->\n" +
    "            <div class=\"client-security-panel-body\"\n" +
    "                 uib-collapse=\"!access.$expanded\">\n" +
    "\n" +
    "                 <div class=\"row\" ng-if=\"access.contact.isClientCenterEnabled && access.clientCenter.isBetaEligible\">\n" +
    "                    <div class=\"col-md-6\">\n" +
    "                        <span>{{'Bluemoon.Core.Setup.ClientCenter.SelectVersion' | translate }}</span>\n" +
    "                        <span class=\"btn-group\" style=\"margin-left: 10px;\">\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"access.clientCenter.version\" uib-btn-radio=\"'Current'\">{{'Bluemoon.Core.Setup.ClientCenter.Current' | translate }}</button>\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"access.clientCenter.version\" uib-btn-radio=\"'Beta'\">{{'Bluemoon.Core.Setup.ClientCenter.Beta' | translate }}</button>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Contact registration information -->\n" +
    "                <tr-user-registration ng-if=\"access.contact\"\n" +
    "                                      id=\"registration_KEY__{{::$index}}\"\n" +
    "                                      data-tr-user-registration-display-email=\"true\"\n" +
    "                                      data-tr-user-registration-client=\"true\"\n" +
    "                                      data-tr-user-registration-contact=\"access.contact\"\n" +
    "                                      data-tr-user-registration-entity-types=\"vm.entityTypes\"\n" +
    "                                      hide-toggle=\"true\">\n" +
    "                </tr-user-registration>\n" +
    "\n" +
    "            </div>\n" +
    "\n" +
    "        </span>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- No results -->\n" +
    "    <div class=\"row\"\n" +
    "         ng-if=\"vm.filteredItems.length == 0\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12 text-center\">\n" +
    "            <h4>\n" +
    "                <small translate=\"Bluemoon.Practice.Common.List.NoResults\"></small>\n" +
    "            </h4>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</ng-form>\n" +
    "\n" +
    "<div class=\"row\"\n" +
    "     ng-if=\"vm.data.related.length === 0\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"alert alert-info\">\n" +
    "            <span translate=\"Bluemoon.Core.Setup.ClientCenterAccess.NoRelationships\"></span>\n" +
    "            <a ui-sref=\"setupClientDetail.relationships.detail\"\n" +
    "               translate=\"Bluemoon.Core.Setup.ClientCenterAccess.AddRelationship\"></a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"bento-alert-container\" ng-if=\"!vm.displayAccess\">\n" +
    "    <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\" translate=\"Bluemoon.Core.Setup.Common.PreviewMode.Warning\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/clients/details/vat/client-detail-vat.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/details/vat/client-detail-vat.html",
    "<ng-form name=\"vatForm\">\n" +
    "    <uk-vat-client-details\n" +
    "        [client-id]=\"vm.id\"\n" +
    "        [save-data-to-angular]=\"vm.saveDataToAngular\"\n" +
    "        (save-data-complete)=\"vm.saveCompleted($event)\"\n" +
    "        (show-error)=\"vm.showError($event)\"\n" +
    "        (form-dirty)=\"vm.formDirty($event)\">\n" +
    "    </uk-vat-client-details>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/clients/list/client-list-related-contacts-grid-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/clients/list/client-list-related-contacts-grid-template.html",
    "<bmc-related-contacts-list\n" +
    "    item=\"$item\"\n" +
    "    grid-name=\"'ClientGrid'\"\n" +
    "    row=\"$row\"\n" +
    "    id=\"$item.id\"\n" +
    "    contact-id=\"$item.contactView.id\">\n" +
    "</bmc-related-contacts-list>");
}]);

angular.module("core-setup/common/contact-editor/contact-editor-address-default.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-editor/contact-editor-address-default.html",
    "<!-- Address Postal Code First-->\n" +
    "<div class =\"row\" ng-if=\"vm.showZipPostalCodeFirst(address)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"zipCodeFirst_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.zipPostalCodeLabel(address)}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'zipCode')\"\n" +
    "        class=\"col-md-2 col-sm-2 col-xs-4 no-padding-l\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"zipCodeFirst_KEY__{{::$index}}\"\n" +
    "            name=\"zipCodeFirst_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"zipCodeFirst_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.postalCode\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Address Line 1 -->\n" +
    "<div class=\"row\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.address1Label(address) }}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine1')\"\n" +
    "        class=\"col-md-8 col-sm-8 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine1\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Additional Address Lines -->\n" +
    "<div class=\"row\" ng-if=\"vm.showAdditionalAddressLines(address)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"additionalAddressLines_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.AdditionalAddressLines' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine2') + vm.detail.errorFor(address, 'addressLine3')\"\n" +
    "        class=\"col-md-8 col-sm-8 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <textarea autocomplete=\"off\" type=\"text\"\n" +
    "                id=\"additionalAddressLines_KEY__{{::$index}}\"\n" +
    "                name=\"additionalAddressLines_KEY__{{::$index}}\"\n" +
    "                data-qe-id=\"additionalAddressLines_KEY__{{::$index}}\"\n" +
    "                class=\"form-control\"\n" +
    "                rows=\"2\"\n" +
    "                data-ng-style=\"{'height':'auto'}\"\n" +
    "                data-ng-model=\"address.$additionalAddressLines\"></textarea>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Address Line 2 -->\n" +
    "<div class=\"row\" ng-if=\"vm.showAddressLine2(address)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.address2Label(address) }}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine2')\"\n" +
    "        class=\"col-md-8 col-sm-8 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine2\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Address Line 3 -->\n" +
    "<div class=\"row\" ng-if=\"vm.showAddressLine3(address)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.address3Label(address) }}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine3')\"\n" +
    "        class=\"col-md-8 col-sm-8 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine3\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Address Line 4 -->\n" +
    "<div class=\"row\" ng-if=\"vm.showAddressLine4(address)\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.address4Label(address) }}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine4')\"\n" +
    "        class=\"col-md-8 col-sm-8 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine4\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- City/Town -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"city_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.cityTownLabel(address)}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'city')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"city_KEY__{{::$index}}\"\n" +
    "            name=\"city_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"city_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.city\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- State/Province -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.stateProvinceLabel(address)}}\"\n" +
    "        data-bmp-control-group-error=\"vm.errorFor(address, 'stateProvince')\"\n" +
    "        ng-if=\"vm.showStateProvince(address)\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-8 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            name=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            type=\"text\"\n" +
    "            bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusStateProvince.{{$index}}'\"\n" +
    "            uib-typeahead=\"stateProvince.name as stateProvince.name for stateProvince in vm.stateProvinceOptions(address, $viewValue)\"\n" +
    "            typeahead-wait-ms=\"10\"\n" +
    "            typeahead-focus-first=\"true\"\n" +
    "            typeahead-on-select=\"vm.onStateProvinceSelected(address, $item, $index)\"\n" +
    "            typeahead-focus-on-select=\"false\"\n" +
    "            data-ng-model=\"address.stateProvince.name\"\n" +
    "            data-ng-blur=\"vm.onStateProvinceNameChanged(address)\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Postal Code -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"zipCode_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.zipPostalCodeLabel(address)}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'zipCode')\"\n" +
    "        class=\"col-md-2 col-sm-2 col-xs-4 setup-common-contact-editor-address-section\"\n" +
    "        ng-if=\"vm.showZipPostalCode(address)\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"zipCode_KEY__{{::$index}}\"\n" +
    "            name=\"zipCode_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"zipCode_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.postalCode\"\n" +
    "            tr-postal-code-country=\"address.$country.id\"\n" +
    "            tr-postal-code\n" +
    "            bm-uppercase />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- County -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"county_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{vm.countyLabel(address)}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'county')\"\n" +
    "        ng-if=\"vm.showCounty(address)\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"county_KEY__{{::$index}}\"\n" +
    "            name=\"county_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"county_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.county\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Country -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"country_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.Country' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'country')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" id=\"country_KEY__{{::$index}}\"\n" +
    "            name=\"country_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"country_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            type=\"text\"\n" +
    "            bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusAddressCountry.{{$index}}'\"\n" +
    "            uib-typeahead=\"country.name as country.name for country in vm.countryOptions($viewValue)\"\n" +
    "            typeahead-wait-ms=\"10\"\n" +
    "            typeahead-focus-first=\"true\"\n" +
    "            typeahead-on-select=\"vm.onCountrySelected(address, $item, $index)\"\n" +
    "            typeahead-select-on-blur=\"true\"\n" +
    "            data-ng-model=\"address.$country.name\"\n" +
    "            data-ng-blur=\"vm.countryChangedDebounce($index)\" />\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/contact-editor/contact-editor-address-nl.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-editor/contact-editor-address-nl.html",
    "<div class=\"row\">\n" +
    "    <!-- Address Line 1 -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.StreetName' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine1')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine1_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine1\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Address Line 2 -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.StreetNumber' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine2')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine2_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine2\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Address Line 3 -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.Addition' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine3')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine3_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine3\" />\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Address Line 4 -->\n" +
    "    <div class=\"row\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.AdditionalAddressLine' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'addressLine4')\"\n" +
    "        class=\"col-md-9 col-sm-9 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            name=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"addressLine4_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.addressLine4\" />\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "    <!-- Postal Code -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"zipCode_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.PostalCode' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'zipCode')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\"\n" +
    "        ng-if=\"vm.showZipPostalCode(address)\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"zipCode_KEY__{{::$index}}\"\n" +
    "            name=\"zipCode_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"zipCode_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.postalCode\"\n" +
    "            bm-uppercase />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- City/Town -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"city_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.City' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'city')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" type=\"text\"\n" +
    "            id=\"city_KEY__{{::$index}}\"\n" +
    "            name=\"city_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"city_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            data-ng-model=\"address.city\"\n" +
    "            bm-uppercase />\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "    <!-- Country -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"country_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.Country' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(address, 'country')\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" id=\"country_KEY__{{::$index}}\"\n" +
    "            name=\"country_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"country_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            type=\"text\"\n" +
    "            bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusAddressCountry.{{$index}}'\"\n" +
    "            uib-typeahead=\"country.name as country.name for country in vm.countryOptions($viewValue)\"\n" +
    "            typeahead-wait-ms=\"10\"\n" +
    "            typeahead-focus-first=\"true\"\n" +
    "            typeahead-on-select=\"vm.onCountrySelected(address, $item, $index)\"\n" +
    "            typeahead-select-on-blur=\"true\"\n" +
    "            data-ng-model=\"address.$country.name\"\n" +
    "            data-ng-blur=\"vm.countryChangedDebounce($index)\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- State/Province -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.Province' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.errorFor(address, 'stateProvince')\"\n" +
    "        ng-if=\"vm.showStateProvince(address)\"\n" +
    "        class=\"col-md-3 col-sm-3 col-xs-8 setup-common-contact-editor-address-section\">\n" +
    "        <input autocomplete=\"off\" id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            name=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            data-qe-id=\"stateProvince_KEY__{{::$index}}\"\n" +
    "            class=\"form-control\"\n" +
    "            type=\"text\"\n" +
    "            bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusStateProvince.{{$index}}'\"\n" +
    "            uib-typeahead=\"stateProvince.name as stateProvince.name for stateProvince in vm.stateProvinceOptions(address, $viewValue)\"\n" +
    "            typeahead-wait-ms=\"10\"\n" +
    "            typeahead-focus-first=\"true\"\n" +
    "            typeahead-on-select=\"vm.onStateProvinceSelected(address, $item, $index)\"\n" +
    "            data-ng-model=\"address.stateProvince.name\"\n" +
    "            data-ng-blur=\"vm.onStateProvinceNameChanged(address)\" />\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/contact-editor/contact-editor-confidentiality-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-editor/contact-editor-confidentiality-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"confidentiality-modal-close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"vm.onClose()\"\n" +
    "                aria-hidden=\"true\"\n" +
    "                aria-label=\"Close Dialog\">\n" +
    "                <i class=\"bento-icon-close-x\"></i>\n" +
    "        </button>\n" +
    "        <div ng-if=\"!vm.isConfidential\">\n" +
    "            <span>{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.RemoveTitle' | translate}}</span>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.isConfidential\">\n" +
    "            <span ng-if=\"!vm.editMode\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.AddTitle' | translate}}</span>\n" +
    "            <span ng-if=\"vm.editMode\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.AssignHeader' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form name=\"dialogForm\">\n" +
    "            <div ng-if=\"!vm.isConfidential\" bento-busy-loader=\"vm.loadingData\">\n" +
    "                <div style=\"margin-bottom: 35px\">\n" +
    "                    <div type=\"warning\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.RemoveMessage' | translate}}</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.isConfidential\"\n" +
    "                 bento-busy-loader=\"vm.loadingData\"\n" +
    "                 class=\"contact-editor-confidentiality-dialog\">\n" +
    "                <div ng-if=\"!vm.editMode\" style=\"margin-bottom: 25px\">{{vm.contactDisplayAs}}</div>\n" +
    "                <h3>{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.AssignHeader' | translate}}</h3>\n" +
    "                <div style=\"margin-bottom: 25px;\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.AssignMessage' | translate}}</div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"permissionGroup{{$index}}\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.PermissionGroup' | translate}}\"\n" +
    "                    class=\"col-md-12 col-sm-12 col-xs-12\"\n" +
    "                    ng-repeat=\"permGroup in vm.permGroupsArray\">\n" +
    "                    <!-- Remove Permission Group -->\n" +
    "                    <div class=\"col-md-12 col-sm-10 col-xs-12 remove-permission-group-container\">\n" +
    "                        <button type=\"button\"\n" +
    "                                class=\"btn btn-link no-margin remove-permission-group-button\"\n" +
    "                                ng-click=\"vm.removePermGroup($index)\"\n" +
    "                                ng-if=\"vm.permGroupsArray.length > 1 && !permGroup.allConf\">\n" +
    "                            <span class=\"bento-icon-remove\"></span>\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"row dropdown-row-width\">\n" +
    "                        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <div bento-combobox=\"\"\n" +
    "                                    columns-width=\"[100,'auto','auto']\"\n" +
    "                                    ng-model=\"vm.permGroupsArray[$index]\"\n" +
    "                                    get-data=\"vm.getData(search, page)\"\n" +
    "                                    label-name=\"label\"\n" +
    "                                    headers=\"vm.permGroupsComboHeaders\"\n" +
    "                                    controller=\"vm.permGroupsComboController[$index]\"\n" +
    "                                    row-template=\"vm.permGroupsComboRowTemplate\"\n" +
    "                                    ng-click=\"vm.refreshCombo($index)\"\n" +
    "                                    ng-readonly=\"permGroup.allConf\"\n" +
    "                                    role=\"combobox\"\n" +
    "                                    aria-labelledby=\"permissionGroup{{$index}}-label\"\n" +
    "                                    bento-append-to-parent=\".modal-content\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Add Permission Group -->\n" +
    "                <button type=\"button\" class=\"btn btn-link no-margin\" ng-click=\"vm.addPermGroup()\" data-qe-id =\"bm-contactEditorConfidentialityDialog-addPermGroup-button\">\n" +
    "                    <span class=\"bento-icon-add\"></span>\n" +
    "                    <span>{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.AddPermissionGroup' | translate}}</span>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"modal-footer\">\n" +
    "                <button id=\"confidentiality-modal-ok\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.onSave()\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                        data-qe-id=\"bm-contactEditorConfidentialityDialog-save-button\"\n" +
    "                        data-ng-disabled=\"vm.saveDisabled() || vm.loadingData\"></button>\n" +
    "                <button id=\"confidentiality-modal-cancel\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.onCancel()\"\n" +
    "                        data-qe-id=\"bm-contactEditorConfidentialityDialog-cancel-button\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\" formnovalidate></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/common/contact-editor/contact-editor-existing-contact-button.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-editor/contact-editor-existing-contact-button.html",
    "<button name=\"selectExistingContactButton\"\n" +
    "        type=\"button\"\n" +
    "        class=\"btn btn-link btn-xs pull-right setup-common-contact-editor-input-right-action\"\n" +
    "        style=\"padding-right:0px\"\n" +
    "        data-ng-show=\"vm.showContactSelector()\"\n" +
    "        data-qe-id=\"selectExistingContact-button\"\n" +
    "        data-ng-click=\"vm.trackAnalyticsEventInContext('selectExistingContact'); vm.openSelectContactDialog()\">\n" +
    "    <span class=\"glyphicon glyphicon-search\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.SelectExistingContact\"></span>\n" +
    "</button>");
}]);

angular.module("core-setup/common/contact-editor/contact-editor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-editor/contact-editor.html",
    "<ng-form name=\"contactEditorForm\">\n" +
    "    <div class=\"row\" bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "        <!-- Entity -->\n" +
    "        <div ng-class=\"{ 'col-md-12': onvioContactEditorQuickAdd, 'col-md-4 col-sm-6 col-xs-12': !onvioContactEditorQuickAdd }\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-hide=\"vm.hideEntityType()\"\n" +
    "                data-bmp-control-group-field-id=\"entityType\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.Contact.EntityType' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(data, 'entityType')\">\n" +
    "                <div class=\"setup-common-contact-editor-custom-combo-loader-container\">\n" +
    "                    <bmp-enum-combo enum=\"custom\" name=\"entityType\"\n" +
    "                                    ng-model=\"data.$entityType\"\n" +
    "                                    ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                                    required=\"true\"\n" +
    "                                    custom-items=\"vm.validContactEntityTypeOptions\"\n" +
    "                                    bm-focus-on-event=\"'bm.core.setup.common.contactEditor.focusEntityType'\"></bmp-enum-combo>\n" +
    "                    <div bento-busy-loader=\"vm.entityTypeLoading\" busy-loader-size=\"small\" class=\"setup-common-contact-editor-custom-combo-loader\">\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Full Name -->\n" +
    "    <!-- Name is required under all conditions, but handled differently when name parts are allowed -->\n" +
    "    <!-- We use custom validation for Persons, and ng-required otherwise -->\n" +
    "    <!-- Full name validation for Persons utilizes contactNameValidationService -->\n" +
    "    <div class=\"row\" data-ng-show=\"vm.showFullName()\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.Contact.FullName' -->\n" +
    "        <div ng-class=\"{ 'col-md-12': onvioContactEditorQuickAdd, 'col-md-4 col-sm-6 col-xs-12': !onvioContactEditorQuickAdd }\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"fullName\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.Contact.FullName' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.errorFor(data, 'fullName')\">\n" +
    "                <div data-ng-include=\"'core-setup/common/contact-editor/contact-editor-existing-contact-button.html'\" data-ng-if=\"!vm.nameExpanded && !onvioContactEditorQuickAdd\"></div>\n" +
    "                <input autocomplete=\"off\" type=\"text\"\n" +
    "                    id=\"fullName\"\n" +
    "                    name=\"fullName\"\n" +
    "                    data-qe-id=\"fullName\"\n" +
    "                    class=\"form-control\"\n" +
    "                    data-ng-model=\"data.fullName\"\n" +
    "                    data-ng-model-options=\"{allowInvalid: true, updateOn: 'blur'}\"\n" +
    "                    data-ng-change=\"vm.onFullNameChange()\"\n" +
    "                    data-ng-blur=\"vm.onFullNameBlur()\"\n" +
    "                    data-ng-required=\"true\"\n" +
    "                    data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                    data-fef-maxlength=\"500\"\n" +
    "                    data-ng-readonly=\"vm.nameIsReadonly\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Name (person) -->\n" +
    "    <div class=\"row\" data-ng-hide=\"!vm.nameExpanded\" id=\"name-details-fields\" ng-attr-tabindex=\"{{vm.nameDetailsOrder ? '0' : '-1'}}\">\n" +
    "\n" +
    "        <!-- Prefix -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"prefix\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.Prefix' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'prefix')\"\n" +
    "             class=\"col-md-2 col-sm-3 col-xs-6\"\n" +
    "             >\n" +
    "            <input autocomplete=\"off\"\n" +
    "                name=\"prefix\"\n" +
    "                id=\"prefix\"\n" +
    "                data-qe-id=\"prefix\"\n" +
    "                class=\"form-control\"\n" +
    "                type=\"text\"\n" +
    "                uib-typeahead=\"prefix as prefix for prefix in vm.getPrefixOptions($viewValue)\"\n" +
    "                typeahead-wait-ms=\"10\"\n" +
    "                typeahead-focus-first=\"true\"\n" +
    "                typeahead-on-select=\"vm.onPrefixSelected($item)\"\n" +
    "                data-ng-model=\"data.prefix\"\n" +
    "                data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "\n" +
    "                data-ng-blur=\"vm.nameDetailsChanged()\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- First Name -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"givenName\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.GivenName' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'givenName')\"\n" +
    "             class=\"col-md-3 col-sm-5 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"givenName\"\n" +
    "                   name=\"givenName\"\n" +
    "                   data-qe-id=\"givenName\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.givenName\"\n" +
    "                   data-ng-model-options=\"{allowInvalid: true, updateOn: 'blur'}\"\n" +
    "                   data-ng-change=\"vm.nameDetailsChanged(); vm.onDisplayAsRuleChanged()\"\n" +
    "                   data-ng-blur=\"vm.contactNameValidationService.checkNamePartsValidity()\"\n" +
    "                   data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                   data-fef-maxlength=\"100\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Middle Name -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"additionalName\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.AdditionalName' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'additionalName')\"\n" +
    "             class=\"col-md-2 col-sm-4 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"additionalName\"\n" +
    "                   name=\"additionalName\"\n" +
    "                   data-qe-id=\"additionalName\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.additionalName\"\n" +
    "                   data-ng-model-options=\"{allowInvalid: true, updateOn: 'blur'}\"\n" +
    "                   data-ng-change=\"vm.nameDetailsChanged(); vm.onDisplayAsRuleChanged()\"\n" +
    "                   data-ng-blur=\"vm.contactNameValidationService.checkNamePartsValidity()\"\n" +
    "                   data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                   data-fef-maxlength=\"100\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Last Name -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"familyName\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.FamilyName' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'familyName')\"\n" +
    "             class=\"col-md-3 col-sm-9 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"familyName\"\n" +
    "                   name=\"familyName\"\n" +
    "                   data-qe-id=\"familyName\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.familyName\"\n" +
    "                   data-ng-model-options=\"{allowInvalid: true, updateOn: 'blur'}\"\n" +
    "                   data-ng-change=\"vm.nameDetailsChanged(); vm.onDisplayAsRuleChanged()\"\n" +
    "                   data-ng-blur=\"vm.contactNameService.checkNamePartsValidity()\"\n" +
    "                   data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                   data-fef-maxlength=\"100\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Suffix -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"suffix\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.Suffix' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'suffix')\"\n" +
    "             class=\"col-md-2 col-sm-3 col-xs-6\">\n" +
    "            <div data-ng-include=\"'core-setup/common/contact-editor/contact-editor-existing-contact-button.html'\" data-ng-if=\"vm.nameExpanded && !onvioContactEditorQuickAdd\"></div>\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                id=\"suffix\"\n" +
    "                name=\"suffix\"\n" +
    "                data-qe-id=\"suffix\"\n" +
    "                class=\"form-control\"\n" +
    "                data-ng-model=\"data.suffix\"\n" +
    "                data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                uib-typeahead=\"suffix as suffix for suffix in vm.getSuffixOptions($viewValue)\"\n" +
    "                typeahead-wait-ms=\"10\"\n" +
    "                typeahead-focus-first=\"true\"\n" +
    "                typeahead-on-select=\"vm.onSuffixSelected($item)\"\n" +
    "                data-ng-blur=\"vm.nameDetailsChanged()\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Show/Hide name details -->\n" +
    "    <div class=\"row\" data-ng-if=\"vm.isPerson()\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <a href=\"\"\n" +
    "               id=\"personal_name_show_details\"\n" +
    "               data-qe-id=\"fullNameShowHideDetails-button\"\n" +
    "               class=\"btn btn-link setup-common-contact-editor-showhide-details-link\"\n" +
    "               data-ng-click=\"vm.nameExpanded = !vm.nameExpanded\"\n" +
    "               data-ng-keydown=\"vm.focusToNameDetails($event)\"\n" +
    "               >\n" +
    "                <span data-ng-if=\"vm.nameExpanded\">\n" +
    "                    <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.NameHide\"></span><span class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "                </span>\n" +
    "                <span data-ng-if=\"!vm.nameExpanded\">\n" +
    "                    <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.NameShow\"></span><span class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "                </span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Doing Business As -->\n" +
    "    <div class=\"row\" ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isOrganization()\"\n" +
    "             data-bmp-control-group-field-id=\"doingBusinessAs\"\n" +
    "             data-bmp-control-group-label=\"{{vm.doingBusinessAsLabel()}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'doingBusinessAs')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"doingBusinessAs\"\n" +
    "                   name=\"doingBusinessAs\"\n" +
    "                   data-qe-id=\"doingBusinessAs\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.doingBusinessAs\"\n" +
    "                   data-fef-maxlength=\"250\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Confidentiality -->\n" +
    "    <div ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "        <div bm-if-perm =\"Platform.ConfidentialClients\">\n" +
    "            <div bm-if-has-access=\"Platform_GranularPermissions\">\n" +
    "                <div class=\"row\" data-ng-if=\"vm.showConfidentiality()\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"confidentiality\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.errorFor(data, 'isConfidential')\"\n" +
    "                        class=\"col-md-12\">\n" +
    "                            <div class=\"btn-group confidentialityToggle confidentialityToggleWrapper\"\n" +
    "                                    data-tooltip-enable = \"{{vm.showConfidentialityToggleTooltip()}}\"\n" +
    "                                    data-uib-tooltip=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.ToggleTooltip' | translate }}\"\n" +
    "                                    data-tooltip-popup-close-delay='1000'\n" +
    "                                    data-tooltip-append-to-body=\"true\"\n" +
    "                                    data-tooltip-trigger=\"mosueenter\"\n" +
    "                                    data-tooltip-placement=\"right\"\n" +
    "                                    role=\"group\"\n" +
    "                                    data-tooltip-class=\"confidentialityToggleCustomWidth\">\n" +
    "                                <button type=\"button\" aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality' | translate}}\" ng-disabled=\"vm.disableConfidentiality()\" class=\"btn btn-default btn-toggle\" data-ng-change=\"vm.onConfidentialityChanged()\" ng-model=\"data.isConfidential\" uib-btn-radio=\"false\" data-qe-id=\"bm-contactEditor-nonConfidentiality-button\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.NonConfidential' | translate}}</button>\n" +
    "                                <button type=\"button\" aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality' | translate}}\" ng-disabled=\"vm.disableConfidentiality()\" class=\"btn btn-default btn-toggle\" data-ng-change=\"vm.onConfidentialityChanged()\" ng-model=\"data.isConfidential\" uib-btn-radio=\"true\" data-qe-id=\"bm-contactEditor-confidentiality-button\">{{'Bluemoon.Core.Setup.Common.ContactEditor.Confidentiality.Confidential' | translate}}</button>\n" +
    "                            </div>\n" +
    "                            <div data-ng-if=\"data.isConfidential === true\">\n" +
    "                                <a href=\"\"\n" +
    "                                    id=\"edit-permission-groups-link\"\n" +
    "                                    class=\"btn btn-link\"\n" +
    "                                    data-ng-click=\"vm.onConfidentialityChanged(true)\">\n" +
    "                                    <span>\n" +
    "                                        <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.ChangePermissionGroups\"></span><i class=\"bento-icon-lock\"></i>\n" +
    "                                    </span>\n" +
    "                                </a>\n" +
    "                            </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "\n" +
    "        <!-- Country -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"countryCode\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.Country' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'countryCode')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"contact-countries\" name=\"countryCode\"\n" +
    "                            ng-model=\"data.$country\"\n" +
    "                            required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Language -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"language\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.PreferredLocale' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'preferredLocale')\"\n" +
    "             ng-if=\"vm.showLanguage()\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"language\"\n" +
    "                            ng-model=\"data.preferredLocale\"\n" +
    "                            required=\"true\"\n" +
    "                            custom-items=\"vm.languageOptions\"\n" +
    "                            label-property=\"translatedDescription\"\n" +
    "                            value-property=\"code\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Country of Nationality and Country of Residence -->\n" +
    "    <div class=\"row\" ng-if=\"vm.showAdditionalCountries() && !onvioContactEditorQuickAdd\">\n" +
    "        <!-- Country of Nationality-->\n" +
    "        <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"nationalityCountryCode\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Contact.NationalityCountry' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.errorFor(data, 'nationalityCountryCode')\" class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" custom-items=\"vm.cachedCountryOptions\" name=\"nationalityCountryCode\" ng-model=\"vm.$nationalityCountry\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Country -->\n" +
    "        <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"residenceCountryCode\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Contact.ResidenceCountry' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.errorFor(data, 'residenceCountryCode')\" class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" custom-items=\"vm.cachedCountryOptions\" name=\"residenceCountryCode\" ng-model=\"vm.$residenceCountry\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Uk Contact Data component -->\n" +
    "    <div data-ng-if=\"vm.showUkContactDataEditor() && !onvioContactEditorQuickAdd\">\n" +
    "        <firm-uk-contact-data-component\n" +
    "            contact=\"data\"\n" +
    "            uk-contact-data=\"onvioContactEditorUkContactData\"\n" +
    "            entity-types=\"vm.validContactEntityTypes\"\n" +
    "            on-change=\"vm.onContactDataComponentChanged(data)\">\n" +
    "        </firm-uk-contact-data-component>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- National Identities -->\n" +
    "    <div class=\"row\" data-ng-if=\"vm.showNationalIdentities()\">\n" +
    "        <div data-ng-repeat=\"countryCode in vm.supportedCountryCodes | orderBy:vm.countryNationalIdGroupOrderBy\">\n" +
    "            <div data-ng-repeat=\"groupedNidVm in vm.getGroupedNidVmsForContactCountryId(countryCode)\">\n" +
    "                <div class=\"col-md-12\" data-ng-if=\"vm.showGroupedNationalIdentity(groupedNidVm)\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                             data-bmp-control-group-field-id=\"nid-combo-{{::groupedNidVm.contactCountryId}}\"\n" +
    "                             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.GroupedNid.IdentityType' | translate}}\"\n" +
    "                             data-bmp-control-group-error=\"vm.errorFor(groupedNidVm, 'nationalIdentityKind')\"\n" +
    "                             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <div class=\"setup-common-contact-editor-custom-combo-loader-container\">\n" +
    "                                <bmp-enum-combo enum=\"custom\" name=\"nid-combo-{{::groupedNidVm.contactCountryId}}\"\n" +
    "                                                ng-model=\"groupedNidVm.nationalIdentityKind\"\n" +
    "                                                required=\"true\"\n" +
    "                                                custom-items=\"groupedNidVm.nationalIdentityKindOptions\"\n" +
    "                                                on-change=\"vm.onGroupedNidVmIdentityKindChanged(groupedNidVm)\"></bmp-enum-combo>\n" +
    "                                <div bento-busy-loader=\"groupedNidVm.optionsLoading\" busy-loader-size=\"small\" class=\"setup-common-contact-editor-custom-combo-loader\">\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                             data-bmp-control-group-field-id=\"nid-{{::groupedNidVm.contactCountryId}}-value\"\n" +
    "                             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.GroupedNid.Number' | translate}}\"\n" +
    "                             data-bmp-control-group-error=\"vm.errorFor(groupedNidVm, 'identity')\"\n" +
    "                             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                   id=\"nid-{{::groupedNidVm.contactCountryId}}-value\"\n" +
    "                                   name=\"nid-{{::groupedNidVm.contactCountryId}}-value\"\n" +
    "                                   data-qe-id=\"nid-{{::groupedNidVm.contactCountryId}}-value\"\n" +
    "                                   class=\"form-control\"\n" +
    "                                   data-tr-national-identity=\"{{groupedNidVm.nationalIdentityKind.id}}\"\n" +
    "                                   data-tr-national-identity-masked-value=\"groupedNidVm.masked\"\n" +
    "                                   data-ng-model=\"groupedNidVm.identity\"\n" +
    "                                   data-ng-change=\"vm.onGroupedNidVmIdentityChanged(groupedNidVm)\"\n" +
    "                                   data-ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                                   data-fef-maxlength=\"100\"\n" +
    "                                   data-bm-format-on-blur=\"\" />\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <div class=\"row\"\n" +
    "                     data-ng-form=\"\"\n" +
    "                     name=\"nidForm_KEY__{{::$index}}\"\n" +
    "                     data-ng-repeat=\"nid in vm.nationalIdentitiesForCountryCode(countryCode)\">\n" +
    "                    <!-- national identity -->\n" +
    "                    <div data-ng-if=\"vm.showNationalIdentity(nid.kind.id)\"\n" +
    "                         data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"nid-{{::nid.kind.id}}\"\n" +
    "                         data-bmp-control-group-label=\"{{nid.kind.name}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.errorFor(nid, 'identity')\"\n" +
    "                         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"nid-{{::nid.kind.id}}\"\n" +
    "                               name=\"nid-{{::nid.kind.id}}\"\n" +
    "                               data-qe-id=\"nid-{{::nid.kind.id}}\"\n" +
    "                               class=\"form-control\"\n" +
    "                               ng-disabled=\"onvioContactEditorQuickAddExisting\"\n" +
    "                               data-tr-national-identity=\"{{nid.kind.id}}\"\n" +
    "                               data-tr-national-identity-masked-value=\"nid.masked\"\n" +
    "                               data-ng-model=\"nid.identity\"\n" +
    "                               data-ng-change=\"nid.$dirty = true\"\n" +
    "                               data-fef-maxlength=\"100\"\n" +
    "                               data-bm-format-on-blur=\"\" />\n" +
    "                    </div>\n" +
    "                    <!-- country of registration -->\n" +
    "                    <div data-ng-if=\"vm.showCountryOfRegistration(nid)\"\n" +
    "                         data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"nid-{{::nid.kind.id}}-countryOfRegistration\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.CountryOfRegistration' | translate}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.errorFor(nid, 'countryOfRegistration')\"\n" +
    "                         class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"nid-{{::nid.kind.id}}-countryOfRegistration\"\n" +
    "                               name=\"nid-{{::nid.kind.id}}-countryOfRegistration\"\n" +
    "                               data-qe-id=\"nid-{{::nid.kind.id}}-countryOfRegistration\"\n" +
    "                               class=\"form-control\"\n" +
    "                               data-ng-model=\"nid.countryOfRegistration\"\n" +
    "                               data-ng-change=\"nid.$dirty = true\"\n" +
    "                               ng-disabled=\"vm.disableCountryOfRegistration(nid)\"\n" +
    "                               data-fef-maxlength=\"100\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-3\"\n" +
    "                             data-ng-if=\"vm.showRemoveNationalIdentity(countryCode)\">\n" +
    "\n" +
    "                            <!-- don't bother making this ng-style into an actual css style. bento styles just\n" +
    "                    end up overwrite it. -->\n" +
    "                            <button type=\"button\"\n" +
    "                                    data-qe-id=\"nid-{{::countryCode}}-remove-button\"\n" +
    "                                    class=\"btn btn-link btn-xs setup-common-contact-editor-remove-nid-button\"\n" +
    "                                    ng-style=\"{'padding-left': '0px'}\"\n" +
    "                                    data-ng-click=\"vm.removeNationalIdentity(countryCode)\">\n" +
    "\n" +
    "                                <span class=\"glyphicon glyphicon-remove\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "        <div bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "            <div class=\"col-md-12\"\n" +
    "                data-ng-if=\"vm.showAddNationalIdentity()\">\n" +
    "                <!-- Add Another National Identity -->\n" +
    "                <div class=\"dropdown setup-common-contact-editor-show-hide-national-id-link pull-left\" uib-dropdown=\"\" data-is-open=\"vm.pcExpanded\">\n" +
    "                    <a href id=\"add_remove_nid_anchor\" uib-dropdown-toggle=\"\" class=\"dropdown-toggle btn btn-link no-padding-l\" data-qe-id=\"nid-add-button\">\n" +
    "                        <span class=\"glyphicon glyphicon-plus-sign\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.ShowHideNationalID\"></span> <span class=\"caret setup-common-contact-editor-addremove-caret\"></span>\n" +
    "                    </a>\n" +
    "                    <ul class=\"dropdown-menu\"> <!-- TODO = KMS - need to revise this so it is data driven and will sort by name in different languages. -->\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('AR')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('AR')\" data-qe-id=\"nid-AR-add-button\" data-translate=\"Core.Enums.ContactCountry.AR\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('AU')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('AU')\" data-qe-id=\"nid-AU-add-button\" data-translate=\"Core.Enums.ContactCountry.AU\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('BR')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('BR')\" data-qe-id=\"nid-BR-add-button\" data-translate=\"Core.Enums.ContactCountry.BR\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('CA')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('CA')\" data-qe-id=\"nid-CA-add-button\" data-translate=\"Core.Enums.ContactCountry.CA\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('GB')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('GB')\" data-qe-id=\"nid-GB-add-button\" data-translate=\"Core.Enums.ContactCountry.GB\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('IN')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('IN')\" data-qe-id=\"nid-IN-add-button\" data-translate=\"Core.Enums.ContactCountry.IN\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('US')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('US')\" data-qe-id=\"nid-US-add-button\" data-translate=\"Core.Enums.ContactCountry.US\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "\n" +
    "                        <li data-ng-if=\"!vm.showNationalIdentity('ZZ')\">\n" +
    "                            <a href data-ng-click=\"vm.addNationalIdentity('ZZ')\" data-qe-id=\"nid-ZZ-add-button\" data-translate=\"Core.Enums.ContactCountry.ZZ\">\n" +
    "                            </a>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "        <!-- Nickname -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"nickname\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.Nickname' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'nickname')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"nickname\"\n" +
    "                   name=\"nickname\"\n" +
    "                   data-qe-id=\"nickname\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.nickname\"\n" +
    "                   data-fef-maxlength=\"250\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "        <!-- Job Title -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"jobTitle\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.JobTitle' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'jobTitle')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"jobTitle\"\n" +
    "                   name=\"jobTitle\"\n" +
    "                   data-qe-id=\"jobTitle\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.jobTitle\"\n" +
    "                   data-fef-maxlength=\"250\" />\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- CompanyName (person) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-hide=\"!vm.isPerson()\"\n" +
    "             data-bmp-control-group-field-id=\"companyName\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.CompanyName' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.errorFor(data, 'companyName')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                   id=\"companyName\"\n" +
    "                   name=\"companyName\"\n" +
    "                   data-qe-id=\"companyName\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"data.companyName\"\n" +
    "                   data-fef-maxlength=\"250\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "    <!-- Date of Birth -->\n" +
    "    <div class=\"row\" ng-if=\"vm.showDateOfBirth() && !onvioContactEditorQuickAdd\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"dateOfBirth\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Contact.DateOfBirth' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(data, 'dateOfBirth')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-bento-datepicker-wrapper id=\"dateOfBirth\"\n" +
    "                                          name=\"dateOfBirth\"\n" +
    "                                          ng-model=\"data.dateOfBirth\">\n" +
    "            </bmp-bento-datepicker-wrapper>\n" +
    "        </div>\n" +
    "        <div data-bmp-control-group=\"\" ng-if=\"vm.showDateOfBirth()\" data-bmp-control-group-field-id\n" +
    "        =\"dateOfDeath\" data-bmp-control-group-label=\"{{'Core.Captions.Contact.DateOfDeath' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.ValidateDateofDeath()\" class=\"col-md-4 col-sm-6 col-xs -12\">\n" +
    "        <bmp-bento-datepicker-wrapper id=\"dateOfDeath\" name=\"dateOfDeath\" ng-model=\"data.dateOfDeath\"></bmp-bento-datepicker-wrapper>\n" +
    "    </div>\n" +
    "\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"firmCards\" ng-if=\" vm.firmSection \">\n" +
    "        <h3 class=\"setup-section-header-margin\" data-translate=\"Bluemoon.Core.Setup.Firm.Detail.Navigation.General.FirmLogo\"></h3>\n" +
    "        <div bento-carousel gutter-size=\"20px\" offsetHeight=\"0\" slideshow=\"false\" hide-arrows=\"true\">\n" +
    "            <ul class=\"list-group\">\n" +
    "                <li class=\"firmCards-square\" bento-carousel-card bm-if-has-license=\"Onvio.FirmSquareLogo\">\n" +
    "                    <div class=\"carousel card-1\">\n" +
    "                        <div ng-hide=\"vm.imageSelectionDiv\" class=\"one\">\n" +
    "                        <div class=\"modal-header\">\n" +
    "                            <h3>{{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.SquareLogo' | translate}}</h3>\n" +
    "                        </div>\n" +
    "                        <div class=\"modal-body text-center\">\n" +
    "                            <p>\n" +
    "                            <i id=\"imageIconSize\" class=\"glyphicon glyphicon-picture\"></i>\n" +
    "                            <br />\n" +
    "                            </p>\n" +
    "                        <div class=\"drop-box-text\">\n" +
    "                            <a ng-click=\"vm.headerImageChange('square', 1, 130, true, true ,vm.resImage)\" class=\"btn btn-default btn-dynamic btn-text-ellipsis\" role=\"button\">\n" +
    "                                {{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.BrowseForImage' | translate}}\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                        </div>\n" +
    "                        </div>\n" +
    "                        <div ng-hide=\"vm.showImageDiv\" class=\"two\">\n" +
    "                            <div class=\"modal-header\">\n" +
    "                                <h3 class=\"logoText\">{{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.SquareLogo' | translate}}</h3>\n" +
    "                                <span id=\"editIcon\" class=\"bento-icon-edit\" ng-click=\"vm.headerImageChange('square', 1, 130, true, true, vm.resImage)\"></span>\n" +
    "                            </div>\n" +
    "                            <div class=\"modal-body text-center\">\n" +
    "                            <div class=\"\">\n" +
    "                                <span>\n" +
    "                                    <img class=\"preview-image\" ng-src=\"{{ vm.resImage }}\" />\n" +
    "                                </span>\n" +
    "                            </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li class=\"firmCards-rectangle\" bento-carousel-card>\n" +
    "                        <div class=\"carousel card-1 rectangleCard\">\n" +
    "                                <div ng-hide=\"vm.rectangleImageSelectionDiv\" class=\"one\">\n" +
    "                                <div class=\"modal-header\">\n" +
    "                                    <h3>{{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.RectangleLogo' | translate}}</h3>\n" +
    "                                </div>\n" +
    "                                <div class=\"modal-body text-center\">\n" +
    "                                    <p>\n" +
    "                                    <i id=\"imageIconSize\" class=\"glyphicon glyphicon-picture\"></i>\n" +
    "                                    <br />\n" +
    "                                    </p>\n" +
    "                                <div class=\"drop-box-text\">\n" +
    "                                    <a ng-click=\"vm.headerImageChange('rectangle', 3, 130, true, true, vm.rectangleImage)\" class=\"btn btn-default btn-dynamic btn-text-ellipsis\" role=\"button\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.BrowseForImage' | translate}}\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                                </div>\n" +
    "                                </div>\n" +
    "                                <div ng-hide=\"vm.showRectangleImageDiv\" class=\"two\">\n" +
    "                                    <div class=\"modal-header\">\n" +
    "                                        <h3 class=\"logoText\">{{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General.RectangleLogo' | translate}}</h3>\n" +
    "                                        <span id=\"editIcon\" class=\"bento-icon-edit\" ng-click=\"vm.headerImageChange('rectangle', 3, 130, true, true, vm.rectangleImage)\"></span>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"modal-body text-center\">\n" +
    "                                    <div>\n" +
    "                                        <span>\n" +
    "                                            <img class=\"header-rectangle-image-preview\" ng-src=\"{{ vm.rectangleImage }}\" />\n" +
    "                                        </span>\n" +
    "                                    </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "        <bm-image-upload-modal api=\"vm.imageUploadApi\"></bm-image-upload-modal>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Addresses, Phones, Emails, and Online Presences (dynamic lists) -->\n" +
    "    <div class=\"row\" ng-if=\"!onvioContactEditorQuickAdd\">\n" +
    "        <!-- Addresses -->\n" +
    "        <div class=\"col-md-12 setup-common-contacts-editor-list\">\n" +
    "            <h3 class=\"setup-section-header-margin\" data-translate=\"Core.Captions.ContactAddress.ClassOther\"></h3>\n" +
    "            <div data-ng-repeat=\"address in data.addresses\"\n" +
    "                 class=\"setup-common-contact-editor-address-area\">\n" +
    "\n" +
    "    			<fieldset class=\"well bm-well\">\n" +
    "                        <span class=\"col-md-11 col-sm-10 col-xs-10\">\n" +
    "                            <!-- Address Type -->\n" +
    "                            <div class=\"row\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"addressType_KEY__{{::$index}}\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.ContactAddress.AddressType' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.errorFor(address, 'addressType')\"\n" +
    "                                    class=\"col-md-3 col-sm-3 col-xs-8 setup-common-contact-editor-address-section\">\n" +
    "                                    <div data-bento-select>\n" +
    "                                        <select id=\"addressType_KEY__{{::$index}}\"\n" +
    "                                                name=\"addressType_KEY__{{::$index}}\"\n" +
    "                                                data-qe-id=\"addressType_KEY__{{::$index}}\"\n" +
    "                                                class=\"form-control\"\n" +
    "                                                data-ng-model=\"address.addressType\"\n" +
    "                                                data-ng-change=\"vm.onAddressTypeChanged(address, $index)\"\n" +
    "                                                data-ng-options=\"option as option.name for option in vm.addressTypeOptionsList track by option.id\">\n" +
    "                                            <option class=\"setup-hidden-default-option\" value=\"\" disabled=\"disabled\"></option>\n" +
    "                                        </select>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-hide=\"!vm.showAddressTypeSpecified(address)\"\n" +
    "                                    data-bmp-control-group-field-id=\"addressTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Phones.Fields.OtherDescription' | translate}}\"\n" +
    "                                    class=\"col-md-3 col-sm-3 col-xs-8 setup-common-contact-editor-address-section\">\n" +
    "                                    <input autocomplete=\"off\" id=\"addressTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                        name=\"addressTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                        data-qe-id=\"addressTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                        class=\"form-control\"\n" +
    "                                        data-ng-model=\"address.addressType.name\"\n" +
    "                                        bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusAddress.{{$index}}'\"\n" +
    "                                        data-fef-maxlength=\"250\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div ng-if=\"address.$country.id === 'NL'\" ng-include=\"'core-setup/common/contact-editor/contact-editor-address-nl.html'\"></div>\n" +
    "                            <div ng-if=\"address.$country.id !== 'NL'\" ng-include=\"'core-setup/common/contact-editor/contact-editor-address-default.html'\"></div>\n" +
    "\n" +
    "                            <!-- Address Usages -->\n" +
    "                            <div class=\"row\">\n" +
    "                                <div class=\"col-md-8\" style=\"padding-left:0px; padding-top:5px\">\n" +
    "                                    <div bento-multiselect-overlay\n" +
    "                                        ng-model=\"vm.addressUsageVms[$index].selected\"\n" +
    "                                        list-data=\"vm.addressUsageVms[$index].allUsages\"\n" +
    "                                        ng-change=\"vm.onAddressUsageChanged($index, vm.addressUsageVms[$index].selected , address)\"\n" +
    "                                        select-button-text=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.UseFor' | translate}}\"\n" +
    "                                        edit-button-text=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.UseFor' | translate}}\"\n" +
    "                                        class=\"setup-bento-multiselect-overlay setup-common-contact-editor-address-multiselect-overlay\">\n" +
    "\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <div class=\"form-control-static setup-common-contact-editor-use-for-text\">\n" +
    "                                        <span class=\"label label-info setup-common-contact-editor-usage-badge\"\n" +
    "                                                data-ng-repeat=\"usage in vm.addressUsageVms[$index].selectedUsages\">\n" +
    "                                            {{usage.name | bluemoonRequiredMark:vm.addressUsageIsRequired(usage.id)}}\n" +
    "                                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                                    data-qe-id=\"addressUsage-remove-{{usage.name}}_KEY__{{::$parent.$index}}-button\"\n" +
    "                                                    data-ng-click=\"vm.onUsageDeletedFromLabel(usage, address, vm.addressUsageVms[$parent.$index])\"\n" +
    "                                                    data-ng-show=\"usage.name !== 'Primary'\"></span>\n" +
    "                                        </span>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </span>\n" +
    "                        <span class=\"col-md-1 col-sm-2 col-xs-2\" style=\"padding:0px\">\n" +
    "                            <button id=\"address-remove_KEY__{{::$index}}-button\"\n" +
    "                                    name=\"address-remove_KEY__{{::$index}}-button\"\n" +
    "                                    data-qe-id=\"address-remove_KEY__{{::$index}}-button\"\n" +
    "                                    type=\"button\"\n" +
    "                                    class=\"btn btn-link\"\n" +
    "                                    style=\"padding:0px; text-align:center\"\n" +
    "                                    data-ng-show=\"vm.allowAddressRemove(address)\"\n" +
    "                                    data-ng-click=\"vm.onDeleteContactAddress($index)\"\n" +
    "                                    aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Remove' | translate}} {{'Core.Captions.ContactAddress.Id' | translate}} #{{::$index + 1}}\">\n" +
    "                                <span class=\"glyphicon glyphicon-remove\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                            </button>\n" +
    "                        </span>\n" +
    "    			</fieldset>\n" +
    "            </div>\n" +
    "             <!-- Add a new address -->\n" +
    "            <a href id=\"address-add-button\"\n" +
    "               class=\"btn btn-link no-padding-l setup-common-contact-editor-add-child-entity\"\n" +
    "               type=\"button\"\n" +
    "               data-qe-id=\"address-add-button\"\n" +
    "               data-ng-click=\"vm.addNewContactAddress()\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.AddAddress\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Phone numbers -->\n" +
    "        <div class=\"col-md-12 setup-common-contacts-editor-list\">\n" +
    "            <h3 class=\"setup-section-header-margin\" data-translate=\"Core.Captions.ContactPhone.ClassOther\"></h3>\n" +
    "            <div class=\"setup-common-contact-editor-phone-area\"\n" +
    "                 data-ng-repeat=\"phone in data.phoneNumbers\"\n" +
    "                 data-ng-form=\"\"\n" +
    "                 name=\"phoneForm_KEY__{{::$index}}\"\n" +
    "                 data-ng-if=\"vm.showDeletableData(phone)\">\n" +
    "                <fieldset class=\"well bm-well\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <span class=\"col-md-11 col-sm-10 col-xs-10\">\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"phoneNumber_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(phone, 'phoneNumber')\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactPhone.PhoneNumber' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12 setup-common-contact-editor-phone-section\">\n" +
    "                                <input autocomplete=\"off\" type=\"tel\"\n" +
    "                                    id=\"phoneNumber_KEY__{{::$index}}\"\n" +
    "                                    name=\"phoneNumber_KEY__{{::$index}}\"\n" +
    "                                    data-qe-id=\"phoneNumber_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"phone.phoneNumber\"\n" +
    "                                    data-fef-maxlength=\"250\"\n" +
    "                                    ng-keyup=\"vm.phoneNumberFormatKeyup(phone, $event)\"\n" +
    "                                    ng-blur=\"vm.phoneNumberFormatBlur(phone)\" />\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"extension_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactPhone.Extension' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(phone, 'extension')\"\n" +
    "                                class=\"col-md-2 col-sm-2 col-xs-12 setup-common-contact-editor-phone-section\">\n" +
    "\n" +
    "                                <input autocomplete=\"off\" type=\"tel\"\n" +
    "                                    id=\"extension_KEY__{{::$index}}\"\n" +
    "                                    name=\"extension_KEY__{{::$index}}\"\n" +
    "                                    data-qe-id=\"extension_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"phone.extension\"\n" +
    "                                    data-fef-maxlength=\"250\" />\n" +
    "                            </div>\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"phoneType_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactPhone.PhoneType' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(phone, 'phoneType')\"\n" +
    "                                class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-phone-section\">\n" +
    "                                <div data-bento-select>\n" +
    "                                    <select id=\"phoneType_KEY__{{::$index}}\"\n" +
    "                                            name=\"phoneType_KEY__{{::$index}}\"\n" +
    "                                            data-qe-id=\"phoneType_KEY__{{::$index}}\"\n" +
    "                                            class=\"form-control\"\n" +
    "                                            data-ng-model=\"phone.phoneType\"\n" +
    "                                            data-ng-change=\"vm.onPhoneTypeChanged(phone, $index)\"\n" +
    "                                            data-ng-options=\"option as option.name for option in vm.phoneTypeOptionsList track by option.id\">\n" +
    "                                        <option class=\"setup-hidden-default-option\" value=\"\" disabled=\"disabled\"></option>\n" +
    "                                    </select>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-hide=\"!vm.showPhoneTypeSpecified(phone)\"\n" +
    "                                data-bmp-control-group-field-id=\"phoneTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Phones.Fields.OtherDescription' | translate}}\"\n" +
    "                                class=\"col-md-3 col-sm-3 col-xs-12 setup-common-contact-editor-phone-section\">\n" +
    "                                <input autocomplete=\"off\" id=\"phoneTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    name=\"phoneTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    data-qe-id=\"phoneTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"phone.phoneType.name\"\n" +
    "                                    bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusPhone.{{$index}}'\"\n" +
    "                                    data-fef-maxlength=\"250\" />\n" +
    "                            </div>\n" +
    "                        </span>\n" +
    "                        <button id=\"phone-remove_KEY__{{::$index}}-button\"\n" +
    "                                name=\"phone-remove_KEY__{{::$index}}-button\"\n" +
    "                                data-qe-id=\"phone-remove_KEY__{{::$index}}-button\"\n" +
    "                                type=\"button\"\n" +
    "                                style=\"padding:0px; text-align:center;\"\n" +
    "                                class=\"col-md-1 col-sm-2 col-xs-2 btn btn-link\"\n" +
    "                                data-ng-show=\"vm.allowPhoneRemove(phone)\"\n" +
    "                                data-ng-click=\"vm.onDeleteContactPhone($index)\"\n" +
    "                                aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Remove' | translate}} {{'Core.Captions.AUPreparerRole.ContactPhoneId' | translate}} #{{::$index + 1}}\">\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "                            <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-6\">\n" +
    "                            <div class=\"input-group\">\n" +
    "                                <label class=\"ng-binding\" aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.UseAsPrimaryPhone' | translate}}\"\n" +
    "                                for=\"useAsPrimaryPhone\">\n" +
    "                                    <input id=\"useAsPrimaryPhone\" autocomplete=\"off\" autocomplete=\"off\"\n" +
    "                                        type=\"checkbox\"\n" +
    "                                        ng-click=\"vm.onSelectPhonePrimary(phone)\"\n" +
    "                                        ng-checked=\"data.phoneNumbers[$index].isPrimary\"\n" +
    "                                        ng-disabled=\"data.phoneNumbers[$index].isPrimary\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Common.ContactEditor.UseAsPrimaryPhone' | translate}}\n" +
    "                                </label>\n" +
    "\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </fieldset>\n" +
    "            </div>\n" +
    "            <a href id=\"phone-add-button\"\n" +
    "               class=\"btn btn-link no-padding-l setup-common-contact-editor-add-child-entity\"\n" +
    "               type=\"button\"\n" +
    "               data-qe-id=\"phone-add-button\"\n" +
    "               data-ng-click=\"vm.addNewContactPhone()\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.AddPhone\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Email -->\n" +
    "        <div class=\"col-md-12 setup-common-contacts-editor-list\">\n" +
    "            <h3 class=\"setup-section-header-margin\" data-translate=\"Core.Captions.Contact.EmailAddresses\"></h3>\n" +
    "            <div class=\"setup-common-contact-editor-email-area\"\n" +
    "                 data-ng-repeat=\"email in data.emailAddresses\"\n" +
    "                 data-ng-form=\"\"\n" +
    "                 name=\"emailForm_KEY__{{::$index}}\"\n" +
    "                 data-ng-if=\"vm.showDeletableData(email)\">\n" +
    "                <fieldset class=\"well bm-well\">\n" +
    "                    <span class=\"col-md-11 col-sm-10 col-xs-10\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"emailAddress_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactEmail.EmailAddress' | translate | bmRequiredMark:vm.isMandatoryClientEmail && email.isPrimary}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(email, 'emailAddress')\"\n" +
    "                                class=\"col-md-4 col-sm-6 col-xs-12 setup-common-contact-editor-email-address-section\">\n" +
    "                                <input autocomplete=\"off\" type=\"text\"\n" +
    "                                    id=\"emailAddress_KEY__{{::$index}}\"\n" +
    "                                    name=\"emailAddress_KEY__{{::$index}}\"\n" +
    "                                    data-qe-id=\"emailAddress_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"email.emailAddress\"\n" +
    "                                    data-fef-maxlength=\"250\"\n" +
    "                                    data-blue-moon-email-validation\n" +
    "                                    data-ng-required=\"vm.isMandatoryClientEmail && email.isPrimary\" />\n" +
    "                                </div>\n" +
    "\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"emailType_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactEmail.EmailType' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(email, 'emailType')\"\n" +
    "                                class=\"col-md-2 col-sm-3 col-xs-12 setup-common-contact-editor-email-address-section\">\n" +
    "                                <div data-bento-select>\n" +
    "                                    <select id=\"emailType_KEY__{{::$index}}\"\n" +
    "                                            name=\"emailType_KEY__{{::$index}}\"\n" +
    "                                            data-qe-id=\"emailType_KEY__{{::$index}}\"\n" +
    "                                            class=\"form-control\"\n" +
    "                                            data-ng-model=\"email.emailType\"\n" +
    "                                            data-ng-change=\"vm.onEmailTypeChanged(email, $index)\"\n" +
    "                                            data-ng-options=\" option as option.name for option in vm.emailTypeOptionsList track by option.id\">\n" +
    "                                        <option class=\"setup-hidden-default-option\" value=\"\" disabled=\"disabled\"></option>\n" +
    "                                    </select>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-hide=\"!vm.showEmailTypeSpecified(email)\"\n" +
    "                                data-bmp-control-group-field-id=\"emailTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.OtherDescription' | translate}}\"\n" +
    "                                class=\"col-md-2 col-sm-3 col-xs-12 setup-common-contact-editor-email-address-section\">\n" +
    "                                <input autocomplete=\"off\" id=\"emailTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    name=\"emailTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    data-qe-id=\"emailTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"email.emailType.name\"\n" +
    "                                    bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusEmail.{{$index}}'\"\n" +
    "                                    data-fef-maxlength=\"250\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-md-6 setup-common-contact-editor-email-address-section\">\n" +
    "                                <div class=\"input-group\">\n" +
    "                                    <label class=\"ng-binding\" for=\"useAsPrimaryEmailAddress\"\n" +
    "                                    aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.UseAsPrimaryEmail' | translate}}\">\n" +
    "                                        <input autocomplete=\"off\"\n" +
    "                                            id=\"useAsPrimaryEmailAddress\"\n" +
    "                                            type=\"checkbox\"\n" +
    "                                            ng-click=\"vm.onSelectEmailPrimary(email)\"\n" +
    "                                            ng-checked=\"data.emailAddresses[$index].isPrimary\"\n" +
    "                                            ng-disabled=\"data.emailAddresses[$index].isPrimary\">\n" +
    "                                            {{'Bluemoon.Core.Setup.Common.ContactEditor.UseAsPrimaryEmail' | translate}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </span>\n" +
    "                    <span class=\"col-md-1 col-sm-2 col-xs-2\" style=\"padding:0px\" style=\"padding:0px; text-align:center\">\n" +
    "                        <button id=\"email-remove_KEY__{{::$index}}-button\"\n" +
    "                                name=\"email-remove_KEY__{{::$index}}-button\"\n" +
    "                                data-qe-id=\"email-remove_KEY__{{::$index}}-button\"\n" +
    "                                type=\"button\"\n" +
    "                                class=\"btn btn-link \"\n" +
    "                                data-ng-show=\"vm.allowEmailRemove(email)\"\n" +
    "                                data-ng-click=\"vm.onDeleteContactEmail($index)\"\n" +
    "                                aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Remove' | translate}} {{'Core.Captions.ContactEmail.EmailAddress' | translate}} #{{::$index + 1}}\">\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                        </button>\n" +
    "                    </span>\n" +
    "                </fieldset>\n" +
    "            </div>\n" +
    "            <a href id=\"add_another_email_button\"\n" +
    "               class=\"btn btn-link no-padding-l setup-common-contact-editor-add-child-entity\"\n" +
    "               type=\"button\"\n" +
    "               data-qe-id=\"email-add-button\"\n" +
    "               data-ng-click=\"vm.addNewContactEmail()\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.AddEmail\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- onvio/client center account -->\n" +
    "        <div ng-if=\"vm.hasTRID\" class=\"col-md-12 setup-common-contacts-editor-list\">\n" +
    "                <h3 class=\"setup-section-header-margin\" data-translate=\"{{'Bluemoon.Core.Setup.Assistance.staff.OnvioOrClientcenterAccount' | translate}}\"></h3>\n" +
    "                <div class=\"setup-common-contact-editor-email-area\">\n" +
    "                    <fieldset class=\"well bm-well\">\n" +
    "                        <span class=\"col-md-11 col-sm-10 col-xs-10\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"hasTRIDEmail\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Assistance.Staff.EmailAddress' | translate}}\"\n" +
    "                                    data-bmp-control-group-label-hide=\"false\"\n" +
    "                                    class=\"col-md-4 col-sm-6 col-xs-12 setup-common-contact-editor-email-address-section\">\n" +
    "                                    <input type=\"text\" name=\"hasTRIDEmail\" class=\"form-control\" data-ng-model=\"vm.hasTRIDEmail\"\n" +
    "                                        ng-readonly=\"vm.hasTRIDEmail\">\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </span>\n" +
    "                    </fieldset>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "        <!-- Online Presence -->\n" +
    "        <div class=\"col-md-12 setup-common-contacts-editor-list\">\n" +
    "            <h3 class=\"setup-section-header-margin\" data-translate=\"Core.Captions.Contact.SocialMedia\"></h3>\n" +
    "            <div class=\"setup-common-contact-editor-social-medium-area\"\n" +
    "                 data-ng-repeat=\"socialMedium in data.socialMedia\"\n" +
    "                 data-ng-form=\"\"\n" +
    "                 name=\"socialMediaForm_KEY__{{::$index}}\"\n" +
    "                 data-ng-if=\"vm.showDeletableData(socialMedium)\">\n" +
    "                <fieldset class=\"well bm-well\">\n" +
    "                    <span class=\"col-md-11 col-sm-10 col-xs-10\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"url_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactSocialMedium.Url' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(socialMedium, 'url')\"\n" +
    "                                class=\"col-md-4 col-sm-6 col-xs-12 setup-common-contact-editor-social-medium-section\">\n" +
    "                                <div class=\"input-group bmp-input-group-icon-only\">\n" +
    "                                    <input autocomplete=\"off\" type=\"url\"\n" +
    "                                        id=\"url_KEY__{{$index}}\"\n" +
    "                                        name=\"url_KEY__{{$index}}\"\n" +
    "                                        data-qe-id=\"url_KEY__{{$index}}\"\n" +
    "                                        class=\"form-control\"\n" +
    "                                        data-ng-model=\"socialMedium.url\"\n" +
    "                                        setup-contact-editor-url-protocol-defaulter=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        data-fef-maxlength=\"250\" />\n" +
    "                                    <span class=\"input-group-btn\">\n" +
    "                                        <a class=\"btn btn-default\" target=\"_blank\"\n" +
    "                                        aria-label=\"Social Media URL\" role=\"link\"\n" +
    "                                        ng-href=\"{{socialMedium.url}}\"\n" +
    "                                        data-qe-id=\"url-go_KEY__{{$index}}-button\"\n" +
    "                                        ng-disabled=\"\">\n" +
    "                                            <i class=\"bento-icon-newtab\"></i>\n" +
    "                                        </a>\n" +
    "                                    </span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"socialMediumType_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ContactSocialMedium.SocialMediumType' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.errorFor(socialMedium, 'socialMediumType')\"\n" +
    "                                class=\"col-md-2 col-sm-3 col-xs-12 setup-common-contact-editor-social-medium-section\">\n" +
    "                                <div data-bento-select>\n" +
    "                                    <select id=\"socialMediumType_KEY__{{::$index}}\"\n" +
    "                                            name=\"socialMediumType_KEY__{{::$index}}\"\n" +
    "                                            data-qe-id=\"socialMediumType_KEY__{{::$index}}\"\n" +
    "                                            class=\"form-control\"\n" +
    "                                            data-ng-model=\"socialMedium.socialMediumType\"\n" +
    "                                            data-ng-change=\"vm.onSocialMediumTypeChanged(socialMedium, $index)\"\n" +
    "                                            data-ng-options=\"option as option.name for option in vm.socialMediumTypeOptionsList track by option.id\">\n" +
    "                                        <option class=\"setup-hidden-default-option\" value=\"\" disabled=\"disabled\"></option>\n" +
    "                                    </select>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-hide=\"!vm.showSocialMediumTypeSpecified(socialMedium)\"\n" +
    "                                data-bmp-control-group-field-id=\"socialMediumTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Contacts.Addresses.Fields.OtherDescription' | translate}}\"\n" +
    "                                class=\"col-md-2 col-sm-3 col-xs-12 setup-common-contact-editor-social-medium-section\">\n" +
    "                                <input autocomplete=\"off\" id=\"socialMediumTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    name=\"socialMediumTypeSpecified_KEY__{{::$index}}\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"socialMedium.socialMediumType.name\"\n" +
    "                                    bm-focus-on-event=\"'bm.core.setup.common.ContactEditor.focusSocialMedium.{{$index}}'\"\n" +
    "                                    data-fef-maxlength=\"250\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </span>\n" +
    "                    <span class=\"col-md-1 col-sm-2 col-xs-2\">\n" +
    "                        <button id=\"socialMedium-remove_KEY__{{$index}}-button\"\n" +
    "                                name=\"socialMedium-remove_KEY__{{$index}}-button\"\n" +
    "                                data-qe-id=\"socialMedium-remove_KEY__{{$index}}-button\"\n" +
    "                                type=\"button\"\n" +
    "                                class=\"btn btn-link\"\n" +
    "                                style=\"padding:0px; text-align:center;\"\n" +
    "                                data-ng-show=\"vm.allowSocialMediumRemove(socialMedium)\"\n" +
    "                                data-ng-click=\"vm.onDeleteContactSocialMedium($index)\"\n" +
    "                                aria-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Remove' | translate}} {{'Core.Captions.Contact.SocialMedia' | translate}} #{{::$index + 1}}\">\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.Remove\"></span>\n" +
    "                        </button>\n" +
    "                    </span>\n" +
    "                </fieldset>\n" +
    "            </div>\n" +
    "            <a href id=\"socialmedium-add-button\"\n" +
    "               class=\"btn btn-link no-padding-l setup-common-contact-editor-add-child-entity\"\n" +
    "               type=\"button\"\n" +
    "               data-qe-id=\"socialmedium-add-button\"\n" +
    "               data-ng-click=\"vm.addNewContactSocialMedium()\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span> <span data-translate=\"Bluemoon.Core.Setup.Common.ContactEditor.AddSocialMedium\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "    <!-- This control exists only to keep the focus on the page when you tab\n" +
    "        off of the contact selector input, instead of moving to the address bar, where we can no longer change it. -->\n" +
    "    <input autocomplete=\"off\" type=\"text\" style=\"width:0px;height:0px;border-width:0px;padding:0px;margin:0px;\" />\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("core-setup/common/contact-selector-dialog/contact-selector-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/contact-selector-dialog/contact-selector-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"displayAsDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"vm.onClose()\"\n" +
    "                aria-hidden=\"true\">\n" +
    "            &times;\n" +
    "        </button>\n" +
    "        {{'Bluemoon.Core.Setup.Common.ContactSelectorDialogModal.DialogHeaderText' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form name=\"dialogForm\">\n" +
    "            <div class=\"row\"\n" +
    "                 ng-show=\"vm.showWarning()\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <uib-alert type=\"warning\">{{'Bluemoon.Core.Setup.Common.ContactSelectorDialogModal.UnsaveChangesWarning' | translate}}</uib-alert>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\"\n" +
    "                 style=\"margin-bottom: 15px\">\n" +
    "                 <!-- /* i18nextract */'Core.Captions.Contact.ClassOne' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"contactSelector\"\n" +
    "                     data-bmp-control-group-label=\"{{'Core.Captions.Contact.ClassOne' | translate | bmRequiredMark}}\"\n" +
    "                     class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <bmp-select-combo class=\"setup-common-contact-selector\"\n" +
    "                                      list=\"contacts#email\"\n" +
    "                                      id=\"contactSelector\"\n" +
    "                                      filter=\"vm.filter\"\n" +
    "                                      data-ng-model=\"vm.selectedContact\"\n" +
    "                                      on-change=\"vm.onSelectContact(item)\"\n" +
    "                                      bmp-default-focus=\"true\"\n" +
    "                                      custom-template=\"true\"\n" +
    "                                      ng-if=\"!vm.useContactForRelationshipSelector()\"></bmp-select-combo>\n" +
    "                    <bmp-select-combo list=\"relationships-select-existing-contact\"\n" +
    "                                      id=\"contactSelectorByRelationship\"\n" +
    "                                      custom-service=\"vm.contactForRelationshipTypeProvider\"\n" +
    "                                      data-ng-model=\"vm.selectedContact\"\n" +
    "                                      on-change=\"vm.onSelectContact(item)\"\n" +
    "                                      bmp-default-focus=\"true\"\n" +
    "                                      custom-template=\"true\"\n" +
    "                                      ng-if=\"vm.useContactForRelationshipSelector()\"></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "            <div class=\"modal-footer\">\n" +
    "                <button id=\"displayAsDialog.ok\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.onOk()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                        data-ng-disabled=\"vm.okDisabled()\"\n" +
    "                        bm-focus-on-enable></button>\n" +
    "                <button id=\"displayAsDialog.cancel\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.onCancel()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                        formnovalidate></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/display-as-dialog/display-as-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/display-as-dialog/display-as-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"displayAsDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"vm.onClose()\"\n" +
    "                aria-hidden=\"true\">\n" +
    "            &times;\n" +
    "        </button>\n" +
    "        {{vm.dialogHeaderText}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form id=\"displayAsModalForm\" name=\"displayAsModalForm\">\n" +
    "            <div class=\"row\">\n" +
    "                <div id=\"form-group-displayAsFormat\" class=\"col-md-12 col-sm-12 col-xs-12 form-group\" data-bmp-control-group-field-id=\"displayAsFormat\">\n" +
    "                    <label class=\"control-label inline\" for=\"displayAsFormat\">{{'Bluemoon.Core.Setup.Common.DisplayAsDialog.DisplayAsFormat' | translate}}</label>\n" +
    "                    <div data-bento-select>\n" +
    "                        <select class=\"form-control\" data-bm-focus-element=\"vm.focusElement\"\n" +
    "                                data-ng-model=\"vm.displayAsFormat\"\n" +
    "                                data-ng-change=\"vm.onDisplayAsFormatChanged()\"\n" +
    "                                data-ng-options=\"option as option.name for option in vm.displayAsFormatOptions track by option.id\">\n" +
    "                            <option class=\"setup-hidden-default-option\" value=\"\"></option>\n" +
    "                        </select>\n" +
    "                    </div>\n" +
    "                    <span class=\"msg\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div id=\"form-group-displayAs\" class=\"col-md-6 col-sm-6 col-xs-12 form-group\" data-ng-class=\"{'has-error': displayAsModalForm.displayAs.$error.required || displayAsModalForm.displayAs.$error.minlength || displayAsModalForm.displayas.$error.maxlength }\">\n" +
    "                    <label class=\"control-label inline\" for=\"displayAs\"><!-- /* i18nextract */'Bluemoon.Core.Setup.Common.DisplayAsDialog.DisplayAsSpecifiedValue' -->{{'Bluemoon.Core.Setup.Common.DisplayAsDialog.DisplayAsSpecifiedValue' | translate | bmRequiredMark:vm.valueIsRequired()}}</label>\n" +
    "                    <div>\n" +
    "                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                               id=\"displayAs\"\n" +
    "                               name=\"displayAs\"\n" +
    "                               class=\"form-control setup-common-display-as-dialog-displayas\"\n" +
    "                               data-ng-model=\"vm.displayAs\"\n" +
    "                               data-fef-maxlength=\"500\"\n" +
    "                               data-ng-disabled=\"vm.disableDisplayAs()\"\n" +
    "                               data-ng-minlength=\"1\"\n" +
    "                               data-ng-maxlength=\"500\"\n" +
    "                               ng-required=\"vm.valueIsRequired()\" />\n" +
    "                    </div>\n" +
    "                    <span class=\"msg\" data-translate=\"Bluemoon.Core.Setup.Common.DisplayAsDialog.DisplayAsClientValidation\"></span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "            <div class=\"modal-footer\">\n" +
    "                <button id=\"displayAsDialog.ok\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.onOk()\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\" data-ng-disabled=\"!displayAsModalForm.$valid\"></button>\n" +
    "                <button id=\"displayAsDialog.cancel\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.onCancel()\" data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\" formnovalidate></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/common/periods-js/periods-js.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/periods-js/periods-js.html",
    "<ng-form name=\"periodsForm\" ng-if=\"vm.selectedContact.id\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <h3 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.Periods' | translate}}</h3>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <bmpp-period-main show-related-contacts=\"vm.wsIdParamName === 'clientId' ? true : false\" owner-id=\"{{vm.selectedContact.id}}\" is-firm-client=\"vm.isFirm\"></bmpp-period-main>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/common/periods-ng/periods-ng.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/periods-ng/periods-ng.html",
    "<ng-form name=\"periodsForm\" ng-if=\"vm.selectedContact.id\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-sm-12\">\n" +
    "            <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.Periods' | translate}}</h2>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "   <bmpp-periods\n" +
    "        class=\"ng-bento\"\n" +
    "        [show-related-contacts]=\"vm.wsIdParamName === 'clientId' ? true : false\"\n" +
    "        owner-id=\"{{vm.selectedContact.id}}\"\n" +
    "        [is-firm-client]=\"vm.isFirm\">\n" +
    "    </bmpp-periods>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/common/setup-detail/setup-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-detail/setup-detail.html",
    "<div class=\"container-fluid no-left-padding view-container setup-detail\" ng-class=\"{'modal-workspace-no-bottom-margin': vm.inWorkspaceModal}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\" ng-class=\"{'modal-workspace-no-padding-right': vm.inWorkspaceModal}\">\n" +
    "             <!-- Bento-Alert -->\n" +
    "             <bento-alert bento-alert-object=\"vm.alerts\"></bento-alert>\n" +
    "            <div ng-form id=\"{{vm.setupDetail.formName}}\" name=\"{{vm.setupDetail.formName}}\" autocomplete=\"off\">\n" +
    "                <bmp-page-header\n" +
    "                    is-in-modal=\"vm.inWorkspaceModal\"\n" +
    "                    is-fixed=\"false\"\n" +
    "                    location=\"{{vm.setupDetail.location}}\"\n" +
    "                    show-help=\"vm.showTitleButtons()\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <bm-profile-photo-select ng-show=\"vm.detailContext.data.primaryContactExpanded && !vm.showDisplayAsLink()\"\n" +
    "                            class=\"profile-photo\"\n" +
    "                            image=\"vm.detailContext.data.primaryContactExpanded.$imageVm.image\"\n" +
    "                            view-only=\"true\"\n" +
    "                            shape=\"circle\"\n" +
    "                            size=\"small\"></bm-profile-photo-select>\n" +
    "                        <bm-profile-photo-select ng-show=\"vm.detailContext.data.primaryContactExpanded && vm.showDisplayAsLink()\"\n" +
    "                            class=\"profile-photo profile-photo-editable\"\n" +
    "                            image=\"vm.detailContext.data.primaryContactExpanded.$imageVm.image\"\n" +
    "                            view-only=\"false\"\n" +
    "                            shape=\"circle\"\n" +
    "                            size=\"small\"></bm-profile-photo-select>\n" +
    "                         <bm-profile-photo-select ng-show=\"!vm.detailContext.data.primaryContactExpanded && !vm.showDisplayAsLink()\"\n" +
    "                            class=\"profile-photo\"\n" +
    "                            image=\"vm.detailContext.data.$imageVm.image\"\n" +
    "                            view-only=\"true\"\n" +
    "                            shape=\"circle\"\n" +
    "                            size=\"small\"></bm-profile-photo-select>\n" +
    "                        <bm-profile-photo-select ng-show=\"!vm.detailContext.data.primaryContactExpanded && vm.showDisplayAsLink()\"\n" +
    "                            class=\"profile-photo profile-photo-editable\"\n" +
    "                            image=\"vm.detailContext.data.$imageVm.image\"\n" +
    "                            view-only=\"false\"\n" +
    "                            shape=\"circle\"\n" +
    "                            size=\"small\"></bm-profile-photo-select>\n" +
    "                        <h1 uib-tooltip=\"{{vm.setupDetail.getHeaderText()}}\"\n" +
    "                            tooltip-append-to-body=\"true\"\n" +
    "                            tooltip-trigger=\"mouseenter\"\n" +
    "                            tooltip-placement=\"bottom\"\n" +
    "                            data-qe-id=\"header-title\"\n" +
    "                            class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.setupDetail.getHeaderText()}}\n" +
    "                        </h1>\n" +
    "                        <h1 ng-if=\"vm.detailContext.detail.isLoadingData() && vm.setupDetail.getHeaderText() === ''\"\n" +
    "                            class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.detailContext.detail.busyText}}\n" +
    "                        </h1>\n" +
    "                        <div class=\"bmp-page-header-display-as\" data-ng-show=\"vm.showTitleButtons()\">\n" +
    "                            <a href role=\"button\"\n" +
    "                                ng-disabled=\"vm.setupDetail.displayAsButtonDisabled\"\n" +
    "                                class=\"btn btn-default no-padding-l\"\n" +
    "                                data-fef-tab-stop=\"false\"\n" +
    "                                ng-show=\"vm.showDisplayAsLink()\"\n" +
    "                                data-ng-click=\"vm.openDisplayAsDialog()\"\n" +
    "                                aria-label=\"{{vm.setupDetail.displayAsTitle | translate}}\"\n" +
    "                                title=\"{{vm.setupDetail.displayAsTitle | translate}}\"\n" +
    "                                data-qe-id=\"header-editDisplayAs-button\">\n" +
    "                                <span class=\"bento-icon-edit\"></span>\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content data-ng-show=\"vm.showTitleButtons()\">\n" +
    "                        <button type=\"button\" id=\"{{vm.setupDetail.formName}}.customsave\" class=\"btn btn-primary\"\n" +
    "                            data-qe-id=\"header-custom-save-button\"\n" +
    "                            data-ng-if=\"vm.inWorkspaceModal && vm.customSave\"\n" +
    "                            data-ng-click=\"vm.customSave(vm.detail, vm.data)\"\n" +
    "                            data-translate=\"{{::vm.customSaveText}}\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"{{vm.setupDetail.formName}}.save\" class=\"btn btn-primary\"\n" +
    "                            data-qe-id=\"header-{{vm.dataQeId}}save-button\"\n" +
    "                            data-ng-click=\"vm.save ? vm.save() : vm.detailContext.detail.save()\"\n" +
    "                            data-translate=\"{{vm.saveBtnText}}\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData() || vm.isVerifyingUniqueEmail\"></button>\n" +
    "                        <button type=\"button\" id=\"{{vm.setupDetail.formName}}.cancel\" data-qe-id=\"header-{{vm.dataQeId}}cancel-button\"\n" +
    "                            class=\"btn btn-default\"\n" +
    "                            data-ng-click=\"vm.detailContext.detail.cancel()\"\n" +
    "                            data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                            ng-disabled=\"vm.detailContext.detail.isLoadingData() || vm.isVerifyingUniqueEmail\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "\n" +
    "                <div ng-class=\"{'modal-workspace-content-wrapper': vm.inWorkspaceModal}\">\n" +
    "                    <bmp-routable-tabset id=\"multiselect-overlay-id\" bmp-routable-tabset-tabs=\"vm.tabs\" bmp-modal-state-data=\"$modalUiView.modalStateData\">\n" +
    "                        <bmp-modal-routable-ui-view ng-hide=\"vm.detailContext.detail.isLoadingData() || vm.isVerifyingUniqueEmail\"></bmp-modal-routable-ui-view>\n" +
    "                        <div bento-busy-loader=\"vm.detailContext.detail.isLoadingData() || vm.isVerifyingUniqueEmail\"></div>\n" +
    "                    </bmp-routable-tabset>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-confirm-reset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-confirm-reset.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"dialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"vm.onClose()\"\n" +
    "                aria-hidden=\"true\">\n" +
    "            &times;\n" +
    "        </button>\n" +
    "        {{'Bluemoon.Core.Setup.Common.SetupRelationships.ConfirmResetDialog.HeaderText' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <form name=\"dialogForm\">\n" +
    "            <span>{{vm.bodyText()}}</span>\n" +
    "            <div class=\"modal-footer\">\n" +
    "                <button id=\"displayAsDialog.ok\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.onOk()\" data-translate=\"Bluemoon.Practice.Common.Actions.Continue\"\n" +
    "                        data-ng-disabled=\"vm.okDisabled()\"></button>\n" +
    "                <button id=\"displayAsDialog.cancel\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.onCancel()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\" formnovalidate></button>\n" +
    "            </div>\n" +
    "        </form>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-detail-general.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div data-onvio-contact-editor=\"vm.data.contactRelationshipData.contactExpanded\"\n" +
    "                contact-name-validation-service=\"vm.contactNameValidationService\"\n" +
    "                data-onvio-contact-editor-parent-form=\"setupRelationshipDetailForm\"\n" +
    "                data-onvio-contact-editor-entity-types=\"vm.entityTypes\"\n" +
    "                data-onvio-contact-editor-show-contact-selector=\"true\"\n" +
    "                data-onvio-contact-editor-show-confidentiality=\"true\"\n" +
    "                data-onvio-contact-editor-disable-confidentiality=\"vm.inWorkspaceModal\"\n" +
    "                data-onvio-contact-editor-is-related-to-a-client=\"vm.isRelatedToAClient()\"\n" +
    "                data-onvio-contact-editor-entity-type-changed-externally=\"vm.entityTypeChanged\"\n" +
    "                data-onvio-contact-editor-analytics-context=\"vm.analyticsContext\"\n" +
    "                data-onvio-contact-editor-related-to-contact-id=\"vm.contact.id\"\n" +
    "                data-onvio-contact-editor-relationship-side-id=\"vm.data.contactRelationshipData.relationshipSide.id\"\n" +
    "                data-onvio-contact-editor-use-dynamic-entity-types=\"vm.useDynamicEntityTypes()\"\n" +
    "                data-onvio-contact-editor-dynamic-entity-type-filter-function=\"vm.entityTypeFilterFunctionAllButPlace(list)\"\n" +
    "                data-onvio-contact-editor-get-valid-dynamic-entity-types=\"vm.getUpdatedValidContactEntityTypes(list)\"\n" +
    "                onvio-contact-editor-is-loading=\"vm.isLoading\">\n" +
    "                </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-detail-representative.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-detail-representative.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <!-- Representative Information -->\n" +
    "        <h3>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Representative.RepresentativeInformationHeading' | translate}}</h3>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeCafNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.CafNumber' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.contactRoleData.representative.cafNumber, 'representativeCafNumber')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input type=\"text\"\n" +
    "                        class=\"form-control\"\n" +
    "                        name=\"representativeCafNumber\"\n" +
    "                        data-ng-model=\"vm.data.contactRoleData.representative.cafNumber\"\n" +
    "                        data-ng-pattern=\"/^[a-zA-Z0-9]{1,11}$/\"\n" +
    "                        data-fef-maxlength=\"11\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeDesignation\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Designation' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12 form-group\">\n" +
    "                <div bento-combobox\n" +
    "                        ng-model=\"vm.data.contactRoleData.representative.designation\"\n" +
    "                        get-data=\"vm.getDesignationData()\"\n" +
    "                        label-name=\"name\"\n" +
    "                        searchable=\"true\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeJurisdiction\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Jurisdiction' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input type=\"text\"\n" +
    "                        class=\"form-control\"\n" +
    "                        name=\"representationJurisdiction\"\n" +
    "                        data-ng-model=\"vm.data.contactRoleData.representative.jurisdiction\"\n" +
    "                        data-ng-pattern=\"/^[a-zA-Z0-9]*$/\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeEnrollmentNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.EnrollmentNumber' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input type=\"text\"\n" +
    "                        class=\"form-control\"\n" +
    "                        name=\"representativeEnrollmentNumber\"\n" +
    "                        data-ng-model=\"vm.data.contactRoleData.representative.enrollmentNumber\"\n" +
    "                        data-ng-pattern=\"/^[a-zA-Z0-9]*$/\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeAddress\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Address' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <div bento-combobox\n" +
    "                        ng-model=\"vm.data.contactRoleData.representative.address\"\n" +
    "                        get-data=\"vm.getAddressData()\"\n" +
    "                        label-name=\"name\"\n" +
    "                        searchable=\"true\"\n" +
    "                        controller=\"vm.contactRoleAddressController\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativePhoneNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Phone' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <div bento-combobox\n" +
    "                        ng-model=\"vm.data.contactRoleData.representative.phone\"\n" +
    "                        get-data=\"vm.getPhoneData()\"\n" +
    "                        label-name=\"name\"\n" +
    "                        searchable=\"true\"\n" +
    "                        controller=\"vm.contactRolePhoneController\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"representativeFaxNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.FaxPhone' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <div bento-combobox\n" +
    "                        ng-model=\"vm.data.contactRoleData.representative.faxPhone\"\n" +
    "                        get-data=\"vm.getFaxData()\"\n" +
    "                        label-name=\"name\"\n" +
    "                        searchable=\"true\"\n" +
    "                        controller=\"vm.contactRoleFaxController\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-detail.html",
    "<div bento-busy-loader=\"vm.detail.isLoadingData()\" ng-hide=\"!vm.detail.isLoadingData()\" class=\"setup-relationships-busyloader\"></div>\n" +
    "<div class=\"row \">\n" +
    "<div ng-form\n" +
    "     id=\"setupRelationshipDetailForm\"\n" +
    "     ng-show=\"!vm.detail.isLoadingData()\"\n" +
    "     name=\"setupRelationshipDetailForm\"\n" +
    "     class=\"well bm-well col-md-12 col-sm-12 col-xs-12\">\n" +
    "     <div ng-class=\"{inWorkspaceModal: vm.inWorkspaceModal, hasDetailContextDetail: vm.detailContext.detail}\">\n" +
    "   <!-- display page-header when only in workspace modal -->\n" +
    "    <bmp-page-header ng-show = \"!vm.detailContext.detail\" is-in-modal=\"vm.inWorkspaceModal\" show-help = \"false\">\n" +
    "            <bmp-page-header-left-content>\n" +
    "                <h3 data-ng-bind-html=\"vm.title()\"\n" +
    "                style=\"padding-left: 20px;\"></h3>\n" +
    "                <h3>{{vm.title()}}</h3>\n" +
    "            </bmp-page-header-left-content>\n" +
    "            <bmp-page-header-right-content>\n" +
    "                <div class=\"row\"\n" +
    "                 style=\"padding-right: 25px;\">\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.detail.save()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.SaveAndClose\"></button>\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.detail.cancel()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "                </div>\n" +
    "            </bmp-page-header-right-content>\n" +
    "        </bmp-page-header>\n" +
    "    <!-- display sub-page-header when not in workspace modal -->\n" +
    "        <bmp-sub-page-header ng-show = \"vm.detailContext.detail\">\n" +
    "            <bmp-sub-page-header-left-content>\n" +
    "                <h3>{{vm.title()}}</h3>\n" +
    "            </bmp-sub-page-header-left-content>\n" +
    "            <bmp-sub-page-header-right-content>\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.detail.save()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "                <button type=\"button\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.detail.cancel()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "            </bmp-sub-page-header-right-content>\n" +
    "        </bmp-sub-page-header>\n" +
    "\n" +
    "        <div class=\"setup-relationships-detail-body\">\n" +
    "\n" +
    "        <!-- Relationship Type -->\n" +
    "        <div class=\"row\">\n" +
    "            <!-- /* i18nextract */'Core.Captions.ContactRelationship.RelationshipTypeSystemId' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"relationshipSide\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.ContactRelationship.RelationshipTypeSystemId' | translate | bmRequiredMark }}\"\n" +
    "                 data-bmp-control-group-error=\"vm.errorFor(data, 'relationshipSide')\"\n" +
    "                 class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo name=\"relationshipSide\"\n" +
    "                                  id=\"relationshipSide\"\n" +
    "                                  ng-model=\"vm.data.contactRelationshipData.relationshipSide\"\n" +
    "                                  required=\"true\"\n" +
    "                                  list=\"contact-relationship-type-v2\"\n" +
    "                                  list-style=\"basic\"\n" +
    "                                  context=\"vm.contact.id\"\n" +
    "                                  on-change=\"vm.common(vm.data.contactRelationshipData.relationshipSide)\"\n" +
    "                                  bmp-verify-relationship-side=\"\"\n" +
    "                                  bmp-verify-relationship-side-contact-id=\"vm.contact.id\"\n" +
    "                                  bmp-verify-relationship-side-exclude-relationship-side-id=\"vm.initialRelationshipSideId\"></bmp-select-combo>\n" +
    "                                  <span ng-if=\"vm.messageAs()\">({{vm.messageAs()}})</span>\n" +
    "            </div>\n" +
    "            <!-- Start Date -->\n" +
    "            <div ng-if=\"vm.showStartAndEndDate\">\n" +
    "                <!-- /* i18nextract */'Core.Captions.ContactRelationship.StartDate' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"startDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ContactRelationship.StartDate' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.errorFor(vm.data.contactRelationshipData, 'startDate')\"\n" +
    "                    class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper id=\"startDate\"\n" +
    "                                                name=\"startDate\"\n" +
    "                                                ng-model=\"vm.data.contactRelationshipData.startDate\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "                <!-- /* i18nextract */'Core.Captions.ContactRelationship.EndDate' -->\n" +
    "                <div data-bmp-control-group=\"\" ng-if=\"vm.showStartAndEndDate\" data-bmp-control-group-field-id=\"endDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ContactRelationship.EndDate' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.validateEndDate()\" class=\"col-md-3 col-sm-3 col-xs -12\">\n" +
    "                    <bmp-bento-datepicker-wrapper id=\"endDate\" name=\"endDate\" ng-model=\"vm.data.contactRelationshipData.endDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12\">\n" +
    "                <!-- TODO (JEB): Move this inline CSS into a new CSS file for client detail -->\n" +
    "                <!--<h3 style=\"padding-top:0px;padding-bottom:0px;margin-top:-5px\">{{vm.contactTitle()}}</h3>-->\n" +
    "                <h3>{{vm.contactTitle()}}</h3>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-12\"\n" +
    "                 style=\"margin-top: -10px; margin-bottom: 15px;\">\n" +
    "                <a href\n" +
    "                   role=\"button\"\n" +
    "                   class=\"btn btn-link no-padding-l\"\n" +
    "                   ng-click=\"vm.changeSelectedRelationship()\"\n" +
    "                   ng-show=\"vm.showChangeSelectedRelationshipContact()\">\n" +
    "                    {{'Bluemoon.Core.Setup.Common.SetupRelationships.ChangeSelectedRelationship' | translate}}\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Relationship contact editor -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmp-tabset>\n" +
    "                    <bmp-tab id=\"relationship-general\"\n" +
    "                             title=\"{{'Bluemoon.Core.Setup.Contacts.Detail.Navigation.General' | translate}}\"\n" +
    "                             src=\"core-setup/common/setup-relationships/setup-relationships-detail-general.html\"\n" +
    "                             on-closing=vm.detail.save(false)></bmp-tab>\n" +
    "                    <bmp-tab id=\"relationship-legal-representative\"\n" +
    "                             title=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Representative.RepresentativeInformationTabHeading' | translate}}\"\n" +
    "                             src=\"core-setup/common/setup-relationships/setup-relationships-detail-representative.html\"\n" +
    "                             on-opening=\"vm.loadRepresentativeData()\"\n" +
    "                             ng-if=\"vm.isLegalRepresentative\"></bmp-tab>\n" +
    "                </bmp-tabset>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-edit-message.component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-edit-message.component.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"dialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"vm.onClose()\"\n" +
    "                aria-hidden=\"true\">\n" +
    "            &times;\n" +
    "        </button>\n" +
    "        <span>{{vm.bodyText()}}</span>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"displayAsDialog.ok\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                data-ng-click=\"vm.onOk()\" data-translate=\"Bluemoon.Practice.Common.Actions.Ok\"\n" +
    "                data-ng-disabled=\"vm.okDisabled()\"></button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships-list-related-contacts-grid-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships-list-related-contacts-grid-template.html",
    "<bmc-related-contacts-list\n" +
    "    item=\"$item\"\n" +
    "    grid-name=\"'RelationshipsGrid'\"\n" +
    "    show-add-button=\"false\"\n" +
    "    row=\"$row\"\n" +
    "    id=\"$item.id\"\n" +
    "    contact-id=\"$item.contact.id\"\n" +
    "    parent-id=\"$item.$parentId\">\n" +
    "</bmc-related-contacts-list>");
}]);

angular.module("core-setup/common/setup-relationships/setup-relationships.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/setup-relationships/setup-relationships.html",
    "<div class=\"setup-list-grid-view container-fluid no-left-padding view-container\" bento-busy-loader=\"vm.loading\" ng-if=\"vm.showGrid()\">\n" +
    "    <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.Relationships' | translate}}</h2>\n" +
    "    <bmp-grid bmp-grid-definition=\"vm.definition\"\n" +
    "                bmp-grid-service=\"vm.repository\">\n" +
    "    </bmp-grid>\n" +
    "</div>\n" +
    "<bmp-modal-routable-ui-view class=\"enter-item-animation\" ng-if=\"!vm.showGrid()\"></bmp-modal-routable-ui-view>");
}]);

angular.module("core-setup/common/tr-user-registration/tr-user-registration-email.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/tr-user-registration/tr-user-registration-email.html",
    "<ng-form name=\"$ctrl.registrationEmailForm\">\n" +
    "    <div class=\"modal-header row\">\n" +
    "        <h2>{{::$ctrl.getHeader()}}</h2>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body row\">\n" +
    "        <span class=\"col-md-12 body-text\">{{::$ctrl.getSendEmail()}}</span>\n" +
    "        <span class=\"col-md-12 body-text\" translate=\"Bluemoon.Core.Setup.Common.trUserRegistration.CurrentEmail\"></span>\n" +
    "        <div bmp-control-group=\"\"\n" +
    "             bmp-control-group-field-id=\"emailAddress\"\n" +
    "             bmp-control-group-caption=\"{{Bluemoon.Core.Setup.Common.trUserRegistration.PrimaryEmailAddress}}\"\n" +
    "             bmp-control-group-error=\"$ctrl.getEmailErrors()\"\n" +
    "             class=\"col-md-9\">\n" +
    "            <input autocomplete=\"off\" type=\"text\" class=\"form-control\"\n" +
    "                id=\"emailAddress\" name=\"emailAddress\"\n" +
    "                qe-id=\"emailaddress\"\n" +
    "                ng-model=\"$ctrl.primaryEmail\"\n" +
    "                ng-keydown=\"$event.keyCode === 13 && !$ctrl.registrationEmailForm.$pending && $ctrl.validatePrimaryEmail()\"\n" +
    "                ng-disabled=\"(!$ctrl.isEditingEmail || $ctrl.registrationEmailForm.$pending) && $ctrl.registrationEmailForm.$valid\"\n" +
    "                fef-maxlength=\"250\"\n" +
    "                ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                bm-focus-on-enable\n" +
    "                blue-moon-email-validation />\n" +
    "        </div>\n" +
    "        <div ng-switch=\"!($ctrl.isEditingEmail || $ctrl.registrationEmailForm.$pending) && $ctrl.registrationEmailForm.$valid\"\n" +
    "            class=\"col-md-3\">\n" +
    "            <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default width-full\"\n" +
    "                ng-switch-when=\"true\"\n" +
    "                ng-click=\"$ctrl.editEmail()\"\n" +
    "                ng-disabled=\"$ctrl.registrationEmailForm.$pending\"\n" +
    "                data-qe-id=\"bm-trUserRegistrationEmail-popup-edit-button\"\n" +
    "                bento-busy-loader=\"$ctrl.registrationEmailForm.$pending\">\n" +
    "                {{'Bluemoon.Practice.Common.Actions.Edit' | translate}}\n" +
    "            </button>\n" +
    "            <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default width-full\"\n" +
    "                ng-switch-when=\"false\"\n" +
    "                ng-click=\"$ctrl.validatePrimaryEmail()\"\n" +
    "                ng-disabled=\"$ctrl.registrationEmailForm.$pending\"\n" +
    "                bento-busy-loader=\"$ctrl.registrationEmailForm.$pending\"\n" +
    "                data-qe-id=\"bm-trUserRegistrationEmail-popup-save-button\">\n" +
    "                {{'Bluemoon.Practice.Common.Actions.Save' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                ng-click=\"$ctrl.send()\"\n" +
    "                ng-disabled=\"$ctrl.registrationEmailForm.$pending || $ctrl.isEditingEmail || $ctrl.registrationEmailForm.$invalid\"\n" +
    "                translate=\"Bluemoon.Core.Setup.Common.Actions.SendNow\"\n" +
    "                data-qe-id=\"bm-trUserRegistrationEmail-popup-sendNow-button\"\n" +
    "                bm-focus-on-enable></button>\n" +
    "            <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                ng-click=\"$ctrl.apply(false)\"\n" +
    "                ng-disabled=\"$ctrl.registrationEmailForm.$pending || $ctrl.isEditingEmail || $ctrl.registrationEmailForm.$invalid\"\n" +
    "                data-qe-id=\"bm-trUserRegistrationEmail-popup-sendLater-button\"\n" +
    "                translate=\"Bluemoon.Core.Setup.Common.trUserRegistration.CancelRegistration\"></button>\n" +
    "            <button\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                ng-click=\"$ctrl.cancel()\"\n" +
    "                data-qe-id=\"bm-trUserRegistrationEmail-popup-cancel-button\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Buttons.Cancel\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/common/tr-user-registration/tr-user-registration.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/common/tr-user-registration/tr-user-registration.html",
    "<div ng-form=\"reg.trUserAuthForm\" ng-show=\"reg.displayAccess\">\n" +
    "    <div class=\"toggle-container\" ng-if=\"!reg.hideToggle\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <div class=\"btn-group\" bento-busy-loader=\"reg.isLoading\" bento-busy-loader-size=\"small\">\n" +
    "                    <button type=\"button\"\n" +
    "                            translate=\"Bluemoon.Core.Setup.Common.On\"\n" +
    "                            class=\"btn btn-default btn-toggle\"\n" +
    "                            ng-model=\"reg.contact.$isAccessEnabled\"\n" +
    "                            uib-btn-radio=\"true\"\n" +
    "                            data-qe-id=\"bm-trUserRegistration-toggle-on-button\"\n" +
    "                            ng-disabled=\"reg.isToggleDisabled\">\n" +
    "                    </button>\n" +
    "                    <button type=\"button\"\n" +
    "                            translate=\"Bluemoon.Core.Setup.Common.Off\"\n" +
    "                            class=\"btn btn-default btn-toggle\"\n" +
    "                            ng-model=\"reg.contact.$isAccessEnabled\"\n" +
    "                            uib-btn-radio=\"false\"\n" +
    "                            data-qe-id=\"bm-trUserRegistration-toggle-off-button\"\n" +
    "                            ng-disabled=\"reg.isToggleDisabled\">\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8\"\n" +
    "             ng-if=\"!reg.HasFirstAndLastName()\">\n" +
    "            <div class=\"alert alert-info alert-error\"\n" +
    "                    data-qe-id=\"{{::reg.id}}-message\">\n" +
    "                {{reg.GetNoFirstAndLastNameWarningMessage()}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-8\"\n" +
    "             ng-if=\"reg.isToggleDisabled\">\n" +
    "            <div class=\"alert alert-info alert-error\"\n" +
    "                    data-qe-id=\"{{::reg.id}}-disabled-message\">\n" +
    "                {{reg.getInactiveStaffMessage()}}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"reg.contact.$isAccessEnabled && !reg.isLoading\">\n" +
    "        <div ng-show=\"reg.HasStatusMessage() && !reg.onvioUserDataLoading\" class=\"status-message\">{{reg.GetStatusMessage()}}</div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-8\">\n" +
    "                <div class=\"alert alert-info\"\n" +
    "                     ng-if=\"reg.IsRegistrationAvailable() && !reg.RegistrationCompleted() && !reg.WillSendRegistrationMessage()\">\n" +
    "                    <span>{{::reg.getResendString()}}</span>\n" +
    "                    <a ng-click=\"reg.SendRegistrationMessage()\"\n" +
    "                        data-qe-id=\"{{::reg.id}}-sendemail-link\"\n" +
    "                        translate=\"Bluemoon.Practice.Common.Actions.Yes\">\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"!reg.isToggleDisabled\">\n" +
    "        <div class=\"row\" ng-show=\"reg.IsEligibleForStaffAccess() && reg.contact.isStaffCenterEnabled\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <bm-multifactor-user contact=\"reg.contact\"></bm-multifactor-user>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"reg.IsEligibleForStaffAccess() && reg.contact.isStaffCenterEnabled\">\n" +
    "            <div class=\"col-md-9\">\n" +
    "                <permission-groups-picker contact=\"reg.contact\"></permission-groups-picker>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-show=\"reg.RegistrationCompleted() && reg.contact.isClientCenterEnabled\" bm-if-perm=\"OnvioSetup.ViewPortal\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <button class=\"btn btn-link\" ng-click=\"reg.ViewClientCenterAs()\">\n" +
    "                    <i class=\"bento-icon-eye\"></i> {{reg.GetViewClientCenterAsLink()}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-show=\"reg.IsEligibleForClientAccess() && reg.contact.isClientCenterEnabled\">\n" +
    "            <div class=\"col-md-6\">\n" +
    "                <bm-multifactor-user contact=\"reg.contact\"></bm-multifactor-user>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"bento-alert-container\" ng-if=\"!reg.displayAccess\">\n" +
    "    <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\" translate=\"Bluemoon.Core.Setup.Common.PreviewMode.Warning\"></span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/conflict-resolution/conflict-resolution.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/conflict-resolution/conflict-resolution.html",
    "<div bento-busy-loader=\"vm.isLoading\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-11\">\n" +
    "            <p>{{'Bluemoon.Core.Setup.ConflictResolution.ResolveMatchDataBelow' | translate}} </p>\n" +
    "            <p>{{'Bluemoon.Core.Setup.ConflictResolution.CancelAndGoBack' | translate}} </p>\n" +
    "        </div>\n" +
    "        <button id=\"displayAsDialog.close\" type=\"button\" class=\"close\" data-ng-click=\"vm.close()\" aria-hidden=\"true\"\n" +
    "            style=\"margin-right: 20px;\">\n" +
    "            &times;\n" +
    "        </button>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div style=\"float: right;\">\n" +
    "                <input id=\"showConflictedOnly\" name=\"showConflictedOnly\" data-qe-id=\"showConflictedOnly\" type=\"checkbox\"\n" +
    "                    ng-model=\"vm.showConflictedOnly\" />\n" +
    "                {{'Bluemoon.Core.Setup.ConflictResolution.ShowConflictedOnly' | translate}}\n" +
    "                <button type=\"button\" class=\"btn btn-link no-margin\" ng-click=\"vm.splitTables = false\">\n" +
    "                    <span class=\"bento-icon-columns\"></span>\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-link no-margin\" ng-click=\"vm.splitTables = true\">\n" +
    "                    <span class=\"bento-icon-tables\"></span>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"bento-container\">\n" +
    "        <div class=\"row\">\n" +
    "            <div style=\"overflow: auto; clear: both;\">\n" +
    "                <table class=\"table table-striped table-hover table-condensed table-bordered table-responsive\">\n" +
    "                    <thead>\n" +
    "                        <tr>\n" +
    "                            <th class=\"text-left col-xs-2\">\n" +
    "                                {{'Bluemoon.Core.Setup.ConflictResolution.Source' | translate}}\n" +
    "                            </th>\n" +
    "                            <th class=\"text-left col-xs-5\">\n" +
    "                                <span class=\"label\" style=\"background-color: purple; color: white;\">\n" +
    "                                    {{'Bluemoon.Core.Setup.ConflictResolution.DPM' | translate}}\n" +
    "                                </span>\n" +
    "                            </th>\n" +
    "                            <th class=\"text-left col-xs-5\" ng-if=\"!vm.splitTables\">\n" +
    "                                <span class=\"label\" style=\"background-color: darkslategrey; color: white;\">\n" +
    "                                    {{'Bluemoon.Core.Setup.ConflictResolution.Onvio' | translate}}\n" +
    "                                </span>\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"field in vm.orderedFields\"\n" +
    "                            ng-hide=\"vm.showConflictedOnly && vm.areSameValues(field.key)\">\n" +
    "                            <td>\n" +
    "                                <b>{{ field.localisationTag | translate }}</b>\n" +
    "                                <span ng-if=\"!vm.areSameValues(field.key) && !vm.splitTables\"\n" +
    "                                    class=\"bento-icon-warning-round\" style=\"float: right;\">\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td data-qe-id=\"cr-{{field.key}}-{{vm.source.id}}\">\n" +
    "                                {{ vm.evaluateStringFormat(vm.source[field.key]) }}</td>\n" +
    "                            <td data-qe-id=\"cr-{{field.key}}-{{vm.target.id}}\"\n" +
    "                                ng-class=\"{'conflict-resolution-mismatch': !vm.areSameValues(field.key)}\"\n" +
    "                                ng-if=\"!vm.splitTables\">{{ vm.evaluateStringFormat(vm.target[field.key]) }}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"vm.splitTables\">\n" +
    "            <div style=\"overflow: auto; clear: both;\">\n" +
    "                <table class=\"table table-striped table-hover table-condensed table-bordered table-responsive\">\n" +
    "                    <thead>\n" +
    "                        <tr>\n" +
    "                            <th class=\"text-left col-xs-2\">\n" +
    "                                {{'Bluemoon.Core.Setup.ConflictResolution.Source' | translate}}\n" +
    "                            </th>\n" +
    "                            <th class=\"text-left col-xs-5\">\n" +
    "                                <span class=\"label\" style=\"background-color: darkslategrey; color: white;\">\n" +
    "                                    {{'Bluemoon.Core.Setup.ConflictResolution.Onvio' | translate}}\n" +
    "                                </span>\n" +
    "                            </th>\n" +
    "                        </tr>\n" +
    "                    </thead>\n" +
    "                    <tbody>\n" +
    "                        <tr ng-repeat=\"field in vm.orderedFields\"\n" +
    "                            ng-hide=\"vm.showConflictedOnly && vm.areSameValues(field.key)\">\n" +
    "                            <td>\n" +
    "                                <b>{{field.localisationTag | translate }}</b>\n" +
    "                                <span ng-if=\"!vm.areSameValues(field.key) && !vm.splitTables\"\n" +
    "                                    class=\"bento-icon-warning-round\" style=\"float: right;\">\n" +
    "                                </span>\n" +
    "                            </td>\n" +
    "                            <td data-qe-id=\"cr-{{field.key}}-{{vm.target.id}}\"\n" +
    "                                ng-class=\"{'conflict-resolution-mismatch': !vm.areSameValues(field.key)}\">\n" +
    "                                {{ vm.evaluateStringFormat(vm.target[field.key]) }}\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <button id=\"matchRecords\" class=\"btn btn-primary\"\n" +
    "            data-ng-click=\"vm.matchButtonClicked()\">{{'Bluemoon.Core.Setup.ConflictResolution.MatchRecords' | translate}}</button>\n" +
    "        <button id=\"createNew\" class=\"btn btn-primary\" data-ng-click=\"vm.newButtonClicked()\"\n" +
    "            data-qe-id=\"cr-create-new-button\">{{'Bluemoon.Core.Setup.ConflictResolution.CreateNew' | translate}}</button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/conflict-resolution/migration-records-created-matched.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/conflict-resolution/migration-records-created-matched.html",
    "<bmp-page-header>\n" +
    "    <bmp-page-header-left-content>\n" +
    "        <h1>Records succesfully migrated ({{ vm.conflicts.length }})</h1>\n" +
    "    </bmp-page-header-left-content>\n" +
    "    <bmp-page-header-right-content>\n" +
    "        <button type=\"button\"\n" +
    "                id=\"close\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Close\"\n" +
    "                ui-sref=\"migrationResults-master\"></button>\n" +
    "    </bmp-page-header-right-content>\n" +
    "</bmp-page-header>\n" +
    "<div bento-busy-loader=\"vm.isLoading\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.SourceApplication' | translate}}: {{ vm.sourceApplication }}\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.Date' | translate}}: {{ vm.migrationDate }}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <hr class=\"bm-section-divider\" />\n" +
    "    <div class=\"setup-list-grid-view view-container\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/conflict-resolution/migration-records-error.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/conflict-resolution/migration-records-error.html",
    "<bmp-page-header>\n" +
    "    <bmp-page-header-left-content>\n" +
    "        <h1>New Records Creation Failure in ONVIO ({{vm.items.length}})</h1>\n" +
    "    </bmp-page-header-left-content>\n" +
    "    <bmp-page-header-right-content>\n" +
    "        <button type=\"button\"\n" +
    "                id=\"close\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Close\"\n" +
    "                ui-sref=\"migrationResults-master\"></button>\n" +
    "    </bmp-page-header-right-content>\n" +
    "</bmp-page-header>\n" +
    "<div bento-busy-loader=\"vm.isLoading\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.SourceApplication' | translate}}: {{ vm.sourceApplication }}\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.Date' | translate}}: {{ vm.migrationDate }}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <hr class=\"bm-section-divider\" />\n" +
    "    <div class=\"setup-list-grid-view view-container\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/conflict-resolution/migration-results.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/conflict-resolution/migration-results.html",
    "<div ng-switch=\"vm.event.status\">\n" +
    "    <migration-summary migration-event=\"vm.event\" ng-switch-when=\"conflict\"></migration-summary>\n" +
    "    <migration-records-error migration-event=\"vm.event\" ng-switch-when=\"localError|remoteError\" ng-switch-when-separator=\"|\"></migration-records-error>\n" +
    "    <migration-records-created-matched migration-event=\"vm.event\" ng-switch-when=\"processed\"></migration-records-created-matched>\n" +
    "</div>");
}]);

angular.module("core-setup/conflict-resolution/migration-summary.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/conflict-resolution/migration-summary.html",
    "<bmp-page-header>\n" +
    "    <bmp-page-header-left-content>\n" +
    "        <h1>{{'Bluemoon.Core.Setup.ConflictResolution.ConflictsDPM' | translate}}</h1>\n" +
    "    </bmp-page-header-left-content>\n" +
    "    <bmp-page-header-right-content>\n" +
    "        <button type=\"button\"\n" +
    "                id=\"close\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Close\"\n" +
    "                ng-click=\"vm.close()\"></button>\n" +
    "    </bmp-page-header-right-content>\n" +
    "</bmp-page-header>\n" +
    "<div bento-busy-loader=\"vm.isLoading\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.SourceApplication' | translate}}: {{ vm.summary.sourceApplication }}\n" +
    "        </div>\n" +
    "        <div class=\"col-md-12\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.Date' | translate}}: {{ vm.summary.date }}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <hr class=\"bm-section-divider\" />\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.FollowingRecordsNotBeenCompletedExtended' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.RecommendClickOnPartialMatchesColumn' | translate}}&nbsp;\n" +
    "            <b>{{'Bluemoon.Core.Setup.ConflictResolution.PartialMatches' | translate}}</b>&nbsp;\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.RecommendClickOnPartialMatchesCompare' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.ToResolveConflict' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-1\">\n" +
    "            <span class=\"label conflict-resolution-buttons-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.Match' | translate}}</span>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-11\">\n" +
    "            <span class=\"conflict-resolution-text-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.OnvioRecordMatchInfo' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-1\">\n" +
    "            <span class=\"label conflict-resolution-buttons-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.Ignore' | translate}}</span>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-8\">\n" +
    "            <span class=\"conflict-resolution-text-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.OnvioRecordIgnoreInfo' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-1\">\n" +
    "            <span class=\"label conflict-resolution-buttons-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.CreateNew' | translate}}</span>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-8\">\n" +
    "            <span class=\"conflict-resolution-text-info-span\">{{'Bluemoon.Core.Setup.ConflictResolution.OnvioRecordCreateNewInfo' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-10\">\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.UseColumnWithCertainty' | translate}}&nbsp;\n" +
    "            <b>{{'Bluemoon.Core.Setup.ConflictResolution.Actions' | translate}}</b>&nbsp;\n" +
    "            {{'Bluemoon.Core.Setup.ConflictResolution.UseColumnWithCertaintyCannotBeReveresed' | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br>\n" +
    "    <div class=\"setup-list-grid-view view-container\">\n" +
    "        <bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/contacts/details/general/contact-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/details/general/contact-detail-general.html",
    "<div ng-hide=\"vm.isLoading\">\n" +
    "\n" +
    "    <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Contacts.Detail.Navigation.General' | translate}}</h2>\n" +
    "\n" +
    "    <!-- Contact editor -->\n" +
    "    <div data-onvio-contact-editor=\"vm.data\"\n" +
    "         contact-name-validation-service=\"vm.contactNameValidationService\"\n" +
    "         data-onvio-contact-editor-uk-contact-data=\"vm.ukContactData\"\n" +
    "         data-onvio-contact-editor-parent-form=\"contactForm\"\n" +
    "         data-onvio-contact-editor-valid-entity-types=\"vm.entityOptions\"\n" +
    "         data-onvio-contact-editor-entity-types=\"vm.entityTypes\"\n" +
    "         data-onvio-contact-editor-show-contact-selector=\"false\"\n" +
    "         data-onvio-contact-editor-show-confidentiality=\"true\"\n" +
    "         data-onvio-contact-editor-disable-confidentiality=\"vm.inWorkspaceModal\"\n" +
    "         onvio-contact-editor-is-loading=\"vm.isLoading\"\n" +
    "         bmp-detail-view-default-focus=\"vm.data\"></div>\n" +
    "\n" +
    "    <h3 data-ng-if=\"vm.data.id\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "      <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.id\" [entity-name]=\"vm.data.displayAs\"> </bmcn-notes>\n" +
    "    </h3>\n" +
    "  <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "</div>");
}]);

angular.module("core-setup/contacts/details/integration/contact-detail-integration.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/details/integration/contact-detail-integration.html",
    "<div class=\"ng-bento\">\n" +
    "    <div bento-busy-loader=\"!vm.data\"></div>\n" +
    "    <bmei-external-integration ng-if=\"vm.data.id\" owner-id={{vm.data.id}} [show-contact-dropdown]=\"false\"></bmei-external-integration>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/contacts/details/security/contact-clients-detail-security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/details/security/contact-clients-detail-security.html",
    "<ng-form name=\"contactSecurityGranularForm\"\n" +
    "         ng-show=\"vm.data.related.length > 0 && vm.displayAccess\"\n" +
    "         bmp-detail-view-default-focus=\"vm.data\">\n" +
    "    <h3 class=\"no-top-margin\" translate=\"Bluemoon.Core.Setup.Clients.Detail.Navigation.Security\"></h3>\n" +
    "    <br/>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <tr-user-registration\n" +
    "                id=\"registration_KEY__{{::$index}}\" ng-model=\"vm.data.contact.isClientCenterEnabled\" data-tr-user-registration-display-email=\"true\"\n" +
    "                data-tr-user-registration-client=\"true\" data-tr-user-registration-contact=\"vm.data.contact\"\n" +
    "                data-tr-user-registration-entity-types=\"vm.entityTypes\" hide-toggle=\"true\">\n" +
    "            </tr-user-registration>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br />\n" +
    "    <!-- Search -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <div class=\"pull-right\">\n" +
    "                <label class=\"sr-only\"\n" +
    "                    for=\"repeaterSearch\">{{'Bluemoon.Practice.Common.Label.Search' | translate}}</label>\n" +
    "                <input autocomplete=\"off\"\n" +
    "                    id=\"repeaterSearch\"\n" +
    "                    class=\"form-control\"\n" +
    "                    bento-reset=\"\"\n" +
    "                    ng-model=\"vm.repeaterSearchTerm\"\n" +
    "                    ng-change=\"vm.updateItems()\"\n" +
    "                    placeholder=\"{{'Bluemoon.Practice.Common.Placeholder.Search' | translate}}\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br />\n" +
    "    <div class=\"contact-security-panel\">\n" +
    "        <!-- Header -->\n" +
    "        <div class=\"contact-security-panel-heading\">\n" +
    "            <div class=\"row\">\n" +
    "                <div ng-class=\"{'col-md-8': vm.showTaxCenterToggle, 'col-sm-8': vm.showTaxCenterToggle, 'col-xs-6': vm.showTaxCenterToggle, 'col-md-10': !vm.showTaxCenterToggle, 'col-sm-10': !vm.showTaxCenterToggle, 'col-xs-9': !vm.showTaxCenterToggle}\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.ClientCenterToggle\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggle\"\n" +
    "                     ng-if=\"vm.showTaxCenterToggle && !vm.displayVNextStrings\"></div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                     translate=\"Bluemoon.Core.Setup.TaxCenterToggleVNext\"\n" +
    "                     ng-if=\"vm.showTaxCenterToggle && vm.displayVNextStrings\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <span ng-repeat=\"access in vm.filteredItems\">\n" +
    "            <!-- Item heading -->\n" +
    "            <div class=\"contact-security-panel-group\">\n" +
    "                <div class=\"row\">\n" +
    "                    <!-- Name -->\n" +
    "                    <div ng-class=\"{'col-md-8': vm.showTaxCenterToggle, 'col-sm-8': vm.showTaxCenterToggle, 'col-xs-6': vm.showTaxCenterToggle, 'col-md-10': !vm.showTaxCenterToggle, 'col-sm-10': !vm.showTaxCenterToggle, 'col-xs-9': !vm.showTaxCenterToggle}\">{{access.client.name}}\n" +
    "                        <span ng-show=\"access.relationship && access.relationship.length > 0\">({{access.relationship}})</span>\n" +
    "                        <br />\n" +
    "                    </div>\n" +
    "                    <!-- Client center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.isClientCenterEnabled\" on-change=\"vm.updateIsCenterAccessEnabled(access.client.id);\"></div>\n" +
    "                    </div>\n" +
    "                    <!-- Tax center -->\n" +
    "                    <div class=\"col-md-2 col-sm-2 col-xs-3 text-center\"\n" +
    "                         ng-if=\"vm.showTaxCenterToggle\">\n" +
    "                        <div bento-toggle\n" +
    "                             ng-model=\"access.isTaxCenterEnabled\"></div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "    <div class=\"row\"\n" +
    "         ng-if=\"vm.filteredItems.length == 0\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12 text-center\">\n" +
    "            <h4>\n" +
    "                <small translate=\"Bluemoon.Practice.Common.List.NoResults\"></small>\n" +
    "            </h4>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "<div class=\"row\"\n" +
    "     ng-if=\"vm.data.related.length === 0\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <div class=\"alert alert-info\">\n" +
    "            <span translate=\"Bluemoon.Core.Setup.ContactClientCenterAccess.NoRelationships\"></span>\n" +
    "            <a ui-sref=\"setupContactDetail.relationships.detail\"\n" +
    "               translate=\"Bluemoon.Core.Setup.ClientCenterAccess.AddRelationship\"></a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"bento-alert-container\" ng-if=\"!vm.displayAccess\">\n" +
    "    <div class=\"alert bento-alert alert-warning\" role=\"alert\">\n" +
    "        <span class=\"strong ng-scope\" translate=\"Bluemoon.Core.Setup.Common.PreviewMode.Warning\"></span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/contacts/details/security/contact-detail-security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/details/security/contact-detail-security.html",
    "<ng-form name=\"securityForm\" bmp-detail-view-default-focus=\"vm.data\">\n" +
    "    <h2 class=\"no-top-margin\" translate=\"Bluemoon.Core.Setup.Clients.Detail.Navigation.Security\"></h2>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <tr-user-registration\n" +
    "                 data-tr-user-registration-display-email=\"true\"\n" +
    "                 data-tr-user-registration-client=\"true\"\n" +
    "                 data-tr-user-registration-contact=\"vm.data.contact\"\n" +
    "                 data-tr-user-registration-entity-types=\"vm.entityTypes\"></tr-user-registration>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" style=\"margin-top: 10px;\" ng-if=\"vm.showTaxCenterToggle && vm.data.contact.isClientCenterEnabled && !vm.isLoading\">\n" +
    "        <div class=\"col-md-11 col-md-offset-1 col-sm-11 col-sm-offset-1 col-xs-11 col-xs-offset-1\">\n" +
    "            <span bento-toggle ng-model=\"vm.data.isTaxCenterEnabled\" class=\"tr-user-reg-toggle\" on-change=\"securityForm.$setDirty();\"></span>\n" +
    "            <span data-translate=\"Bluemoon.Core.Setup.EnableTaxCenter\" ng-if=\"!vm.displayVNextStrings\"></span>\n" +
    "            <span data-translate=\"Bluemoon.Core.Setup.EnableTaxCenterVNext\" ng-if=\"vm.displayVNextStrings\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"vm.showTaxCenterToggle && vm.data.contact.isClientCenterEnabled && vm.data.isTaxCenterEnabled && !vm.isLoading\">\n" +
    "        <div class=\"col-md-11 col-md-offset-1 col-sm-11 col-sm-offset-1 col-xs-11 col-xs-offset-1\">\n" +
    "            <h4 translate=\"Bluemoon.Core.Setup.CenterAccessRelatedClients\"></h4>\n" +
    "            <!-- Multiselect Overlay Directive -->\n" +
    "            <!--translate=\"Bluemoon.Core.Setup.TaxCenter.Validation.MustSelectClients\"-->\n" +
    "            <div data-bmp-control-group=\"\">\n" +
    "                <div bento-multiselect-overlay\n" +
    "                    list-data=\"vm.relatedClients\"\n" +
    "                    ng-model=\"vm.selectedClients\"\n" +
    "                    bmp-control-group-field=\"Bluemoon.Core.Setup.CenterAccessRelatedClients\"\n" +
    "                    bmp-custom-validation-defer=\"vm.mustHaveAccessToOneOrMoreClients()\"\n" +
    "                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.TaxCenter.Validation.MustSelectClients\"\n" +
    "                    revert-selections-on-dismissal=\"true\"\n" +
    "                    class=\"setup-bento-multiselect-overlay\"></div>\n" +
    "            </div>\n" +
    "            <br />\n" +
    "            <div class=\"well small\">\n" +
    "                <span ng-if=\"vm.selectedClients.length===0\" translate=\"Bluemoon.Core.Setup.TaxCenter.NoClientsSelected\"></span>\n" +
    "                <span ng-if=\"vm.selectedClients.length>=1\" translate=\"Bluemoon.Core.Setup.TaxCenter.ClientsSelected\"></span>&nbsp;\n" +
    "                <span ng-repeat=\"selected in vm.selectedClients\">\n" +
    "                    <span class=\"label label-info\">{{selected.name}}</span>&nbsp;\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/contacts/details/vat/contact-detail-vat.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/details/vat/contact-detail-vat.html",
    "<ng-form name=\"vatForm\">\n" +
    "    <uk-vat-contact-details\n" +
    "        [contact-id]=\"vm.id\"\n" +
    "        [save-data-to-angular]=\"vm.saveDataToAngular\"\n" +
    "        (save-data-complete)=\"vm.saveCompleted($event)\"\n" +
    "        (show-error)=\"vm.showError($event)\"\n" +
    "        (form-dirty)=\"vm.formDirty($event)\">\n" +
    "    </uk-vat-contact-details>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/contacts/list/contact-list-related-contacts-grid-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/contacts/list/contact-list-related-contacts-grid-template.html",
    "<bmc-related-contacts-list\n" +
    "    item=\"$item\"\n" +
    "    grid-name=\"'ContactGrid'\"\n" +
    "    row=\"$row\"\n" +
    "    id=\"$item.id\"\n" +
    "    contact-id=\"$item.id\">\n" +
    "</bmc-related-contacts-list>");
}]);

angular.module("core-setup/documents/practice-documents.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/documents/practice-documents.html",
    "<dms-nav-breadcrumb\n" +
    "    container-type=\"{{container.itemType}}\"\n" +
    "    container-id=\"{{container.id}}\"\n" +
    "    root-container-type=\"Project\"\n" +
    "    root-container-id=\"{{projectId}}\"\n" +
    "    collapse-length=\"3\"\n" +
    "    item-click-callback=\"breadcrumbItemClicked(item)\"\n" +
    "    item-clickable-callback=\"breadcrumbItemClickable(item)\"\n" +
    "    item-href-callback=\"breadcrumbItemHref()\">\n" +
    "</dms-nav-breadcrumb>\n" +
    "\n" +
    "<dms-document-grid-toolbar container=\"container\" client-id=\"clientId\"></dms-document-grid-toolbar>\n" +
    "\n" +
    "<dms-document-grid\n" +
    "    container=\"container\"\n" +
    "    action-override=\"gridItemActionOverride\"\n" +
    "    client-id=\"clientId\"\n" +
    "    project-id=\"projectId\">\n" +
    "</dms-document-grid>");
}]);

angular.module("core-setup/edit-multiple/edit-multiple-folders/edit-multiple-folders.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/edit-multiple/edit-multiple-folders/edit-multiple-folders.html",
    "<h3 translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Edit.Folders.SubHeader\"></h3>\n" +
    "<br>\n" +
    "<div ng-form name=\"foldersForm\" class=\"client-folder-container\">\n" +
    "    <!-- Add Folder -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"clientFolders\"\n" +
    "        data-bmp-control-group-label=\"\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.project, 'projectTemplate')\"\n" +
    "        class=\"col-md-12 col-sm-12 col-xs-12\"\n" +
    "        ng-repeat=\"folder in folders.foldersArray\">\n" +
    "\n" +
    "        <!-- Remove Folder -->\n" +
    "        <div class=\"col-md-9 col-sm-10 col-xs-12 remove-client-folder-container\">\n" +
    "            <button id=\"remove_client_folder\"\n" +
    "                type=\"button\"\n" +
    "                class=\"btn btn-link no-margin remove-client-folder-button\"\n" +
    "                ng-click=\"folders.removeClientFolder($index)\"\n" +
    "                ng-if=\"folders.foldersArray.length > 1\">\n" +
    "                <span class=\"bento-icon-remove\"></span>\n" +
    "                <span data-translate=\"Bluemoon.Core.Setup.Common.ClientFolders.RemoveAssignment\"></span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <div bm-if-perm=\"OnvioDrive.Documents\" >\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Storage -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"documentFolderOption_{{$index}}\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.EditMultiple.DocumentFolderOption' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderOption')\"\n" +
    "                            class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                            <bmp-enum-combo\n" +
    "                                enum=\"custom\"\n" +
    "                                name=\"documentFolderOption_{{$index}}\"\n" +
    "                                required=\"true\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                bmp-default-focus=\"true\"\n" +
    "                                on-change=\"folders.changeDocumentFolderOption($index);\"\n" +
    "                                ng-model=\"folder.documentFolderOption\"\n" +
    "                                custom-items=\"folders.documentFolderOptions\" >\n" +
    "                            </bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-9 col-sm-12 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div ng-if=\"folder.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"documentFolderTemplateId_{{$index}}\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.EditMultiple.DocumentFolderTemplateId' | translate}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderTemplateId')\"\n" +
    "                                        class=\"col-md-5 col-sm-6 col-xs-6\">\n" +
    "                                        <bmp-select-combo\n" +
    "                                            defer-load=\"true\"\n" +
    "                                            required=\"true\"\n" +
    "                                            on-change=\"folders.changeFolderTemplate($index);\"\n" +
    "                                            name=\"documentFolderTemplateId_{{$index}}\"\n" +
    "                                            list=\"dms-project-templates#dms\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            data-qe-id=\"documentFolderTemplateId_{{$index}}\"\n" +
    "                                            ng-model=\"folder.documentFolderTemplate\"></bmp-select-combo>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div ng-if=\"folder.documentFolderOption.id === 'NEW' || folder.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"documentFolderDefaultName_{{$index}}\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.EditMultiple.DocumentFolderDefaultName' | translate}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderDefaultName')\"\n" +
    "                                        class=\"col-md-5 col-sm-6 col-xs-6\">\n" +
    "                                        <input\n" +
    "                                            autocomplete=\"off\"\n" +
    "                                            data-ng-required=\"true\"\n" +
    "                                            required=\"true\"\n" +
    "                                            ng-required=\"true\"\n" +
    "                                            ng-change=\"folders.changeClientFolder($index);\" class=\"form-control\" name=\"documentFolderDefaultName_{{$index}}\"\n" +
    "                                            data-qe-id=\"documentFolderDefaultName_{{$index}}\"\n" +
    "                                            ng-model=\"folder.documentFolderDefaultName\" />\n" +
    "                                    </div>\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"documentFolderYear_{{$index}}\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Bluemoon.Practice.Common.DateRange.Year' | translate}}\"\n" +
    "                                        class=\"col-md-2 col-sm-6 col-xs-6\">\n" +
    "                                        <input\n" +
    "                                            autocomplete=\"off\"\n" +
    "                                            data-ng-required=\"false\"\n" +
    "                                            required=\"false\"\n" +
    "                                            placeholder=\"{{'Bluemoon.DMS.Modal.Common.YearPlaceholder' | translate}}\"\n" +
    "                                            ng-required=\"false\"\n" +
    "                                            type=\"number\"\n" +
    "                                            ng-change=\"folders.changeClientFolderYear($index);\" class=\"form-control\" name=\"documentFolderYear_{{$index}}\"\n" +
    "                                            data-qe-id=\"documentFolderYear_{{$index}}\"\n" +
    "                                            ng-model=\"folder.documentFolderYear\"\n" +
    "                                            data-bmp-custom-validation-defer = \"folders.isYearValid(folder.documentFolderYear)\"\n" +
    "                                            data-bmp-custom-validation-message = \"Bluemoon.DMS.Modal.NewContainer.Container.InvalidYear\" />\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Add Client Folder -->\n" +
    "    <button id=\"add_new_folder_template\"\n" +
    "        type=\"button\"\n" +
    "        class=\"btn btn-link no-margin\"\n" +
    "        ng-click=\"folders.addClientFolder()\">\n" +
    "        <span class=\"bento-icon-add\"></span>\n" +
    "        <span translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Edit.ClientFolders.AddClientFolder\"></span>\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("core-setup/edit-multiple/edit-multiple-general/edit-multiple-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/edit-multiple/edit-multiple-general/edit-multiple-general.html",
    "<div ng-repeat=\"(group, value) in general.fields\">\n" +
    "    <h3 class=\"setup-section-header-margin\">{{value.label}}</h3>\n" +
    "    <div class=\"row\" ng-repeat=\"(key, field) in value.values\">\n" +
    "        <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"{{key}}\"\n" +
    "            data-bmp-control-group-label=\"{{field.label | translate}}\" bmp-if-firm-permission=\"{{field.firmPermission}}\"\n" +
    "            class=\"col-md-6 col-sm-6 col-xs-11\">\n" +
    "            <bmp-select-combo ng-if=\"field.dataType === 'SELECT'\" list=\"{{field.list}}\" name=\"{{key}}\"\n" +
    "                ng-model=\"field.model\" on-change=\"general.onChange(key, group)\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </bmp-select-combo>\n" +
    "            <bmp-select-combo ng-if=\"field.dataType === 'SELECT-BASIC'\" list=\"{{field.list}}\" name=\"{{key}}\"\n" +
    "                ng-model=\"field.model\" list-style=\"basic\" required=\"field.required\"\n" +
    "                on-change=\"general.onChange(key, group)\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </bmp-select-combo>\n" +
    "            <bmp-bento-datepicker-wrapper ng-if=\"field.dataType === 'DATEPICKER'\" ng-model=\"field.model\"\n" +
    "                placeholder=\"{{field.model.name}}\" name=\"{{key}}\" ng-change=\"general.onChange(key, group)\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </bmp-bento-datepicker-wrapper>\n" +
    "            <bmp-enum-combo ng-if=\"field.dataType === 'ENUM'\" enum=\"custom\" name=\"{{key}}\" ng-model=\"field.model\"\n" +
    "                custom-items=\"field.enumOptions\" ng-disabled=\"general.disableEnum(key, group)\"\n" +
    "                on-change=\"general.onChange(key, group)\" uib-tooltip=\"{{general.getTooltip(key, group)}}\"\n" +
    "                data-tooltip-placement=\"right\" tooltip-append-to-body=\"true\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </bmp-enum-combo>\n" +
    "            <bmp-enum-combo ng-if=\"field.dataType === 'ENUM-BASIC'\" enum=\"{{field.enum}}\" name=\"{{key}}\"\n" +
    "                ng-model=\"field.model\" on-change=\"general.onChange(key, group)\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </bmp-enum-combo>\n" +
    "            <div ng-if=\"field.dataType === 'INPUT-NUMBER'\" class=\"input-group\">\n" +
    "                <span>\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"{{field.min}}\" max=\"{{field.max}}\"\n" +
    "                        name=\"{{key}}\" ng-model=\"field.model\" bmp-integer=\"true\" bmp-clear-value=\"0\"\n" +
    "                        ng-change=\"general.onChange(key, group)\"\n" +
    "                        data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\" />\n" +
    "                </span>\n" +
    "            </div>\n" +
    "            <textarea ng-if=\"field.dataType === 'TEXTAREA'\" rows=\"{{field.rows}}\" name=\"{{key}}\" class=\"form-control\"\n" +
    "                data-ng-model=\"field.model\" data-ng-style=\"{'height':'auto'}\" ng-change=\"general.onChange(key, group)\"\n" +
    "                data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            </textarea>\n" +
    "            <div ng-if=\"field.dataType === 'DATE-RANGE-GRID'\">\n" +
    "                <div ng-repeat=\"range in field.dateRangeArray\"\n" +
    "                    class=\"col-md-{{12 / field.dateRangeArray.length}} col-sm-{{12 / field.dateRangeArray.length}} col-xs-12\">\n" +
    "                    <div class=\"well bm-well\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"{{key}}-{{range.startDate.name}}\"\n" +
    "                                data-bmp-control-group-label=\"{{range.startDate.label | translate}}\" class=\"col-md-11\">\n" +
    "                                <bmp-bento-datepicker-wrapper ng-model=\"range.startDate.model\"\n" +
    "                                    placeholder=\"{{range.startDate.model.name}}\" name=\"{{range.startDate.name}}\"\n" +
    "                                    ng-change=\"general.onChange(key, group)\"\n" +
    "                                    data-qe-id=\"datepicker-{{key}}-{{range.startDate.name}}\">\n" +
    "                                </bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                            <a class=\"undo-button\" ng-show=\"range.startDate.changed\"\n" +
    "                                uib-tooltip=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Edit.Revert' | translate }}\"\n" +
    "                                ng-click=\"general.undoChangesForTargetAndActualDates(key, group, range.startDate)\"\n" +
    "                                data-qe-id=\"undo-{{key}}-{{range.startDate.name}}\">\n" +
    "                                <i class=\"bento-icon-undo revert-changes\"></i>\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"{{key}}-{{range.endDate.name}}\"\n" +
    "                                data-bmp-control-group-label=\"{{range.endDate.label | translate}}\" class=\"col-md-11\">\n" +
    "                                <bmp-bento-datepicker-wrapper ng-model=\"range.endDate.model\"\n" +
    "                                    placeholder=\"{{range.endDate.model.name}}\" name=\"{{range.endDate.name}}\"\n" +
    "                                    ng-change=\"general.onChange(key, group)\"\n" +
    "                                    data-qe-id=\"datepicker-{{key}}-{{range.endDate.name}}\">\n" +
    "                                </bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                            <a class=\"undo-button\" ng-show=\"range.endDate.changed\"\n" +
    "                                uib-tooltip=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Edit.Revert' | translate }}\"\n" +
    "                                ng-click=\"general.undoChangesForTargetAndActualDates(key, group, range.endDate)\"\n" +
    "                                data-qe-id=\"undo-{{key}}-{{range.endDate.name}}\">\n" +
    "                                <i class=\"bento-icon-undo revert-changes\"></i>\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"field.dataType === 'INPUT-TEXT'\">\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"text\" ng-model=\"field.model\"\n" +
    "                    ng-change=\"general.onChange(key, group)\"\n" +
    "                    data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\" />\n" +
    "            </div>\n" +
    "            <div ng-if=\"field.dataType === 'MULTISELECT-OVERLAY'\">\n" +
    "                <div>\n" +
    "                    <div bento-multiselect-overlay list-data=\"field.listAdd\" ng-model=\"general.departmentsAdd\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                        select-button-text=\"{{'Bluemoon.Practice.Common.Actions.Add' | translate }} {{field.label}}\"\n" +
    "                        edit-button-text=\"{{'Bluemoon.Practice.Common.Actions.Add' | translate }} {{field.label}}\"\n" +
    "                        ng-change=\"general.onDepartmentsAdd()\"\n" +
    "                        class=\"setup-bento-multiselect-overlay general-multiselect-overlay\"\n" +
    "                        data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-control-static general-multiselect-list\">\n" +
    "                        <span class=\"label label-info label general-usage-badge\"\n" +
    "                            data-ng-repeat=\"selectedDepartment in general.departmentsAdd track by selectedDepartment.data.id\">\n" +
    "                            {{general.getDepartmentName(selectedDepartment)}}\n" +
    "                            <span data-ng-if=\"selectedDepartment.data.departmentDefault && selectedDepartment.data.departmentDefault === true\">\n" +
    "                                {{'Core.Captions.EmployeeMain.System' | translate}}\n" +
    "                            </span>\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                data-qe-id=\"department-remove-{{general.getDepartmentName(selectedDepartment)}}-button\"\n" +
    "                                data-ng-click=\"general.onDepartmentsRemoveByLabelAdd(selectedDepartment)\"></span>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <div bento-multiselect-overlay list-data=\"field.listRemove\" ng-model=\"general.departmentsRemove\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                        select-button-text=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Review.Remove' | translate }} {{field.label}}\"\n" +
    "                        edit-button-text=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Review.Remove' | translate }} {{field.label}}\"\n" +
    "                        ng-change=\"general.onDepartmentsRemove()\"\n" +
    "                        class=\"setup-bento-multiselect-overlay general-multiselect-overlay\"\n" +
    "                        data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-control-static general-multiselect-list\">\n" +
    "                        <span class=\"label label-info label general-usage-badge\"\n" +
    "                            data-ng-repeat=\"selectedDepartment in general.departmentsRemove track by selectedDepartment.data.id\">\n" +
    "                            {{general.getDepartmentName(selectedDepartment)}}\n" +
    "                            <span data-ng-if=\"selectedDepartment.data.departmentDefault && selectedDepartment.data.departmentDefault === true\">\n" +
    "                                {{'Core.Captions.EmployeeMain.System' | translate}}\n" +
    "                            </span>\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                data-qe-id=\"department-remove-{{general.getDepartmentName(selectedDepartment)}}-button\"\n" +
    "                                data-ng-click=\"general.onDepartmentsRemoveByLabelRemove(selectedDepartment)\"></span>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"field.dataType === 'MULTISELECT-OVERLAY-INNER'\">\n" +
    "                <div>\n" +
    "                    <div bento-multiselect-overlay list-data=\"field.listAdd\" ng-model=\"general.secondaryAssignmentsAdd\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                        select-button-text=\"{{'Bluemoon.Practice.Common.Actions.Add' | translate }} {{field.label}}\"\n" +
    "                        edit-button-text=\"{{'Bluemoon.Practice.Common.Actions.Add' | translate }} {{field.label}}\"\n" +
    "                        ng-change=\"general.onSecondaryAssignmentsAdd()\"\n" +
    "                        class=\"setup-bento-multiselect-overlay general-multiselect-overlay\"\n" +
    "                        data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-control-static general-multiselect-list\">\n" +
    "                        <span class=\"label label-info label general-usage-badge\"\n" +
    "                            data-ng-repeat=\"selectedSecondaryAssignment in general.secondaryAssignmentsAdd\">\n" +
    "                            {{selectedSecondaryAssignment.name}}\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                data-qe-id=\"secondaryAssignment-remove-{{selectedSecondaryAssignment.name}}-button\"\n" +
    "                                data-ng-click=\"general.onSecondaryAssignmentsRemoveByLabelAdd(selectedSecondaryAssignment)\"></span>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <div bento-multiselect-overlay list-data=\"field.listRemove\" ng-model=\"general.secondaryAssignmentsRemove\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                        select-button-text=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Review.Remove' | translate }} {{field.label}}\"\n" +
    "                        edit-button-text=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Review.Remove' | translate }} {{field.label}}\"\n" +
    "                        ng-change=\"general.onSecondaryAssignmentsRemove()\"\n" +
    "                        class=\"setup-bento-multiselect-overlay general-multiselect-overlay\"\n" +
    "                        data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-control-static general-multiselect-list\">\n" +
    "                        <span class=\"label label-info label general-usage-badge\"\n" +
    "                            data-ng-repeat=\"selectedSecondaryAssignment in general.secondaryAssignmentsRemove\">\n" +
    "                            {{selectedSecondaryAssignment.name}}\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                data-qe-id=\"secondaryAssignment-remove-{{selectedSecondaryAssignment.name}}-button\"\n" +
    "                                data-ng-click=\"general.onSecondaryAssignmentsRemoveByLabelRemove(selectedSecondaryAssignment)\"></span>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <a class=\"undo-button\" ng-show=\"field.changed && key !== 'targetAndActualDates'\"\n" +
    "            uib-tooltip=\"{{'Bluemoon.Core.Setup.EditMultiple.Common.Edit.Revert' | translate }}\"\n" +
    "            ng-click=\"general.undoChanges(key, group)\" data-qe-id=\"bm-editMultipleProjects-{{key}}-{{field.dataType}}\">\n" +
    "            <i class=\"bento-icon-undo revert-changes\"></i>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/edit-multiple/edit-multiple-onvio-access/edit-multiple-onvio-access.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/edit-multiple/edit-multiple-onvio-access/edit-multiple-onvio-access.html",
    "<h3 translation=\"Bluemoon.Core.Setup.EditMultiple.Staff.OnvioAccess.Title\"></h3>\n" +
    "<div class=\"col-md-12\">\n" +
    "    <label>\n" +
    "        <input\n" +
    "            type=\"radio\"\n" +
    "            data-ng-value=\"true\"\n" +
    "            ng-change=\"access.onOnvioAccessChange()\"\n" +
    "            ng-model=\"access.onvioAccess\">\n" +
    "        <span translate=\"Bluemoon.Core.Setup.EditMultiple.Staff.EnableOnvio\"></span>\n" +
    "    </label>\n" +
    "    <br>\n" +
    "    <label>\n" +
    "        <input\n" +
    "            type=\"radio\"\n" +
    "            data-ng-value=\"false\"\n" +
    "            ng-change=\"access.onOnvioAccessChange()\"\n" +
    "            ng-model=\"access.onvioAccess\">\n" +
    "        <span translate=\"Bluemoon.Core.Setup.EditMultiple.Staff.DisableOnvio\"></span>\n" +
    "    </label>\n" +
    "</div>\n" +
    "<div class=\"col-md-6\" ng-if=\"access.onvioAccess\">\n" +
    "    <br>\n" +
    "    <div data-bmp-control-group=\"\" >\n" +
    "        <label class=\"strong\" translate=\"Bluemoon.Core.Setup.Groups.Title\" bm-required-mark></label>\n" +
    "        <div bento-multiselect-overlay\n" +
    "            list-data=\"access.permissionList\"\n" +
    "            ng-change=\"access.onOnvioAccessChange();\"\n" +
    "            ng-model=\"access.permissionSelected\"\n" +
    "            revert-selections-on-dismissal=\"false\"\n" +
    "            sort=\"true\"\n" +
    "            bmp-control-group-field=\"Bluemoon.Core.Setup.Groups.Title\"\n" +
    "            bmp-custom-validation-defer=\"access.mustHaveAccessToOneOrMoreGroups()\"\n" +
    "            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Groups.Validation.MustSelectGroups\"\n" +
    "            class=\"setup-bento-multiselect-overlay\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <p class=\"well\">\n" +
    "        <strong translate=\"Bluemoon.Core.Setup.Groups.SelectedGroups\"></strong>\n" +
    "        <span ng-repeat=\"item in access.permissionSelected\">\n" +
    "            <span class=\"label label-success\">{{item.name}}</span>\n" +
    "        </span>\n" +
    "    </p>\n" +
    "</div>");
}]);

angular.module("core-setup/edit-multiple/edit-multiple-templates/edit-multiple-templates.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/edit-multiple/edit-multiple-templates/edit-multiple-templates.html",
    "<h3>{{templates.templateOptions.headerText}}</h3>\n" +
    "<br>\n" +
    "<div class=\"template-container\">\n" +
    "    <!-- Template -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"template_{{$index}}\"\n" +
    "        data-bmp-control-group-label=\"{{templates.templateOptions.label}}\"\n" +
    "        class=\"col-md-12 col-sm-12 col-xs-12\"\n" +
    "        ng-repeat=\"template in templates.templatesArray\" ng-init=\"$last && templates.updateFocus()\">\n" +
    "\n" +
    "        <!-- Remove Template -->\n" +
    "        <div class=\"col-md-8 col-sm-10 col-xs-12 remove-template-container\">\n" +
    "            <button type=\"button\"\n" +
    "                    class=\"btn btn-link no-margin remove-template-button\"\n" +
    "                    ng-click=\"templates.removeTemplate($index)\"\n" +
    "                    ng-if=\"templates.templatesArray.length > 1\">\n" +
    "                <span class=\"bento-icon-remove\"></span>\n" +
    "                <span translate=\"Bluemoon.Core.Setup.Common.ProjectTemplates.RemoveAssignment\"></span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <bmp-select-combo\n" +
    "                    list=\"{{templates.templateOptions.listType}}\"\n" +
    "                    name=\"template\"\n" +
    "                    ng-model=\"templates.templatesArray[$index]\"\n" +
    "                    on-change=\"templates.changeTemplate($index)\">\n" +
    "                </bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Add Template -->\n" +
    "    <button type=\"button\"\n" +
    "            class=\"btn btn-link no-margin\"\n" +
    "            ng-click=\"templates.addTemplate()\">\n" +
    "        <span class=\"bento-icon-add\"></span>\n" +
    "        <span>{{templates.templateOptions.addText}}</span>\n" +
    "    </button>\n" +
    "</div>");
}]);

angular.module("core-setup/edit-multiple/edit-multiple.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/edit-multiple/edit-multiple.html",
    "<div class=\"modal-body no-margin edit-multiple-wizard\">\n" +
    "    <bmp-page-header\n" +
    "        is-in-modal=\"true\"\n" +
    "        header-class-fn=\"$em.headerFunction()\"\n" +
    "        location=\"{{'/edit-multiple-' + $em.strings.modelType}}\"\n" +
    "        show-help=\"true\">\n" +
    "        <bmp-page-header-left-content>\n" +
    "            <h1>{{$em.strings.wizardHeader}}</h1>\n" +
    "        </bmp-page-header-left-content>\n" +
    "    </bmp-page-header>\n" +
    "    <div bento-wizard\n" +
    "         on-change=\"$em.onWizardChange(step)\"\n" +
    "         on-finish=\"$em.onWizardFinish()\"\n" +
    "         on-cancel=\"$em.onCancel(step)\"\n" +
    "         use-side-arrows=\"false\"\n" +
    "         current-step=\"step\"\n" +
    "         total-step=\"totalStep\"\n" +
    "         show-cancel-button=\"!$em.hasErrors\"\n" +
    "         hide-next-button=\"$em.hasErrors\"\n" +
    "         hide-previous-button=\"$em.hasErrors\">\n" +
    "        <div ng-form id=\"edit-multiple-wizard\" name=\"editMultipleWizardForm\" autocomplete=\"off\" ng-class=\"{'has-errors': $em.hasErrors}\">\n" +
    "            <!-- Define step titles and descriptions -->\n" +
    "            <ol class=\"steps\">\n" +
    "                <li>\n" +
    "                    <span class=\"title\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Choose.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Choose.Description\"></span>\n" +
    "                </li>\n" +
    "                <li ng-disabled=\"!$em.chooseToEdit\">\n" +
    "                    <span class=\"title\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Edit.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Edit.Description\"></span>\n" +
    "                </li>\n" +
    "                <li ng-disabled=\"!$em.isReviewStepEnabled()\">\n" +
    "                    <span class=\"title\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Review.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Review.Description\"></span>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "\n" +
    "            <!-- Define step content; within each list item, content is completely arbitrary -->\n" +
    "            <div class=\"contents-spacer\"></div>\n" +
    "            <ul class=\"contents\">\n" +
    "                <li class=\"choose-to-edit\">\n" +
    "                    <h1>{{$em.strings.chooseHeader}}</h1>\n" +
    "                    <br>\n" +
    "                    <div ng-repeat=\"(setting, value) in $em.settings\">\n" +
    "                        <div ng-if=\"value.permission\" ng-attr-data-qe-id=\"{{value.dataQeId}}\">\n" +
    "                            <label bm-if-perm-every=\"value.permission\">\n" +
    "                                <input type=\"radio\" value=\"{{setting}}\" ng-model=\"$em.chooseToEdit\">\n" +
    "                                <span translate=\"{{value.label}}\"></span>\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"value.license\">\n" +
    "                            <label bm-if-has-license-every=\"value.license\">\n" +
    "                                <input type=\"radio\" value=\"{{setting}}\" ng-model=\"$em.chooseToEdit\">\n" +
    "                                <span translate=\"{{value.label}}\"></span>\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"value.access\">\n" +
    "                            <label bm-if-has-access-every=\"value.license\">\n" +
    "                                <input type=\"radio\" value=\"{{setting}}\" ng-model=\"$em.chooseToEdit\">\n" +
    "                                <span translate=\"{{value.label}}\"></span>\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"!value.permission && !value.license && !value.access\">\n" +
    "                            <label>\n" +
    "                                <input type=\"radio\" value=\"{{setting}}\" ng-model=\"$em.chooseToEdit\">\n" +
    "                                <span translate=\"{{value.label}}\"></span>\n" +
    "                            </label>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"$em.entityType === 'contacts'\">\n" +
    "                        <h1 translate=\"Bluemoon.Core.Setup.EditMultiple.Contacts.Choose.Header\"></h1>\n" +
    "                        <label>\n" +
    "                            <input type=\"radio\" value=\"general\" ng-model=\"$em.chooseToEdit\">\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Choose.Option.General\"></span>\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <li bento-busy-loader=\"$em.isChangesTabLoading\">\n" +
    "                    <h1 translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Edit.Description\"></h1>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                            <ng-transclude>\n" +
    "                            </ng-transclude>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "                <!-- Review Tab -->\n" +
    "                <li bento-busy-loader=\"$em.isReviewTabLoading\">\n" +
    "                    <h1 translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Review.Title\" ng-if=\"!$em.hasErrors\"></h1>\n" +
    "                    <div class=\"alert bento-alert alert-danger error-banner\" ng-if=\"$em.hasErrors\">\n" +
    "                        <span translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Error.Header\"></span>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                            <b translate=\"Bluemoon.Core.Setup.EditMultiple.Common.Review.General.SelectedChanges\"></b>\n" +
    "                            <div class=\"selected-changes\">\n" +
    "                                <div ng-repeat=\"reviewString in $em.childController.getReviewStrings() track by $index\">\n" +
    "                                    <span>{{reviewString}}</span>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"toggle-grid-container\" ng-if=\"!$em.hasErrors\">\n" +
    "                                <span ng-bind-html=\"$em.getSelectChangesString()\"></span>\n" +
    "                                <div class=\"toggle-grid-button\">\n" +
    "                                    <a ng-click=\"$em.toggleGrid()\">\n" +
    "                                        <span ng-show=\"!$em.displayReviewGrid\" translate=\"Bluemoon.Core.Setup.ShowDetails\"></span>\n" +
    "                                        <span ng-show=\"$em.displayReviewGrid\" translate=\"Bluemoon.Core.Setup.HideDetails\"></span>\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Review/Error Report Grid -->\n" +
    "                        <div ng-if=\"$em.currentStep === 2\" ng-show=\"$em.displayReviewGrid || $em.hasErrors\">\n" +
    "                            <div class=\"col-md-12 review-grid-container\">\n" +
    "                                <div bento-toolbar\n" +
    "                                     class=\"navbar navbar-default bento-toolbar\"\n" +
    "                                     toolbar-data=\"$em.toolbarButtons\">\n" +
    "                                </div>\n" +
    "                                <wj-flex-grid\n" +
    "                                    class=\"bento-flex-grid\"\n" +
    "                                    id=\"edit-multiple-grid\"\n" +
    "                                    is-read-only=\"true\"\n" +
    "                                    items-source=\"$em.collectionView\"\n" +
    "                                    show-errors=\"true\"\n" +
    "                                    allow-sorting=\"true\"\n" +
    "                                    show-sort=\"true\"\n" +
    "                                    headers-visibility=\"Column\"\n" +
    "                                    initialized=\"$em.InitReviewGrid(s,e)\">\n" +
    "                                    <wj-flex-grid-column header=\"\" width=\"40\" binding=\"_selected\" align=\"center\" css-class=\"col-select\">\n" +
    "                                        <wj-flex-grid-cell-template cell-type=\"ColumnHeader\">\n" +
    "                                                <div class=\"col-select\">\n" +
    "                                                </div>\n" +
    "                                        </wj-flex-grid-cell-template>\n" +
    "                                        <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                            <i class=\"bento-flex-grid-checkbox bmp-wijmo-table-vertically-center\"\n" +
    "                                                ng-if=\"$item && !$item.$isRowDirty\"\n" +
    "                                                ng-click=\"$item._selected = !$item._selected;$em.onReviewGridCheckboxChange();\"\n" +
    "                                                ng-class=\"{'bento-icon-checkmark':$item._selected === true,'disabled':$item.disabled === true}\">\n" +
    "                                            </i>\n" +
    "                                        </wj-flex-grid-cell-template>\n" +
    "                                    </wj-flex-grid-column>\n" +
    "                                    <wj-flex-grid-column ng-if=\"$em.hasErrors\" name=\"warning\" header=\"\" binding=\"\" width=\"75\" allow-dragging=\"false\"\n" +
    "                                        align=\"center\">\n" +
    "                                        <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                            <span>\n" +
    "                                                <a data-qe-id=\"error-icon\" class=\"bmp-wijmo-table-actions-column-icon-item error-icon\">\n" +
    "                                                    <span class=\"bento-icon-warning\"\n" +
    "                                                        data-tooltip-placement=\"right\"\n" +
    "                                                        data-tooltip-trigger=\"mouseenter\"\n" +
    "                                                        data-uib-tooltip=\"{{$em.getErrorTooltipForGeneral($row.dataItem) || $row.dataItem.errorString}}\"\n" +
    "                                                        data-tooltip-append-to-body=\"true\">\n" +
    "                                                    </span>\n" +
    "                                                </a>\n" +
    "                                            </span>\n" +
    "                                        </wj-flex-grid-cell-template>\n" +
    "                                    </wj-flex-grid-column>\n" +
    "                                    <wj-flex-grid-column\n" +
    "                                        ng-repeat=\"column in $em.preModelGridColumns\"\n" +
    "                                        header=\"{{column.label}}\"\n" +
    "                                        binding=\"{{column.binding}}\"\n" +
    "                                        binding=\"name\"\n" +
    "                                        width=\"*\">\n" +
    "                                    </wj-flex-grid-column>\n" +
    "                                    <wj-flex-grid-column\n" +
    "                                        header=\"{{$em.strings.gridColumn}}\"\n" +
    "                                        binding=\"name\"\n" +
    "                                        width=\"*\">\n" +
    "                                    </wj-flex-grid-column>\n" +
    "                                    <wj-flex-grid-column\n" +
    "                                        ng-repeat=\"column in $em.gridColumns\"\n" +
    "                                        header=\"{{column.label}}\"\n" +
    "                                        binding=\"{{column.binding}}\"\n" +
    "                                        visible=\"{{column.visible}}\"\n" +
    "                                        width=\"*\">\n" +
    "                                        <wj-flex-grid-cell-template cell-type=\"Cell\" ng-if=\"column.customTemplate\">\n" +
    "                                            <div tooltip-append-to-body=\"true\" uib-tooltip=\"{{$em.formatTooltipForReview($row.dataItem.templatesNames)}}\"\n" +
    "                                                tooltip-placement=\"left\">\n" +
    "                                                <span class=\"label label-info\" ng-repeat=\"label in $row.dataItem.templatesNames.split(';') track by $index\">{{label}}</span>\n" +
    "                                            </div>\n" +
    "                                        </wj-flex-grid-cell-template>\n" +
    "                                    </wj-flex-grid-column>\n" +
    "                                </wj-flex-grid>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/employees/details/general/employee-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/details/general/employee-detail-general.html",
    "<div ng-hide=\"vm.contactEditorIsLoading\">\n" +
    "    <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Employees.Detail.Navigation.General' | translate}}</h2>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"!vm.detail.isLoadingData()\">\n" +
    "        <!-- Code/ID -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.Employee.Code' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"code\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Employee.Code' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'code')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                id=\"code\"\n" +
    "                name=\"code\"\n" +
    "                class=\"form-control\"\n" +
    "                data-ng-model=\"vm.data.code\"\n" +
    "                data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'code')\"\n" +
    "                data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                data-ng-required=\"true\"\n" +
    "                data-bmp-entity-code=\"\"\n" +
    "                data-bmp-entity-code-id=\"vm.id\"\n" +
    "                data-bmp-entity-code-type=\"employees\"\n" +
    "                data-bm-focus-on-link=\"\"\n" +
    "                data-bm-focus-on-event=\"'bm.core.setup.common.contactSelectedEvent'\"\n" +
    "                data-fef-maxlength=\"20\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- TODO - KMS - need to figure out CSS here... also, should this go on ContactEditor.html? Plus, we are getting programmer errors from the backend... -->\n" +
    "    <!-- alert alert-danger -->\n" +
    "    <div class=\"msg\">{{vm.detail.errorFor(vm.data, 'primaryContact')}}</div>\n" +
    "    <div data-onvio-contact-editor=\"vm.data.primaryContactExpanded\"\n" +
    "        contact-name-validation-service=\"vm.contactNameValidationService\"\n" +
    "        data-onvio-contact-editor-parent-form=\"employeeForm\"\n" +
    "        data-onvio-contact-editor-contact-selected=\"vm.onContactSelected()\"\n" +
    "        data-onvio-contact-editor-display-as-rule-changed=\"vm.onDisplayAsRuleChanged()\"\n" +
    "        data-onvio-contact-editor-entity-type-changed=\"vm.onEntityTypeChanged()\"\n" +
    "        data-onvio-contact-editor-valid-entity-types=\"vm.entityOptions\"\n" +
    "        data-onvio-contact-editor-entity-types=\"vm.entityTypes\"\n" +
    "        data-onvio-contact-editor-exclude-employee-contacts=\"true\"\n" +
    "        data-onvio-contact-editor-show-confidentiality=\"false\"\n" +
    "        data-onvio-contact-editor-is-loading=\"vm.contactEditorIsLoading\"\n" +
    "        data-onvio-contact-editor-analytics-context=\"'setup_staffDetail_general'\">\n" +
    "        </div>\n" +
    "\n" +
    "    <!-- Groupings -->\n" +
    "    <div class=\"row\" data-ng-if=\"vm.data.employeeMainExpanded\">\n" +
    "        <div class=\"col-md-12\" bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "            <h3 class=\"setup-section-header-margin\"\n" +
    "                data-translate=\"Bluemoon.Core.Setup.Employees.EmployeeDetail.EmployeeGroupingSectionHeader\"></h3>\n" +
    "\n" +
    "            <!-- Office -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"office\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.Office' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.employeeMainExpanded, 'office')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"offices\" name=\"office\"\n" +
    "                                    ng-model=\"vm.data.employeeMainExpanded.office\" aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Department -->\n" +
    "            <div class=\"row\" bm-if-perm=\"OnvioSetup.Departments\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"department\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.Departments' | translate}}\"\n" +
    "                    class=\"col-md-8\">\n" +
    "                    <div bento-multiselect-overlay\n" +
    "                        list-data=\"vm.relatedDepartments\"\n" +
    "                        ng-model=\"vm.selectedDepartments\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                        class=\"setup-bento-multiselect-overlay setup-common-employee-detail-general-multiselect-overlay\">\n" +
    "                    </div>\n" +
    "                    <div class=\"form-control-static setup-common-employee-detail-general-multiselect-list\">\n" +
    "                        <span class=\"label label-info label setup-common-employee-detail-general-usage-badge\"\n" +
    "                            data-ng-repeat=\"selectedDepartment in vm.selectedDepartments track by selectedDepartment.data.id\">\n" +
    "                            {{vm.getDepartmentName(selectedDepartment)}}\n" +
    "                            <span data-ng-if=\"selectedDepartment.data.departmentDefault && selectedDepartment.data.departmentDefault === true\">\n" +
    "                                {{'Core.Captions.EmployeeMain.System' | translate}}\n" +
    "                            </span>\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                    data-qe-id=\"department-remove-{{vm.getDepartmentName(selectedDepartment)}}-button\"\n" +
    "                                    data-ng-click=\"vm.onRemoveDepartmentByLabel(selectedDepartment)\"></span>\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Supervisor -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"supervisorEmployee\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.SupervisorEmployee' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.employeeMainExpanded, 'supervisorEmployee')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"staff#active\" name=\"supervisorEmployee\"\n" +
    "                                    ng-model=\"vm.data.employeeMainExpanded.supervisorEmployee\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Level -->\n" +
    "            <div class=\"row\" bm-if-perm=\"OnvioSetup.StaffLevels\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"employeeLevel\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.EmployeeLevel' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.employeeMainExpanded, 'employeeLevel')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"employee-levels\" name=\"employeeLevel\"\n" +
    "                                    ng-model=\"vm.data.employeeMainExpanded.employeeLevel\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Employee Information -->\n" +
    "    <div class=\"row\" bm-if-not-perm=\"USTax.PlatformEA\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\"\n" +
    "                data-translate=\"Bluemoon.Core.Setup.Employees.EmployeeDetail.EmployeeInformationSectionHeader\"></h3>\n" +
    "\n" +
    "            <!-- Status -->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"status\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.Status' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(data.employeeMainExpanded, 'status')\"\n" +
    "                    class=\"col-md-6 col-sm-8 col-xs-12\">\n" +
    "                    <bmp-radio-button-group id=\"status\"\n" +
    "                                            name=\"status\"\n" +
    "                                            data-bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                            data-ng-model=\"vm.data.employeeMainExpanded.status\"\n" +
    "                                            data-ng-change=\"vm.onStatusChanged()\"\n" +
    "                                            data-bmp-radio-button-group-options=\"vm.statusOptions\"></bmp-radio-button-group>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" data-ng-if=\"vm.data.employeeMainExpanded\">\n" +
    "                <!-- Hire Date -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"dateHired\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.DateHired' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.employeeMainExpanded, 'dateHired')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper ng-model=\"vm.data.employeeMainExpanded.dateHired\"\n" +
    "                                                    name=\"dateHired\"\n" +
    "                                                    id=\"dateHired\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Left Date -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"dateLeft\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.EmployeeMain.DateLeft' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.employeeMainExpanded, 'dateLeft')\"\n" +
    "                    class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper ng-model=\"vm.data.employeeMainExpanded.dateLeft\"\n" +
    "                                                    ng-change=\"vm.onLeftDateChanged()\"\n" +
    "                                                    name=\"dateLeft\"\n" +
    "                                                    id=\"dateLeft\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3 data-ng-if=\"vm.data.primaryContactExpanded.id\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "        <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.primaryContactExpanded.id\" [entity-name]=\"vm.data.primaryContactExpanded.displayAs\">\n" +
    "        </bmcn-notes>\n" +
    "    </h3>\n" +
    "  <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/employees/details/rates/employee-detail-rates.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/details/rates/employee-detail-rates.html",
    "<!--vm is EmployeeDetailRatesController-->\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <div data-onvio-employee-rate=\"vm.id\"\n" +
    "             data-onvio-employee-rate-in-edit-mode=\"vm.inEditMode\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/employees/details/roles/employee-detail-roles-preparer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/details/roles/employee-detail-roles-preparer.html",
    "<!-- Preparer alert -->\n" +
    "<div class=\"row\" data-ng-if=\"!vm.contactRoleData.preparer.enabled\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <div class=\"alert alert-info\">\n" +
    "            {{vm.getPreparerRoleAssignmentMessage()}}\n" +
    "            <small class=\"pull-right\"><a data-qe-id=\"roleAssignmentLinkMessage\" data-ng-click=\"vm.enablePreparer()\">{{vm.getPreparerRoleAssignmentLinkMessage()}}</a></small>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" data-ng-if=\"vm.contactRoleData.preparer.enabled\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <!-- Preparer Information -->\n" +
    "        <h3>{{vm.getPreparerInformationHeading()}}</h3>\n" +
    "        <div class=\"row\">\n" +
    "            <!--Tax Agent Number for US-->\n" +
    "            <div  data-ng-if=\"vm.USTaxEnabled\"\n" +
    "             data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"preparerPersonalIdentifier\"\n" +
    "            data-bmp-control-group-label=\"{{vm.showPersonalIdentifierLabel()}}\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"preparerPersonalIdentifier\"\n" +
    "                data-ng-model=\"vm.contactRoleData.preparer.personalIdentifier\"\n" +
    "                data-bmp-custom-validation-defer=\"vm.isUSPersonalIdentifierValid(vm.contactRoleData.preparer.personalIdentifier)\"\n" +
    "                data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.PersonalIdentifierValidationMessage' | translate}}\"\n" +
    "                data-fef-maxlength=\"9\" bm-capitalize-on-blur data-qe-id=\"usPreparerPersonalIdentifier\" />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showDesigneePin()\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"preparerDesigneePin\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DesigneePersonalId' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"preparerDesigneePin\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.usPreparer.designeePersonalId\"\n" +
    "                    data-bmp-custom-validation-defer=\"vm.isDesigneePinValid(vm.contactRoleData.preparer.usPreparer.designeePersonalId)\"\n" +
    "                    data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.DesigneePinValidationMessage' | translate}}\"\n" +
    "                    data-fef-maxlength=\"5\"  data-qe-id=\"preparerDesigneePin\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showDefaultDesigneeIsOther()\">\n" +
    "            <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <input name=\"defaultDesigneeIsOther\" autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneeIsOther\"\n" +
    "                    data-qe-id=\"defaultDesigneeIsOther\"\n" +
    "                    />{{'Core.Captions.USPreparerRole.DefaultDesigneeIsOther' | translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"well bm-well\" data-ng-if=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneeIsOther\">\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"defaultDesigneeName\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DefaultDesigneeName' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"defaultDesigneeName\" data-qe-id=\"defaultDesigneeName\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneeName\" data-fef-maxlength=\"250\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"defaultDesigneePin\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DefaultDesigneePin' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"defaultDesigneePin\" data-qe-id=\"defaultDesigneePin\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneePin\" data-fef-maxlength=\"5\"\n" +
    "                        data-bmp-custom-validation-defer=\"vm.isDesigneePinValid(vm.contactRoleData.preparer.usPreparer.defaultDesigneePin)\"\n" +
    "                        data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.DesigneePinValidationMessage' | translate}}\"/>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"defaultDesigneeEmailAddress\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DefaultDesigneeEmailAddress' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"defaultDesigneeEmailAddress\" data-qe-id=\"defaultDesigneeEmailAddress\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneeEmailAddress\" data-fef-maxlength=\"250\"\n" +
    "                        blue-moon-email-validation />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"defaultDesigneePhoneNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DefaultDesigneePhoneNumber' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"defaultDesigneePhoneNumber\" data-qe-id=\"defaultDesigneePhoneNumber\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneePhoneNumber\" data-fef-maxlength=\"50\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "             <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"defaultDesigneeForeignPhoneNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.DefaultDesigneeForeignPhoneNumber' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"defaultDesigneeForeignPhoneNumber\" data-qe-id=\"defaultDesigneeForeignPhoneNumber\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.defaultDesigneeForeignPhoneNumber\" data-fef-maxlength=\"50\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Electronic Filing Information -->\n" +
    "        <div data-ng-if=\"vm.USTaxEnabled\">\n" +
    "            <h3>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.ElectronicFilingInformation' | translate}}</h3>\n" +
    "            <h4>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.EFINAndEROinfo' | translate}}</h4>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"preparerElectronicFilingId\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.ElectronicFilingId' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"preparerElectronicFilingId\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.electronicFilingId\"\n" +
    "                        data-bmp-custom-validation-defer=\"vm.isElectronicFilingIdValid(vm.contactRoleData.preparer.electronicFilingId)\"\n" +
    "                        data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.ElectronicFilingIdValidationMessage' | translate}}\"\n" +
    "                        data-fef-maxlength=\"6\" data-qe-id=\"preparerElectronicFilingId\"/>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"electronicReturnOriginator\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.ElectronicReturnOriginator' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <bmp-select-combo list=\"contact-roles\" name=\"electronicReturnOriginator\"\n" +
    "                                    data-qe-id=\"electronicReturnOriginator\"\n" +
    "                                    data-ng-disabled=\"vm.disableAssignERO()\"\n" +
    "                                    ng-model=\"vm.contactRoleData.preparer.usPreparer.electronicReturnOriginator\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Print Options -->\n" +
    "        <div data-ng-if=\"vm.showPrintOptions()\">\n" +
    "            <h3>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.PrintOptionsHeading'\n" +
    "                | translate}}</h3>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <div class=\"checkbox\">\n" +
    "                        <input name=\"isSelfEmployed\" autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.preparer.usPreparer.isSelfEmployed\"\n" +
    "                        data-qe-id=\"isSelfEmployed\"\n" +
    "                        />{{'Core.Captions.USPreparerRole.IsSelfEmployed'\n" +
    "                        | translate}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <div class=\"checkbox\">\n" +
    "                        <input name=\"printNameInSignatureBlock\" autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.preparer.usPreparer.printNameInSignatureBlock\"\n" +
    "                        data-qe-id=\"printNameInSignatureBlock\"\n" +
    "                        />{{'Core.Captions.USPreparerRole.PrintNameInSignatureBlock' | translate}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- State Options -->\n" +
    "        <div data-ng-if=\"vm.showStateOptions()\">\n" +
    "            <h3>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Preparer.StateOptionsHeading'\n" +
    "                | translate}}</h3>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"checkbox\">\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.preparer.usPreparer.useSignature\"\n" +
    "                        data-qe-id=\"useSignature\" name=\"useSignature\"\n" +
    "                        /> {{'Core.Captions.USPreparerRole.UseSignature'|\n" +
    "                        translate}}\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"preparerTitle\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.Title' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"preparerTitle\" data-qe-id=\"preparerTitle\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.title\"\n" +
    "                    />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- California, Form 3596 -->\n" +
    "        <div data-ng-if=\"vm.showUSCAOptions()\">\n" +
    "            <div class=\"row\">\n" +
    "                <!--California Registration Number-->\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerCAEnrollmentNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.CAEnrollmentNumber' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerCAEnrollmentNumber\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.caEnrollmentNumber\" data-qe-id=\"usTaxPreparerCAEnrollmentNumber\"\n" +
    "                        data-fef-maxlength=\"20\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!--California Registration Type-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerCAEnrollmentType\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.CAEnrollmentType' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <bmp-enum-combo enum=\"us-ca-enrollment-types\" name=\"usTaxPreparerCAEnrollmentType\"\n" +
    "                        ng-model=\"vm.contactRoleData.preparer.usPreparer.caEnrollmentType\" data-qe-id=\"usTaxPreparerCAEnrollmentType\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "\n" +
    "            <!--California Registration Other Type-->\n" +
    "                <div data-ng-if=\"vm.isOtherCAEnrollmentType()\">\n" +
    "                    <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerCAEnrollmentTypeSpecified\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.CAOtherEnrollmentType' | translate}}\"\n" +
    "                        class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                        <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerCAEnrollmentTypeSpecified\"\n" +
    "                            data-ng-model=\"vm.contactRoleData.preparer.usPreparer.caOtherEnrollmentType\" data-qe-id=\"usTaxPreparerCAEnrollmentTypeSpecified\"\n" +
    "                            data-fef-maxlength=\"18\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!--California Registration State-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerCAEnrollmentStateProvince\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.CAEnrollmentState' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <input autocomplete=\"off\" id=\"caEnrollmentState\" name=\"usTaxPreparerCAEnrollmentStateProvince\"\n" +
    "                        data-qe-id=\"usTaxPreparerCAEnrollmentStateProvince\" class=\"form-control\"\n" +
    "                        type=\"text\" uib-typeahead=\"province.name as province.name for province in vm.californiaStateProvinceOptions($viewValue)\"\n" +
    "                        typeahead-wait-ms=\"10\" typeahead-focus-first=\"true\"\n" +
    "                        typeahead-on-select=\"vm.onCaliforniaStateProvinceSelected($item, $index)\"\n" +
    "                        ng-blur=\"vm.onCaliforniaStateProvinceBlur(registration)\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.caEnrollmentState.name\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- New Mexico CRS Identification Number -->\n" +
    "\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showUSNMOptions()\">\n" +
    "            <!--New Mexico Registration Number-->\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerNMCRSNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.NMCrsIdNumber' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerNMCRSNumber\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.usPreparer.nmCrsIdNumber\" data-qe-id=\"usTaxPreparerNMCRSNumber\"\n" +
    "                    data-fef-maxlength=\"13\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- New York Registration Number -->\n" +
    "        <div data-ng-if=\"vm.showUSNYOptions()\">\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "                <!--New York Registration Number-->\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerNYRegistrationNumber\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.NYRegistrationNumber' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerNYRegistrationNumber\"\n" +
    "                        data-ng-model=\"vm.contactRoleData.preparer.usPreparer.nyRegistrationNumber\" data-qe-id=\"usTaxPreparerNYRegistrationNumber\"\n" +
    "                        data-fef-maxlength=\"8\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!--New York Exclusion Code-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerNYExclusionType\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.NYExclusionCode' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <bmp-enum-combo enum=\"us-ny-exclusioncode-types\" name=\"usTaxPreparerNYExclusionType\"\n" +
    "                        ng-model=\"vm.contactRoleData.preparer.usPreparer.nyExclusionCode\" data-qe-id=\"usTaxPreparerNYExclusionType\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Oregon License Number -->\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showUSOROptions()\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerORLicenseNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.ORLicenseNumber' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerORLicenseNumber\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.usPreparer.orLicenseNumber\"\n" +
    "                    data-fef-maxlength=\"10\" data-qe-id=\"usTaxPreparerORLicenseNumber\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Ohio Tax Practitioner Akron Id Number -->\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showOHAkronTPOptions()\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerOHAkronTPNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.OHAkronTPIdNumber' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerOHAkronTPNumber\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.usPreparer.ohAkronTPIdNumber\" data-qe-id=\"usTaxPreparerOHAkronTPNumber\"\n" +
    "                    data-fef-maxlength=\"3\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Viriginia Authorized Agent Number -->\n" +
    "        <div class=\"row\" data-ng-if=\"vm.showUSVAOptions()\">\n" +
    "            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"usTaxPreparerVAAgentNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.USPreparerRole.VAAuthorizedAgentNumber' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"usTaxPreparerVAAgentNumber\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.usPreparer.vaAuthorizedAgentNumber\" data-qe-id=\"usTaxPreparerVAAgentNumber\"\n" +
    "                    data-fef-maxlength=\"10\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!--For AU-->\n" +
    "        <div data-ng-if=\"vm.AUTaxEnabled && !vm.USTaxEnabled\">\n" +
    "\n" +
    "\n" +
    "            <!--AU Address DD Menu-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"contactAddressId\" data-bmp-control-group-label=\"{{'Core.Captions.AUPreparerRole.ContactAddressId' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <div bento-combobox ng-model=\"vm.contactRoleData.preparer.auTaxAgent.contactAddressId\" get-data=\"vm.getAddressData()\" label-name=\"name\"\n" +
    "                        searchable=\"true\"></div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!--AU Phone number DD Menu-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"contactPhoneId\" data-bmp-control-group-label=\"{{'Core.Captions.AUPreparerRole.ContactPhoneId' | translate}}\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <div bento-combobox ng-model=\"vm.contactRoleData.preparer.auTaxAgent.contactPhoneId\" get-data=\"vm.getPhoneData()\" label-name=\"name\" searchable=\"true\"></div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!--AU Software Identification number-->\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"softwareIdentificationNumber\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.AUPreparerRole.SoftwareIdentificationNumber' | translate}}\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "\n" +
    "                    <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"softwareIdentificationNumber\"\n" +
    "                    data-ng-model=\"vm.contactRoleData.preparer.auTaxAgent.softwareIdentificationNumber\" data-qe-id=\"softwareIdentificationNumber\"\n" +
    "                    data-fef-maxlength=\"15\" data-ng-disabled=\"true\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/employees/details/roles/employee-detail-roles.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/details/roles/employee-detail-roles.html",
    "<!-- \"Roles\" Header -->\n" +
    "<h3 class=\"no-top-margin\">{{vm.showRolesHeader()}}</h3>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <div class=\"checkbox\" data-ng-if=\"!vm.isFirm\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.preparer.enabled\" />{{vm.getPreparerRoleEnabledLabel()}}\n" +
    "        </div>\n" +
    "        <div class=\"checkbox\" data-ng-if=\"vm.showReviewerCheckbox()\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.reviewer.enabled\" />{{'Core.Captions.ContactRole.Reviewer'\n" +
    "            | translate}}\n" +
    "        </div>\n" +
    "        <div class=\"checkbox\" data-ng-if=\"vm.showRepresentativeInformationTab()\">\n" +
    "            <input autocomplete=\"off\" type=\"checkbox\" data-ng-model=\"vm.contactRoleData.representative.enabled\" />{{'Core.Captions.RepresentativeRole.Enabled'\n" +
    "            | translate}}\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<!-- Tabs section -->\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <uib-tabset class=\"tabs-top\">\n" +
    "            <uib-tab>\n" +
    "                <uib-tab-heading>{{vm.getPreparerInformationTabHeading()}}</uib-tab-heading>\n" +
    "                <div ng-include=\"'core-setup/employees/details/roles/employee-detail-roles-preparer.html'\"></div>\n" +
    "            </uib-tab>\n" +
    "\n" +
    "            <uib-tab ng-if=\"vm.showRepresentativeInformationTab()\">\n" +
    "                <uib-tab-heading>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Representative.RepresentativeInformationTabHeading' | translate}}</uib-tab-heading>\n" +
    "\n" +
    "                <!-- Representative alert -->\n" +
    "                <div class=\"alert alert-info\" data-ng-if=\"!vm.contactRoleData.representative.enabled\">\n" +
    "                    {{vm.getRepresentativeRoleAssignmentMessage()}}\n" +
    "                    <small class=\"pull-right\"><a data-ng-click=\"vm.enableRepresentative()\">{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Representative.RoleAssignmentLinkMessage' | translate}}</a></small>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"row\" data-ng-if=\"vm.contactRoleData.representative.enabled\">\n" +
    "                    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <!-- Representative Information -->\n" +
    "                        <h3>{{'Bluemoon.Core.Setup.Employees.EmployeeRoles.Representative.RepresentativeInformationHeading' | translate}}</h3>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeCafNumber\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.CafNumber' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"representativeCafNumber\" data-ng-model=\"vm.contactRoleData.representative.cafNumber\"\n" +
    "                                    data-ng-pattern=\"/^[a-zA-Z0-9\\-]{1,11}$/\" data-fef-maxlength=\"11\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeDesignation\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Designation' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12 form-group\">\n" +
    "                                <div bento-combobox ng-model=\"vm.contactRoleData.representative.designation\" get-data=\"vm.getDesignationData()\" label-name=\"name\"\n" +
    "                                    searchable=\"true\"></div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeJurisdiction\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Jurisdiction' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"representationJurisdiction\" data-ng-model=\"vm.contactRoleData.representative.jurisdiction\"\n" +
    "                                    data-ng-pattern=\"/^[a-zA-Z0-9\\s]*$/\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeEnrollmentNumber\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.EnrollmentNumber' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\" type=\"text\" class=\"form-control\" name=\"representativeEnrollmentNumber\" data-ng-model=\"vm.contactRoleData.representative.enrollmentNumber\"\n" +
    "                                    data-ng-pattern=\"/^[a-zA-Z0-9]*$/\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeAddress\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Address' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <div bento-combobox ng-model=\"vm.contactRoleData.representative.address\" get-data=\"vm.getAddressData()\" label-name=\"name\"\n" +
    "                                    searchable=\"true\"></div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativePhoneNumber\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.Phone' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <div bento-combobox ng-model=\"vm.contactRoleData.representative.phone\" get-data=\"vm.getPhoneData()\" label-name=\"name\" searchable=\"true\"></div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"representativeFaxNumber\" data-bmp-control-group-label=\"{{'Core.Captions.RepresentativeRole.FaxPhone' | translate}}\"\n" +
    "                                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                <div bento-combobox ng-model=\"vm.contactRoleData.representative.faxPhone\" get-data=\"vm.getFaxData()\" label-name=\"name\" searchable=\"true\"></div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "            </uib-tab>\n" +
    "        </uib-tabset>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/employees/details/security/employee-detail-security.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/details/security/employee-detail-security.html",
    "<ng-form name=\"securityForm\" bmp-detail-view-default-focus=\"vm.data\">\n" +
    "    <h2 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Employees.Detail.Navigation.Security' | translate}}</h2>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <tr-user-registration\n" +
    "                 data-tr-user-registration-display-email=\"true\"\n" +
    "                 data-tr-user-registration-staff=\"true\"\n" +
    "                 data-tr-user-registration-contact=\"vm.data.primaryContactExpanded\"\n" +
    "                 data-tr-user-registration-entity-types=\"vm.entityTypes\"\n" +
    "                 employee=\"vm.data\">\n" +
    "            </tr-user-registration>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div data-ng-if=\"vm.data.primaryContactExpanded.isStaffCenterEnabled\">\n" +
    "        <span data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></span>\n" +
    "    </div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("core-setup/employees/directives/employee-rate-directive.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/employees/directives/employee-rate-directive.html",
    "<!-- \"vm\" is an 'bm.core.setup.employeesEmployeeRateController -->\n" +
    "<!-- \"vm.data\" is an expanded IEmployeeCostRateV2Dto (data: cs.IEmployeeCostRateV2Dto;) -->\n" +
    "<!-- \"vm.list\" is a ListVM-->\n" +
    "<!-- \"Effective Date / Cost Rate read-only list mode controls -->\n" +
    "<div ng-if=\"vm.listModeActivated()\" class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "    <div class=\"setup-list-grid-view\">\n" +
    "\n" +
    "        <!-- \"Rates\" header -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <h2 class=\"no-top-margin\">{{'Core.Captions.EmployeeCostRate.ClassOther' | translate}}</h2>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- REFACTOR -->\n" +
    "\n" +
    "        <div>\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.repository\"></bmp-grid>\n" +
    "\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"vm.editModeActivated()\" bento-busy-loader=\"vm.detail.isLoadingData()\">\n" +
    "    <!-- \"Edit one Cost Rate and/or its child Billing Rate -mode controls -->\n" +
    "    <div data-ng-form name=\"employeeCostRateForm\" bmp-detail-view-default-focus=\"vm.data\"\n" +
    "         class=\"well bm-well\">\n" +
    "        <div data-bmp-set-form-dirty-when=\"vm.employeeCostRateIsNew()\">\n" +
    "        </div>\n" +
    "        <bmp-sub-page-header>\n" +
    "            <bmp-sub-page-header-left-content>\n" +
    "                <h3>{{'Core.Captions.EmployeeCostRate.DateEffective' | translate}}: {{vm.data.dateEffective}}</h3>\n" +
    "            </bmp-sub-page-header-left-content>\n" +
    "            <bmp-sub-page-header-right-content>\n" +
    "                <button type=\"button\" id=\"employeeCostRateForm.save\" class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"vm.editModeDone()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "                <button type=\"button\" id=\"employeeCostRateForm.cancel\"\n" +
    "                        class=\"btn btn-default\"\n" +
    "                        data-ng-click=\"vm.editModeCancel()\"\n" +
    "                        data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "            </bmp-sub-page-header-right-content>\n" +
    "        </bmp-sub-page-header>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Effective Date editor-->\n" +
    "            <!-- /* i18nextract */'Core.Captions.EmployeeCostRate.DateEffective' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"dateEffective\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.EmployeeCostRate.DateEffective' | translate | bmRequiredMark}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.errorFor(vm.data, 'dateEffective')\"\n" +
    "                 class=\"col-md-3 col-sm-4 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper name=\"dateEffective\"\n" +
    "                                              id=\"dateEffective\"\n" +
    "                                              bmp-control-group-field=\"Core.Captions.EmployeeCostRate.DateEffective\"\n" +
    "                                              ng-model=\"vm.data.dateEffective\"\n" +
    "                                              data-onvio-employee-rate-date-effective=\"vm.onvioEmployeeRate\"\n" +
    "                                              data-onvio-employee-rate-date-effective-employee-id=\"vm.onvioEmployeeRate\"\n" +
    "                                              data-onvio-employee-rate-date-effective-exclude-cost-rate-id=\"vm.data.id\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Hourly Cost Rate editor-->\n" +
    "            <!-- /* i18nextract */'Core.Captions.EmployeeCostRate.HourlyCost' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"hourlyCost\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.EmployeeCostRate.HourlyCost' | translate | bmRequiredMark}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.errorFor(vm.data, 'hourlyCost')\"\n" +
    "                 class=\"col-md-3 col-sm-4 col-xs-6\">\n" +
    "                <input autocomplete=\"off\" type=\"text\"\n" +
    "                       bmp-clear-value=\"0\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.EmployeeCostRate.HourlyCost\"\n" +
    "                       data-bmp-big-number=\"'c2'\"\n" +
    "                       data-bmp-clear-value=\"0\"\n" +
    "                       bm-format-on-blur=\"\"\n" +
    "                       class=\"form-control input-lg\"\n" +
    "                       data-ng-model=\"vm.data.hourlyCost\"\n" +
    "                       data-bmp-big-number-range-validator\n" +
    "                       min=\"0\"\n" +
    "                       max=\"9999999.99\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- \"Billing Rates\" header -->\n" +
    "            <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                <h3 class=\"no-top-margin\">{{'Core.Captions.EmployeeBillingRate.ClassOther' | translate}}</h3>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- List of Billing Rate edit controls -->\n" +
    "        <div data-ng-repeat=\"billingRate in vm.data.employeeBillingRates\">\n" +
    "            <div class=\"row\">\n" +
    "                <div data-ng-form name=\"billingRateForm_{{$index}}\" class=col-md-12>\n" +
    "                    <div class=\"form-group\">\n" +
    "                        <!-- Enabled -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                             data-bmp-control-group-field-id=\"enabled\"\n" +
    "                             data-bmp-control-group-label=\"{{ $first ? ('Core.Captions.EmployeeBillingRate.Enabled' | translate) : null}}\"\n" +
    "                             data-bmp-control-group-error=\"vm.errorFor(billingRate, 'enabled')\"\n" +
    "                             class=\"col-md-2 col-sm-2 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                   name=\"enabled\"\n" +
    "                                   id=\"enabled\"\n" +
    "                                   data-ng-model=\"billingRate.enabled\"\n" +
    "                                   data-ng-change=\"vm.setDefaultBillingRate($index)\">\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Billing Rate Description -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                             data-bmp-control-group-field-id=\"employeeRateDescription\"\n" +
    "                             data-bmp-control-group-label=\"{{ $first ? ('Core.Captions.EmployeeBillingRate.EmployeeRateDescription' | translate) : null}}\"\n" +
    "                             data-bmp-control-group-error=\"vm.data.errorFor(data, 'employeeRateDescription')\"\n" +
    "                             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <span>{{billingRate.employeeRateDescription.name}}</span>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Billing Rate -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                             data-bmp-control-group-field-id=\"billableRate\"\n" +
    "                             data-bmp-control-group-label=\"{{ $first ? ('Core.Captions.EmployeeBillingRate.BillableRate' | translate) : null}}\"\n" +
    "                             data-bmp-control-group-error=\"vm.errorFor(billingRate, 'billableRate')\"\n" +
    "                             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\"\n" +
    "                                   data-bmp-big-number=\"'c2'\"\n" +
    "                                   bm-format-on-blur=\"\"\n" +
    "                                   data-bmp-clear-value=\"0\"\n" +
    "                                   name=\"billableRate\"\n" +
    "                                   bmp-control-group-field=\"Core.Captions.EmployeeBillingRate.BillableRate\"\n" +
    "                                   class=\"form-control input-lg\"\n" +
    "                                   data-ng-model=\"billingRate.billableRate\"\n" +
    "                                   data-ng-disabled=\"!billingRate.enabled\"\n" +
    "                                   data-bmp-clear-invalid-value-when=\"!billingRate.enabled\"\n" +
    "                                   data-bmp-big-number-range-validator\n" +
    "                                   min=\"0\"\n" +
    "                                   max=\"9999999.99\"\n" +
    "                                   style=\"text-align:right;\"/>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "      <div data-translate=\"Bluemoon.Core.Setup.Common.RequiredField\"></div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/firm/firm-detail-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-billing.html",
    "<!-- Approval and Posting -->\n" +
    "<div ng-if=\"vm.approveAndPostTime || vm.approveAndPostInvoice\">\n" +
    "        <h3>{{'Bluemoon.Core.Setup.Firm.Detail.Billing.ApprovalPostingHeading' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <div ng-if=\"vm.approveAndPostTime\">\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" data-qe-id=\"bm-firmDetailBilling-requireApprovalForTimeAndExpenseEntry-checkbox\"\n" +
    "                                ng-model=\"vm.data.mainData.requireApprovalForTimeAndExpenseEntry\" /> {{'Core.Captions.CompanyMain.RequireApprovalForTimeAndExpenseEntry' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.approveAndPostInvoices\">\n" +
    "                <div class=\"checkbox\">\n" +
    "                    <label>\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" data-qe-id=\"bm-firmDetailBilling-requireApprovalForBilling-checkbox\"\n" +
    "                                ng-model=\"vm.data.mainData.requireApprovalForBilling\" /> {{'Core.Captions.CompanyMain.RequireApprovalForBilling' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"checkbox\" bm-if-perm=\"TimeAndBilling.InternalComponent\">\n" +
    "                <label>\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" data-qe-id=\"bm-firmDetailBilling-requireApprovalForReceiptAndAdjustmentEntry-checkbox\"\n" +
    "                            ng-model=\"vm.data.mainData.requireApprovalForReceiptAndAdjustmentEntry\" /> {{'Core.Captions.CompanyMain.RequireApprovalForReceiptAndAdjustmentEntry' | translate}}\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "    <!-- Time Entry -->\n" +
    "<div ng-if=\"vm.displayTimeEntry\">\n" +
    "    <h3>{{'Bluemoon.Core.Setup.Firm.Detail.TimeEntry' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <div class=\"checkbox\">\n" +
    "                <label>\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" data-qe-id=\"bm-firmDetailBilling-requireEngagementsForTimeAndExpenseEntry-checkbox\"\n" +
    "                           ng-model=\"vm.data.mainData.requireEngagementsForTimeAndExpenseEntry\" /> {{'Core.Captions.CompanyMain.RequireEngagementsForTimeAndExpenseEntry' | translate}}\n" +
    "                </label>\n" +
    "            </div>\n" +
    "            <div class=\"checkbox\">\n" +
    "                <label>\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" data-qe-id=\"bm-firmDetailBilling-requireProjectsForTimeAndExpenseEntry-checkbox\"\n" +
    "                        ng-model=\"vm.data.mainData.requireProjectsForTimeAndExpenseEntry\" /> {{'Core.Captions.CompanyMain.RequireProjectsForTimeAndExpenseEntry' | translate}}\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "    <!-- Billing -->\n" +
    "<div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions', 'ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "    <h3>{{'Bluemoon.Core.Setup.Firm.Detail.Billing' | translate}}</h3>\n" +
    "    <div class=\"row\" ng-if=\"vm.displayAccountingMethod\">\n" +
    "        <!-- Default Accounting method for the firm -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"accountingMethodDefinition\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountingMethod' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountingMethod')\"\n" +
    "        class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"accounting-methods\"\n" +
    "                            name=\"accountingMethodDefinition\"\n" +
    "                            ng-model=\"vm.data.billingData.accountingMethod\"\n" +
    "                            required=\"true\">\n" +
    "            </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Default Invoice Format for New Clients -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"invoiceReportDefinition\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.InvoiceReportDefinition' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'invoiceCompanyLayoutOption')\"\n" +
    "             class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "             <bmp-select-combo list=\"report-definition#invoice\"\n" +
    "                                    name=\"report-definition#invoice\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    ng-model=\"vm.data.billingData.invoiceCompanyLayoutOption\"\n" +
    "                                    required=\"true\">\n" +
    "             </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "        <!-- Default Statement Format for New Clients -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"statementReportDefinition\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.StatementCompanyLayoutOption' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'statementCompanyLayoutOption')\"\n" +
    "             class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "             <bmp-select-combo list=\"report-definition#statement\"\n" +
    "                                    name=\"report-definition#statement\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    ng-model=\"vm.data.billingData.statementCompanyLayoutOption\"\n" +
    "                                    required=\"true\">\n" +
    "             </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "        <!-- Late Fee -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"lateFeeTemplates\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.LateFeeTemplate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'lateFeeTemplate' )\"\n" +
    "             class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "             <bmp-select-combo  id=\"lateFeeTemplates\"\n" +
    "                                    list=\"late-fee-templates\"\n" +
    "                                    name=\"lateFeeTemplates\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    ng-model=\"vm.data.billingData.lateFeeTemplate\">\n" +
    "             </bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Days until invoice -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"daysUntilInvoiceDue\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.DaysUntilInvoiceIsDue' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'daysUntilInvoiceIsDue' )\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"999999\"\n" +
    "                           name=\"daysUntilInvoiceDue\"\n" +
    "                           ng-model=\"vm.data.billingData.daysUntilInvoiceIsDue\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"0\"\n" +
    "                           bmp-control-group-field=\"Core.Captions.CompanyBilling.DaysUntilInvoiceIsDue\" />\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "        <div class=\"col-md-6\">\n" +
    "            <span data-bento-toggle ng-model=\"vm.data.billingData.relieveNonbillableWip\"\n" +
    "                  data-on-change=\"vm.bentoToggleChanged()\" style=\"margin: 5px;\"\n" +
    "                  data-qe-id=\"bm-firmDetailBilling-relieveNonbillableWip-toggle\"></span>\n" +
    "            <span translate=\"Core.Captions.CompanyBilling.RelieveNonbillableWip\"\n" +
    "                  data-qe-id=\"bm-firmDetailBilling-relieveNonbillableWip-message\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-6\">\n" +
    "            <span data-bento-toggle ng-model=\"vm.data.billingData.markZeroInvoiceAsPrinted\"\n" +
    "                    data-on-change=\"vm.bentoToggleChanged()\"\n" +
    "                    style=\"margin: 5px;\" data-qe-id=\"bm-firmDetailBilling-markZeroInvoiceAsPrinted-toggle\"></span>\n" +
    "            <span translate=\"Core.Captions.CompanyBilling.MarkZeroInvoiceAsPrinted\"\n" +
    "                  data-qe-id=\"bm-firmDetailBilling-markZeroInvoiceAsPrinted-message\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-6\">\n" +
    "            <span data-bento-toggle ng-model=\"vm.data.billingData.allowIndependentInvoiceComposeRows\"\n" +
    "                    data-on-change=\"vm.bentoToggleChanged()\"\n" +
    "                    style=\"margin: 5px;\" data-qe-id=\"bm-firmDetailBilling-allowIndependentInvoiceComposeRows-toggle\"></span>\n" +
    "            <span translate=\"Core.Captions.CompanyBilling.AllowIndependentInvoiceComposeRows\"\n" +
    "                  data-qe-id=\"bm-firmDetailBilling-allowIndependentInvoiceComposeRows-message\"></span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"vm.includeStripeOption()\" class=\"setup-firm-detail-online-payment-container\">\n" +
    "        <h3>{{'Bluemoon.Core.Setup.Firm.Detail.Billing.AcceptOnlinePayments' | translate}}</h3>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <span ng-if=\"!vm.connectedToStripe\">{{ 'Bluemoon.Core.Setup.Firm.Detail.Billing.ConnectStripe' | translate }}</span>\n" +
    "                <span ng-if=\"vm.connectedToStripe\">{{ 'Bluemoon.Core.Setup.Firm.Detail.Billing.ConnectedToStripe' | translate }}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <button class=\"btn btn-default\" data-qe-id=\"connectToStripeButton\" ng-if=\"!vm.connectedToStripe\" ng-click=\"vm.connectToStripe()\" analytics-on=\"click\" analytics-event=\"firm-detail-billing-connect-stripe-button-click\">{{'Bluemoon.Core.Setup.Firm.Detail.Billing.ConnectStripeButtonText' | translate}}</button>\n" +
    "                <button class=\"btn btn-primary\" data-qe-id=\"disconnectFromStripeButton\" ng-if=\"vm.connectedToStripe\" ng-click=\"vm.openDisconnectStripeModal()\" analytics-on=\"click\" analytics-event=\"firm-detail-billing-disconnect-stripe-button-click\">{{'Bluemoon.Core.Setup.Firm.Detail.Billing.DisconnectStripeButtonText' | translate}}</button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- CA tax IDs-->\n" +
    "    <div ng-if=\"vm.showCanadianTaxSection\">\n" +
    "        <h3>{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.FederalHeader' | translate}}</h3>\n" +
    "        <!-- CA Federal Registration Number -->\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-2 col-sm-2 col-xs-2 \">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Firm.Detail.Billing.CompanyTaxRegistrationFederal.Number' | translate}}\"\n" +
    "                    data-bmp-control-group-field-id=\"canadian-sales-tax-registration-federal\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor('TODO', 'TODOdueOnDay')\">\n" +
    "                        <input autocomplete=\"off\"\n" +
    "                            id=\"canadian-sales-tax-registration-federal\"\n" +
    "                            name=\"canadian-sales-tax-registration-federal\"\n" +
    "                            data-qe-id=\"canadian-sales-tax-registration-federal\"\n" +
    "                            class=\"form-control\"\n" +
    "                            type=\"text\"\n" +
    "                            data-ng-model=\"vm.data.billingData.companyTaxRegistrationFederal.taxRegistrationNumber\"\n" +
    "                            data-tr-national-identity=\"CA-F\"/>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <h3 class=\"col-md-2 col-sm-2 col-xs-2\">{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.ProvincialHeader' | translate}}</h3>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"vm.data.billingData.companyTaxRegistrationProvincials.length > 0\">\n" +
    "            <label class=\"col-md-2 col-sm-2 col-xs-2 control-label\">{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.ProvinceColumnHeader' | translate}}</label>\n" +
    "            <label class=\"col-md-2 col-sm-2 col-xs-2 control-label\">{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.NumberColumnHeader' | translate}}</label>\n" +
    "        </div>\n" +
    "        <div ng-repeat=\"registration in vm.data.billingData.companyTaxRegistrationProvincials\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-2\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.ProvinceColumnHeader' | translate}}\"\n" +
    "                        data-bmp-control-group-label-hide=\"true\"\n" +
    "                        data-bmp-control-group-field-id=\"canadian-sales-tax-registration-province-{{$index}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor('TODO', 'TODOdueOnDay')\">\n" +
    "                            <!-- State/Province -->\n" +
    "                            <input autocomplete=\"off\"\n" +
    "                                id=\"canadian-sales-tax-registration-province-{{::$index}}\"\n" +
    "                                name=\"canadian-sales-tax-registration-province-{{::$index}}\"\n" +
    "                                data-qe-id=\"canadian-sales-tax-registration-province-{{::$index}}\"\n" +
    "                                class=\"form-control\"\n" +
    "                                type=\"text\"\n" +
    "                                uib-typeahead=\"province.name as province.name for province in vm.canadianProvinceOptions($viewValue)\"\n" +
    "                                typeahead-wait-ms=\"10\"\n" +
    "                                typeahead-focus-first=\"true\"\n" +
    "                                typeahead-on-select=\"vm.onCanadianProvinceSelected(registration, $item, $index)\"\n" +
    "                                ng-blur=\"vm.onCanadianProvinceBlur(registration)\"\n" +
    "                                data-ng-model=\"registration.stateProvince.name\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                ng-readonly=\"registration.stateProvince.name && registration.stateProvince.id\"/>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-2 \">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Firm.Detail.CanadianSalesTaxRegistrationNumbers.NumberColumnHeader' | translate}}\"\n" +
    "                        data-bmp-control-group-label-hide=\"true\"\n" +
    "                        data-bmp-control-group-field-id=\"canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor('TODO', 'TODOdueOnDay')\">\n" +
    "                            <input autocomplete=\"off\"\n" +
    "                                class=\"form-control\"\n" +
    "                                id=\"canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                                name=\"canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                                data-qe-id=\"canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                                ng-model=\"registration.taxRegistrationNumber\"\n" +
    "                                data-tr-national-identity=\"{{registration.stateProvince.id}}\"\n" +
    "\n" +
    "                                ng-disabled=\"registration.stateProvince.id.length === 0\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- Remove CA tax ID -->\n" +
    "                <div class=\"col-md-2 col-sm-2 col-xs-2\">\n" +
    "                    <button id=\"remove-canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                            name=\"remove-canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                            data-qe-id=\"remove-canadian-sales-tax-registration-number-{{$index}}\"\n" +
    "                            type=\"button\"\n" +
    "                            class=\"btn btn-link\"\n" +
    "                            style=\"padding-left:0px\"\n" +
    "                            data-ng-click=\"vm.removeCanadianTaxRegistration(registration, $index); vm.setFormDirty(); focus('add-sales-tax-registration-button');\">\n" +
    "                        <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "                        <span translate=\"Bluemoon.Core.Setup.Firm.Detail.RemoveCanadianSalesTaxRegistrationNumber\"></span>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div> <!--END CA tax ID ng-repeat-->\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Add Another CA tax registration number -->\n" +
    "            <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <a href id=\"add-sales-tax-registration-button\" class=\"btn btn-link\" type=\"button\"\n" +
    "                data-ng-click=\"vm.addCanadianTaxRegistrationNumber(data, defaultData); vm.setFormDirty(); focus('canadian-sales-tax-registration-number-' + '{{$index}}' + (vm.data.billingData.companyTaxRegistrations.items.length-1));\">\n" +
    "                    <span class=\"glyphicon glyphicon-plus-sign\"></span>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Firm.Detail.AddCanadianSalesTaxRegistrationNumber\"></span>\n" +
    "                </a>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div> <!-- END ng-if=\"vm.showCanadianTaxSection\"-->\n" +
    "\n" +
    "    <!-- Standard Bill Rounding -->\n" +
    "    <div bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "    <h3>{{'Bluemoon.Core.Setup.Firm.Detail.StandardBillRounding' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Type -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"standardBillRounding\"\n" +
    "                data-bmp-control-group-label=\"\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(data, 'standardBillRoundingMethod')\"\n" +
    "                class=\"col-md-4 col-xs-12\">\n" +
    "                <bmp-enum-radio-group enum=\"standard-bill-rounding-methods\" name=\"standardBillRoundingMethod\"\n" +
    "                                    ng-model=\"vm.data.billingData.standardBillRoundingMethod\"></bmp-enum-radio-group>\n" +
    "        </div>\n" +
    "\n" +
    "        <!-- Rounding Increments -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"standardBillRoundingIncrement\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.StandardBillRoundingIncrement' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'standardBillRoundingIncrement')\"\n" +
    "                data-bmp-control-group-hide=\"vm.data.billingData.standardBillRoundingMethod.id === 'NOROUNDING'\"\n" +
    "                class=\"col-md-4 col-xs-12\">\n" +
    "            <input autocomplete=\"off\"\n" +
    "                    type=\"text\"\n" +
    "                    bmp-big-number=\"'c2'\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    min=\"1\" max=\"99\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    ng-model=\"vm.data.billingData.standardBillRoundingIncrement\"\n" +
    "                    bmp-clear-value-when=\"vm.data.billingData.standardBillRoundingMethod.id === 'NOROUNDING'\"\n" +
    "                    bmp-clear-value=\"1\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.CompanyBilling.StandardBillRoundingIncrement\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Dunning Messages -->\n" +
    "    <div bmp-if-firm-permission=\"TimeAndBilling.Billing\">\n" +
    "    <h3>{{'Bluemoon.Core.Setup.Firm.Detail.DunningMessages' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Dunning Fields -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableDunning1\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableDunning1' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableDunning1')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableDunning1\" name=\"accountsReceivableDunning1\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableDunning1\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableDunning2\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableDunning2' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableDunning2')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableDunning2\" name=\"accountsReceivableDunning2\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableDunning2\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableDunning3\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableDunning3' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableDunning3')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableDunning3\" name=\"accountsReceivableDunning3\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableDunning3\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableDunning4\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableDunning4' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableDunning4')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableDunning4\" name=\"accountsReceivableDunning4\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableDunning4\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableDunning5\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableDunning5' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableDunning5')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableDunning5\" name=\"accountsReceivableDunning5\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableDunning5\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    <!-- Acounts Receivable Terms -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"accountsReceivableTerms\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.CompanyBilling.AccountsReceivableTerms' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.billingData, 'accountsReceivableTerms')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"accountsReceivableTerms\" name=\"accountsReceivableTerms\"\n" +
    "                      class=\"form-control\"\n" +
    "                      data-ng-model=\"vm.data.billingData.accountsReceivableTerms\"\n" +
    "                      data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/firm/firm-detail-ca-tax.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-ca-tax.html",
    "<div class=\"row\">\n" +
    "    <catax-firmsetup></catax-firmsetup>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/firm/firm-detail-document-delivery.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-document-delivery.html",
    "<h3 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Clients.Detail.Navigation.DocumentDelivery' | translate}}</h3>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-8\">\n" +
    "        <table class=\"bm-timeAndExpense-up-hide-skip-table time-and-billing-document-delivery-table bento-flex-grid wj-content\">\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th rowspan=\"2\" scope=\"col\" class=\"wj-header wj-cell\"></th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DeliveryMethod' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.DownloadFile' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.Email' | translate}}</th>\n" +
    "                <th ng-if=\"vm.connectedToStripe\" scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.ClientCenter' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Header.OnvioDocuments' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Invoices' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesDownloadFile\" name=\"invoicesDownloadFile\" data-qe-id=\"invoicesDownloadFile\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToFile\" />\n" +
    "                    <label for=\"invoicesDownloadFile\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryInvoiceToFile' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesEmail\" name=\"invoicesEmail\" data-qe-id=\"invoicesEmail\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToEmail\" />\n" +
    "                    <label for=\"invoicesEmail\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryInvoiceToEmail' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td ng-if=\"vm.connectedToStripe\" class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesClientCenter\" name=\"invoicesClientCenter\" data-qe-id=\"invoicesClientCenter\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToClientCenter\" />\n" +
    "                    <label for=\"invoicesClientCenter\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryInvoiceToClientCenter' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"invoicesOnvioDocuments\" name=\"invoicesOnvioDocuments\" data-qe-id=\"invoicesOnvioDocuments\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryInvoiceToStorage\" />\n" +
    "                    <label for=\"invoicesOnvioDocuments\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryInvoiceToStorage' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr bm-if-has-license=\"TimeAndBilling.PrintStatements\">\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.Core.Setup.DocumentDelivery.Statements' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsDownloadFile\" name=\"statementsDownloadFile\" data-qe-id=\"statementsDownloadFile\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToFile\" />\n" +
    "                    <label for=\"statementsDownloadFile\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryStatementToFile' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"statementsEmail\" name=\"statementsEmail\" data-qe-id=\"statementsEmail\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToEmail\" />\n" +
    "                    <label for=\"statementsEmail\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryStatementToEmail' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td ng-if=\"vm.connectedToStripe\" class=\"wj-cell\">\n" +
    "                    <input id=\"statementsClientCenter\" name=\"statementsClientCenter\" data-qe-id=\"statementsClientCenter\" type=\"checkbox\" disabled=\"true\" />\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell setup-firm-detail-document-delivery-cell\">\n" +
    "                    <input id=\"statementsOnvioDocuments\" name=\"statementsOnvioDocuments\" data-qe-id=\"statementsOnvioDocuments\" type=\"checkbox\" ng-model=\"vm.data.documentDeliveryStatementToStorage\" />\n" +
    "                    <label for=\"statementsOnvioDocuments\" class=\"sr-only\">{{'Core.Captions.CompanyBilling.DocumentDeliveryStatementToStorage' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/firm/firm-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-general.html",
    "<div ng-hide=\"vm.isLoading\">\n" +
    "    <h3 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Firm.Detail.Navigation.General' | translate}}</h3>\n" +
    "\n" +
    "    <div class=\"row\"\n" +
    "         ng-show=\"vm.showEmsFirmIdField\">\n" +
    "        <!-- Code/ID -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.Client.Code' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"code\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Client.Code' | translate | bmRequiredMark}}\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\"\n" +
    "                   type=\"text\"\n" +
    "                   id=\"code\"\n" +
    "                   name=\"code\"\n" +
    "                   class=\"form-control\"\n" +
    "                   data-ng-model=\"vm.EmsFirmId\"\n" +
    "                   readonly />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- contact -->\n" +
    "    <div data-onvio-contact-editor=\"vm.data.companyClientExpanded.primaryContactExpanded\"\n" +
    "         contact-name-validation-service=\"vm.contactNameValidationService\"\n" +
    "         data-onvio-contact-editor-parent-form=\"firmForm\"\n" +
    "         data-onvio-contact-editor-contact-changed=\"vm.onContactChanged()\"\n" +
    "         data-onvio-contact-editor-display-as-rule-changed=\"vm.onDisplayAsRuleChanged()\"\n" +
    "         data-onvio-contact-editor-entity-type-changed=\"vm.onEntityTypeChanged()\"\n" +
    "         data-onvio-contact-editor-valid-entity-types=\"vm.entityOptions\"\n" +
    "         data-onvio-contact-editor-primary-email-is-required=\"true\"\n" +
    "         data-onvio-contact-editor-entity-types=\"vm.entityTypes\"\n" +
    "         data-onvio-contact-editor-name-is-readonly=\"vm.nameIsReadonly\"\n" +
    "         data-onvio-contact-editor-show-confidentiality=\"false\"\n" +
    "         onvio-contact-editor-is-loading=\"vm.isLoading\"\n" +
    "         bmp-detail-view-default-focus=\"vm.data\"></div>\n" +
    "\n" +
    "    <!-- Notification Email -->\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\"\n" +
    "             ng-show=\"vm.displayOwnerEmail\">\n" +
    "            <h3 class=\"setup-section-header-margin\"\n" +
    "                translate=\"Bluemoon.Core.Setup.NotificationEmails.Header\"></h3>\n" +
    "            <fieldset class=\"well bm-well\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"firm-notification-email-address\"\n" +
    "                         data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.NotificationEmails.Label' | translate}}\"\n" +
    "                         class=\"col-md-4 col-sm-6 col-xs-10\">\n" +
    "                        <input autocomplete=\"off\"\n" +
    "                               type=\"text\"\n" +
    "                               id=\"notificationEmail\"\n" +
    "                               name=\"notificationEmail\"\n" +
    "                               class=\"form-control \"\n" +
    "                               ng-model=\"vm.notificationEmail.emailAddress\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </fieldset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/firm/firm-detail-preferences.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-preferences.html",
    "<ng-form name=\"firmForm\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\">\n" +
    "                {{'Bluemoon.Core.Setup.Preferences.NewContactDefaults' | translate}}</h3>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div id=\"form-group-contactDisplayAsFormat\" class=\"col-md-4 col-sm-4 col-xs-4 form-group\"\n" +
    "            data-bmp-control-group-field-id=\"contactDisplayAsFormat\">\n" +
    "            <label class=\"control-label inline\"\n" +
    "                for=\"contactDisplayAsFormat\">{{'Bluemoon.Core.Setup.Preferences.DisplayNameFormatIndividuals' | translate}}</label>\n" +
    "            <div data-bento-select>\n" +
    "                <select class=\"form-control\" data-ng-model=\"vm.data.contactDisplayAsFormat\"\n" +
    "                    data-ng-options=\"option as option.name for option in vm.contactDisplayAsFormatOptions track by option.id\">\n" +
    "                    <option class=\"setup-hidden-default-option\" value=\"\"></option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\">{{'Bluemoon.Core.Setup.Preferences.NewClientDefaults' | translate}}\n" +
    "            </h3>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div id=\"form-group-clientNameFormat\" class=\"col-md-4 col-sm-4 col-xs-4 form-group\"\n" +
    "            data-bmp-control-group-field-id=\"clientNameFormat\">\n" +
    "            <label class=\"control-label inline\"\n" +
    "                for=\"clientNameFormat\">{{'Bluemoon.Core.Setup.Preferences.DisplayNameFormatIndividuals' | translate}}</label>\n" +
    "            <div data-bento-select>\n" +
    "                <select class=\"form-control\" data-ng-model=\"vm.data.clientNameFormat\"\n" +
    "                    data-ng-options=\"option as option.name for option in vm.clientNameFormatOptions track by option.id\">\n" +
    "                    <option class=\"setup-hidden-default-option\" value=\"\"></option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <h3 class=\"setup-section-header-margin\">{{'Bluemoon.Core.Setup.Preferences.NewStaffDefaults' | translate}}\n" +
    "            </h3>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div id=\"form-group-employeeNameFormat\" class=\"col-md-4 col-sm-4 col-xs-4 form-group\"\n" +
    "            data-bmp-control-group-field-id=\"employeeNameFormat\">\n" +
    "            <label class=\"control-label inline\"\n" +
    "                for=\"employeeNameFormat\">{{'Bluemoon.Core.Setup.Preferences.DisplayNameFormat' | translate}}</label>\n" +
    "            <div data-bento-select>\n" +
    "                <select class=\"form-control\" data-ng-model=\"vm.data.employeeNameFormat\"\n" +
    "                    data-ng-options=\"option as option.name for option in vm.employeeNameFormatOptions track by option.id\">\n" +
    "                    <option class=\"setup-hidden-default-option\" value=\"\"></option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</ng-form>");
}]);

angular.module("core-setup/firm/firm-detail-tax-ng.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-tax-ng.html",
    "<ng-bluemoon-ustax-firmsetup [load-promise]=\"vm.loadRegistration\" [save-promise]=\"vm.saveRegistration\">\n" +
    "</ng-bluemoon-ustax-firmsetup>");
}]);

angular.module("core-setup/firm/firm-detail-uk-hmrc-detail-ng.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-uk-hmrc-detail-ng.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <firm-authorisation-details id=\"{{vm.id}}\" (close-details)=\"vm.goToUkHmrcAuthorisationList($event)\"></firm-authorisation-details>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/firm/firm-detail-uk-hmrc-list-ng.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail-uk-hmrc-list-ng.html",
    "<firm-authorisation-list (open-details)=\"vm.openDetails($event)\" (show-error)=\"vm.showError($event)\"></firm-authorisation-list>");
}]);

angular.module("core-setup/firm/firm-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/firm/firm-detail.html",
    "<div class=\"container-fluid no-left-padding view-container setup-detail\" ng-class=\"{'modal-workspace-no-bottom-margin': vm.inWorkspaceModal}\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\" ng-class=\"{'modal-workspace-no-padding-right': vm.inWorkspaceModal}\">\n" +
    "            <form id=\"firmForm\" name=\"firmForm\" autocomplete=\"off\">\n" +
    "                <bmp-page-header ng-hide=\"vm.isOnIframe\"\n" +
    "                is-in-modal=\"vm.inWorkspaceModal\"\n" +
    "                ng-class=\"{loading: vm.detailContext.detail.isLoadingData()}\">\n" +
    "                    <bmp-page-header-left-content>\n" +
    "                        <h1\n" +
    "                            uib-tooltip=\"{{vm.firmLabel()}}\"\n" +
    "                            tooltip-append-to-body=\"true\"\n" +
    "                            tooltip-trigger=\"mouseenter\"\n" +
    "                            tooltip-placement=\"bottom\"\n" +
    "                            class=\"bmp-page-header-truncate\">{{vm.firmLabel()}}</h1>\n" +
    "                        <h1 ng-if=\"vm.detailContext.detail.isLoadingData() && vm.firmLabel() === ''\" class=\"bmp-page-header-truncate\">\n" +
    "                            {{vm.detailContext.detail.busyText}}\n" +
    "                        </h1>\n" +
    "                        <div class=\"bmp-page-header-display-as\">\n" +
    "                            <a href class=\"btn btn-default setup-no-pad-l\"\n" +
    "                                    role=\"button\"\n" +
    "                                    data-ng-click=\"vm.openDisplayAsDialog()\"\n" +
    "                                    data-ng-show=\"vm.showDisplayAsLink()\"\n" +
    "                                    title=\"{{'Bluemoon.Core.Setup.Client.DisplayAs.Firm' | translate}}\"><span class=\"bento-icon-edit\"></span></a>\n" +
    "                        </div>\n" +
    "                    </bmp-page-header-left-content>\n" +
    "                    <bmp-page-header-right-content data-ng-show=\"vm.detailContext.showTitleButtons()\">\n" +
    "                        <button type=\"button\" id=\"firmForm.save\" class=\"btn btn-primary\"\n" +
    "                                data-ng-click=\"vm.detailContext.detail.save()\"\n" +
    "                                translate=\"Bluemoon.Practice.Common.Actions.Save\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                        <button type=\"button\" id=\"firmForm.cancel\"\n" +
    "                                class=\"btn btn-default\"\n" +
    "                                data-ng-click=\"vm.detailContext.detail.cancel()\"\n" +
    "                                translate=\"Bluemoon.Practice.Common.Actions.Cancel\"\n" +
    "                                ng-disabled=\"vm.detailContext.detail.isLoadingData()\"></button>\n" +
    "                    </bmp-page-header-right-content>\n" +
    "                </bmp-page-header>\n" +
    "                <div ng-class=\"{'modal-workspace-content-wrapper': vm.inWorkspaceModal}\">\n" +
    "                    <bmp-routable-tabset bmp-routable-tabset-tabs=\"vm.tabs\" bmp-modal-state-data=\"$modalUiView.modalStateData\">\n" +
    "                        <div bmp-modal-routable-ui-view class=\"enter-item-animation\" ng-hide=\"vm.detailContext.detail.isLoadingData()\"></div>\n" +
    "                        <div bento-busy-loader=\"vm.detailContext.detail.isLoadingData()\"></div>\n" +
    "                    </bmp-routable-tabset>\n" +
    "                </div>\n" +
    "            </form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/fixed-fee-billing-templates/fixed-fee-billing-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/fixed-fee-billing-templates/fixed-fee-billing-template-detail.html",
    "<div>\n" +
    "    <div class=\"row\">\n" +
    "        <!--Name-->\n" +
    "        <!-- /* i18nextract */'Core.Captions.FixedFeeBillingTemplate.Name' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"fixedFeeBillingTemplateName\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.Name' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                id=\"fixedFeeBillingTemplateName\"\n" +
    "                name=\"fixedFeeBillingTemplateName\"\n" +
    "                data-qe-id=\"fixedFeeBillingTemplateName\"\n" +
    "                class=\"form-control\"\n" +
    "                data-ng-required=\"true\"\n" +
    "                data-ng-disabled=\"vm.data.systemId\"\n" +
    "                data-ng-model=\"vm.data.name\"\n" +
    "                data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'name')\"\n" +
    "                data-bmp-entity-code=\"\"\n" +
    "                data-bmp-entity-code-id=\"vm.id\"\n" +
    "                data-bmp-entity-code-type=\"{{vm.definition.code}}\"\n" +
    "                data-bmp-entity-code-company-id=\"vm.detail.getCurrentCompanyId()\"\n" +
    "                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Level -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.Level' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'level')\"\n" +
    "            class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "            <bmp-enum-radio-group enum=\"fixed-fee-billing-template-level\"\n" +
    "                        name=\"level\"\n" +
    "                        data-qe-id=\"level\"\n" +
    "                        ng-model=\"vm.data.$level\"></bmp-enum-radio-group>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <fieldset class=\"well bm-well\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Frequency -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.Frequency' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'frequency')\"\n" +
    "                class=\"col-md-3 col-sm-3 col-xs-5\">\n" +
    "                <bmp-enum-combo enum=\"fixed-fee-billing-template-frequency\"\n" +
    "                            name=\"frequency\"\n" +
    "                            data-qe-id=\"frequency\"\n" +
    "                            ng-model=\"vm.data.frequency\"\n" +
    "                            required=\"true\"></bmp-enum-combo>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.domainModel.showClientAmount(vm.data)\">\n" +
    "                <!--Client Amount-->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"fixedFeeBillingTemplateClientAmount\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.ClientAmount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'clientAmount')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-6 pull-right\">\n" +
    "                    <input autocomplete=\"off\" type=\"text\"\n" +
    "                        id=\"fixedFeeBillingTemplateClientAmount\"\n" +
    "                        name=\"fixedFeeBillingTemplateClientAmount\"\n" +
    "                        data-qe-id=\"fixedFeeBillingTemplateClientAmount\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.clientAmount\"\n" +
    "                        data-ng-disabled=\"vm.domainModel.disableClientAmountField(vm.data)\"\n" +
    "                        data-bmp-clear-value=\"0\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        min=\"0\"\n" +
    "                        max=\"9999999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- List of Engagement Template edit controls -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingEngagementTemplateAmounts\" class=\"col-md-8 col-sm-10 col-xs-12\"></div>\n" +
    "            <div ng-if=\"vm.domainModel.showEngagementAmounts(vm.data)\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 pull-right\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{ 'Core.Captions.Engagement.ClassOther' | translate }}\">\n" +
    "                            <div bento-multiselect-overlay\n" +
    "                                revert-selections-on-dismissal=\"true\"\n" +
    "                                ng-model=\"vm.data.$engagementMultiselectDataSelected\"\n" +
    "                                list-data=\"vm.data.$engagementMultiselectData\"\n" +
    "                                select-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectEngagements' | translate }}\"\n" +
    "                                edit-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectEngagements' | translate }}\"\n" +
    "                                class=\"setup-bento-multiselect-overlay\"\n" +
    "                                data-qe-id=\"bm-fixedFeeBillingTemplateDetail-engagementTemplate-multiselect\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.data.$engagementMultiselectDataSelected.length > 0\">\n" +
    "                            <table class=\"fixed-fee-template-table bento-flex-grid wj-content\">\n" +
    "                                <tr class=\"wj-colheaders\">\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.EngagementTemplate.Code' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.FixedFeeEngagementAmountCommon.EngagementTemplate' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header text-right\">{{ 'Core.Captions.FixedFeeEngagementAmountCommon.Amount' | translate }}</th>\n" +
    "                                </tr>\n" +
    "                                <tr data-ng-repeat=\"fixedFeeEngagementAmount in vm.data.$engagementMultiselectDataSelected\">\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeEngagementAmount.data.engagementTemplate.code }}</td>\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeEngagementAmount.data.engagementTemplate.name }}</td>\n" +
    "                                    <td class=\"wj-cell\">\n" +
    "                                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                                            data-bmp-big-number=\"'c2'\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            data-bmp-clear-value=\"0\"\n" +
    "                                            id=\"engagementAmount_{{$index}}\"\n" +
    "                                            name=\"engagementAmount_{{$index}}\"\n" +
    "                                            class=\"form-control input-lg text-right\"\n" +
    "                                            data-ng-model=\"fixedFeeEngagementAmount.data.amount\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableEngagementAmountField(vm.data, fixedFeeEngagementAmount.data)\"\n" +
    "                                            bmp-field-error=\"Core.Captions.FixedFeeEngagementAmountCommon.Amount\"\n" +
    "                                            data-bmp-big-number-range-validator\n" +
    "                                            min=\"0\"\n" +
    "                                            max=\"9999999.99\"/>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "\n" +
    "            <!-- List of Project Template edit controls -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingProjectTemplateAmounts\" class=\"col-md-8 col-sm-10 col-xs-12\"></div>\n" +
    "            <div ng-if=\"vm.domainModel.showProjectAmounts(vm.data)\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 pull-right\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{ 'Core.Captions.Project.ClassOther' | translate }}\">\n" +
    "                            <div bento-multiselect-overlay\n" +
    "                                revert-selections-on-dismissal=\"true\"\n" +
    "                                ng-model=\"vm.data.$projectMultiselectDataSelected\"\n" +
    "                                list-data=\"vm.data.$projectMultiselectData\"\n" +
    "                                select-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectProjects' | translate }}\"\n" +
    "                                edit-button-text=\"{{ 'Bluemoon.Core.Setup.FixedFeeBillingTemplate.SelectProjects' | translate }}\"\n" +
    "                                class=\"setup-bento-multiselect-overlay\"\n" +
    "                                data-qe-id=\"bm-fixedFeeBillingTemplateDetail-projectTemplate-multiselect\">\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.data.$projectMultiselectDataSelected.length > 0\">\n" +
    "                            <table class=\"fixed-fee-template-table bento-flex-grid wj-content\">\n" +
    "                                <tr class=\"wj-colheaders\">\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.ProjectTemplate.Code' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header\">{{ 'Core.Captions.FixedFeeProjectAmountCommon.ProjectTemplate' | translate }}</th>\n" +
    "                                    <th class=\"wj-cell wj-header text-right\" >{{ 'Core.Captions.FixedFeeProjectAmountCommon.Amount' | translate }}</th>\n" +
    "                                </tr>\n" +
    "                                <tr data-ng-repeat=\"fixedFeeProjectAmount in vm.data.$projectMultiselectDataSelected\">\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeProjectAmount.data.projectTemplate.code }}</td>\n" +
    "                                    <td class=\"wj-cell\">{{ fixedFeeProjectAmount.data.projectTemplate.name }}</td>\n" +
    "                                    <td class=\"wj-cell\">\n" +
    "                                        <input autocomplete=\"off\" type=\"text\"\n" +
    "                                            data-bmp-big-number=\"'c2'\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            data-bmp-clear-value=\"0\"\n" +
    "                                            id=\"projectAmount_{{$index}}\"\n" +
    "                                            name=\"projectAmount_{{$index}}\"\n" +
    "                                            class=\"form-control input-lg  text-right\"\n" +
    "                                            data-ng-model=\"fixedFeeProjectAmount.data.amount\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableProjectAmountField(vm.data, fixedFeeProjectAmount.data)\"\n" +
    "                                            bmp-field-error=\"Core.Captions.FixedFeeProjectAmountCommon.Amount\"\n" +
    "                                            data-bmp-big-number-range-validator\n" +
    "                                            min=\"0\"\n" +
    "                                            max=\"9999999.99\"/>\n" +
    "                                    </td>\n" +
    "                                </tr>\n" +
    "                            </table>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <br>\n" +
    "        <br>\n" +
    "        <fieldset class=\"well bm-well inner-well\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Template Type -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.FixedFeeBillingTemplate.TemplateType' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'templateType')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "                    <bmp-enum-radio-group enum=\"fixed-fee-billing-template-type\"\n" +
    "                        name=\"templateType\"\n" +
    "                        data-qe-id=\"templateType\"\n" +
    "                        ng-model=\"vm.data.$templateType\"\n" +
    "                        required=\"true\"></bmp-enum-radio-group>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Staff -->\n" +
    "                <div class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Employee.ClassOne' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'employee')\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12 pull-right\">\n" +
    "                            <bmp-select-combo list=\"staff#active\"\n" +
    "                                            name=\"employee\"\n" +
    "                                            data-qe-id=\"employee\"\n" +
    "                                            ng-model=\"vm.data.employee\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableEmployeeField(vm.data)\"></bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <!-- Activity -->\n" +
    "                <div class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Activity.ClassOne' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activity')\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12 pull-right\">\n" +
    "                            <bmp-select-combo list=\"activities#active\"\n" +
    "                                            name=\"activity\"\n" +
    "                                            data-qe-id=\"activity\"\n" +
    "                                            ng-model=\"vm.data.activity\"\n" +
    "                                            data-ng-disabled=\"vm.domainModel.disableActivityField(vm.data)\"></bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- HHTC Article -->\n" +
    "            <div bento-busy-loader=\"vm.data.$loadingHelpArticleSection\" bento-busy-loader-size=\"small\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <fieldset class=\"well bm-well inner-well\">\n" +
    "                            <div data-ng-repeat=\"templateTypeArticle in vm.domainModel.hhtcArticles\">\n" +
    "                                <div ng-if=\"templateTypeArticle.id === vm.data.$templateType.id\">\n" +
    "                                    <h1>{{ templateTypeArticle.header }}</h1>\n" +
    "                                    <p>{{ templateTypeArticle.content }}</p>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </fieldset>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </fieldset>\n" +
    "    </fieldset>\n" +
    "</div>");
}]);

angular.module("core-setup/migration-results/detail/practiceCS/practice-cs-migration-results.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/migration-results/detail/practiceCS/practice-cs-migration-results.html",
    "<bmp-page-header>\n" +
    "    <bmp-page-header-left-content>\n" +
    "        <h1>{{'Practice CS Migration'}}</h1>\n" +
    "    </bmp-page-header-left-content>\n" +
    "    <bmp-page-header-right-content>\n" +
    "        <button type=\"button\"\n" +
    "                id=\"close\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                translate=\"Bluemoon.Practice.Common.Actions.Close\"\n" +
    "                ui-sref=\"migrationResults-master\"></button>\n" +
    "    </bmp-page-header-right-content>\n" +
    "</bmp-page-header>\n" +
    "\n" +
    "<pre>{{vm.data | json}}</pre>\n" +
    "");
}]);

angular.module("core-setup/migration-results/list/migration-results-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/migration-results/list/migration-results-list.html",
    "<div ng-if=\"vm.enteredMaster\">\n" +
    "    <div id=\"migration\" class=\"setup-list-grid-view container-fluid no-left-padding view-container\" ng-show=\"!vm.inDetail()\">\n" +
    "        <h1 id=\"migration-results-grid-header\" class=\"no-top-margin\">\n" +
    "            {{'Bluemoon.Core.Setup.MigrationResults.List.Migrations' | translate}}\n" +
    "        </h1>\n" +
    "\n" +
    "        <div bento-busy-loader=\"vm.isLoading\">\n" +
    "            <div class=\"toolbar-navbar-right\"\n" +
    "                role=\"group\">\n" +
    "                <ul class=\"nav navbar-right ng-scope\">\n" +
    "                    <li class=\"ng-scope\">\n" +
    "                        <span>{{'Bluemoon.Core.Setup.MigrationResults.List.LastUpdatedBy' | translate}} {{ vm.lastRefreshed | date:'medium' }}</span>\n" +
    "                        <button\n" +
    "                        class=\"btn btn-default btn-lg refresh-button-spacing\"\n" +
    "                        ng-click=\"vm.refresh()\"><i class=\"bento-icon-refresh\"></i></button>\n" +
    "                    </li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            <div class=\"clearfix\"></div>\n" +
    "            <bmp-grid bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\" ng-class=\"{'minHeight':vm.isAUTaxApp}\"></bmp-grid>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div id=\"migration-details\" class=\"setup-list-grid-view container-fluid no-left-padding view-container\"\n" +
    "    ng-if=\"vm.eventId && vm.isAUTaxApp\">\n" +
    "    <div class=\"toolbar-navbar-right\" role=\"group\">\n" +
    "        <ul class=\"nav navbar-right ng-scope\">\n" +
    "            <li class=\"ng-scope\">\n" +
    "                <button type=\"button\" class=\"btn btn-icon btn-default scroll-button-spacing\" uib-tooltip=\"Scroll to Top\"\n" +
    "                ng-click=\"vm.scrollTo('migration')\">\n" +
    "                <i class=\"bento-icon-arrow-up\"></i>\n" +
    "                </button>\n" +
    "                <button type=\"button\" class=\"btn btn-icon btn-default scroll-button-spacing\"\n" +
    "                    uib-tooltip=\"Close Table\" ng-click=\"vm.closeDetails('migration')\">\n" +
    "                    <i class=\"bento-icon-close-x\"></i>\n" +
    "                </button>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<ui-view></ui-view>");
}]);

angular.module("core-setup/notes/notes-v2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/notes/notes-v2.html",
    "<h4 ng-if=\"entityId && entityId !== 'new'\">\n" +
    "    <!-- Add Comment -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.AddComment' -->\n" +
    "    <a ng-click=\"open()\" href=\"\"><span class=\"bento-icon-bubble-empty\"></span> <span translate=\"Bluemoon.Core.Setup.AddComment\"></span></a>\n" +
    "    <span class=\"badge\" ng-show=\"commentCount>0\">{{commentCount}}</span>\n" +
    "</h4>\n" +
    "");
}]);

angular.module("core-setup/notes/notes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/notes/notes.html",
    "<h4 ng-if=\"entityId && entityId !== 'new'\">\n" +
    "    <a ng-click=\"open()\" href=\"\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span></a>\n" +
    "    <span class=\"badge\" ng-show=\"commentCount>0\">{{commentCount}}</span>\n" +
    "</h4>\n" +
    "");
}]);

angular.module("core-setup/notes/project-notes.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/notes/project-notes.html",
    "<div class=\"project-notes\">\n" +
    "    <button id=\"projectsNotesClose\" type=\"button\" class=\"close pull-right\" [attr.data-qe-id]=\"qeIdPrefix + 'bmcn-notes-modal-X-button'\" aria-hidden=\"true\"\n" +
    "        ng-click=\"vm.closeModal()\">\n" +
    "        <i class=\"bento-icon-close-x\"></i>\n" +
    "    </button>\n" +
    "    <div class=\"project-notes-modal\">\n" +
    "        <bmcn-notes-modal ng-if=\"vm.entityId\" [entity-id]=\"vm.entityId\" [icon]=\"''\" [name]=\"vm.entityName\"\n" +
    "            [note-type]=\"'general'\" [user-contact-id]=\"vm.userContactId\">\n" +
    "        </bmcn-notes-modal>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/offices/office-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/offices/office-detail.html",
    "<div bento-busy-loader=\"vm.service.contactEditorIsLoading\"></div>\n" +
    "<div ng-hide=\"vm.service.contactEditorIsLoading\">\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Code/ID -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.Office.Code' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"code\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.Office.Code' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'code')\"\n" +
    "                class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                    id=\"code\"\n" +
    "                    name=\"code\"\n" +
    "                    class=\"form-control\"\n" +
    "                    data-ng-model=\"vm.data.code\"\n" +
    "                    data-ng-change=\"vm.detail.clearErrorFor(vm.data, 'code')\"\n" +
    "                    data-ng-model-options=\"vm.detail.defaultAsyncValidationNgModelOptions\"\n" +
    "                    data-ng-required=\"true\"\n" +
    "                    data-bmp-entity-code=\"\"\n" +
    "                    data-bmp-entity-code-id=\"vm.id\"\n" +
    "                    data-bmp-entity-code-type=\"offices\"\n" +
    "                    data-bm-focus-on-link=\"\"\n" +
    "                    data-bm-focus-on-event=\"'bm.core.setup.common.contactSelectedEvent'\"\n" +
    "                    data-fef-maxlength=\"20\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"msg\">{{vm.detail.errorFor(vm.data, 'primaryContact')}}</div>\n" +
    "    <div ng-if=\"vm.service.entityTypes && vm.service.validEntityTypes\" data-onvio-contact-editor=\"vm.data.primaryContactExpanded\"\n" +
    "        contact-name-validation-service=\"vm.domainModel.contactNameValidationService\"\n" +
    "        data-onvio-contact-editor-parent-form=\"detailForm\"\n" +
    "        data-onvio-contact-editor-valid-entity-types=\"vm.service.validEntityTypes\"\n" +
    "        data-onvio-contact-editor-entity-types=\"vm.service.entityTypes\"\n" +
    "        data-onvio-contact-editor-show-contact-selector=\"false\"\n" +
    "        data-onvio-contact-editor-show-confidentiality=\"false\"\n" +
    "        data-onvio-contact-editor-is-loading=\"vm.service.contactEditorIsLoading\"\n" +
    "        data-onvio-contact-editor-exclude-office-contacts=\"true\">\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/permission-groups/permission-groups-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/permission-groups/permission-groups-detail.html",
    "<bm-permission-groups-detail></bm-permission-groups-detail>");
}]);

angular.module("core-setup/permission-groups/permission-groups.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/permission-groups/permission-groups.html",
    "<bm-permission-groups-list></bm-permission-groups-list>");
}]);

angular.module("core-setup/project-list-component/app-timer-start.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-list-component/app-timer-start.html",
    "<div ng-hide=\"vm.errorMessage\" bento-busy-loader=\"true\" bento-busy-loader-size=\"large\" style=\"height:80vh\"></div>\n" +
    "<div ng-show=\"vm.errorMessage\">\n" +
    "<h3>{{vm.errorMessage}}</h3>\n" +
    "<button ng-show=\"vm.destinationUrl\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.onConfirmError()\" data-translate=\"Bluemoon.Practice.Common.Actions.Ok\"></button>\n" +
    "</div>");
}]);

angular.module("core-setup/project-list-component/project-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-list-component/project-list.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-xs-12\">\n" +
    "        <div style=\"float: left;\">\n" +
    "            <h1 style=\"margin-top: 0px\" class=\"project-title\">{{ ctrl.title | translate }} <span ng-if=\"ctrl.grid.definition.userFilter && !ctrl.filterIsEmpty()\">({{'Bluemoon.Core.Setup.ProjectList.FilteredLabel' | translate}})</span></h1>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-6 col-xs-12 bm-core-project-list-controls\" ng-if=\"!ctrl.projectId\">\n" +
    "        <div style=\"float: right\" class=\"btn-group title-case\" ng-if=\"ctrl.hasTasksPermissions\">\n" +
    "            <button type=\"button\" class=\"btn btn-default btn-toggle buttonFocusOutline\" ng-model=\"ctrl.projectTaskFilter\" uib-btn-radio=\"'All'\" qe-id=\"CoreProjectList-IncludeAll-button\" >{{'Bluemoon.Practice.Common.DateRange.All' | translate}}</button>\n" +
    "            <button type=\"button\" class=\"btn btn-default btn-toggle buttonFocusOutline\" ng-model=\"ctrl.projectTaskFilter\" uib-btn-radio=\"'Projects'\" qe-id=\"CoreProjectList-IncludeProjects-button\" >{{'Core.Captions.Project.ClassOther' | translate}}</button>\n" +
    "            <button type=\"button\" class=\"btn btn-default btn-toggle buttonFocusOutline\" ng-model=\"ctrl.projectTaskFilter\" uib-btn-radio=\"'Tasks'\" qe-id=\"CoreProjectList-IncludeTasks-button\" >{{'Core.Captions.Task.ClassOther' | translate}}</button>\n" +
    "        </div>\n" +
    "        <div style=\"float: right; margin-right: 8px;\" class=\"btn-group title-case\" ng-if=\"!ctrl.isWidgetStyle()\">\n" +
    "            <button type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle title-case\"\n" +
    "                qe-id=\"hideClosedProjects\"\n" +
    "                ng-disabled=\"!ctrl.grid\"\n" +
    "                ng-model=\"ctrl.hideClosedProjects\"\n" +
    "                uib-btn-checkbox btn-checkbox-true=\"true\"\n" +
    "                btn-checkbox-false=\"false\">\n" +
    "                {{'Bluemoon.Core.Setup.ProjectList.HideClosedProjects' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "        <div style=\"float: right; margin-right: 8px;\" class=\"btn-group title-case\" ng-if=\"ctrl.isWidgetStyle() && ctrl.tasksMode()\">\n" +
    "            <button type=\"button\"\n" +
    "                class=\"btn btn-default btn-toggle title-case\"\n" +
    "                qe-id=\"readyTasksOnly\"\n" +
    "                ng-disabled=\"!ctrl.grid\"\n" +
    "                ng-model=\"ctrl.readyTasksOnly\"\n" +
    "                uib-btn-checkbox btn-checkbox-true=\"true\"\n" +
    "                btn-checkbox-false=\"false\">\n" +
    "                {{'Bluemoon.Core.Setup.ProjectList.ReadyTasksOnly' | translate}}\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" id=\"bm-practice-projects-list\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "            <!-- <bmp-view-mode-tabset bmp-view-mode-tabset-tabs=\"ctrl.tabs\" bmp-view-mode-tabset-orientation=\"top\" class=\"tabset-no-padding\"> -->\n" +
    "            <bmp-slideout-filter-panel bmp-slideout-filter-panel-hide=\"ctrl.hideSlideoutFilterPanel()\" ng-class=\"{'widget-mode-grid':ctrl.isWidgetButtonVisible}\">\n" +
    "                <div ng-if=\"ctrl.projectsAndTasksMode()\">\n" +
    "                    <bmp-grid data-bmp-grid-definition=\"ctrl.projectsAndTasksDefinition\" data-bmp-grid-service=\"ctrl.service\" data-bmp-grid-before-load=\"ctrl.gridLoaded($sender)\"></bmp-grid>\n" +
    "                </div>\n" +
    "                <div ng-if=\"ctrl.projectsMode()\">\n" +
    "                    <bmp-grid data-bmp-grid-definition=\"ctrl.projectsDefinition\" data-bmp-grid-service=\"ctrl.service\" data-bmp-grid-before-load=\"ctrl.gridLoaded($sender)\"></bmp-grid>\n" +
    "                </div>\n" +
    "                <div ng-if=\"ctrl.tasksMode()\">\n" +
    "                    <bmp-grid data-bmp-grid-definition=\"ctrl.tasksDefinition\" data-bmp-grid-service=\"ctrl.service\" data-bmp-grid-before-load=\"ctrl.gridLoaded($sender)\"></bmp-grid>\n" +
    "                </div>\n" +
    "            </bmp-slideout-filter-panel>\n" +
    "            <!-- </bmp-view-mode-tabset> -->\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/project-list-component/project-tasks-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-list-component/project-tasks-dialog.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"tasksDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"tasksDialog.onClose()\"\n" +
    "                aria-hidden=\"true\">&times;</button>\n" +
    "        {{'Core.Captions.Task.ClassOther' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "\n" +
    "        <bmp-grid bmp-grid-definition=\"tasksDialog.gridDefinition\"\n" +
    "                    bmp-grid-service=\"tasksDialog.service\"\n" +
    "                    bmp-grid-before-load=\"tasksDialog.gridLoaded($sender)\"></bmp-grid>\n" +
    "\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button id=\"tasksDialog.ok\"\n" +
    "                    class=\"btn btn-primary\"\n" +
    "                    data-ng-click=\"tasksDialog.onClose()\" data-translate=\"Bluemoon.Practice.Common.Actions.Close\"></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/project-list-component/task-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-list-component/task-list.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-6 col-xs-12 col-md-offset-6\">\n" +
    "        <div style=\"float: right; margin-right: 8px;\">\n" +
    "            <label>\n" +
    "                <input type=\"checkbox\" ng-model=\"ctrl.hideClosedTasks\" qe-id=\"hideClosedTasks\" ng-disabled=\"!ctrl.grid\" /> {{'Bluemoon.Core.Setup.ProjectList.HideClosedTasks' | translate}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" id=\"bm-practice-tasks-list\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <bmp-grid data-bmp-grid-definition=\"ctrl.definition\" data-bmp-grid-service=\"ctrl.service\" data-bmp-grid-before-load=\"ctrl.gridLoaded($sender)\"></bmp-grid>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/project-templates/project-template-detail-recurrence.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-templates/project-template-detail-recurrence.html",
    "<div ng-form name=\"detailForm\" ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Single Series -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"allowOnlyOneSeries\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.AllowOnlyOneSeries' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'allowOnlyOneSeries')\"\n" +
    "                class=\"col-md-8 col-sm-10\">\n" +
    "            <bmp-radio-button-group id=\"allowOnlyOneSeries\" name=\"allowOnlyOneSeries\"\n" +
    "                                    ng-model=\"vm.data.$allowOnlyOneSeries\"\n" +
    "                                    bmp-radio-button-group-tab-stop=\"true\"\n" +
    "                                    bmp-radio-button-group-options=\"vm.domainModel.booleanOptions\"></bmp-radio-button-group>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <schedule-item-series-detail data=\"vm.data.scheduleItemSeries\"\n" +
    "        default-data=\"vm.defaultData.scheduleItemSeries\"\n" +
    "        controller=\"vm\"\n" +
    "        domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "        is-project-screen-recurrence=\"false\">\n" +
    "    </schedule-item-series-detail>\n" +
    "\n" +
    "    <h3 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions\"></h3>\n" +
    "    <h5 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.Subtitle\"></h5>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Column Headings -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"extensionNumber\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplateExtension.Number' | translate}}\"\n" +
    "            class=\"col-md-2 col-sm-2 col-xs-2\">\n" +
    "        </div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"extensionMonth\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplateExtension.Month' | translate}}\"\n" +
    "            class=\"col-md-3 col-sm-4 col-xs-4\">\n" +
    "        </div>\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"extensionDay\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplateExtension.Day' | translate}}\"\n" +
    "            class=\"col-md-3 col-sm-4 col-xs-4\">\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"vm.data.extensions.length===0\">\n" +
    "        <!-- No Extensions -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"extension-none\"\n" +
    "            class=\"col-md-8 col-sm-10\">\n" +
    "            <em><span translate=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.None\" data-qe-id=\"extension-none-message\"></span></em>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-repeat=\"extension in vm.data.extensions\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"extension\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(extension, 'id') || vm.detail.errorFor(extension, 'month') || vm.detail.errorFor(extension, 'day')\"\n" +
    "            class=\"col-md-12 col-sm-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Extensions -->\n" +
    "                <!--translate=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.MustBeOrdered\"-->\n" +
    "                <div class=\"col-md-2 col-sm-2\">\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" readonly=\"true\"\n" +
    "                        name=\"extension_number_KEY__{{$index}}\"\n" +
    "                        data-qe-id=\"extension_number_KEY__{{$index}}\"\n" +
    "                        ng-model=\"extension.number\"\n" +
    "                        bmp-integer=\"true\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.ProjectTemplateExtension.Number\"\n" +
    "                        bmp-custom-validation=\"vm.domainModel.isExtensionOrderedCorrectly(vm.data, extension)\"\n" +
    "                        bmp-custom-validation-message=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.MustBeOrdered\" />\n" +
    "                </div>\n" +
    "                <div class=\"col-md-3 col-sm-4\">\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                        name=\"extension_month_KEY__{{$index}}\"\n" +
    "                        data-qe-id=\"extension_month_KEY__{{$index}}\"\n" +
    "                        ng-model=\"extension.month\"\n" +
    "                        bmp-integer=\"true\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.ProjectTemplateExtension.Month\"\n" +
    "                        bmp-custom-validation=\"vm.domainModel.isExtensionOrderedCorrectly(vm.data, extension)\"\n" +
    "                        bmp-custom-validation-message=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.MustBeOrdered\" />\n" +
    "                </div>\n" +
    "                <div class=\"col-md-3 col-sm-4\">\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                        name=\"extension_day_KEY__{{$index}}\"\n" +
    "                        data-qe-id=\"extension_day_KEY__{{$index}}\"\n" +
    "                        ng-model=\"extension.day\"\n" +
    "                        bmp-integer=\"true\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.ProjectTemplateExtension.Day\"\n" +
    "                        bmp-custom-validation=\"vm.domainModel.isExtensionOrderedCorrectly(vm.data, extension)\"\n" +
    "                        bmp-custom-validation-message=\"Bluemoon.Core.Setup.ProjectTemplate.Extensions.MustBeOrdered\" />\n" +
    "                </div>\n" +
    "                <!-- Remove extension -->\n" +
    "                <div class=\"col-md-4 col-sm-2\">\n" +
    "                    <button id=\"extension_remove_KEY__{{$index}}\"\n" +
    "                            name=\"extension_remove_KEY__{{$index}}\"\n" +
    "                            data-qe-id=\"extension_remove_KEY__{{$index}}-button\"\n" +
    "                            type=\"button\"\n" +
    "                            class=\"btn btn-link\"\n" +
    "                            style=\"padding-left:0px\"\n" +
    "                            data-ng-show=\"vm.domainModel.canRemoveExtension(vm.data, extension)\"\n" +
    "                            data-ng-click=\"vm.domainModel.removeExtension(vm.data, extension); vm.setFormDirty(); focus('add_another_extension_button')\">\n" +
    "                        <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "                        <span data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.RemoveExtension\"></span>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Add another extension -->\n" +
    "        <div class=\"col-md-12 col-sm-12\">\n" +
    "            <a href id=\"add_another_extension_button\" class=\"btn btn-link\" type=\"button\"\n" +
    "            data-qe-id=\"extension_add-button\"\n" +
    "            data-ng-show=\"vm.domainModel.canAddNewExtension(vm.data, vm.defaultData)\"\n" +
    "            data-ng-click=\"vm.domainModel.addNewExtension(vm.data, vm.defaultData); vm.setFormDirty(); focus('extension_month_KEY__' + (vm.data.extensions.length-1))\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span>\n" +
    "                <span ng-if=\"vm.data.extensions.length===0\" data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.AddExtension\"></span>\n" +
    "                <span ng-if=\"vm.data.extensions.length!==0\" data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.AddAnotherExtension\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row col-md-8 col-sm-10\">\n" +
    "        <schedule-item-project-generation-options data=\"vm.data.scheduleItemSeries\"\n" +
    "            default-data=\"vm.defaultData.scheduleItemSeries\"\n" +
    "            controller=\"vm\"\n" +
    "            domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "            primary-label=\"vm.domainModel.getPrimaryAssignmentLabel(vm.data)\"\n" +
    "            secondary-label=\"vm.domainModel.getSecondaryAssignmentLabel(vm.data)\"\n" +
    "            is-project-screen-recurrence=\"false\">\n" +
    "        </schedule-item-project-generation-options>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8 col-sm-10\">\n" +
    "            <!-- Task generation options -->\n" +
    "            <schedule-task-generation-options\n" +
    "                data=\"vm.data.scheduleItemSeries\"\n" +
    "                default-data=\"vm.data.scheduleItemSeries\"\n" +
    "                controller=\"vm\"\n" +
    "                domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "                is-project-screen-recurrence=\"false\"></schedule-task-generation-options>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/project-templates/project-template-detail-time-and-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-templates/project-template-detail-time-and-billing.html",
    "<div ng-form name=\"detailForm\" ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "    <h3 class=\"no-top-margin\" translate=\"Bluemoon.Core.Setup.Project.Detail.Navigation.TimeAndBilling\"></h3>\n" +
    "    <div class=\"row\" bmp-if-firm-permission=\"hasEngagements\">\n" +
    "        <!-- Engagement Template -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"engagementTemplate\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.EngagementTemplate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'engagementTemplate')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"engagement-templates#active\" name=\"engagementTemplate\" ng-model=\"vm.data.engagementTemplate\"\n" +
    "                              data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-engagementTemplate-select-combo\"></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" bm-if-has-license-some=\"['ProjectManagement.Projects','OnvioAU.Platform']\">\n" +
    "        <!-- Invoice Description -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"invoiceDescription\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.InvoiceDescription' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "                class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"invoiceDescription\" name=\"invoiceDescription\"\n" +
    "                        data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-invoiceDescription-textarea\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                        data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "        <div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "            <div ng-if=\"vm.domainModel.showTaxGroup(vm.data)\">\n" +
    "                <div bm-if-perm-some=\"['TimeAndBilling.AssessServiceCharges','TimeAndBilling.Billing','TimeAndBilling.PrintStatements','TimeAndBilling.ReceiptAndAdjustment','TimeAndBilling.ReviewInvoices','TimeAndBilling.TimeAndExpense']\">\n" +
    "                <!-- Tax Group -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"taxGroupType\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.TaxGroupId' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxGroupType')\"\n" +
    "                        class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <bmp-enum-combo enum=\"tax-group-types\" name=\"taxGroupType\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-taxGroupType-select-combo\"\n" +
    "                                ng-model=\"vm.data.taxGroupType\"></bmp-enum-combo>\n" +
    "                    </div>\n" +
    "                <!-- Specified Tax Group -->\n" +
    "                    <div ng-show=\"vm.domainModel.shouldSpecifyTaxGroup(vm.data)\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SpecifiedTaxGroupId' | translate}}\"\n" +
    "                            data-bmp- data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroupId')\"\n" +
    "                            class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            name=\"taxgroup\"\n" +
    "                                            data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-indirectTaxProvider-select-combo\"\n" +
    "                                            ng-model=\"vm.data.$taxGroup\" provider=\"vm.domainModel.indirectTaxProvider\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-has-license=\"ProjectManagement.Budget\">\n" +
    "        <div bm-if-perm=\"ProjectManagement.Budget\">\n" +
    "\n" +
    "            <h3 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.Budgets\"></h3>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <label>\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-budgetedBasedOnTasks-checkbox\"\n" +
    "                                ng-model=\"vm.data.$budgetedBasedOnTasks\" /> {{'Core.Captions.ProjectTemplate.BudgetedBasedOnTasks' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12 form-group\">\n" +
    "                    <label>\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-budgetedAmountIsCalculated-checkbox\"\n" +
    "                                ng-model=\"vm.data.$budgetedAmountIsCalculated\" ng-disabled=\"vm.data.budgetedBasedOnTasks\" /> {{'Core.Captions.ProjectTemplate.BudgetedAmountIsCalculated' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.BudgetedHours' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedHours')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" name=\"budgetedHours\" type=\"text\" class=\"form-control\"\n" +
    "                            data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-budgetedBasedOnTasks-text\"\n" +
    "                            ng-model=\"vm.data.budgetedHours\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ProjectTemplate.BudgetedHours\"\n" +
    "                            ng-readonly=\"vm.data.budgetedBasedOnTasks\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-big-number-range-validator=\"\"\n" +
    "                            bm-format-on-blur=\"\"\n" +
    "                            bmp-big-number=\"'n2'\"\n" +
    "                            min=\"0\" max=\"99999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.BudgetedAmount' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedAmount')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" name=\"budgetedAmount\" type=\"text\" class=\"form-control\"\n" +
    "                            data-qe-id=\"bm-projectTemplateDetailTimeAndBilling-budgetedAmount-text\"\n" +
    "                            ng-model=\"vm.data.budgetedAmount\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ProjectTemplate.BudgetedAmount\"\n" +
    "                            ng-readonly=\"vm.data.budgetedBasedOnTasks || vm.data.budgetedAmountIsCalculated\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-big-number-range-validator=\"\"\n" +
    "                            bm-format-on-blur=\"\"\n" +
    "                            bmp-big-number=\"'c2'\"\n" +
    "                            min=\"0\" max=\"999999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div>");
}]);

angular.module("core-setup/project-templates/project-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-templates/project-template-detail.html",
    "<div class=\"row\">\n" +
    "    <!-- Project Application -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"applicationType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.ApplicationType' | translate | bmRequiredMark }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationType')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"application-types\"\n" +
    "                        name=\"applicationType\"\n" +
    "                        data-qe-id=\"bm-projectTemplateDetail-applicationType-enum-combo\"\n" +
    "                        on-change=\"vm.domainModel.updateForApplicationType(vm.data)\"\n" +
    "                        ng-model=\"vm.data.applicationType\"\n" +
    "                        ng-disabled=\"vm.domainModel.isApplicationTypeDisabled(vm.data)\"\n" +
    "                        required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"vm.data.applicationType.id == 'CATAX'\"  class=\"row\">\n" +
    "    <!-- Application Form Type CA -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.ApplicationFormType' | translate | bmRequiredMark }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-enum-combo  ng-readonly =\"!vm.data.$applicationFormTypeOptions\"\n" +
    "                        enum=\"custom\"\n" +
    "                        name=\"applicationFormType\"\n" +
    "                        data-qe-id=\"bm-projectTemplateDetail-applicationFormType-enum-combo\"\n" +
    "                        ng-model=\"vm.data.$applicationFormType\"\n" +
    "                        custom-items=\"vm.data.$applicationFormTypeOptions\"\n" +
    "                        ng-disabled=\"vm.domainModel.isApplicationFormTypeDisabled(vm.data)\"\n" +
    "                        ng-required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"vm.domainModel.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id) || vm.data.applicationType.id == 'UKTAX' ||  vm.data.applicationType.id == 'UKSECRETARIAL'|| vm.data.applicationType.id === 'USADVISORYTOOLS'\"  class=\"row\">\n" +
    "    <!-- Application Form Type US / UK  -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectTemplate.ApplicationFormType.UKType' -->\n" +
    "    <!-- vm.domainModel.getApplicationFormTypeTitle(vm.data.applicationType)' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "         data-bmp-control-group-label=\"{{ vm.domainModel.getApplicationFormTypeTitle(vm.data.applicationType.id) | translate | bmRequiredMark }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo  ng-readonly =\"!vm.data.$applicationFormTypeOptions\"\n" +
    "                        enum=\"custom\"\n" +
    "                        name=\"applicationFormType\"\n" +
    "                        data-qe-id=\"bm-projectTemplateDetail-applicationFormType-isUsTaxOrUltraTax-enum-combo\"\n" +
    "                        ng-model=\"vm.data.$applicationFormType\"\n" +
    "                        on-change=\"vm.domainModel.onApplicationFormTypeChanged(vm.data)\"\n" +
    "                        custom-items=\"vm.data.$applicationFormTypeOptions\"\n" +
    "                        ng-disabled=\"vm.domainModel.isApplicationFormTypeDisabled(vm.data)\"\n" +
    "                        ng-required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- Application Form Sub Type US / UK  -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectTemplate.ApplicationFormSubType.UKType' -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectTemplate.ApplicationFormSubType.USType' -->\n" +
    "    <div ng-if=\"vm.data.$applicationFormSubtypeOptions.length > 0 && vm.data.applicationFormSubtype.id !== 'NONE'\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationFormSubtype\"\n" +
    "            data-bmp-control-group-label=\"{{vm.data.applicationType.id === 'UKTAX' ? 'Bluemoon.Core.Setup.ProjectTemplate.ApplicationFormSubType.UKType' : 'Bluemoon.Core.Setup.ProjectTemplate.ApplicationFormSubType.USType' | translate | bmRequiredMark }}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormSubtype')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <bmp-enum-combo ng-readonly=\"!vm.data.$applicationFormSubtypeOptions || vm.data.$applicationFormSubtypeOptions.length < 1\"\n" +
    "                            enum=\"custom\"\n" +
    "                            name=\"applicationFormSubtype\"\n" +
    "                            data-qe-id=\"bm-projectTemplateDetail-applicationFormSubtype-enum-combo\"\n" +
    "                            ng-model=\"vm.data.applicationFormSubtype\"\n" +
    "                            custom-items=\"vm.data.$applicationFormSubtypeOptions\"\n" +
    "                            ng-disabled=\"vm.domainModel.isApplicationFormSubtypeDisabled(vm.data)\"\n" +
    "                            ng-required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "    <!-- Priority -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"projectPriority\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.ProjectPriority' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectPriority')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"priority-types\" name=\"projectPriority\" data-qe-id=\"bm-projectTemplateDetail-projectPriority-enum-combo\" ng-model=\"vm.data.projectPriority\" required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Tracking Description -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ProjectTemplate.TrackingDescription' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.TrackingDescription' | translate | bmRequiredMark }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-select-combo list-style=\"basic\" list=\"tracking-descriptions\" aotf-default\n" +
    "            name=\"trackingDescription\" data-qe-id=\"bm-projectTemplateDetail-trackingDescription-enum-combo\" ng-model=\"vm.data.trackingDescription\" required=\"true\"></bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "    <!-- Department -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"department\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.DepartmentGroupType' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'departmentGroupType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo\n" +
    "            enum=\"custom\"\n" +
    "            name=\"departmentGroupType\"\n" +
    "            data-qe-id=\"bm-projectTemplateDetail-departmentGroupType-enum-combo\"\n" +
    "            required=\"true\"\n" +
    "            ng-model=\"vm.data.departmentGroupType\"\n" +
    "            custom-items=\"vm.data.$departmentGroupTypeOptions\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- Specified Department -->\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyDepartment(vm.data)\">\n" +
    "        <!-- <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SpecifiedDepartment' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'department')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo\n" +
    "                list=\"departments\"\n" +
    "                name=\"department\"\n" +
    "                ng-model=\"vm.data.departments[0].department\"\n" +
    "                aotf-default>\n" +
    "            </bmp-select-combo>\n" +
    "        </div> -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"department\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SpecifiedDepartment' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'department')\"\n" +
    "            >\n" +
    "            <bmp-multi-select-control\n" +
    "                name=\"department\"\n" +
    "                style=\"padding-right: 10px; float: left;\"\n" +
    "                list-data=\"vm.domainModel.departmentsList\"\n" +
    "                ng-model=\"vm.domainModel.selectedDepartments\"\n" +
    "                revert-selections-on-dismissal=\"true\">\n" +
    "            </bmp-multi-select-control>\n" +
    "            <div class=\"form-control-static\">\n" +
    "                <span data-ng-repeat=\"department in vm.domainModel.selectedDepartments\">\n" +
    "                    <span class=\"label label-info\">\n" +
    "                        {{department.name}}\n" +
    "                        <span class=\"glyphicon glyphicon-remove scheduleitem-label-glyphicon\"\n" +
    "                                data-qe-id=\"department-remove-{{department.name}}-button\"\n" +
    "                                data-ng-click=\"vm.domainModel.onRemoveDepartmentByLabel(department); vm.setFormDirty();\"></span>\n" +
    "                    </span>&nbsp;\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<!-- Remove this section with User Story 2520286-->\n" +
    "\n" +
    "\n" +
    "\n" +
    "\n" +
    "<h3 data-translate=\"Core.Captions.ProjectTemplate.PrimaryAssignments\"></h3>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Primary/Preparer Assignment -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"assignEmployeeType\"\n" +
    "         data-bmp-control-group-label=\"{{ vm.domainModel.getPrimaryAssignmentLabel(vm.data) }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'assignEmployeeGroupType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"employee-grouping-types\" name=\"assignEmployeeType\" data-qe-id=\"bm-projectTemplateDetail-assignEmployeeGroupType-enum-combo\" required=\"true\"\n" +
    "                        ng-model=\"vm.data.assignEmployeeGroupType\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyAssignedStaff(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "			 <div class=\"col-md-6 col-sm-9\" ng-class=\"col-xs-12\">\n" +
    "				<div data-bmp-control-group=\"\"\n" +
    "					 data-bmp-control-group-field-id=\"primaryAssignment_employee_KEY__{{$index}}\"\n" +
    "					 data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplateAssignment.Employee' | translate | bmRequiredMark:vm.domainModel.primaryAssignmentRequired(vm.data)}}\"\n" +
    "					 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.primaryAssignment, 'employee')\">\n" +
    "					<bmp-select-combo list=\"staff#active\" name=\"primaryAssignment_employee_KEY__{{$index}}\" data-qe-id=\"bm-projectTemplateDetail-primaryAssignment_employee_KEY__{{$index}}-select-combo\"\n" +
    "									ng-model=\"vm.data.primaryAssignment.employee\"\n" +
    "									ng-required=\"vm.domainModel.primaryAssignmentRequired(vm.data)\"\n" +
    "									aotf-default></bmp-select-combo>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "\n" +
    "                <!-- Commenting this out since it is not supported -->\n" +
    "				<!--\n" +
    "                <div class=\"col-md-4 col-sm-3 col-xs-2\">\n" +
    "                    <button id=\"primaryAssignment_remove_KEY__{{$index}}\"\n" +
    "                            name=\"primaryAssignment_remove_KEY__{{$index}}\"\n" +
    "                            data-qe-id=\"primaryAssignment_remove_KEY__{{$index}}-button\"\n" +
    "                            type=\"button\"\n" +
    "                            class=\"btn btn-link\"\n" +
    "                            style=\"padding-left:0px\"\n" +
    "                            data-ng-show=\"vm.domainModel.canRemovePrimaryAssignment(vm.data, assignment)\"\n" +
    "                            data-ng-click=\"vm.domainModel.removePrimaryAssignment(vm.data, assignment); vm.setFormDirty(); focus('add_another_primary_assignment_button');\">\n" +
    "                        <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "                        <span data-translate=\"Bluemoon.Core.Setup.Common.ProjectTemplates.RemoveAssignment\"></span>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "				-->\n" +
    "            <!-- Commenting this out since adding new primary assignments are not supported.\n" +
    "            <div class=\"row\" ng-show=\"vm.domainModel.canAddNewPrimaryAssignment(vm.data, vm.defaultData)\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <a href id=\"add_another_primary_assignment_button\" class=\"btn btn-link\" type=\"button\"\n" +
    "                       data-ng-click=\"vm.domainModel.addNewPrimaryAssignment(vm.data, vm.defaultData); vm.setFormDirty(); focus('primaryAssignment_employee_KEY__' + (vm.data.primaryAssignments.length-1));\">\n" +
    "                        <span class=\"glyphicon glyphicon-plus-sign\"></span>\n" +
    "                        <span data-translate=\"Bluemoon.Core.Setup.Common.ProjectTemplates.AddAssignment\"></span>\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            -->\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Secondary/Staff Assignment -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"secondaryAssignEmployeeType\"\n" +
    "         data-bmp-control-group-label=\"{{ vm.domainModel.getSecondaryAssignmentLabel(vm.data) }}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'secondaryAssignEmployeeGroupType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"employee-grouping-types\" name=\"secondaryAssignEmployeeType\" data-qe-id=\"bm-projectTemplateDetail-secondaryAssignEmployeeType-enum-combo\" required=\"true\"\n" +
    "                        ng-model=\"vm.data.secondaryAssignEmployeeGroupType\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifySecondaryAssignedStaff(vm.data)\">\n" +
    "        <!-- <div ng-if=\"vm.data.applicationType.id !== 'UKTAX' && !vm.domainModel.singleAssignment\" class=\"row\"> -->\n" +
    "        <div ng-if=\"!vm.domainModel.singleAssignment\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"secondaryAssignEmployeeTypeSpecified\"\n" +
    "                 class=\"col-md-8 col-sm-8 col-xs-12\"\n" +
    "                 style=\"padding-top: 24px;\">\n" +
    "                 <bmp-multi-select-control\n" +
    "                     name=\"singleAssignment\"\n" +
    "                     style=\"padding-right: 10px; float: left;\"\n" +
    "                     revert-selections-on-dismissal=\"true\"\n" +
    "                     ng-model=\"vm.data.$multiselectDataSelected\"\n" +
    "                     list-data=\"vm.data.$multiselectData\"\n" +
    "                     select-button-text=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                     edit-button-text=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SecondaryAssignment.SelectStaff' | translate}}\">\n" +
    "                </bmp-multi-select-control>\n" +
    "                <div class=\"form-control-static\">\n" +
    "                    <span ng-repeat=\"assignment in vm.data.secondaryAssignments\">\n" +
    "                        <span class=\"label label-info\" data-qe-id=\"bm-projectTemplateDetail-secondaryAssignments-name_{{assignment.employee.name}}\">\n" +
    "                            {{assignment.employee.name}}\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                  data-qe-id=\"bm-projectTemplateDetail-secondaryAssignments-removeButton_{{assignment.employee.name}}\"\n" +
    "                                  data-ng-click=\"vm.domainModel.removeSecondaryAssignment(vm.data, assignment, true); vm.setFormDirty();\">\n" +
    "                            </span>\n" +
    "                        </span>&nbsp;\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.domainModel.singleAssignment\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"secondaryAssignEmployeeType\"\n" +
    "                 data-bmp-control-group-field-id=\"secondaryAssignEmployeeType_KEY__{{$index}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.secondaryAssignments[0], 'employee')\"\n" +
    "                 class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"staff#active\"\n" +
    "                                  ng-model=\"vm.data.secondaryAssignments[0].employee\"\n" +
    "                                  aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Reviewer Assignment -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"responsibleEmployeeType\"\n" +
    "         data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ResponsibleAssignment' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'responsibleEmployeeType')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"employee-grouping-types\" name=\"responsibleEmployeeType\" data-qe-id=\"bm-projectTemplateDetail-responsibleEmployeeType-enum-combo\" required=\"true\"\n" +
    "                        ng-model=\"vm.data.responsibleEmployeeGroupType\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.domainModel.shouldSpecifyResponsibleStaff(vm.data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"responsibleEmployee\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.ResponsibleEmployee' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'responsibleEmployee')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"responsibleEmployee\" data-qe-id=\"bm-projectTemplateDetail-responsibleEmployee-select-combo\"\n" +
    "                            ng-model=\"vm.data.responsibleEmployee\"\n" +
    "                             aotf-default></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div bm-if-perm-some=\"['Onvio.DocumentStorage', 'OnvioDrive.ClientDocuments']\">\n" +
    "    <h3 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.DocumentStorage\"></h3>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Storage -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"documentFolderOption\"\n" +
    "             data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' :\n" +
    "                'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderOption')\"\n" +
    "             class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <div ng-switch=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                <div ng-switch-when=\"true\">\n" +
    "                    <bmp-enum-combo enum=\"document-binder-options\" name=\"documentBinderOption\" data-qe-id=\"bm-projectTemplateDetail-documentBinderOption-enum-combo\" required=\"true\"\n" +
    "                                    ng-model=\"vm.data.documentFolderOption\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "                <div ng-switch-default=\"\">\n" +
    "                    <div ng-switch=\"vm.domainModel.applicationTypeIsAUTaxOrAUActivityStatementOrAdvisory(vm.data)\">\n" +
    "                        <div ng-switch-when=\"true\">\n" +
    "                            <bmp-enum-combo enum=\"document-folder-options-without-none\" name=\"documentFolderOption\" required=\"true\"\n" +
    "                                    ng-model=\"vm.data.documentFolderOption\"></bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                        <div ng-switch-default=\"\">\n" +
    "                            <bmp-enum-combo enum=\"document-folder-options\" name=\"documentFolderOption\" required=\"true\"\n" +
    "                                    ng-model=\"vm.data.documentFolderOption\"></bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div ng-if=\"vm.data.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' -->\n" +
    "                    <!-- /* i18nextract */'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"documentFolderTemplateId\"\n" +
    "                         data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                            'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' :\n" +
    "                            'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' | translate}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderTemplateId')\"\n" +
    "                         class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <bmp-select-combo name=\"documentFolderTemplateId\"\n" +
    "                                          data-qe-id=\"bm-projectTemplateDetail-documentFolderTemplateId-select-combo\"\n" +
    "                                          list=\"dms-project-templates#dms\"\n" +
    "                                          list-style=\"basic\"\n" +
    "                                          ng-model=\"vm.data.$documentFolderTemplate\"></bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.data.documentFolderOption.id === 'NEW' || vm.data.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                         data-bmp-control-group-field-id=\"documentFolderDefaultName\"\n" +
    "                         data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplate.DocumentFolderDefaultName' | translate}}\"\n" +
    "                         data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderDefaultName')\"\n" +
    "                         class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" name=\"documentFolderDefaultName\"\n" +
    "                               data-qe-id=\"bm-projectTemplateDetail-documentFolderDefaultName-input\"\n" +
    "                               ng-model=\"vm.data.documentFolderDefaultName\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\"\n" +
    "        ng-if=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "        <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <label>\n" +
    "                <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                ng-model=\"vm.data.useRollForwardSettings\" />\n" +
    "                       {{ 'Core.Captions.ProjectTemplate.UseRollForwardSettings' | translate}}\n" +
    "            </label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/project-templates/project-template-import.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/project-templates/project-template-import.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"importDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"importDialog.onClose()\"\n" +
    "                aria-hidden=\"true\">&times;</button>\n" +
    "        {{'Bluemoon.Core.Setup.ProjectTemplate.Import.Title' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "\n" +
    "        <bmp-grid bmp-grid-definition=\"importDialog.gridDefinition\"\n" +
    "                    bmp-grid-service=\"importDialog.projectTemplateImportService\"\n" +
    "                    bmp-grid-before-load=\"importDialog.gridLoaded($sender)\"></bmp-grid>\n" +
    "\n" +
    "        <div class=\"modal-footer\">\n" +
    "            <button id=\"importDialog.ok\"\n" +
    "                    class=\"btn btn-primary\"\n" +
    "                    data-ng-click=\"importDialog.onOk()\" data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.Import.Done\" data-ng-disabled=\"importDialog.gridData.selectedItems.length===0\"></button>\n" +
    "            <button id=\"importDialog.cancel\"\n" +
    "                    class=\"btn btn-default\"\n" +
    "                    data-ng-click=\"importDialog.onCancel()\" data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\" formnovalidate></button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/related-contacts-list/related-contacts-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/related-contacts-list/related-contacts-list.html",
    "<div bento-busy-loader=\"!vm.item.$relatedContacts\" ng-style=\"vm.getStyle()\">\n" +
    "    <wj-flex-grid ng-if=\"vm.item.$relatedContacts.length > 0\" control=\"vm.flexGrid\"\n" +
    "        class=\"bento-flex-grid client-list-related-contacts-grid\" items-source=\"vm.item.$relatedContacts\"\n" +
    "        item-formatter=\"vm.itemFormatter\" selection-mode=\"None\" headers-visibility=\"Column\" is-read-only=\"false\"\n" +
    "        style=\"height:auto\" id=\"bm-clientListRelatedContactsForm-contactsGrid\">\n" +
    "        <wj-flex-grid-column binding=\"relationshipSide.name\" is-read-only=\"true\" width=\"*\"\n" +
    "            header=\"{{'Bluemoon.Core.Setup.Clients.List.Relationship' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <!-- TODO: Use the backend strings associated with these fields. DO NOT add new strings for these headers -->\n" +
    "        <wj-flex-grid-column binding=\"contact.displayAs\" is-read-only=\"true\" width=\"*\"\n" +
    "            header=\"{{'Bluemoon.Core.Setup.Clients.List.Contact' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column binding=\"contact.primaryPhone.phoneNumber\" is-read-only=\"true\" width=\"*\"\n" +
    "            header=\"{{'Bluemoon.Core.Setup.Clients.List.PrimaryPhone' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column binding=\"contact.primaryEmail.emailAddress\" is-read-only=\"true\" width=\"*\"\n" +
    "            header=\"{{'Bluemoon.Core.Setup.Clients.List.PrimaryEmail' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "\n" +
    "        <wj-flex-grid-column binding=\"contactEntityType.name\" is-read-only=\"true\" width=\"*\"\n" +
    "            header=\"{{'Bluemoon.Core.Setup.Clients.List.EntityType' | translate}}\">\n" +
    "        </wj-flex-grid-column>\n" +
    "    </wj-flex-grid>\n" +
    "    <div ng-if=\"vm.item.$relatedContacts.length === 0\">\n" +
    "        <br>\n" +
    "        <p class=\"no-contacts-message\"\n" +
    "            data-translate=\"{{'Bluemoon.Core.Setup.Clients.List.ThereAreNoItemsYet' | translate}}\">\n" +
    "        </p>\n" +
    "        <br>\n" +
    "        <p ng-if=\"vm.showAddButtonGrid()\" class=\"no-related-contacts-add-button\" role=\"button\" ng-click=\"vm.add(vm.item.id)\">\n" +
    "            <i class=\"bento-icon-add no-related-contacts\" style=\"margin: 5px\"></i>\n" +
    "            <span class=\"no-related-contacts-add\"\n" +
    "                data-translate=\"{{'Bluemoon.Core.Setup.Clients.List.Add' | translate}}\"></span>\n" +
    "        </p>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-item-generation/schedule-item-project-generation-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-item-generation/schedule-item-project-generation-options.html",
    "<div class=\"project-generation-styles\">\n" +
    "	<fieldset class=\"project-generation-options\">\n" +
    "		<h3 class=\"no-underline\">{{'Bluemoon.Core.Setup.Recurrence.ProjectGenerationOptions' | translate}}</h3>\n" +
    "		<div>\n" +
    "			{{'Bluemoon.Core.Setup.Recurrence.ProjectGenerationOptions.Instruction' | translate}}:\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Name -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\">\n" +
    "				<input ng-model=\"data.useProjectDescriptions\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"name_checkbox\" id=\"name_checkbox\"/>\n" +
    "				<label for=\"name_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectDescriptions\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Service -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\" bm-if-has-license=\"OnvioSetup.Engagements\">\n" +
    "				<input ng-model=\"data.useProjectEngagement\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"service_checkbox\" id=\"service_checkbox\"/>\n" +
    "				<label for=\"service_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectEngagement\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Department -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\" bm-if-has-license=\"OnvioSetup.Departments\">\n" +
    "				<input ng-model=\"data.useProjectDepartments\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"department_checkbox\" id=\"department_checkbox\"/>\n" +
    "				<label for=\"department_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectDepartments\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Primary/Preparer -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\">\n" +
    "				<input ng-model=\"data.useProjectPrimaryAssigned\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"primary_checkbox\" id=\"primary_checkbox\"/>\n" +
    "				<label for=\"primary_checkbox\" translate=\"{{primaryLabel}}\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Secondary/Staff -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\">\n" +
    "				<input ng-model=\"data.useProjectSecondaryAssigned\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"secondary_checkbox\" id=\"secondary_checkbox\"/>\n" +
    "				<label for=\"secondary_checkbox\" translate=\"{{secondaryLabel}}\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Reviewer -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\">\n" +
    "				<input ng-model=\"data.useProjectResponsible\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"reviewer_checkbox\" id=\"reviewer_checkbox\"/>\n" +
    "				<label for=\"reviewer_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectResponsible\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Comment -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\">\n" +
    "				<input ng-model=\"data.useProjectNotes\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"comment_checkbox\" id=\"comment_checkbox\"/>\n" +
    "				<label for=\"comment_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectNotes\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"row\">\n" +
    "			<!-- Task List -->\n" +
    "			<div class=\"col-md-2 col-sm-3 project-generation-checkbox\" bm-if-has-license=\"ProjectManagement.Tasks\" >\n" +
    "				<input ng-model=\"data.useProjectTasks\" ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || data.recurrence.recurrenceType.id === 'None'\" autocomplete=\"off\" type=\"checkbox\" name=\"task_checkbox\" id=\"task_checkbox\"/>\n" +
    "				<label for=\"task_checkbox\" translate=\"Core.Captions.ScheduleItemSeries.UseProjectTasks\"></label>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</fieldset>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/schedule-item-series/schedule-item-series-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-item-series/schedule-item-series-detail.html",
    "<h3 data-translate=\"Core.Captions.ScheduleItemSeries.SeriesRecurrenceMethod\"></h3>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"recurrenceType\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.Recurrence.RecurrenceType' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence, 'recurrenceType')\"\n" +
    "         class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"project-recurrence-types\" name=\"recurrenceType\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceType-enum-combo\" required=\"true\"\n" +
    "                       ng-model=\"data.recurrence.recurrenceType\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div ng-if=\"isProjectScreenRecurrence ? data.recurrence.recurrenceType.id !== 'None' : true\">\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_options\"\n" +
    "             class=\"col-md-8 col-sm-9 col-xs-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\" ng-show=\"domain.canRecurWeekdaysOnly(data)\">\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekday\" id=\"recur_weekday\" data-qe-id=\"bm-scheduleItemSeriesDetail-frequencyMustBeOnWeekdays-checkbox\"\n" +
    "                            data-qe-id=\"recur_weekday\"\n" +
    "                            ng-model=\"data.$frequencyMustBeOnWeekdays\"\n" +
    "                            ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                        <label for=\"recur_weekday\" translate=\"Core.Captions.ScheduleItemSeries.FrequencyMustBeOnWeekdays\"></label>\n" +
    "                        <bmp-enum-radio-group enum=\"frequency-weekday\"\n" +
    "                            class=\"frequency-weekday-options\"\n" +
    "                            name=\"frequency_weekday\"\n" +
    "                            data-qe-id=\"frequency_weekday\"\n" +
    "                            ng-model=\"data.frequencyWeekday\"\n" +
    "                            data-ng-disabled=\"!data.$frequencyMustBeOnWeekdays || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-radio-group>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\" ng-show=\"domain.canRecurBasedOnFYE(data)\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_fiscalyear\" id=\"recur_fiscalyear\"\n" +
    "                           data-qe-id=\"recur_fiscalyear\"\n" +
    "                           ng-model=\"data.frequencyBasedOnClientFiscalYearEnd\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_fiscalyear\" translate=\"Core.Captions.ScheduleItemSeries.FrequencyBasedOnClientFiscalYearEnd\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurDaily(data)\">\n" +
    "        <!-- Due every (daily) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"dueOnDays\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.daily, 'dueOnDays')\"\n" +
    "             class=\"col-md-5 col-sm-5 col-xs-8\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueEvery\"></span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"99\"\n" +
    "                       name=\"recur_daily_dueOnDays\"\n" +
    "                       data-qe-id=\"recur_daily_dueOnDays\"\n" +
    "                       ng-model=\"data.recurrence.daily.dueOnDays\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"1\"\n" +
    "                       bmp-clear-invalid-value-when=\"!domain.doesRecurDaily(data)\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.DailyRecurrence.DueOnDays\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurWeekly(data)\">\n" +
    "        <!-- Due every (weekly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"numberOfWeeksDue\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.weekly, 'numberOfWeeksDue')\"\n" +
    "             class=\"col-md-5 col-sm-5 col-xs-8\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueEvery\"></span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"53\"\n" +
    "                       name=\"recur_weekly_numberOfWeeksDue\"\n" +
    "                       data-qe-id=\"recur_weekly_numberOfWeeksDue\"\n" +
    "                       ng-model=\"data.recurrence.weekly.numberOfWeeksDue\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"1\"\n" +
    "                       bmp-clear-invalid-value-when=\"!domain.doesRecurWeekly(data)\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.WeeklyRecurrence.NumberOfWeeksDue\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Weeks\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurWeekly(data)\">\n" +
    "        <!-- Days of week -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"daysOfWeek\"\n" +
    "             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Recurrence.Weekly.DaysOfWeek' | translate}}\"\n" +
    "             class=\"col-md-12 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_sunday\" id=\"recur_weekly_sunday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklySunday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_sunday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.sunday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <label for=\"recur_weekly_sunday\" translate=\"Core.Captions.WeeklyRecurrence.Sunday\"></label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_monday\" id=\"recur_weekly_monday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklyMonday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_monday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.monday\"\n" +
    "                        ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_weekly_monday\" translate=\"Core.Captions.WeeklyRecurrence.Monday\"></label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_tuesday\" id=\"recur_weekly_tuesday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklyTuesday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_tuesday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.tuesday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_weekly_tuesday\" translate=\"Core.Captions.WeeklyRecurrence.Tuesday\"></label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_wednesday\" id=\"recur_weekly_wednesday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklyWednesday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_wednesday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.wednesday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_weekly_wednesday\" translate=\"Core.Captions.WeeklyRecurrence.Wednesday\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_thursday\" id=\"recur_weekly_thursday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklyThursday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_thursday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.thursday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_weekly_thursday\" translate=\"Core.Captions.WeeklyRecurrence.Thursday\"></label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_friday\" id=\"recur_weekly_friday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklyFriday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_friday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.friday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <label for=\"recur_weekly_friday\" translate=\"Core.Captions.WeeklyRecurrence.Friday\"></label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 col-sm-3\" style=\"white-space: nowrap;\">\n" +
    "                    <input autocomplete=\"off\" type=\"checkbox\" name=\"recur_weekly_saturday\" id=\"recur_weekly_saturday\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceWeeklySaturday-checkbox\"\n" +
    "                           data-qe-id=\"recur_weekly_saturday\"\n" +
    "                           ng-model=\"data.recurrence.weekly.saturday\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <label for=\"recur_weekly_saturday\" translate=\"Core.Captions.WeeklyRecurrence.Saturday\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurSemiMonthly(data)\">\n" +
    "        <!-- Semi-monthly frequency -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_semimonthly_frequency\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.semiMonthly, 'semiMonthlyFrequency')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOn\"></span>\n" +
    "                <bmp-enum-combo enum=\"semi-monthly-frequencies\" name=\"recur_semimonthly_frequency\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceSemiMonthlySemiMonthlyFrequency-enum-combo\" required=\"true\"\n" +
    "                                ng-model=\"data.recurrence.semiMonthly.semiMonthlyFrequency\"\n" +
    "                                ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"></bmp-enum-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Monthly frequency -->\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurMonthly(data)\">\n" +
    "        <!-- Due on specified (monthly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_monthly_specified\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.monthly, 'dueOnDay') || controller.detail.errorFor(data.recurrence.monthly, 'dueOnSpecifiedDayInMonthDueOnMonths')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"monthlyPattern\" id=\"monthlySpecified\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceMonthlyMonthlyFrequencyDueOnSpecifiedDayInMonth-radio\"\n" +
    "                    ng-model=\"data.recurrence.monthly.monthlyFrequency.id\" value=\"DueOnSpecifiedDayInMonth\"\n" +
    "                    ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnDay\"></span>\n" +
    "                </label>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"31\"\n" +
    "                    name=\"recur_monthly_specified_dueOnDay\"\n" +
    "                    data-qe-id=\"recur_monthly_specified_dueOnDay\"\n" +
    "                    ng-model=\"data.recurrence.monthly.dueOnDay\"\n" +
    "                    bmp-integer=\"true\"\n" +
    "                    bmp-clear-value=\"1\"\n" +
    "                    bmp-clear-invalid-value-when=\"!domain.doesRecurMonthlySpecified(data)\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.MonthlyRecurrence.DueOnDay\"\n" +
    "                    ng-disabled=\"data.recurrence.monthly.monthlyFrequency.id !== 'DueOnSpecifiedDayInMonth' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.OfEvery\"></span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"12\"\n" +
    "                       name=\"recur_monthly_specified_dueOnMonth\"\n" +
    "                       data-qe-id=\"recur_monthly_specified_dueOnMonth\"\n" +
    "                       ng-model=\"data.recurrence.monthly.dueOnSpecifiedDayInMonthDueOnMonths\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"1\"\n" +
    "                       bmp-clear-invalid-value-when=\"!domain.doesRecurMonthlySpecified(data)\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.MonthlyRecurrence.DueOnSpecifiedDayInMonthDueOnMonths\"\n" +
    "                       ng-disabled=\"data.recurrence.monthly.monthlyFrequency.id !== 'DueOnSpecifiedDayInMonth' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurMonthly(data)\">\n" +
    "        <!-- Due on calculated (monthly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_monthly_calculated\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.monthly, 'dueOnCalculatedDayInMonthDueOnMonths')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"monthlyPattern\" id=\"monthlyCalculated\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceMonthlyMonthlyFrequencyDueOnCalculatedDayInMonth-radio\"\n" +
    "                           ng-model=\"data.recurrence.monthly.monthlyFrequency.id\" value=\"DueOnCalculatedDayInMonth\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnThe\"></span>\n" +
    "                </label>\n" +
    "                <bmp-enum-combo enum=\"monthly-places\" name=\"recur_monthly_calculated_monthlyPlace\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceMonthlyMonthlyPlace-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.monthly.monthlyPlace\"\n" +
    "                                ng-disabled=\"data.recurrence.monthly.monthlyFrequency.id !== 'DueOnCalculatedDayInMonth' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\">&nbsp;</span>\n" +
    "                <bmp-enum-combo enum=\"weekday-types\" name=\"recur_monthly_calculated_weekdayType\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceMonthlyWeekdayType-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.monthly.weekdayType\"\n" +
    "                                ng-disabled=\"data.recurrence.monthly.monthlyFrequency.id !== 'DueOnCalculatedDayInMonth' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.OfEvery\"></span>\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"12\"\n" +
    "                           name=\"recur_monthly_calculated_dueOnMonth\"\n" +
    "                           data-qe-id=\"recur_monthly_calculated_dueOnMonth\"\n" +
    "                           ng-model=\"data.recurrence.monthly.dueOnCalculatedDayInMonthDueOnMonths\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurMonthlyCalculated(data)\"\n" +
    "                           bmp-control-group-field=\"Core.Captions.MonthlyRecurrence.DueOnCalculatedDayInMonthDueOnMonths\"\n" +
    "                           ng-disabled=\"data.recurrence.monthly.monthlyFrequency.id !== 'DueOnCalculatedDayInMonth' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                </span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Quarterly frequency -->\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurQuarterly(data)\">\n" +
    "        <!-- Due on specified (quarterly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_quarterly_specified\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.quarterly, 'dueOnDay')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"quarterlyPattern\" id=\"quarterlySpecified\" ng-model=\"data.recurrence.quarterly.quarterlyFrequency.id\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyQuarterlyFrequencyDueOnSpecifiedDayInQuarter-radio\"\n" +
    "                        value=\"DueOnSpecifiedDayInQuarter\"\n" +
    "                        ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnDay\"></span>\n" +
    "                </label>\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"31\"\n" +
    "                           name=\"recur_quarterly_specified_dueOnDay\"\n" +
    "                           data-qe-id=\"recur_quarterly_specified_dueOnDay\"\n" +
    "                           ng-model=\"data.recurrence.quarterly.dueOnDay\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurQuarterlySpecified(data)\"\n" +
    "                           bmp-control-group-field=\"Core.Captions.QuarterlyRecurrence.DueOnDay\"\n" +
    "                           ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnSpecifiedDayInQuarter' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                </span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.OfThe\"></span>\n" +
    "                <bmp-enum-combo enum=\"quarterly-places\" name=\"recur_quarterly_specified_place\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyDueOnSpecifiedDayQuarterlyPlace-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.quarterly.dueOnSpecifiedDayQuarterlyPlace\"\n" +
    "                                ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnSpecifiedDayInQuarter' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthInEveryQuarter\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurQuarterly(data)\">\n" +
    "        <!-- Due on calculated (quarterly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_quarterly_calculated\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"quarterlyPattern\" id=\"quarterlyCalculated\" ng-model=\"data.recurrence.quarterly.quarterlyFrequency.id\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyQuarterlyFrequencyDueOnCalculatedDayInQuarter-radio\"\n" +
    "                        value=\"DueOnCalculatedDayInQuarter\" ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnThe\"></span>\n" +
    "                </label>\n" +
    "                <bmp-enum-combo enum=\"monthly-places\" name=\"recur_quarterly_calculated_monthlyPlace\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyMonthlyPlace-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.quarterly.monthlyPlace\"\n" +
    "                                ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayInQuarter' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\"><unlocalized>&nbsp;</unlocalized></span>\n" +
    "                <bmp-enum-combo enum=\"weekday-types\" name=\"recur_quarterly_calculated_weekdayType\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyWeekdayType-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.quarterly.weekdayType\"\n" +
    "                                ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayInQuarter' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.OfThe\"></span>\n" +
    "                <bmp-enum-combo enum=\"quarterly-places\" name=\"recur_quarterly_calculated_place\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyDueOnCalculatedDayQuarterlyPlace-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.quarterly.dueOnCalculatedDayQuarterlyPlace\"\n" +
    "                                ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayInQuarter' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthInEveryQuarter\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurQuarterly(data)\">\n" +
    "        <!-- Due on calculated offset (quarterly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_quarterly_calculated_offset\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"quarterlyPattern\" id=\"quarterlyCalculatedOffset\" ng-model=\"data.recurrence.quarterly.quarterlyFrequency.id\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyQuarterlyFrequencyDueOnCalculatedDayQuarterOffset-radio\"\n" +
    "                        value=\"DueOnCalculatedDayQuarterOffset\" ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Due\"></span>\n" +
    "                </label>\n" +
    "\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"2\" name=\"recur_quarterly_calculated_offset_dueOnMonth\"\n" +
    "                        data-qe-id=\"recur_quarterly_calculated_offset_dueOnMonth\" ng-model=\"data.recurrence.quarterly.dueOnCalculatedDayQuarterlyMonths\"\n" +
    "                        bmp-integer=\"true\" bmp-clear-value=\"1\" bmp-clear-invalid-value-when=\"!domain.doesRecurQuarterlyCalculatedOffset(data)\" bmp-control-group-field=\"Core.Captions.QuarterlyRecurrence.DueOnCalculatedDayQuarterlyMonths\"\n" +
    "                        ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayQuarterOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                    </span>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthsAnd\"></span>\n" +
    "\n" +
    "                <span>\n" +
    "                     <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                           name=\"recur_quarterly_calculated_offset_dueOnDayOffset\"\n" +
    "                           data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyDueOnDayOffset-number\"\n" +
    "                           data-qe-id=\"recur_quarterly_calculated_dueOnDayOffset\"\n" +
    "                           ng-model=\"data.recurrence.quarterly.dueOnDayOffset\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurQuarterlyCalculatedOffset(data)\"\n" +
    "                           bmp-control-group-field=\"Core.Captions.QuarterlyRecurrence.DueOnDayOffset\"\n" +
    "                           ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayQuarterOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                </span>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "\n" +
    "                <div data-bento-select>\n" +
    "                    <select name=\"afterFiscalYearEnd\" class=\"form-control\" id=\"afterFiscalYearEnd-quarterly-select\" data-ng-model=\"data.recurrence.quarterly.afterFiscalYearEnd\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceQuarterlyDueOnDayOffset-select\"\n" +
    "                        ng-disabled=\"data.recurrence.quarterly.quarterlyFrequency.id !== 'DueOnCalculatedDayQuarterOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\">\n" +
    "                        <option value=\"true\" ng-selected=\"data.recurrence.quarterly.afterFiscalYearEnd === true\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.After' | translate }}</option>\n" +
    "                        <option value=\"false\" ng-selected=\"data.recurrence.quarterly.afterFiscalYearEnd === false\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.Before' | translate }}</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.EndOfQuarter\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Due on specified (yearly) -->\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurYearly(data)\">\n" +
    "        <!-- Due on specified (yearly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_yearly_specified\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.yearly, 'dueOnDay')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                    <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                        <input type=\"radio\" name=\"yearlyPattern\" id=\"yearlySpecified\" ng-model=\"data.recurrence.yearly.yearlyFrequency.id\"\n" +
    "                               data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyYearlyFrequencyDueOnSpecifiedDayAnnually-radio\"\n" +
    "                               value=\"DueOnSpecifiedDayAnnually\"\n" +
    "                               ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                        <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnThe\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "                        <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnDay\" ng-show=\"!domain.recurBasedOnFYE(data)\"></span>\n" +
    "                    </label>\n" +
    "                    <bmp-enum-combo enum=\"yearly-places\" name=\"recur_yearly_specified_place\" ng-show=\"domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyDueOnSpecifiedDayAnnuallyMonthOfYear-enum-combo\"\n" +
    "                        ng-model=\"data.recurrence.yearly.$dueOnSpecifiedDayAnnuallyMonthOfYear\"\n" +
    "                        ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnSpecifiedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                    <bmp-enum-combo enum=\"months\" name=\"recur_yearly_specified_month\" ng-show=\"!domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyDueOnSpecifiedDayAnnuallyMonthOfYear-enum-combo\"\n" +
    "                        ng-model=\"data.recurrence.yearly.$dueOnSpecifiedDayAnnuallyMonthOfYear\"\n" +
    "                        ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnSpecifiedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthAfterFYEOnDay\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" ng-show=\"!domain.recurBasedOnFYE(data)\">&nbsp;</span>\n" +
    "                    <span>\n" +
    "                        <!-- this span is required by IE to valign correctly -->\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"31\"\n" +
    "                            name=\"recur_yearly_specified_dueOnDay\"\n" +
    "                            data-qe-id=\"recur_yearly_specified_dueOnDay\"\n" +
    "                            ng-model=\"data.recurrence.yearly.dueOnDay\"\n" +
    "                            bmp-integer=\"true\"\n" +
    "                            bmp-clear-value=\"1\"\n" +
    "                            bmp-clear-invalid-value-when=\"!domain.doesRecurYearlySpecified(data)\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.YearlyRecurrence.DueOnDay\"\n" +
    "                            ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnSpecifiedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                    </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurYearly(data)\">\n" +
    "        <!-- Due on calculated (yearly) -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_yearly_calculated\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                <input type=\"radio\" name=\"yearlyPattern\" id=\"yearlyCalculated\" ng-model=\"data.recurrence.yearly.yearlyFrequency.id\"\n" +
    "                       data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyYearlyFrequencyDueOnCalculatedDayAnnually-radio\"\n" +
    "                       value=\"DueOnCalculatedDayAnnually\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnThe\"></span>\n" +
    "                </label>\n" +
    "                <bmp-enum-combo enum=\"monthly-places\" name=\"recur_yearly_calculated_monthlyPlace\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyMonthlyPlace-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.yearly.monthlyPlace\"\n" +
    "                                ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\"><unlocalized>&nbsp;</unlocalized></span>\n" +
    "                <bmp-enum-combo enum=\"weekday-types\" name=\"recur_yearly_calculated_weekdayType\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyWeekdayType-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.yearly.weekdayType\"\n" +
    "                                ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.OfThe\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Of\" ng-show=\"!domain.recurBasedOnFYE(data)\"></span>\n" +
    "                <bmp-enum-combo enum=\"yearly-places\" name=\"recur_yearly_calculated_place\" ng-show=\"domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyDueOnCalculatedDayAnnuallyMonthOfYear-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.yearly.$dueOnCalculatedDayAnnuallyMonthOfYear\"\n" +
    "                                ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <bmp-enum-combo enum=\"months\" name=\"recur_yearly_calculated_month\" ng-show=\"!domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyDueOnCalculatedDayAnnuallyMonthOfYear-enum-combo\"\n" +
    "                                ng-model=\"data.recurrence.yearly.$dueOnCalculatedDayAnnuallyMonthOfYear\"\n" +
    "                                ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnually' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthAfterFYE\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurYearly(data)\">\n" +
    "        <!-- Due on calculated (yearly) before/after -->\n" +
    "        <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"recur_yearly_calculated_before_after_fye\" class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <label class=\"input-group-addon input-group-addon-clear input-group-addon-first\">\n" +
    "                    <input type=\"radio\" name=\"yearlyPattern\" id=\"yearlyCalculatedOffset\" ng-model=\"data.recurrence.yearly.yearlyFrequency.id\"\n" +
    "                           data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyYearlyFrequencyDueOnCalculatedDayAnnuallyOffset-radio\"\n" +
    "                           value=\"DueOnCalculatedDayAnnuallyOffset\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"/>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Due\"></span>\n" +
    "                </label>\n" +
    "\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"11\" name=\"recur_yearly_calculated_offset_dueOnMonth\"\n" +
    "                        data-qe-id=\"recur_yearly_calculated_offset_dueOnMonth\" ng-model=\"data.recurrence.yearly.dueOnCalculatedDayAnnuallyOffsetMonths\"\n" +
    "                        bmp-integer=\"true\" bmp-clear-value=\"1\" bmp-clear-invalid-value-when=\"!domain.doesRecurYearlyCalculatedOffset(data)\" bmp-control-group-field=\"Core.Captions.YearlyRecurrence.DueOnCalculatedDayAnnuallyOffsetMonths\"\n" +
    "                        ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnuallyOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\" />\n" +
    "                </span>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthsAnd\"></span>\n" +
    "\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\" name=\"recur_yearly_calculated_dueOnDayOffset\" data-qe-id=\"recur_yearly_calculated_dueOnDayOffset\"\n" +
    "                        ng-model=\"data.recurrence.yearly.dueOnDayOffset\" bmp-integer=\"true\" bmp-clear-value=\"1\" bmp-clear-invalid-value-when=\"!domain.doesRecurYearlyCalculatedOffset(data)\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.YearlyRecurrence.DueOnDayOffset\" ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnuallyOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\"\n" +
    "                    />\n" +
    "                </span>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "\n" +
    "                <div data-bento-select>\n" +
    "                    <select name=\"afterFiscalYearEnd\" class=\"form-control\" id=\"afterFiscalYearEnd-select\" data-ng-model=\"data.recurrence.yearly.afterFiscalYearEnd\"\n" +
    "                        data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceYearlyAfterFiscalYearEnd-select\"\n" +
    "                        ng-disabled=\"data.recurrence.yearly.yearlyFrequency.id !== 'DueOnCalculatedDayAnnuallyOffset' || (isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE')\">\n" +
    "                        <option value=\"true\" ng-selected=\"data.recurrence.yearly.afterFiscalYearEnd === true\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.After' | translate }}</option>\n" +
    "                        <option value=\"false\" ng-selected=\"data.recurrence.yearly.afterFiscalYearEnd === false\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.Before' | translate }}</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" ng-show=\"domain.recurBasedOnFYE(data)\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.FiscalYearEnd\"></span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" ng-show=\"!domain.recurBasedOnFYE(data)\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.YearEnd\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurPeriodic(data)\" ng-repeat=\"recur_period in data.recurrence.periodic.periodicList\">\n" +
    "\n" +
    "        <!-- Periodic -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_periodic_KEY__{{$index}}\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(recur_period, 'dueOnDay')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-10\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnThe\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.DueOnDay\" ng-show=\"!domain.recurBasedOnFYE(data)\"></span>\n" +
    "                <bmp-enum-combo enum=\"yearly-places\" name=\"recur_periodic_place_KEY__{{$index}}\" ng-show=\"domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurPeriodMonthOfYear-enum-combo\"\n" +
    "                                ng-model=\"recur_period.$monthOfYear\" ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"></bmp-enum-combo>\n" +
    "                <bmp-enum-combo enum=\"months\" name=\"recur_periodic_month_KEY__{{$index}}\" ng-show=\"!domain.recurBasedOnFYE(data)\" required=\"true\"\n" +
    "                                data-qe-id=\"bm-scheduleItemSeriesDetail-recurPeriodMonthOfYear-enum-combo\"\n" +
    "                                ng-model=\"recur_period.$monthOfYear\" ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"></bmp-enum-combo>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthAfterFYEOnDay\" ng-show=\"domain.recurBasedOnFYE(data)\"></span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" ng-show=\"!domain.recurBasedOnFYE(data)\">&nbsp;</span>\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"31\"\n" +
    "                           name=\"recur_periodic_dueOnDay_KEY__{{$index}}\"\n" +
    "                           data-qe-id=\"recur_periodic_dueOnDay_KEY__{{$index}}\"\n" +
    "                           ng-model=\"recur_period.dueOnDay\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurPeriodic(data)\"\n" +
    "                           bmp-control-group-field=\"Core.Captions.PeriodicRecurrenceRule.DueOnDay\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" />\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Remove Periodic Occurrence -->\n" +
    "        <div class=\"col-md-4 col-sm-2 col-xs-2\">\n" +
    "            <button id=\"recur_periodic_remove_KEY__{{$index}}\"\n" +
    "                    name=\"recur_periodic_remove_KEY__{{$index}}\"\n" +
    "                    type=\"button\"\n" +
    "                    class=\"btn btn-link\"\n" +
    "                    style=\"padding-left:0px\"\n" +
    "                    data-ng-show=\"domain.canRemovePeriodicOccurrence(data, recur_period)\"\n" +
    "                    data-ng-click=\"domain.removePeriodicOccurrence(data, recur_period); controller.setFormDirty(); focus('add_another_periodic_occurrence_button');\"\n" +
    "                    ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\">\n" +
    "                <span class=\"glyphicon glyphicon-remove\"></span>\n" +
    "                <span data-translate=\"Bluemoon.Core.Setup.Common.ProjectTemplates.RemovePeriodicOccurrence\"></span>\n" +
    "            </button>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurPeriodic(data)\">\n" +
    "        <!-- Add Another Periodic Occurrence -->\n" +
    "        <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <a href id=\"add_another_periodic_occurrence_button\" class=\"btn btn-link\" type=\"button\" data-qe-id=\"bm-scheduleItemSeriesDetails-addAnotherPeriodicOccurrence-button\"\n" +
    "               data-ng-click=\"domain.addNewPeriodicOccurrence(data, defaultData); controller.setFormDirty(); focus('recur_periodic_place_KEY__' + (data.recurrence.periodic.periodicList.length-1));\"\n" +
    "               ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\">\n" +
    "                <span class=\"glyphicon glyphicon-plus-sign\"></span>\n" +
    "                <span data-translate=\"Bluemoon.Core.Setup.Common.ProjectTemplates.AddPeriodicOccurrence\"></span>\n" +
    "            </a>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecurBasedOnPeriods(data)\">\n" +
    "\n" +
    "        <!-- Based On Periods -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"recur_basedOnPeriod_KEY__{{$index}}\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data.recurrence.basedOnPeriod, 'dueOnDay')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-10\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Due\"></span>\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"11\"\n" +
    "                           name=\"recur_basedOnPeriod_dueOnMonth_KEY__{{$index}}\"\n" +
    "                           data-qe-id=\"recur_basedOnPeriod_dueOnMonth_KEY__{{$index}}\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                           ng-model=\"data.recurrence.basedOnPeriod.dueOnMonthOffset\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurBasedOnPeriods(data)\"\n" +
    "                           bmp-control-group-field=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Due\" />\n" +
    "                </span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthsAnd\"></span>\n" +
    "                <span>\n" +
    "                    <!-- this span is required by IE to valign correctly -->\n" +
    "                    <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                           name=\"recur_basedOnPeriod_dueOnDay_KEY__{{$index}}\"\n" +
    "                           data-qe-id=\"recur_basedOnPeriod_dueOnDay_KEY__{{$index}}\"\n" +
    "                           ng-model=\"data.recurrence.basedOnPeriod.dueOnDayOffset\"\n" +
    "                           ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                           bmp-integer=\"true\"\n" +
    "                           bmp-clear-value=\"1\"\n" +
    "                           bmp-clear-invalid-value-when=\"!domain.doesRecurBasedOnPeriods(data)\"\n" +
    "                           bmp-control-group-field=\"Bluemoon.Core.Setup.Recurrence.InputAddon.MonthsAnd\" />\n" +
    "                </span>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                <div data-bento-select>\n" +
    "                    <select ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" name=\"afterPeriodEnd\" class=\"form-control\" id=\"afterPeriodEnd-select\" data-ng-model=\"data.recurrence.basedOnPeriod.afterPeriodEnd\" data-qe-id=\"bm-scheduleItemSeriesDetail-recurrenceBasedOnPeriodAfterPeriodEnd-select\">\n" +
    "                        <option value=\"true\" ng-selected=\"data.recurrence.basedOnPeriod.afterPeriodEnd === true\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.After' | translate }}</option>\n" +
    "                        <option value=\"false\" ng-selected=\"data.recurrence.basedOnPeriod.afterPeriodEnd === false\">{{ 'Bluemoon.Core.Setup.Recurrence.InputAddon.Before' | translate }}</option>\n" +
    "                    </select>\n" +
    "                </div>\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.EndOfPeriod\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- No Longer Required #707246\n" +
    "    <h3 data-translate=\"Core.Captions.ScheduleItemSeries.SeriesExpirationMethod\" ng-show=\"domain.doesRecur(data)\"></h3>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecur(data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data, 'expirationMethod')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <bmp-enum-dropdown enum=\"project-template-expiration-methods\" name=\"expirationMethod\"\n" +
    "                           ng-model=\"data.seriesExpirationMethod\"></bmp-enum-dropdown>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecur(data) && domain.expiresAfterSpecified(data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data, 'expirationOccurrences')\"\n" +
    "             class=\"col-md-5 col-sm-5 col-xs-8\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <span class=\"input-group-addon input-group-addon-clear input-group-addon-first\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.EndsAfter\"></span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"1\" max=\"99\"\n" +
    "                       name=\"expirationOccurrences\"\n" +
    "                       ng-model=\"data.expirationOccurrences\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"1\"\n" +
    "                       bmp-clear-invalid-value-when=\"!(domain.doesRecur(data) && domain.expiresAfterSpecified(data))\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.ExpirationOccurrences\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Occurrences\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    -->\n" +
    "\n" +
    "    <h3 data-translate=\"Core.Captions.ScheduleItemSeries.SeriesGenerationMethod\" ng-show=\"domain.doesRecur(data)\"></h3>\n" +
    "    <h5 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.GenerationMethod\" ng-show=\"domain.doesRecur(data)\"></h5>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecur(data)\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"generationMethod\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data, 'generationMethod')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <bmp-enum-combo ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\" enum=\"generation-methods\" name=\"generationMethod\" required=\"true\" data-qe-id=\"bm-scheduleItemSeriesDetail-seriesGenerationMethod-enum-combo\"\n" +
    "                            ng-model=\"data.seriesGenerationMethod\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\" ng-show=\"domain.doesRecur(data) && domain.generatedAfterSpecified(data)\">\n" +
    "        <!-- Generated after -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"generationMonthsAndDays\"\n" +
    "             data-bmp-control-group-error=\"controller.detail.errorFor(data, 'generationMonths') || controller.detail.errorFor(data, 'generationDays')\"\n" +
    "             class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"input-group\">\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"12\"\n" +
    "                       name=\"generationMonths\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                       data-qe-id=\"generationMonths\"\n" +
    "                       ng-model=\"data.generationMonth\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"0\"\n" +
    "                       bmp-clear-invalid-value-when=\"!(domain.doesRecur(data) && domain.generatedAfterSpecified(data))\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.GenerationMonth\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                       name=\"generationDays\"\n" +
    "                       data-qe-id=\"generationDays\"\n" +
    "                       ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                       ng-model=\"data.generationDay\"\n" +
    "                       bmp-integer=\"true\"\n" +
    "                       bmp-clear-value=\"0\"\n" +
    "                       bmp-clear-invalid-value-when=\"!(domain.doesRecur(data) && domain.generatedAfterSpecified(data))\"\n" +
    "                       bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.GenerationDay\" />\n" +
    "                <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "        <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItemSeries.TargetDates\"></h3>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Target start dates -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ScheduleItemSeries.TargetStartDate' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"controller.detail.errorFor(data, 'targetStartMonth') || controller.detail.errorFor(data, 'targetStartDay')\"\n" +
    "                class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <div class=\"input-group\">\n" +
    "                    <span>\n" +
    "                        <!-- this span is required by IE to valign correctly -->\n" +
    "                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.ProjectTemplate.TargetDates\"-->\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                            name=\"targetStartMonth\"\n" +
    "                            data-qe-id=\"targetStartMonth\"\n" +
    "                            ng-model=\"data.targetStartMonth\"\n" +
    "                            ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                            bmp-integer=\"true\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-custom-validation=\"domain.areTargetDatesValid(data)\"\n" +
    "                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.ProjectTemplate.TargetDates\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.TargetStartMonth\" />\n" +
    "                    </span>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                    <span>\n" +
    "                        <!-- this span is required by IE to valign correctly -->\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                            name=\"targetStartDay\"\n" +
    "                            ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                            data-qe-id=\"targetStartDay\"\n" +
    "                            ng-model=\"data.targetStartDay\"\n" +
    "                            bmp-integer=\"true\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.TargetStartDay\" />\n" +
    "                    </span>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                    <bmp-enum-combo enum=\"target-date-methods\" name=\"startTargetDateMethod\" required=\"true\"\n" +
    "                                    data-qe-id=\"bm-scheduleItemSeriesDetail-startTargetDateMethod-enum-combo\"\n" +
    "                                    ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                                    ng-model=\"data.startTargetDateMethod\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Target completion dates -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ScheduleItemSeries.TargetCompleteDate' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"controller.detail.errorFor(data, 'targetCompleteMonth') || controller.detail.errorFor(data, 'targetCompleteDay')\"\n" +
    "                class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <div class=\"input-group\">\n" +
    "                    <span>\n" +
    "                        <!-- this span is required by IE to valign correctly -->\n" +
    "                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.ProjectTemplate.TargetDates\"-->\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                            name=\"targetCompleteMonth\"\n" +
    "                            data-qe-id=\"targetCompleteMonth\"\n" +
    "                            ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                            ng-model=\"data.targetCompleteMonth\"\n" +
    "                            bmp-integer=\"true\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-custom-validation=\"domain.areTargetDatesValid(data)\"\n" +
    "                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.ProjectTemplate.TargetDates\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.TargetCompleteMonth\" />\n" +
    "                    </span>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                    <span>\n" +
    "                        <!-- this span is required by IE to valign correctly -->\n" +
    "                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                            name=\"targetCompleteDay\"\n" +
    "                            data-qe-id=\"targetCompleteDay\"\n" +
    "                            ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                            ng-model=\"data.targetCompleteDay\"\n" +
    "                            bmp-integer=\"true\"\n" +
    "                            bmp-clear-value=\"0\"\n" +
    "                            bmp-control-group-field=\"Core.Captions.ScheduleItemSeries.TargetCompleteDay\" />\n" +
    "                    </span>\n" +
    "                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                    <bmp-enum-combo enum=\"target-date-methods\" name=\"completeDateMethod\" required=\"true\"\n" +
    "                                    data-qe-id=\"bm-scheduleItemSeriesDetail-completeTargetDateMethod-enum-combo\"\n" +
    "                                    ng-disabled=\"isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE'\"\n" +
    "                                    ng-model=\"data.completeTargetDateMethod\"></bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/core-project-task.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/core-project-task.html",
    "<div class=\"container-fluid no-left-padding view-container\" >\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectsAndTasks.Header' -->\n" +
    "            <bmp-project-list bmp-project-list-name=\"'CoreProjectList'\"\n" +
    "                  bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "                  bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "                  bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "                  bmp-project-list-analytics-context=\"'core_projects'\"\n" +
    "                  bmp-project-list-style=\"'core'\"\n" +
    "                  bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\"\n" +
    "                  modalUiView = \"$modalUiView\"></bmp-project-list>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/core-projects.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/core-projects.html",
    "<h1 translate=\"Core.Captions.Project.ClassOther\"></h1>\n" +
    "<!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectsAndTasks.Header' -->\n" +
    "<bmp-project-list bmp-project-list-name=\"'CoreProjectList'\"\n" +
    "                  bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "                  bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "                  bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "                  bmp-project-list-analytics-context=\"'core_projects'\"\n" +
    "                  bmp-project-list-style=\"'core'\"\n" +
    "                  bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\"\n" +
    "                  modalUiView = \"$modalUiView\"></bmp-project-list>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/core-tasks.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/core-tasks.html",
    "<h1 translate=\"Core.Captions.Task.ClassOther\"></h1>\n" +
    "\n" +
    "<bmp-task-list bmp-task-list-name=\"'CoreTaskList'\"\n" +
    "               bmp-task-list-analytics-context=\"'core_tasks'\"\n" +
    "               bmp-task-list-style=\"'core'\"></bmp-task-list>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/periods-on-projects-fields/periods-on-projects-fields.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/periods-on-projects-fields/periods-on-projects-fields.html",
    "<div ng-if=\"vm.basedOnPeriods(vm.project)\">\n" +
    "    <div class=\"row\" >\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItemSeries.SeriesRecurrenceMethod' -->\n" +
    "        <!-- Recurrence Type -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"period\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItemSeries.SeriesRecurrenceMethod' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.project, 'period')\"\n" +
    "            class=\"col-md-4 col-sm-5 col-xs-6\">\n" +
    "            <input type=\"string\" id=\"period\" name=\"period\"\n" +
    "                data-qe-id=\"period-input\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-disabled=\"true\"\n" +
    "                ng-model=\"vm.project.scheduleItemSeries.recurrence.recurrenceType.name\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.basedOnAccountingPeriods(vm.project)\">\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.FiscalYearEnd' -->\n" +
    "        <!-- Fiscal Year End -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"fiscalYearEndDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.FiscalYearEnd' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.project, 'fiscalYearEndDate')\"\n" +
    "            class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo\n" +
    "                enum=\"custom\"\n" +
    "                ng-model=\"vm.project.$fiscalYearEndDate\"\n" +
    "                custom-items=\"vm.project.$fiscalYears\"\n" +
    "                required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.Project.AccountingPeriodId' -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.VatPeriod' -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.VatPeriod.NonePresentError' -->\n" +
    "        <!-- Accounting Period -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"accountingPeriodEndDate\"\n" +
    "            data-bmp-control-group-label=\"{{vm.basedOnPeriodsTranslate(vm.project) | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.project, 'accountingPeriodEndDate')\"\n" +
    "            class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo\n" +
    "                enum=\"custom\"\n" +
    "                ng-model=\"vm.project.$accountingPeriodEndDate\"\n" +
    "                custom-items=\"vm.project.$periods\"\n" +
    "                required=\"true\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"!vm.basedOnVatPeriods(vm.project) && !vm.basedOnTaxPeriods(vm.project) && !vm.basedOnPropertyPeriods(vm.project)\">\n" +
    "        <div class=\"col-md-5 col-sm-6 col-xs-12\">\n" +
    "            <div>\n" +
    "                {{'Bluemoon.Core.Setup.Project.PeriodFrequency' | translate}}:\n" +
    "                <span style=\"font-weight: bold\">\n" +
    "                    {{vm.getPeriodFrequency(vm.project) | translate}}\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/schedule-item-client-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-client-list.html",
    "<!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectsAndTasks.Header' -->\n" +
    "<bmp-project-list bmp-project-list-name=\"'ScheduleItemList'\"\n" +
    "                  bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "                  bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "                  bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "                  bmp-project-list-analytics-context=\"'setup_clientDetail_projects'\"\n" +
    "                  bmp-project-list-style=\"'core'\"\n" +
    "                  bmp-project-list-route=\"'#/setup/clients/'+vm.getContextId()+'/projects'\"\n" +
    "                  bmp-project-list-client-filter=\"vm.getContextId()\"\n" +
    "                  bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\" \n" +
    "                  modal-ui-view=\"$modalUiView\">\n" +
    "</bmp-project-list>");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-documents.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-documents.html",
    "<!--translate=\"Bluemoon.Core.Setup.Project.Detail.Navigation.Documents\"-->\n" +
    "<h3 class=\"no-top-margin\">{{'Bluemoon.Core.Setup.Project.Detail.Navigation.Documents' | translate}}</h3>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12\">\n" +
    "        <practice-documents project-id=\"vm.data.documentFolderId\" client-id=\"vm.data.client.id\"></practice-documents>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-general-v2.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-general-v2.html",
    "<div bento-busy-loader=\"vm.domainModel.isLoading\" busy-loader-size=\"small\">\n" +
    "    <uib-accordion close-others=\"false\" class=\"bento-accordion\">\n" +
    "        <!-- Project Settings -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectSettings' -->\n" +
    "        <div uib-accordion-group\n" +
    "            class=\"panel-default\"\n" +
    "            is-open=\"vm.data.$projectSettings\"\n" +
    "            heading=\"{{'Bluemoon.Core.Setup.Project.ProjectSettings' | translate}}\"\n" +
    "            data-qe-id=\"bm-projectDetail-projectSettings-accordion\">\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Project Status -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectStatus' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ProjectStatus' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription')\"\n" +
    "                    class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-9 col-sm-9 col-xs-12\">\n" +
    "                            <bmp-select-combo name=\"trackingDescription\"\n" +
    "                                            list=\"tracking-descriptions\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            ng-model=\"vm.data.$trackingDescription\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            required=\"true\" aotf-default></bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <!-- New -->\n" +
    "                        <div class=\"col-md-4 col-sm-4 col-xs-2\" ng-if=\"false\">\n" +
    "                            <button id=\"add_new_project_template\"\n" +
    "                                    type=\"button\"\n" +
    "                                    class=\"btn btn-link\"\n" +
    "                                    style=\"padding-left:0px\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    ng-click=\"vm.domainModel.newTrackingDescription(vm.data); vm.setFormDirty();\">\n" +
    "                                <span class=\"bento-icon-add\"></span>\n" +
    "                                <span data-translate=\"Bluemoon.Practice.Common.Actions.Add\"></span>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "                    <!-- Priority -->\n" +
    "                    <!-- /* i18nextract */'Core.Captions.ScheduleItem.Priority' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"priority\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Priority' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'priority')\"\n" +
    "                        class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-md-9 col-sm-9 col-xs-12\">\n" +
    "                                <bmp-enum-combo enum=\"priority-types\" name=\"priority\"\n" +
    "                                                ng-model=\"vm.data.priority\"\n" +
    "                                                required=\"true\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"></bmp-enum-combo>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <!-- Project Assignments -->\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectAssignments' -->\n" +
    "                    <h3 data-translate=\"Bluemoon.Core.Setup.Project.ProjectAssignments\"></h3>\n" +
    "                    <!-- Primary/Preparer Assignment -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"primary_assignment_employee\"\n" +
    "                        data-bmp-control-group-label=\"{{ vm.domainModel.getPrimaryAssignmentLabel(vm.data) }}\"\n" +
    "                        data-bmp-control-group-field-id=\"primary_assignment_employee_KEY__{{$index}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.primaryAssignment, 'employee')\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-md-7 col-sm-7 col-xs-12\">\n" +
    "                                <bmp-select-combo list=\"staff#active\"\n" +
    "                                name=\"primary_assignment_employee\"\n" +
    "                                                ng-model=\"vm.data.primaryAssignment.employee\"\n" +
    "                                                on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                aotf-default></bmp-select-combo>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.data.applicationType.id !== 'UKTAX' && !vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "                        <!-- Secondary/Staff Assignment -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.domainModel.getSecondaryAssignmentLabel(vm.data)}}\"\n" +
    "                            class=\"col-md-12 col-sm-12 col-xs-12\" style=\"margin-bottom: 0px;\">\n" +
    "                            <div bento-multiselect-overlay style=\"padding-right: 10px; float: left;\"\n" +
    "                                bento-append-to-parent=\"#multiselect-overlay-id > div > div.tab-content\"\n" +
    "                                revert-selections-on-dismissal=\"true\"\n" +
    "                                ng-model=\"vm.data.$multiselectDataSelected\"\n" +
    "                                list-data=\"vm.data.$multiselectData\"\n" +
    "                                select-button-text=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                                edit-button-text=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                                class=\"setup-bento-multiselect-overlay\"\n" +
    "                                data-qe-id=\"bm-projectDetail-secondaryAssignments-multiselect\">\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"form-control-static\">\n" +
    "                                <span ng-repeat=\"assignment in vm.data.secondaryAssignments\">\n" +
    "                                    <span class=\"label label-info\" data-qe-id=\"bm-projectDetail-secondaryAssignments-name_{{assignment.employee.name}}\">\n" +
    "                                        {{assignment.employee.name}}\n" +
    "                                        <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                            data-qe-id=\"bm-projectDetail-secondaryAssignments-removeButton_{{assignment.employee.name}}\"\n" +
    "                                            data-ng-click=\"vm.domainModel.removeSecondaryAssignment(vm.data, assignment, true); vm.setFormDirty();\">\n" +
    "                                        </span>\n" +
    "                                    </span>&nbsp;\n" +
    "                                </span>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div ng-if=\"vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "                            data-bmp-control-group-label=\"{{ vm.domainModel.getSecondaryAssignmentLabel(vm.data) }}\"\n" +
    "                            data-bmp-control-group-field-id=\"secondary_assignment_employee_KEY__{{$index}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.secondaryAssignments[0], 'employee')\"\n" +
    "                            class=\"col-md-7 col-sm-7 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"staff#active\"\n" +
    "                                            ng-model=\"vm.data.secondaryAssignments[0].employee\"\n" +
    "                                            on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            aotf-default></bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Reviewer Assignment -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"responsibleEmployee\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ResponsibleAssignment' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'responsibleEmployee')\"\n" +
    "                            class=\"col-md-7 col-sm-7 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"staff#active\" name=\"responsibleEmployee\"\n" +
    "                                            ng-model=\"vm.data.responsibleEmployee\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            aotf-default></bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <!-- Project Deadlines -->\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectDeadlines' -->\n" +
    "                    <h3 data-translate=\"Bluemoon.Core.Setup.Project.ProjectDeadlines\"></h3>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Due Date -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.DueDate' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"currentDueDateExclusive\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.DueDate' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'currentDueDateExclusive')\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-bento-datepicker-wrapper name=\"currentDueDateExclusive\"\n" +
    "                                                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                        ng-required=\"true\"\n" +
    "                                                        ng-model=\"vm.data.$currentDueDateExclusive\"></bmp-bento-datepicker-wrapper>\n" +
    "                        </div>\n" +
    "                        <div bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "                            <!-- Received date -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"receivedDate\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItemView.ReceivedDate' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'receivedDate')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <bmp-bento-datepicker-wrapper name=\"receivedDate\"\n" +
    "                                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                            ng-model=\"vm.data.$receivedDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Target Start -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.TargetStart' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"targetStartDate\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.TargetStart' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetStartDate')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"-->\n" +
    "                                <bmp-bento-datepicker-wrapper name=\"targetStartDate\"\n" +
    "                                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                            ng-model=\"vm.data.targetStartDate\"\n" +
    "                                                            bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"\n" +
    "                                                            bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetStartDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                            <!-- Target Complete -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.TargetComplete' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"targetCompleteDate\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.TargetComplete' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetCompleteDateExclusive')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"-->\n" +
    "                                <bmp-bento-datepicker-wrapper name=\"targetCompleteDate\"\n" +
    "                                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                            ng-model=\"vm.data.targetCompleteDateExclusive\"\n" +
    "                                                            bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"\n" +
    "                                                            bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetCompleteDateExclusive\"></bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Actual Start -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ActualStart' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"actualStartDate\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ActualStart' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualStartDate')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"-->\n" +
    "                                <bmp-bento-datepicker-wrapper name=\"actualStartDate\"\n" +
    "                                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                                ng-model=\"vm.data.$actualStartDate\"\n" +
    "                                                                ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualStartDate')\"\n" +
    "                                                                bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"\n" +
    "                                                                bmp-control-group-field=\"Core.Captions.Project.ActualStartDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                            <!-- Actual Complete -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ActualComplete' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"actualCompleteDate\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ActualComplete' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"-->\n" +
    "                                <bmp-bento-datepicker-wrapper name=\"actualCompleteDate\"\n" +
    "                                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                                ng-model=\"vm.data.$actualCompleteDate\"\n" +
    "                                                                ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                                                                bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"\n" +
    "                                                                bmp-control-group-field=\"Core.Captions.Project.ActualCompleteDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Extension -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"extensionNumber\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Project.ExtensionNumber' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'extensionNumber')\"\n" +
    "                            class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <div data-bento-select>\n" +
    "                                <select class=\"form-control\" name=\"extensionNumber\" id=\"extensionNumber\"\n" +
    "                                        data-qe-id=\"extensionNumber-select\"\n" +
    "                                        data-ng-model=\"vm.data.$extensionNumber\"\n" +
    "                                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                        data-ng-options=\"option.number as vm.domainModel.getExtensionText(option) for option in vm.data.extensions\"></select>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-3 col-sm-6 col-xs-12\">\n" +
    "                    <!-- Project Comments -->\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectComments' -->\n" +
    "                    <h3 data-translate=\"Bluemoon.Core.Setup.Project.ProjectComments\"></h3>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <h3 data-ng-if=\"vm.data.id\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "                                <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.id\" [entity-name]=\"vm.data.name\"> </bmcn-notes>\n" +
    "                            </h3>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Advanced Project Settings -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.AdvancedProject' -->\n" +
    "        <div uib-accordion-group\n" +
    "            class=\"panel-default\"\n" +
    "            is-open=\"vm.data.$advancedProjectSettings\"\n" +
    "            heading=\"{{'Bluemoon.Core.Setup.Project.AdvancedProject' | translate}}\"\n" +
    "            data-qe-id=\"bm-projectDetail-advanceProjectSettings-accordion\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <!-- Project Number -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"projectNumber\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Project.ProjectNumber' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectNumber')\"\n" +
    "                            class=\"col-md-4 col-sm-5 col-xs-6\">\n" +
    "                        <input autocomplete=\"off\" type=\"number\" min=\"0\" max=\"999999999\" id=\"projectNumber\" name=\"projectNumber\"\n" +
    "                                data-qe-id=\"projectNumber-input\"\n" +
    "                                class=\"form-control\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                bmp-integer=\"true\"\n" +
    "                                ng-model=\"vm.data.projectNumber\"\n" +
    "                                ng-change=\"vm.detail.clearErrorFor(vm.data, 'projectNumber')\"\n" +
    "                                bmp-control-group-field=\"Core.Captions.Project.ProjectNumber\"\n" +
    "                                placeholder=\"{{'Bluemoon.Core.Setup.Project.NextAvailablePlaceholder' | translate}}\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <!-- Project Template -->\n" +
    "                    <!-- /* i18nextract */'Core.Captions.Project.ProjectTemplate' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"projectTemplate\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.Project.ProjectTemplate' | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectTemplate')\"\n" +
    "                            data-bmp-control-group-loading=\"vm.domainModel.isLoading\"\n" +
    "                            class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                                <bmp-select-combo list=\"project-templates\" name=\"projectTemplate\"\n" +
    "                                                ng-model=\"vm.data.$projectTemplate\"\n" +
    "                                                ng-readonly=\"vm.data.id\"\n" +
    "                                                filter=\"vm.domainModel.optionalFilterByApplication(vm.getUrlParam('application') || vm.appRouting.getCurrentApplicationInstant())\"\n" +
    "                                                required=\"true\" aotf-default></bmp-select-combo>\n" +
    "                            </div>\n" +
    "                            <!-- New -->\n" +
    "                            <div class=\"col-md-4 col-sm-4 col-xs-2\" ng-if=\"false\">\n" +
    "                                <button id=\"add_new_project_template\"\n" +
    "                                        type=\"button\"\n" +
    "                                        class=\"btn btn-link\"\n" +
    "                                        style=\"padding-left:0px\"\n" +
    "                                        ng-disabled=\"vm.data.id\"\n" +
    "                                        ng-click=\"vm.domainModel.newProjectTemplate(vm.data); vm.setFormDirty();\">\n" +
    "                                        <span class=\"bento-icon-add\"></span>\n" +
    "                                        <span data-translate=\"Bluemoon.Practice.Common.Actions.Add\"></span>\n" +
    "                                </button>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <!-- Name -->\n" +
    "                    <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"name\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' | translate | bmRequiredMark}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                        <input autocomplete=\"off\" type=\"text\" id=\"name\" name=\"name\"\n" +
    "                                data-qe-id=\"name-input\"\n" +
    "                                class=\"form-control\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                ng-model=\"vm.data.$name\"\n" +
    "                                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <!-- original due dates -->\n" +
    "                    <!-- /* i18nextract */'Core.Captions.ScheduleItem.OriginalDueDate' -->\n" +
    "                    <div data-bmp-control-group=\"\" ng-if=\"vm.data.$advancedView\"\n" +
    "                        data-bmp-control-group-field-id=\"originalDueDate\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Project.OriginalDueDate' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'originalDueDate')\"\n" +
    "                        class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                        <bmp-bento-datepicker-wrapper name=\"originalDueDate\"\n" +
    "                                                    ng-readonly=\"true\"\n" +
    "                                                    ng-model=\"vm.data.originalDueDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <schedule-item-setup-application-fields-v2 data=\"vm.data\" ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"></schedule-item-setup-application-fields-v2>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                        <div bm-if-perm=\"OnvioSetup.Departments\">\n" +
    "                            <!-- <div class=\"row\" ng-if=\"vm.data.$advancedView\"> -->\n" +
    "                                <!-- Department -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"department\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.Department' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'department')\"\n" +
    "                                    class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                        <div bento-multiselect-overlay style=\"padding-right: 10px; float: left;\"\n" +
    "                                            list-data=\"vm.domainModel.departmentsList\"\n" +
    "                                            ng-model=\"vm.domainModel.selectedDepartments\"\n" +
    "                                            revert-selections-on-dismissal=\"true\"\n" +
    "                                            class=\"setup-bento-multiselect-overlay\">\n" +
    "                                        </div>\n" +
    "                                        <div class=\"form-control-static\">\n" +
    "                                            <span data-ng-repeat=\"department in vm.domainModel.selectedDepartments\">\n" +
    "                                                <span class=\"label label-info\">\n" +
    "                                                    {{department.name}}\n" +
    "                                                    <span class=\"glyphicon glyphicon-remove scheduleitem-label-glyphicon\"\n" +
    "                                                            data-qe-id=\"department-remove-{{department.name}}-button\"\n" +
    "                                                            data-ng-click=\"vm.domainModel.onRemoveDepartmentByLabel(department); vm.setFormDirty();\"></span>\n" +
    "                                                </span>&nbsp;\n" +
    "                                            </span>\n" +
    "                                        </div>\n" +
    "                                </div>\n" +
    "                            <!-- </div> -->\n" +
    "                        </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 col-sm-6 col-xs-6\">\n" +
    "                    <!-- Recurrence -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItemSeries.SeriesRecurrenceMethod' | translate}}\"\n" +
    "                            data-bmp-control-group-field-id=\"seriesRecurrenceMethod\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.scheduleItemSeries, 'seriesRecurrenceMethod')\"\n" +
    "                            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                            <div class=\"col-md-8 col-sm-10 col-xs-12\" ng-if=\"vm.data.$seriesRecurrenceMethod.id === 'USEPARENTPROJECT'\">\n" +
    "                                <!-- vm.data.$parent.wherever needs to be replaced with the valid value that will come from the Parent Project Checking in now For String Translate-->\n" +
    "                                <p>{{ 'Bluemoon.Core.Setup.Common.ParentFrequencyStatement' | translate: { projectName: vm.data.parent.name, clientName: vm.data.$parentProjectClientName} }}</p>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"vm.data.$seriesRecurrenceMethod.id !== 'USEPARENTPROJECT'\">\n" +
    "                                <div>\n" +
    "                                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                                    name=\"seriesRecurrenceMethod_NONE\"\n" +
    "                                                    value=\"NONE\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                                    name=\"seriesRecurrenceMethod_USEPROJECTTEMPLATE\"\n" +
    "                                                    value=\"USEPROJECTTEMPLATE\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                                    <label>({{vm.data.projectTemplateExpanded.scheduleItemSeries.recurrence.descriptionPattern}})</label>\n" +
    "                                </div>\n" +
    "                                <div>\n" +
    "                                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                                    name=\"seriesRecurrenceMethod_USESPECIFICRULE\"\n" +
    "                                                    value=\"USESPECIFICRULE\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Project Documents -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ProjectDocuments' -->\n" +
    "        <div uib-accordion-group\n" +
    "            class=\"panel-default\"\n" +
    "            is-open=\"vm.data.$projectDocuments\"\n" +
    "            heading=\"{{'Bluemoon.Core.Setup.Project.ProjectDocuments' | translate}}\"\n" +
    "            data-qe-id=\"bm-projectDetail-projectDocuments-accordion\"\n" +
    "            bm-if-perm-some=\"['Onvio.DocumentStorage', 'OnvioDrive.ClientDocuments']\">\n" +
    "            <div class=\"form-group\" ng-if=\"!vm.domainModel.canViewDocuments(vm.data)\">\n" +
    "                <span class=\"label label-info pull-left scheduleitem-projectdocuments-label-info\"\n" +
    "                      data-translate=\"Bluemoon.Core.Setup.Project.ProjectDocumentsInfo\"></span>\n" +
    "                <div class=\"scheduleitem-projectdocuments-documentstorage\">\n" +
    "                    <span data-translate=\"Bluemoon.Core.Setup.Project.ProjectDocumentsInfoMessage\"></span>\n" +
    "                    <h3 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.DocumentStorage\"></h3>\n" +
    "                    <div class=\"row\" ng-if=\"!vm.data.id && !vm.data.documentFolderId\">\n" +
    "                        <!-- Storage -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"documentFolderOption\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ? 'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' : 'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' | translate}}\"\n" +
    "                            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                            <div ng-switch=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                                <div ng-switch-when=\"true\">\n" +
    "                                    <bmp-enum-combo enum=\"document-binder-options\" name=\"documentBinderOption\"\n" +
    "                                                    ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                                    required=\"true\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                                <div ng-switch-default=\"\">\n" +
    "                                    <div ng-switch=\"vm.domainModel.applicationTypeIsAUTaxOrAUActivityStatementOrAdvisory(vm.data)\">\n" +
    "                                        <div ng-switch-when=\"true\">\n" +
    "                                            <bmp-enum-combo enum=\"document-folder-options-without-none\" name=\"documentFolderOption\"\n" +
    "                                                    ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                                    required=\"true\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                                        </div>\n" +
    "                                        <div ng-switch-default=\"\">\n" +
    "                                            <bmp-enum-combo enum=\"document-folder-options\" name=\"documentFolderOption\"\n" +
    "                                                    ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                                    required=\"true\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div ng-if=\"vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' -->\n" +
    "                                    <!-- /* i18nextract */'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"documentFolderTemplateId\"\n" +
    "                                        data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                            'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' :\n" +
    "                                            'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' | translate}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.projectTemplateExpanded, 'documentFolderTemplateId')\"\n" +
    "                                        class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                        <bmp-select-combo name=\"documentFolderTemplateId\"\n" +
    "                                                        list=\"dms-project-templates#dms\"\n" +
    "                                                        list-style=\"basic\"\n" +
    "                                                        ng-model=\"vm.data.projectTemplateExpanded.$documentFolderTemplate\"\n" +
    "                                                        required=\"true\"\n" +
    "                                                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                        bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderTemplateId\"></bmp-select-combo>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div ng-if=\"vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEW' || vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Core.Captions.Project.DocumentFolderName' | translate}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.projectTemplateExpanded, 'documentFolderDefaultName')\"\n" +
    "                                        class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                        <input autocomplete=\"off\" class=\"form-control\" name=\"documentFolderDefaultName\"\n" +
    "                                            data-qe-id=\"documentFolderName-input\"\n" +
    "                                            ng-model=\"vm.data.projectTemplateExpanded.documentFolderDefaultName\"\n" +
    "                                            ng-required=\"true\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.Project.DocumentFolderName\" />\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Storage -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.data.documentFolderId ?\n" +
    "                                (vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName')\n" +
    "                                : '' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderId')\"\n" +
    "                            class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div ng-if=\"vm.data.documentFolderId\" class=\"col-md-4 col-sm-6 col-xs-6 scheduleitem-folder-input-container\">\n" +
    "                                    <span class=\"bento-icon-folder scheduleitem-folder-icon\"></span>\n" +
    "                                    <input autocomplete=\"off\" class=\"form-control scheduleitem-folder-input\"\n" +
    "                                        data-qe-id=\"documentFolderName-input\"\n" +
    "                                        ng-model=\"vm.data.documentFolderName\"\n" +
    "                                        readonly\n" +
    "                                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                        ng-required=\"vm.data.documentFolderId\"\n" +
    "                                        bmp-control-group-field=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                            'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                            'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName'}}\" />\n" +
    "                                </div>\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"!vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || !vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                                    <!-- Select Binder or Folder button -->\n" +
    "                                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.SelectBinder' -->\n" +
    "                                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.SelectDMSFolder' -->\n" +
    "                                    <button type=\"button\"\n" +
    "                                            class=\"btn btn-default\"\n" +
    "                                            ng-if=\"!vm.data.documentFolderId && vm.data.projectTemplateExpanded.documentFolderOption.id === 'MANUAL'\"\n" +
    "                                            data-qe-id=\"documentFolderName-selectbutton\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            ng-click=\"vm.domainModel.selectDocumentFolder(vm.data); vm.setFormDirty();\"\n" +
    "                                            translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data)  || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                                'Bluemoon.Core.Setup.Project.SelectBinder' : 'Bluemoon.Core.Setup.Project.SelectDMSFolder'}}\">\n" +
    "                                    </button>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\" ng-if=\"!vm.data.id && vm.data.projectTemplateExpanded.documentFolderOption.id === 'COPYEXISTING'\">\n" +
    "                        <!-- Storage -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                            data-bmp-control-group-label=\"{{vm.data.documentFolderId ?\n" +
    "                                (vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\n" +
    "                                    ? 'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                    'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName')\n" +
    "                                : '' | translate}}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, '$documentFolderId')\"\n" +
    "                            class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <div ng-if=\"vm.data.documentFolderId\" class=\"col-md-4 col-sm-6 col-xs-12 scheduleitem-folder-input-container\">\n" +
    "                                    <span class=\"bento-icon-folder scheduleitem-folder-icon\"></span>\n" +
    "                                    <input autocomplete=\"off\" class=\"form-control scheduleitem-folder-input\"\n" +
    "                                        data-qe-id=\"documentFolderName-input\"\n" +
    "                                        ng-model=\"vm.data.$documentFolderName\"\n" +
    "                                        readonly\n" +
    "                                        ng-required=\"vm.data.$documentFolderId\"\n" +
    "                                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                        bmp-control-group-field=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                            'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                            'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName'}}\" />\n" +
    "                                </div>\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                    <!-- Copy Folder button -->\n" +
    "                                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.CopyBinder' -->\n" +
    "                                    <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.CopyDMSFolder' -->\n" +
    "                                    <a class=\"btn btn-link no-padding\" href=\"\"\n" +
    "                                    data-qe-id=\"documentFolderName-copybutton\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    ng-click=\"vm.domainModel.selectDocumentFolderToCopy(vm.data); vm.setFormDirty();\"\n" +
    "                                    translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                        'Bluemoon.Core.Setup.Project.CopyBinder' : 'Bluemoon.Core.Setup.Project.CopyDMSFolder'}}\"></a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" ng-if=\"vm.domainModel.canViewDocuments(vm.data)\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div ng-if=\"!vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || !vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                        <!-- Change Binder or Folder button -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeProjectBinder' -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeProjectFolder' -->\n" +
    "                        <button type=\"button\"\n" +
    "                                ng-if=\"vm.data.documentFolderId\"\n" +
    "                                class=\"btn btn-default pull-right\"\n" +
    "                                data-qe-id=\"documentFolderName-changebutton\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                ng-click=\"vm.domainModel.selectDocumentFolder(vm.data); vm.setFormDirty();\"\n" +
    "                                translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.ChangeProjectBinder' : 'Bluemoon.Core.Setup.Project.ChangeProjectFolder'}}\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"pull-right\" ng-if=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                        <label>\n" +
    "                            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                ng-model=\"vm.data.useRollForwardSettings\" />\n" +
    "                                {{ 'Core.Captions.Project.UseRollForwardSettings' | translate}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                    <practice-documents project-id=\"vm.data.documentFolderId\" client-id=\"vm.data.client.id\"></practice-documents>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Tasks -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Tasks' -->\n" +
    "        <div uib-accordion-group\n" +
    "            class=\"panel-default\"\n" +
    "            is-open=\"vm.data.$tasksAccordian\"\n" +
    "            heading=\"{{vm.domainModel.getTaskCount()}}\"\n" +
    "            data-qe-id=\"bm-projectDetail-Tasks-accordion\">\n" +
    "            <div class=\"row\">\n" +
    "                <bmp-project-list bmp-project-list-name=\"'TaskList'\"\n" +
    "                    bmp-project-list-analytics-context=\"'setup_task'\"\n" +
    "                    bmp-project-list-style=\"(vm.inWorkspaceModal ? 'app' : 'setup')\"\n" +
    "                    bmp-project-list-project-filter=\"vm.data.id\"\n" +
    "                    bmp-project-list-client-filter=\"vm.data.$client.id\"\n" +
    "                    bmp-project-list-affect-url=\"false\"\n" +
    "                    bmp-project-list-fill-vertical-height=\"false\"\n" +
    "                    bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\"\n" +
    "                    ng-if=\"vm.data.id && vm.data.$client.id\"></bmp-project-list>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <!-- Tasks -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.BudgetAndBilling' -->\n" +
    "        <div uib-accordion-group\n" +
    "            class=\"panel-default\"\n" +
    "            is-open=\"vm.data.$budgetAndBillingAccordian\"\n" +
    "            heading=\"{{'Bluemoon.Core.Setup.Project.BudgetAndBilling' | translate}}\"\n" +
    "            data-qe-id=\"bm-projectDetail-BudgetAndBilling-accordion\">\n" +
    "            <div class=\"row\">\n" +
    "                <div ng-form name=\"detailForm\" ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "                    <div bm-if-has-license=\"ProjectManagement.Budget\" class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                        <div bm-if-perm=\"ProjectManagement.Budget\">\n" +
    "                            <h3 style=\"margin-top: 0\">\n" +
    "                                <span data-translate=\"Bluemoon.Core.Setup.Project.Budgets\"></span>\n" +
    "                                <span ng-show=\"vm.data.$recalculatingBudgets\" style=\"padding-left: 10px;\" class=\"small\">\n" +
    "                                    <i class=\"bento-icon-refresh\"></i>\n" +
    "                                    <span style=\"padding-left: 5px;\" data-translate=\"Bluemoon.Core.Setup.Project.RecalculatingBudgets\"></span>\n" +
    "                                </span>\n" +
    "                            </h3>\n" +
    "\n" +
    "                            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <label>\n" +
    "                                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                            ng-model=\"vm.data.$budgetedBasedOnTasks\" /> {{'Core.Captions.Project.BudgetedBasedOnTasks' | translate}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                                <div class=\"col-md-4 col-sm-4 col-xs-12 form-group\">\n" +
    "                                    <label>\n" +
    "                                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                            ng-model=\"vm.data.$budgetedAmountIsCalculated\" ng-disabled=\"vm.data.budgetInfo.budgetedBasedOnTasks\" /> {{'Core.Captions.Project.BudgetedAmountIsCalculated' | translate}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"row\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.BudgetedHours' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'budgetedHours')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"budgetedHours\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.budgetInfo.budgetedHours\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.BudgetedHours\"\n" +
    "                                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                        bmp-big-number=\"'n2'\"\n" +
    "                                        min=\"0\" max=\"99999.99\" />\n" +
    "                                </div>\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.BudgetedAmount' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'budgetedAmount')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"budgetedAmount\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.budgetInfo.budgetedAmount\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.BudgetedAmount\"\n" +
    "                                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks || vm.data.budgetInfo.budgetedAmountIsCalculated\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        bmp-big-number=\"'c2'\"\n" +
    "                                        min=\"0\" max=\"999999.99\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualHours' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'actualHours')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"actualHours\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.budgetInfo.actualHours\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.ActualHours\"\n" +
    "                                        ng-readonly=\"true\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        bmp-big-number=\"'n2'\"\n" +
    "                                        min=\"0\" max=\"99999.99\" />\n" +
    "                                </div>\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualAmount' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'actualAmount')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"actualAmount\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.budgetInfo.actualAmount\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.ActualAmount\"\n" +
    "                                        ng-readonly=\"true\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        bmp-big-number=\"'c2'\"\n" +
    "                                        min=\"0\" max=\"999999.99\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.EstimatedRemaining' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'estimatedRemaining')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"estimatedRemaining\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.$estimatedRemaining\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.EstimatedRemaining\"\n" +
    "                                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                        bmp-big-number=\"'n2'\"\n" +
    "                                        min=\"0\" max=\"99999.99\" />\n" +
    "                                </div>\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.PercentComplete' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'percentComplete')\"\n" +
    "                                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                                    <input autocomplete=\"off\" name=\"percentComplete\" type=\"text\" class=\"form-control\"\n" +
    "                                        ng-model=\"vm.data.budgetInfo.percentComplete\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Project.PercentComplete\"\n" +
    "                                        ng-readonly=\"true\"\n" +
    "                                        bmp-clear-value=\"0\"\n" +
    "                                        bmp-big-number-range-validator=\"\"\n" +
    "                                        bm-format-on-blur=\"\"\n" +
    "                                        bmp-big-number=\"'p0'\"\n" +
    "                                        min=\"0\" max=\"99999.99\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- Show/hide the adjustments -->\n" +
    "                            <div class=\"row\" ng-show=\"!vm.data.budgetInfo.budgetedBasedOnTasks\">\n" +
    "                                <div class=\"col-md-8\">\n" +
    "                                    <a href=\"\" id=\"adjustmentsShowHide\" data-qe-id=\"adjustmentsShowHide-button\" class=\"btn btn-link\" style=\"padding-left: 0px;\"\n" +
    "                                    ng-click=\"vm.domainModel.showHideAdjustments(vm.data)\">\n" +
    "                                        {{vm.domainModel.showHideAdjustmentsLabel(vm.data)}}\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <h3 style=\"margin-top: 0\">\n" +
    "                                <span data-translate=\"Bluemoon.Core.Setup.Project.Billing\"></span>\n" +
    "                            </h3>\n" +
    "                        <div bmp-if-firm-permission=\"hasEngagements\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <!-- Engagement -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"engagement\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Engagement' | translate }}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'engagement')\"\n" +
    "                                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                                    <bmp-select-combo name=\"engagement\"\n" +
    "                                                    list=\"client-engagements#active\"\n" +
    "                                                    custom-items=\"vm.domainModel.engagementTemplate\"\n" +
    "                                                    context=\"vm.data.client.id\"\n" +
    "                                                    ng-model=\"vm.data.engagement\"\n" +
    "                                                    on-change=\"vm.data.$recalculateBudgets()\"></bmp-select-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row\" ng-if=\"vm.domainModel.createEngagement(vm.data)\">\n" +
    "                            <div class=\"col-md-8\">\n" +
    "                                <div class=\"alert alert-info\">\n" +
    "                                    <small>\n" +
    "                                        <span translate=\"Bluemoon.Core.Setup.Project.CreateEngagement\"></span>\n" +
    "                                    </small>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "                            <div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "                                <div ng-if=\"vm.domainModel.showTaxGroup(vm.data)\">\n" +
    "                                    <!-- Tax Group -->\n" +
    "                                    <div bm-if-perm-some=\"['TimeAndBilling.AssessServiceCharges','TimeAndBilling.Billing','TimeAndBilling.PrintStatements','TimeAndBilling.ReceiptAndAdjustment','TimeAndBilling.ReviewInvoices','TimeAndBilling.TimeAndExpense']\">\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Project.TaxGroupId' | translate}}\"\n" +
    "                                            data-bmp-data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroupId')\"\n" +
    "                                            class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                                            <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                                            list-style=\"basic\"\n" +
    "                                                            name=\"taxgroup\"\n" +
    "                                                            ng-model=\"vm.data.$taxGroup\" provider=\"vm.domainModel.indirectTaxProvider\">\n" +
    "                                            </bmp-select-combo>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Invoice Description -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"invoiceDescription\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.Project.InvoiceDescription' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "                                    class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                                <textarea rows=\"3\" id=\"invoiceDescription\" name=\"invoiceDescription\"\n" +
    "                                            data-qe-id=\"invoiceDescription-input\"\n" +
    "                                            class=\"form-control\"\n" +
    "                                            data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                                            data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div bm-if-has-license=\"ProjectManagement.Budget\" class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <div bm-if-perm=\"ProjectManagement.Budget\">\n" +
    "                            <!-- Estimated Remaining Adjustments and Time Entries -->\n" +
    "                            <div class=\"row\" ng-if=\"!vm.data.budgetInfo.budgetedBasedOnTasks && vm.data.$adjustmentsVisible\">\n" +
    "                                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                    <div class=\"well bm-well\" style=\"padding-top:0px;padding-bottom:0px;\">\n" +
    "\n" +
    "                                        <h3 translate=\"Bluemoon.Core.Setup.Projects.AdjustmentHistory\"></h3>\n" +
    "\n" +
    "                                        <div style=\"margin-bottom:25px;\" data-qe-id=\"adjustments-grid\">\n" +
    "\n" +
    "                                        <bmp-toolbar toolbar-buttons=\"vm.domainModel.adjustmentsToolbar(vm, vm.data)\"\n" +
    "                                                    aria-controls=\"adjustments-table\"\n" +
    "                                                    has-column-picker=\"false\"></bmp-toolbar>\n" +
    "\n" +
    "                                            <!-- Grid -->\n" +
    "                                            <div style=\"overflow:auto;overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch;\">\n" +
    "                                                <table class=\"bento-flex-grid no-footer scheduleitem-estimated-remaining-grid\">\n" +
    "\n" +
    "                                                    <!-- Header -->\n" +
    "                                                    <thead>\n" +
    "                                                        <tr>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-description-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EntryType' | translate}}</th>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\" data-qe-id=\"adjustment-entrydate-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EntryDate' | translate}}</th>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;;\" data-qe-id=\"adjustment-staffcode-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EmployeeCode' | translate}}</th>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-hours-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.Hours' | translate}}</th>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-balance-header\">{{'Bluemoon.Core.Setup.ScheduleItemAdjustRemainingEntry.Balance' | translate}}</th>\n" +
    "                                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;width:100%;\" data-qe-id=\"adjustment-comments-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.Notes' | translate}}</th>\n" +
    "                                                        </tr>\n" +
    "                                                    </thead>\n" +
    "                                                    <tbody>\n" +
    "\n" +
    "                                                        <!-- Budgeted -->\n" +
    "                                                        <tr>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\" translate=\"Bluemoon.Core.Setup.Project.AdjustmentsGrid.Budgeted\"></td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Balance -->\n" +
    "                                                                <input autocomplete=\"off\" name=\"balance\" type=\"text\" class=\"form-control\"\n" +
    "                                                                    ng-model=\"vm.data.budgetInfo.budgetedHours\"\n" +
    "                                                                    ng-readonly=\"true\"\n" +
    "                                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                                    min=\"0\" max=\"99999.99\" />\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                                        </tr>\n" +
    "\n" +
    "                                                        <!-- Adjustments -->\n" +
    "                                                        <tr data-ng-repeat=\"adjustment in vm.data.adjustRemainingEntries\" ng-form=\"{{'adjustment_' + $index.toString()}}\">\n" +
    "\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Type -->\n" +
    "                                                                {{adjustment.entryType.name}}\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Entry Date -->\n" +
    "                                                                <div class=\"form-group\" style=\"margin-right:15px;margin-bottom:0px;width:100%\">\n" +
    "                                                                    <bmp-bento-datepicker-wrapper name=\"entryDate\"\n" +
    "                                                                                                ng-model=\"adjustment.entryDate\"\n" +
    "                                                                                                bmp-field-error=\"Core.Captions.ScheduleItemAdjustRemainingEntry.EntryDate\"\n" +
    "                                                                                                bmp-field-server-error=\"vm.detail.errorFor(adjustment, 'entryDate')\"\n" +
    "                                                                                                ng-required=\"true\"\n" +
    "                                                                                                ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\">\n" +
    "                                                                    </bmp-bento-datepicker-wrapper>\n" +
    "                                                                </div>\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Staff -->\n" +
    "                                                                {{adjustment.employeeCode}}\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Hours -->\n" +
    "                                                                <input autocomplete=\"off\" name=\"hours\" type=\"text\" class=\"form-control\"\n" +
    "                                                                    ng-model=\"adjustment.hours\"\n" +
    "                                                                    ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\"\n" +
    "                                                                    bmp-field-error=\"Core.Captions.ScheduleItemAdjustRemainingEntry.Hours\"\n" +
    "                                                                    bmp-field-server-error=\"vm.detail.errorFor(adjustment, 'hours')\"\n" +
    "                                                                    bmp-clear-value=\"0\"\n" +
    "                                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                                    bm-format-on-blur=\"\"\n" +
    "                                                                    ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                                    min=\"-99999.99\" max=\"99999.99\" />\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Balance -->\n" +
    "                                                                <input autocomplete=\"off\" name=\"balance\" type=\"text\" class=\"form-control\"\n" +
    "                                                                    ng-model=\"adjustment.$balance\"\n" +
    "                                                                    ng-readonly=\"true\"\n" +
    "                                                                    bmp-big-number=\"'n2'\" />\n" +
    "                                                            </td>\n" +
    "                                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                                <!-- Comments -->\n" +
    "                                                                <input autocomplete=\"off\" name=\"comments\" type=\"text\" class=\"form-control\"\n" +
    "                                                                    ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\"\n" +
    "                                                                    ng-model=\"adjustment.notes\" />\n" +
    "                                                            </td>\n" +
    "                                                        </tr>\n" +
    "\n" +
    "                                                    </tbody>\n" +
    "                                                </table>\n" +
    "                                            </div>\n" +
    "\n" +
    "                                            <!-- Validation errors -->\n" +
    "                                            <uib-alert type=\"danger\" ng-show=\"vm.showHistoryError()\" data-qe-id=\"partnerHistory-error\">{{vm.partnerHistoryValidationMessage()}}</uib-alert>\n" +
    "\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\" ng-if=\"vm.domainModel.canViewDocuments(vm.data)\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div ng-if=\"!vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || !vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                        <!-- Change Binder or Folder button -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeProjectBinder' -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeProjectFolder' -->\n" +
    "                        <button type=\"button\"\n" +
    "                                ng-if=\"vm.data.documentFolderId\"\n" +
    "                                class=\"btn btn-default pull-right\"\n" +
    "                                data-qe-id=\"documentFolderName-changebutton\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                ng-click=\"vm.domainModel.selectDocumentFolder(vm.data); vm.setFormDirty();\"\n" +
    "                                translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.ChangeProjectBinder' : 'Bluemoon.Core.Setup.Project.ChangeProjectFolder'}}\">\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"pull-right\" ng-if=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                        <label>\n" +
    "                            <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                ng-model=\"vm.data.useRollForwardSettings\" />\n" +
    "                                {{ 'Core.Captions.Project.UseRollForwardSettings' | translate}}\n" +
    "                        </label>\n" +
    "                    </div>\n" +
    "                    <practice-documents project-id=\"vm.data.documentFolderId\" client-id=\"vm.data.client.id\"></practice-documents>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </uib-accordion>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-general.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-general.html",
    "<div class=\"row\" ng-init=\"vm.domainModel.setForm(detailForm)\">\n" +
    "    <div class=\"text-right pull-right no-padding col-sm-6\">\n" +
    "        <button type=\"button\" data-qe-id=\"bm-scheduleItemDetailGeneral-switchView-button\" class=\"btn btn-link no-padding\" ng-click=\"vm.domainModel.switchView(vm.data);\" ng-disabled=\"detailForm.$invalid\">{{vm.domainModel.switchViewText(vm.data)}}</button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div bento-busy-loader=\"vm.domainModel.isLoading\" busy-loader-size=\"small\">\n" +
    "<div class=\"row\">\n" +
    "    <!-- Project Template -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.Project.ProjectTemplate' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"projectTemplate\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Project.ProjectTemplate' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectTemplate')\"\n" +
    "            data-bmp-control-group-loading=\"vm.domainModel.isLoading\"\n" +
    "            class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"project-templates\" name=\"projectTemplate\"\n" +
    "                                ng-model=\"vm.data.$projectTemplate\"\n" +
    "                                ng-readonly=\"vm.data.id\"\n" +
    "                                filter=\"vm.domainModel.optionalFilterByApplication(vm.getUrlParam('application') || vm.appRouting.getCurrentApplicationInstant())\"\n" +
    "                                required=\"true\" aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "            <!-- New -->\n" +
    "            <div class=\"col-md-4 col-sm-2 col-xs-2\" ng-if=\"false\">\n" +
    "                <button id=\"add_new_project_template\"\n" +
    "                        type=\"button\"\n" +
    "                        class=\"btn btn-link\"\n" +
    "                        style=\"padding-left:0px\"\n" +
    "                        ng-disabled=\"vm.data.id\"\n" +
    "                        ng-click=\"vm.domainModel.newProjectTemplate(vm.data); vm.setFormDirty();\">\n" +
    "                        <span class=\"bento-icon-add\"></span>\n" +
    "                        <span data-translate=\"Bluemoon.Practice.Common.Actions.Add\"></span>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Client -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.Client' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"client\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Client' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'client')\"\n" +
    "            data-bmp-control-group-loading=\"vm.domainModel.isLoading\"\n" +
    "            class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "        <bmp-select-combo list=\"clients#active\" name=\"client\"\n" +
    "                            ng-model=\"vm.data.$client\"\n" +
    "                            ng-readonly=\"vm.parsedContext.parentContextId || vm.data.id || vm.data.$clientPreselected\"\n" +
    "                            required=\"true\"\n" +
    "                             aotf-default></bmp-select-combo>\n" +
    "    </div>\n" +
    "    <!-- For Contact -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.ForContact' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"forContact\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ForContact' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'forContact')\"\n" +
    "            class=\"col-md-4 col-sm-5 col-xs-12\">\n" +
    "        <bmp-select-combo name=\"forContact\"\n" +
    "                            list=\"related-contacts\"\n" +
    "                            list-style=\"basic\"\n" +
    "                            context=\"vm.data.client.contactId\"\n" +
    "                            filter = \"vm.domainModel.ukAccountFilter(vm.data)\"\n" +
    "                            custom-items=\"[vm.data.forContact]\"\n" +
    "                            ng-model=\"vm.data.$forContact\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-disabled=\"vm.isLoading || !vm.data.projectTemplate.id || !vm.data.client.id\"></bmp-select-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"vm.data.$advancedView\">\n" +
    "    <!-- Project Number -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"projectNumber\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.Project.ProjectNumber' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectNumber')\"\n" +
    "            class=\"col-md-4 col-sm-5 col-xs-6\">\n" +
    "        <input autocomplete=\"off\" type=\"number\" min=\"0\" max=\"999999999\" id=\"projectNumber\" name=\"projectNumber\"\n" +
    "                data-qe-id=\"projectNumber-input\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                bmp-integer=\"true\"\n" +
    "                ng-model=\"vm.data.projectNumber\"\n" +
    "                ng-change=\"vm.detail.clearErrorFor(vm.data, 'projectNumber')\"\n" +
    "                bmp-control-group-field=\"Core.Captions.Project.ProjectNumber\"\n" +
    "                placeholder=\"{{'Bluemoon.Core.Setup.Project.NextAvailablePlaceholder' | translate}}\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\">\n" +
    "    <!-- Name -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"name\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.ProjectList.ScheduleItem.Name' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "        <input autocomplete=\"off\" type=\"text\" id=\"name\" name=\"name\"\n" +
    "                data-qe-id=\"name-input\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-required=\"true\"\n" +
    "                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                ng-model=\"vm.data.$name\"\n" +
    "                data-ng-blur=\"vm.updateLabelName()\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <schedule-item-setup-application-fields data=\"vm.data\" ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"></schedule-item-setup-application-fields>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-perm=\"ProjectManagement.Projects\">\n" +
    "        <div class=\"row\" ng-if=\"vm.data.$advancedView\">\n" +
    "            <!-- Priority -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.Priority' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"priority\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Priority' | translate | bmRequiredMark}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'priority')\"\n" +
    "                 class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                <bmp-enum-combo enum=\"priority-types\" name=\"priority\"\n" +
    "                                ng-model=\"vm.data.priority\"\n" +
    "                                required=\"true\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"></bmp-enum-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Tracking Description -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.TrackingDescription' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TrackingDescription' | translate | bmRequiredMark }}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription')\"\n" +
    "             class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "                    <bmp-select-combo name=\"trackingDescription\"\n" +
    "                                      list=\"tracking-descriptions\"\n" +
    "                                      list-style=\"basic\"\n" +
    "                                      ng-model=\"vm.data.$trackingDescription\"\n" +
    "                                      ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                      required=\"true\" aotf-default></bmp-select-combo>\n" +
    "                </div>\n" +
    "                <!-- New -->\n" +
    "                <div class=\"col-md-4 col-sm-2 col-xs-2\" ng-if=\"false\">\n" +
    "                    <button id=\"add_new_project_template\"\n" +
    "                            type=\"button\"\n" +
    "                            class=\"btn btn-link\"\n" +
    "                            style=\"padding-left:0px\"\n" +
    "                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                            ng-click=\"vm.domainModel.newTrackingDescription(vm.data); vm.setFormDirty();\">\n" +
    "                        <span class=\"bento-icon-add\"></span>\n" +
    "                        <span data-translate=\"Bluemoon.Practice.Common.Actions.Add\"></span>\n" +
    "                    </button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <periods-on-projects-fields ng-if=\"vm.data.$advancedView\" project=\"vm.data\"></periods-on-projects-fields>\n" +
    "\n" +
    "    <div bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "        <div ng-if=\"vm.data.$advancedView\">\n" +
    "            <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItem.TargetDates\"></h3>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Target start & complete dates -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"targetStartDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TargetStartDate' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetStartDate')\"\n" +
    "                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"-->\n" +
    "                    <bmp-bento-datepicker-wrapper name=\"targetStartDate\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                ng-model=\"vm.data.targetStartDate\"\n" +
    "                                                bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetStartDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"targetCompleteDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TargetCompleteDateExclusive' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetCompleteDateExclusive')\"\n" +
    "                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"-->\n" +
    "                    <bmp-bento-datepicker-wrapper name=\"targetCompleteDate\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                ng-model=\"vm.data.targetCompleteDateExclusive\"\n" +
    "                                                bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.TargetDates\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetCompleteDateExclusive\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItem.ActualDates\"></h3>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Received date -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"receivedDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ReceivedDate' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'receivedDate')\"\n" +
    "                    class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-bento-datepicker-wrapper name=\"receivedDate\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                ng-model=\"vm.data.$receivedDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Actual start & complete dates -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"actualStartDate\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualStartDate' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualStartDate')\"\n" +
    "                        class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"-->\n" +
    "                    <bmp-bento-datepicker-wrapper name=\"actualStartDate\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    ng-model=\"vm.data.$actualStartDate\"\n" +
    "                                                    ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualStartDate')\"\n" +
    "                                                    bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Project.ActualStartDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"actualCompleteDate\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualCompleteDate' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                        class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"-->\n" +
    "                    <bmp-bento-datepicker-wrapper name=\"actualCompleteDate\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                    ng-model=\"vm.data.$actualCompleteDate\"\n" +
    "                                                    ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                                                    bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Project.ActualDates\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Project.ActualCompleteDate\"></bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItem.DueDates\" ng-if=\"vm.data.$advancedView\"></h3>\n" +
    "\n" +
    "    <div class=\"row\" ng-if=\"vm.data.$advancedView\">\n" +
    "        <!-- Extension -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"extensionNumber\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Project.ExtensionNumber' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'extensionNumber')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <div data-bento-select>\n" +
    "                <select class=\"form-control\" name=\"extensionNumber\" id=\"extensionNumber\"\n" +
    "                        data-qe-id=\"extensionNumber-select\"\n" +
    "                        data-ng-model=\"vm.data.$extensionNumber\"\n" +
    "                        ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                        data-ng-options=\"option.number as vm.domainModel.getExtensionText(option) for option in vm.data.extensions\"></select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Current due & original due dates -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.CurrentDueDateExclusive' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"currentDueDateExclusive\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.CurrentDueDateExclusive' | translate | bmRequiredMark}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'currentDueDateExclusive')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-bento-datepicker-wrapper name=\"currentDueDateExclusive\"\n" +
    "                                          ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                          ng-required=\"true\"\n" +
    "                                          ng-model=\"vm.data.$currentDueDateExclusive\"></bmp-bento-datepicker-wrapper>\n" +
    "        </div>\n" +
    "        <div data-bmp-control-group=\"\" ng-if=\"vm.data.$advancedView\"\n" +
    "             data-bmp-control-group-field-id=\"originalDueDate\"\n" +
    "             data-bmp-control-group-label=\"{{'Core.Captions.Project.OriginalDueDate' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'originalDueDate')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-bento-datepicker-wrapper name=\"originalDueDate\"\n" +
    "                                          ng-readonly=\"true\"\n" +
    "                                          ng-model=\"vm.data.originalDueDate\"></bmp-bento-datepicker-wrapper>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3 data-translate=\"Bluemoon.Core.Setup.Project.Assignments\"></h3>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Primary/Preparer Assignment -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"primary_assignment_employee\"\n" +
    "             data-bmp-control-group-label=\"{{ vm.domainModel.getPrimaryAssignmentLabel(vm.data) }}\"\n" +
    "             data-bmp-control-group-field-id=\"primary_assignment_employee_KEY__{{$index}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.primaryAssignment, 'employee')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"primary_assignment_employee\"\n" +
    "                                ng-model=\"vm.data.primaryAssignment.employee\"\n" +
    "                                on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                                ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                aotf-default></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"vm.data.applicationType.id !== 'UKTAX' && !vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "        <!-- Secondary/Staff Assignment -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "            data-bmp-control-group-label=\"{{vm.domainModel.getSecondaryAssignmentLabel(vm.data)}}\"\n" +
    "            class=\"col-md-12 col-sm-12 col-xs-12\" style=\"margin-bottom: 0px;\">\n" +
    "            <bmp-multi-select-control\n" +
    "                style=\"padding-right: 10px; float: left;\"\n" +
    "                name=\"secondaryAssignment\"\n" +
    "                bento-append-to-parent=\"#multiselect-overlay-id > div > div.tab-content\"\n" +
    "                revert-selections-on-dismissal=\"true\"\n" +
    "                ng-model=\"vm.data.$multiselectDataSelected\"\n" +
    "                list-data=\"vm.data.$multiselectData\"\n" +
    "                select-button-text=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                edit-button-text=\"{{'Bluemoon.Practice.Common.Actions.Add' | translate}}\">\n" +
    "            </bmp-multi-select-control>\n" +
    "\n" +
    "            <div class=\"form-control-static\">\n" +
    "                <span ng-repeat=\"assignment in vm.data.secondaryAssignments\">\n" +
    "                    <span class=\"label label-info\" data-qe-id=\"bm-projectDetail-secondaryAssignments-name_{{assignment.employee.name}}\">\n" +
    "                        {{assignment.employee.name}}\n" +
    "                        <span class=\"glyphicon glyphicon-remove\"\n" +
    "                            data-qe-id=\"bm-projectDetail-secondaryAssignments-removeButton_{{assignment.employee.name}}\"\n" +
    "                            data-ng-click=\"vm.domainModel.removeSecondaryAssignment(vm.data, assignment, true); vm.setFormDirty();\">\n" +
    "                        </span>\n" +
    "                    </span>&nbsp;\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "            data-bmp-control-group-label=\"{{ vm.domainModel.getSecondaryAssignmentLabel(vm.data) }}\"\n" +
    "            data-bmp-control-group-field-id=\"secondary_assignment_employee_KEY__{{$index}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.secondaryAssignments[0], 'employee')\"\n" +
    "            class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "           <bmp-select-combo list=\"staff#active\"\n" +
    "                               ng-model=\"vm.data.secondaryAssignments[0].employee\"\n" +
    "                               on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                               ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                               aotf-default></bmp-select-combo>\n" +
    "       </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Reviewer Assignment -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "             data-bmp-control-group-field-id=\"responsibleEmployee\"\n" +
    "             data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.ResponsibleAssignment' | translate}}\"\n" +
    "             data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'responsibleEmployee')\"\n" +
    "             class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "            <bmp-select-combo list=\"staff#active\" name=\"responsibleEmployee\"\n" +
    "                              ng-model=\"vm.data.responsibleEmployee\"\n" +
    "                              ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                              aotf-default></bmp-select-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-perm=\"OnvioSetup.Departments\">\n" +
    "        <div class=\"row\" ng-if=\"vm.data.$advancedView\">\n" +
    "            <!-- Department -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"department\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.Project.Department' | translate}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'department')\"\n" +
    "                 class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <bmp-multi-select-control\n" +
    "                        style=\"padding-right: 10px; float: left;\"\n" +
    "                        name=\"projectDepartament\"\n" +
    "                        list-data=\"vm.domainModel.departmentsList\"\n" +
    "                        ng-model=\"vm.domainModel.selectedDepartments\"\n" +
    "                        revert-selections-on-dismissal=\"true\"\n" +
    "                    >\n" +
    "                    </bmp-multi-select-control>\n" +
    "                    <div class=\"form-control-static\">\n" +
    "                        <span data-ng-repeat=\"department in vm.domainModel.selectedDepartments\">\n" +
    "                            <span class=\"label label-info\">\n" +
    "                                {{department.name}}\n" +
    "                                <span class=\"glyphicon glyphicon-remove scheduleitem-label-glyphicon\"\n" +
    "                                        data-qe-id=\"department-remove-{{department.name}}-button\"\n" +
    "                                        data-ng-click=\"vm.domainModel.onRemoveDepartmentByLabel(department); vm.setFormDirty();\"></span>\n" +
    "                            </span>&nbsp;\n" +
    "                        </span>\n" +
    "                    </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-perm-some=\"['Onvio.DocumentStorage', 'OnvioDrive.ClientDocuments']\" class=\"form-group\">\n" +
    "        <div ng-if=\"vm.data.$advancedView\">\n" +
    "            <h3 data-translate=\"Bluemoon.Core.Setup.ProjectTemplate.DocumentStorage\"></h3>\n" +
    "            <div class=\"row\" ng-if=\"!vm.data.id && !vm.data.documentFolderId\">\n" +
    "                <!-- Storage -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"documentFolderOption\"\n" +
    "                     data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\n" +
    "                        ? 'Bluemoon.Core.Setup.Project.Detail.DocumentBinderOption' : 'Bluemoon.Core.Setup.Project.Detail.DocumentFolderOption' | translate}}\"\n" +
    "                     class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <div ng-switch=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                        <div ng-switch-when=\"true\">\n" +
    "                            <bmp-enum-combo enum=\"document-binder-options\" name=\"documentBinderOption\"\n" +
    "                                            ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                            required=\"true\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                        <div ng-switch-default=\"\">\n" +
    "                            <div ng-switch=\"vm.domainModel.applicationTypeIsAUTaxOrAUActivityStatementOrAdvisory(vm.data)\">\n" +
    "                                <div ng-switch-when=\"true\">\n" +
    "                                    <bmp-enum-combo enum=\"document-folder-options-without-none\" name=\"documentFolderOption\"\n" +
    "                                            ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                            required=\"true\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                                <div ng-switch-default=\"\">\n" +
    "                                    <bmp-enum-combo enum=\"document-folder-options\" name=\"documentFolderOption\"\n" +
    "                                            ng-model=\"vm.data.projectTemplateExpanded.documentFolderOption\"\n" +
    "                                            required=\"true\"\n" +
    "                                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderOption\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div ng-if=\"vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' -->\n" +
    "                            <!-- /* i18nextract */'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                 data-bmp-control-group-field-id=\"documentFolderTemplateId\"\n" +
    "                                 data-bmp-control-group-label=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\n" +
    "                                    ? 'Bluemoon.Core.Setup.Project.Detail.BinderTemplate' :\n" +
    "                                    'Core.Captions.ProjectTemplate.DocumentFolderTemplateId' | translate}}\"\n" +
    "                                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.projectTemplateExpanded, 'documentFolderTemplateId')\"\n" +
    "                                 class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                <bmp-select-combo name=\"documentFolderTemplateId\"\n" +
    "                                                  list=\"dms-project-templates#dms\"\n" +
    "                                                  list-style=\"basic\"\n" +
    "                                                  ng-model=\"vm.data.projectTemplateExpanded.$documentFolderTemplate\"\n" +
    "                                                  required=\"true\"\n" +
    "                                                  ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                  bmp-control-group-field=\"Core.Captions.ProjectTemplate.DocumentFolderTemplateId\"></bmp-select-combo>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEW' || vm.data.projectTemplateExpanded.documentFolderOption.id === 'NEWFROMTEMPLATE'\">\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                 data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                                 data-bmp-control-group-label=\"{{'Core.Captions.Project.DocumentFolderName' | translate}}\"\n" +
    "                                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.projectTemplateExpanded, 'documentFolderDefaultName')\"\n" +
    "                                 class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                                <input autocomplete=\"off\" class=\"form-control\" name=\"documentFolderDefaultName\"\n" +
    "                                       data-qe-id=\"documentFolderName-input\"\n" +
    "                                       ng-model=\"vm.data.projectTemplateExpanded.documentFolderDefaultName\"\n" +
    "                                       ng-required=\"true\"\n" +
    "                                       ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                       bmp-control-group-field=\"Core.Captions.Project.DocumentFolderName\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- Storage -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                     data-bmp-control-group-label=\"{{vm.data.documentFolderId ?\n" +
    "                        (vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                        'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                        'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName')\n" +
    "                        : '' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'documentFolderId')\"\n" +
    "                     class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div ng-if=\"vm.data.documentFolderId\" class=\"col-md-4 col-sm-6 col-xs-6 scheduleitem-folder-input-container\">\n" +
    "                            <span class=\"bento-icon-folder scheduleitem-folder-icon\"></span>\n" +
    "                            <input autocomplete=\"off\" class=\"form-control scheduleitem-folder-input\"\n" +
    "                                   data-qe-id=\"documentFolderName-input\"\n" +
    "                                   ng-model=\"vm.data.documentFolderName\"\n" +
    "                                   readonly\n" +
    "                                   ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                   ng-required=\"vm.data.documentFolderId\"\n" +
    "                                   bmp-control-group-field=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                    'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                    'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName'}}\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-12 col-sm-12 col-xs-12\" ng-if=\"!vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || !vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                            <!-- Select or Change Folder button -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeBinder' -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.ChangeDMSFolder' -->\n" +
    "                            <a ng-if=\"vm.data.documentFolderId\" class=\"btn btn-link no-padding\" href=\"\"\n" +
    "                            data-qe-id=\"documentFolderName-changebutton\"\n" +
    "                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                            ng-click=\"vm.domainModel.selectDocumentFolder(vm.data); vm.setFormDirty();\"\n" +
    "                            translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.ChangeBinder' : 'Bluemoon.Core.Setup.Project.ChangeDMSFolder'}}\"></a>\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.SelectBinder' -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.SelectDMSFolder' -->\n" +
    "                            <a ng-if=\"!vm.data.documentFolderId && vm.data.projectTemplateExpanded.documentFolderOption.id === 'MANUAL'\" class=\"btn btn-link no-padding\" href=\"\"\n" +
    "                            data-qe-id=\"documentFolderName-selectbutton\"\n" +
    "                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                            ng-click=\"vm.domainModel.selectDocumentFolder(vm.data); vm.setFormDirty();\"\n" +
    "                            translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.SelectBinder' : 'Bluemoon.Core.Setup.Project.SelectDMSFolder'}}\"></a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" ng-if=\"!vm.data.id && vm.data.projectTemplateExpanded.documentFolderOption.id === 'COPYEXISTING'\">\n" +
    "                <!-- Storage -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                     data-bmp-control-group-field-id=\"documentFolderName\"\n" +
    "                     data-bmp-control-group-label=\"{{vm.data.documentFolderId ?\n" +
    "                        (vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\n" +
    "                            ? 'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                            'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName')\n" +
    "                        : '' | translate}}\"\n" +
    "                     data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, '$documentFolderId')\"\n" +
    "                     class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div ng-if=\"vm.data.documentFolderId\" class=\"col-md-4 col-sm-6 col-xs-12 scheduleitem-folder-input-container\">\n" +
    "                            <span class=\"bento-icon-folder scheduleitem-folder-icon\"></span>\n" +
    "                            <input autocomplete=\"off\" class=\"form-control scheduleitem-folder-input\"\n" +
    "                                   data-qe-id=\"documentFolderName-input\"\n" +
    "                                   ng-model=\"vm.data.$documentFolderName\"\n" +
    "                                   readonly\n" +
    "                                   ng-required=\"vm.data.$documentFolderId\"\n" +
    "                                   ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                   bmp-control-group-field=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                       'Bluemoon.Core.Setup.Project.Detail.DocumentBinderName' :\n" +
    "                                       'Bluemoon.Core.Setup.Project.Detail.DocumentFolderName'}}\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                            <!-- Copy Folder button -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.CopyBinder' -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Project.CopyDMSFolder' -->\n" +
    "                            <a class=\"btn btn-link no-padding\" href=\"\"\n" +
    "                            data-qe-id=\"documentFolderName-copybutton\"\n" +
    "                            ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                            ng-click=\"vm.domainModel.selectDocumentFolderToCopy(vm.data); vm.setFormDirty();\"\n" +
    "                            translate=\"{{vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data) ?\n" +
    "                                'Bluemoon.Core.Setup.Project.CopyBinder' : 'Bluemoon.Core.Setup.Project.CopyDMSFolder'}}\"></a>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\"\n" +
    "                ng-if=\"vm.domainModel.applicationTypeIsCheckpointOrWorkpapers(vm.data) || vm.domainModel.applicationTypeIsTrailBalance(vm.data)\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <label>\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                               ng-model=\"vm.data.useRollForwardSettings\" />\n" +
    "                               {{ 'Core.Captions.Project.UseRollForwardSettings' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div>\n" +
    "        <h3  ng-if=\"vm.data.$advancedView && vm.data.id\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "            <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.id\" [entity-name]=\"vm.data.name\"> </bmcn-notes>\n" +
    "        </h3>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- THIS IS FOR TESTING ONLY. It will never be exposed to the user. -->\n" +
    "    <div bm-if-perm=\"TimeAndBilling.InternalComponent\">\n" +
    "        <a href=\"{{'#/billing-component?projectScheduleItemId=' + vm.data.id}}\"><span class=\"bento-icon-arrow-curved-right\"></span>Billing Component</a>\n" +
    "    </div>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-recurrence.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-recurrence.html",
    "<div ng-form name=\"detailForm\" ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItemSeries.SeriesRecurrenceMethod' | translate}}\"\n" +
    "            data-bmp-control-group-field-id=\"seriesRecurrenceMethod\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.scheduleItemSeries, 'seriesRecurrenceMethod')\"\n" +
    "            class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <div class=\"col-md-8 col-sm-10 col-xs-12\" ng-if=\"vm.data.$seriesRecurrenceMethod.id === 'USEPARENTPROJECT'\">\n" +
    "                <!-- vm.data.$parent.wherever needs to be replaced with the valid value that will come from the Parent Project Checking in now For String Translate-->\n" +
    "                <p>{{ 'Bluemoon.Core.Setup.Common.ParentFrequencyStatement' | translate: { projectName: vm.data.parent.name, parentProjectNumber:vm.data.$parentProjectNumber, clientName: vm.data.$parentProjectClientName} }}</p>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.data.$seriesRecurrenceMethod.id !== 'USEPARENTPROJECT'\">\n" +
    "                <div>\n" +
    "                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                    name=\"seriesRecurrenceMethod_NONE\"\n" +
    "                                    value=\"NONE\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                    name=\"seriesRecurrenceMethod_USEPROJECTTEMPLATE\"\n" +
    "                                    value=\"USEPROJECTTEMPLATE\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                    <label>({{vm.data.projectTemplateExpanded.scheduleItemSeries.recurrence.descriptionPattern}})</label>\n" +
    "                </div>\n" +
    "                <div>\n" +
    "                    <bmp-enum-radio enum=\"recurrence-methods\"\n" +
    "                                    name=\"seriesRecurrenceMethod_USESPECIFICRULE\"\n" +
    "                                    value=\"USESPECIFICRULE\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    ng-model=\"vm.data.$seriesRecurrenceMethod\"\n" +
    "                                    ng-click=\"vm.trackAnalyticsEventInContext('recurrenceMethodChanged')\"></bmp-enum-radio>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row col-md-8 col-sm-10\" ng-if=\"vm.data.scheduleItemSeries.seriesRecurrenceMethod.id !== 'NONE'\">\n" +
    "        <schedule-item-series-detail data=\"vm.data.scheduleItemSeries\"\n" +
    "            default-data=\"vm.defaultData.scheduleItemSeries\"\n" +
    "            controller=\"vm\"\n" +
    "            domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "            is-project-screen-recurrence=\"true\">\n" +
    "        </schedule-item-series-detail>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row col-md-8 col-sm-10\" ng-if=\"vm.domainModel.hasRecurrence(vm.data)\">\n" +
    "        <schedule-item-project-generation-options data=\"vm.data.scheduleItemSeries\"\n" +
    "            default-data=\"vm.defaultData.scheduleItemSeries\"\n" +
    "            controller=\"vm\"\n" +
    "            domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "            primary-label=\"vm.domainModel.getPrimaryAssignmentLabel(vm.data)\"\n" +
    "            secondary-label=\"vm.domainModel.getSecondaryAssignmentLabel(vm.data)\"\n" +
    "            is-project-screen-recurrence=\"true\">\n" +
    "        </schedule-item-project-generation-options>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\"  ng-if=\"vm.domainModel.hasRecurrence(vm.data)\">\n" +
    "        <div class=\"col-md-8 col-sm-10\">\n" +
    "            <!-- Task generation options -->\n" +
    "            <schedule-task-generation-options\n" +
    "                data=\"vm.data.scheduleItemSeries\"\n" +
    "                default-data=\"vm.data.scheduleItemSeries\"\n" +
    "                controller=\"vm\"\n" +
    "                domain=\"vm.domainModel.scheduleItemSeries\"\n" +
    "                is-project-screen-recurrence=\"true\"></schedule-task-generation-options>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-time-and-billing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-time-and-billing.html",
    "<div ng-form name=\"detailForm\" ng-class=\"{ 'well bm-well': !vm.inWorkspaceModal && vm.parsedContext.parentContextId }\">\n" +
    "    <h3 class=\"no-top-margin\" translate=\"Bluemoon.Core.Setup.Project.Detail.Navigation.TimeAndBilling\"></h3>\n" +
    "    <div bmp-if-firm-permission=\"hasEngagements\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Engagement -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"engagement\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Engagement' | translate }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'engagement')\"\n" +
    "                class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo name=\"engagement\"\n" +
    "                                list=\"client-engagements#active\"\n" +
    "                                custom-items=\"vm.domainModel.engagementTemplate\"\n" +
    "                                context=\"vm.data.client.id\"\n" +
    "                                ng-model=\"vm.data.engagement\"\n" +
    "                                on-change=\"vm.data.$recalculateBudgets()\"></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-if=\"vm.domainModel.createEngagement(vm.data)\">\n" +
    "        <div class=\"col-md-8\">\n" +
    "            <div class=\"alert alert-info\">\n" +
    "                <small>\n" +
    "                    <span translate=\"Bluemoon.Core.Setup.Project.CreateEngagement\"></span>\n" +
    "                </small>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div bm-if-not-perm-some=\"['ARTimeAndExpense.AllPermissions','ARTimeAndExpense.PermissionsAdmin']\">\n" +
    "        <div class=\"row\" bm-if-has-access=\"OnvioIndirectTax.TaxGroups\">\n" +
    "            <div ng-if=\"vm.domainModel.showTaxGroup(vm.data)\">\n" +
    "                <!-- Tax Group -->\n" +
    "                <div bm-if-perm-some=\"['TimeAndBilling.AssessServiceCharges','TimeAndBilling.Billing','TimeAndBilling.PrintStatements','TimeAndBilling.ReceiptAndAdjustment','TimeAndBilling.ReviewInvoices','TimeAndBilling.TimeAndExpense']\">\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"taxgroup\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.Project.TaxGroupId' | translate}}\"\n" +
    "                        data-bmp-data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taxgroupId')\"\n" +
    "                        class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                        <bmp-select-combo list=\"taxGroupList\"\n" +
    "                                        list-style=\"basic\"\n" +
    "                                        name=\"taxgroup\"\n" +
    "                                        ng-model=\"vm.data.$taxGroup\" provider=\"vm.domainModel.indirectTaxProvider\">\n" +
    "                        </bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Invoice Description -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"invoiceDescription\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.Project.InvoiceDescription' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'invoiceDescription')\"\n" +
    "                class=\"col-md-8 col-sm-10 col-xs-12\">\n" +
    "            <textarea rows=\"3\" id=\"invoiceDescription\" name=\"invoiceDescription\"\n" +
    "                        data-qe-id=\"invoiceDescription-input\"\n" +
    "                        class=\"form-control\"\n" +
    "                        data-ng-model=\"vm.data.invoiceDescription\"\n" +
    "                        data-ng-style=\"{'height':'auto'}\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div bm-if-has-license=\"ProjectManagement.Budget\">\n" +
    "        <div bm-if-perm=\"ProjectManagement.Budget\">\n" +
    "            <h3>\n" +
    "                <span data-translate=\"Bluemoon.Core.Setup.Project.Budgets\"></span>\n" +
    "                <span ng-show=\"vm.data.$recalculatingBudgets\" style=\"padding-left: 10px;\" class=\"small\">\n" +
    "                    <i class=\"bento-icon-refresh\"></i>\n" +
    "                    <span style=\"padding-left: 5px;\" data-translate=\"Bluemoon.Core.Setup.Project.RecalculatingBudgets\"></span>\n" +
    "                </span>\n" +
    "            </h3>\n" +
    "\n" +
    "            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <label for=\"budgetedBasedOnTasks\" id=\"budgetedBasedOnTasksLabel\" aria-label=\"Base on Tasks\">\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" id=\"budgetedBasedOnTasks\"\n" +
    "                           aria-labelledby=\"budgetedBasedOnTasksLabel\" ng-model=\"vm.data.$budgetedBasedOnTasks\" /> {{'Core.Captions.Project.BudgetedBasedOnTasks' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-4 col-sm-4 col-xs-12 form-group\">\n" +
    "                    <label for=\"budgetedAmountIsCalculated\" id=\"budgetedAmountIsCalculatedLabel\" aria-label=\"{{'Core.Captions.Project.BudgetedAmountIsCalculated' | translate}}\">\n" +
    "                        <input autocomplete=\"off\" type=\"checkbox\" id=\"budgetedAmountIsCalculated\"\n" +
    "                           aria-labelledby=\"budgetedAmountIsCalculatedLabel\" ng-model=\"vm.data.$budgetedAmountIsCalculated\" ng-disabled=\"vm.data.budgetInfo.budgetedBasedOnTasks\" /> {{'Core.Captions.Project.BudgetedAmountIsCalculated' | translate}}\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"budgetedHours\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.BudgetedHours' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'budgetedHours')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"budgetedHours\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.budgetInfo.budgetedHours\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.BudgetedHours' | translate}}\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.BudgetedHours\"\n" +
    "                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                        bmp-big-number=\"'n2'\"\n" +
    "                        min=\"0\" max=\"99999.99\" />\n" +
    "                </div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.BudgetedAmount' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'budgetedAmount')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"budgetedAmount\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.budgetInfo.budgetedAmount\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.BudgetedAmount\"\n" +
    "                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks || vm.data.budgetInfo.budgetedAmountIsCalculated\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.BudgetedAmount' | translate}}\"\n" +
    "                        bmp-big-number=\"'c2'\"\n" +
    "                        min=\"0\" max=\"999999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualHours' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'actualHours')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"actualHours\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.budgetInfo.actualHours\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.ActualHours\"\n" +
    "                        ng-readonly=\"true\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.ActualHours' | translate}}\"\n" +
    "                        bmp-big-number=\"'n2'\"\n" +
    "                        min=\"0\" max=\"99999.99\" />\n" +
    "                </div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ActualAmount' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'actualAmount')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"actualAmount\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.budgetInfo.actualAmount\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.ActualAmount\"\n" +
    "                        ng-readonly=\"true\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.ActualAmount' | translate}}\"\n" +
    "                        bmp-big-number=\"'c2'\"\n" +
    "                        min=\"0\" max=\"999999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.EstimatedRemaining' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'estimatedRemaining')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"estimatedRemaining\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.$estimatedRemaining\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.EstimatedRemaining\"\n" +
    "                        ng-readonly=\"vm.data.budgetInfo.budgetedBasedOnTasks\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.budgetedBasedOnTasks' | translate}}\"\n" +
    "                        ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                        bmp-big-number=\"'n2'\"\n" +
    "                        min=\"0\" max=\"99999.99\" />\n" +
    "                </div>\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.PercentComplete' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.budgetInfo, 'percentComplete')\"\n" +
    "                    class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                    <input autocomplete=\"off\" name=\"percentComplete\" type=\"text\" class=\"form-control\"\n" +
    "                        ng-model=\"vm.data.budgetInfo.percentComplete\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Project.PercentComplete\"\n" +
    "                        ng-readonly=\"true\"\n" +
    "                        bmp-clear-value=\"0\"\n" +
    "                        bmp-big-number-range-validator=\"\"\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        aria-label=\"{{'Core.Captions.Project.PercentComplete' | translate}}\"\n" +
    "                        bmp-big-number=\"'p0'\"\n" +
    "                        min=\"0\" max=\"99999.99\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Show/hide the adjustments -->\n" +
    "            <div class=\"row\" ng-show=\"!vm.data.budgetInfo.budgetedBasedOnTasks\">\n" +
    "                <div class=\"col-md-8\">\n" +
    "                    <a href=\"\" id=\"adjustmentsShowHide\" data-qe-id=\"adjustmentsShowHide-button\" class=\"btn btn-link\" style=\"padding-left: 0px;\"\n" +
    "                    ng-click=\"vm.domainModel.showHideAdjustments(vm.data)\">\n" +
    "                        {{vm.domainModel.showHideAdjustmentsLabel(vm.data)}}\n" +
    "                    </a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <!-- Estimated Remaining Adjustments and Time Entries -->\n" +
    "            <div class=\"row\" ng-if=\"!vm.data.budgetInfo.budgetedBasedOnTasks && vm.data.$adjustmentsVisible\">\n" +
    "                <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                    <div class=\"well bm-well\" style=\"padding-top:0px;padding-bottom:0px;\">\n" +
    "\n" +
    "                        <h3 translate=\"Bluemoon.Core.Setup.Projects.AdjustmentHistory\"></h3>\n" +
    "\n" +
    "                        <div style=\"margin-bottom:25px;\" data-qe-id=\"adjustments-grid\">\n" +
    "\n" +
    "                        <bmp-toolbar toolbar-buttons=\"vm.domainModel.adjustmentsToolbar(vm, vm.data)\"\n" +
    "                                    aria-controls=\"adjustments-table\"\n" +
    "                                    has-column-picker=\"false\"></bmp-toolbar>\n" +
    "\n" +
    "                            <!-- Grid -->\n" +
    "                            <div style=\"overflow:auto;overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch;\">\n" +
    "                                <table class=\"bento-flex-grid no-footer scheduleitem-estimated-remaining-grid\">\n" +
    "\n" +
    "                                    <!-- Header -->\n" +
    "                                    <thead>\n" +
    "                                        <tr>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-description-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EntryType' | translate}}</th>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\" data-qe-id=\"adjustment-entrydate-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EntryDate' | translate}}</th>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;;\" data-qe-id=\"adjustment-staffcode-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.EmployeeCode' | translate}}</th>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-hours-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.Hours' | translate}}</th>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;\" data-qe-id=\"adjustment-balance-header\">{{'Bluemoon.Core.Setup.ScheduleItemAdjustRemainingEntry.Balance' | translate}}</th>\n" +
    "                                            <th class=\"wj-cell wj-header\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap;width:100%;\" data-qe-id=\"adjustment-comments-header\">{{'Core.Captions.ScheduleItemAdjustRemainingEntry.Notes' | translate}}</th>\n" +
    "                                        </tr>\n" +
    "                                    </thead>\n" +
    "                                    <tbody>\n" +
    "\n" +
    "                                        <!-- Budgeted -->\n" +
    "                                        <tr>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\" translate=\"Bluemoon.Core.Setup.Project.AdjustmentsGrid.Budgeted\"></td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Balance -->\n" +
    "                                                <input autocomplete=\"off\" name=\"balance\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.budgetedHours\"\n" +
    "                                                    ng-readonly=\"true\"\n" +
    "                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                    min=\"0\" max=\"99999.99\" />\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\"></td>\n" +
    "                                        </tr>\n" +
    "\n" +
    "                                        <!-- Adjustments -->\n" +
    "                                        <tr data-ng-repeat=\"adjustment in vm.data.adjustRemainingEntries\" ng-form=\"{{'adjustment_' + $index.toString()}}\">\n" +
    "\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Type -->\n" +
    "                                                {{adjustment.entryType.name}}\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Entry Date -->\n" +
    "                                                <div class=\"form-group\" style=\"margin-right:15px;margin-bottom:0px;width:100%\">\n" +
    "                                                    <bmp-bento-datepicker-wrapper name=\"entryDate\"\n" +
    "                                                                                ng-model=\"adjustment.entryDate\"\n" +
    "                                                                                bmp-field-error=\"Core.Captions.ScheduleItemAdjustRemainingEntry.EntryDate\"\n" +
    "                                                                                bmp-field-server-error=\"vm.detail.errorFor(adjustment, 'entryDate')\"\n" +
    "                                                                                ng-required=\"true\"\n" +
    "                                                                                ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\">\n" +
    "                                                    </bmp-bento-datepicker-wrapper>\n" +
    "                                                </div>\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Staff -->\n" +
    "                                                {{adjustment.employeeCode}}\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Hours -->\n" +
    "                                                <input autocomplete=\"off\" name=\"hours\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"adjustment.hours\"\n" +
    "                                                    ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\"\n" +
    "                                                    bmp-field-error=\"Core.Captions.ScheduleItemAdjustRemainingEntry.Hours\"\n" +
    "                                                    bmp-field-server-error=\"vm.detail.errorFor(adjustment, 'hours')\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                    min=\"-99999.99\" max=\"99999.99\" />\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Balance -->\n" +
    "                                                <input autocomplete=\"off\" name=\"balance\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"adjustment.$balance\"\n" +
    "                                                    ng-readonly=\"true\"\n" +
    "                                                    bmp-big-number=\"'n2'\" />\n" +
    "                                            </td>\n" +
    "                                            <td class=\"wj-cell\" style=\"overflow:visible;position:relative;min-width:150px;white-space:nowrap\">\n" +
    "                                                <!-- Comments -->\n" +
    "                                                <input autocomplete=\"off\" name=\"comments\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-readonly=\"adjustment.entryType.id === 'TIMEENTERED'\"\n" +
    "                                                    ng-model=\"adjustment.notes\" />\n" +
    "                                            </td>\n" +
    "                                        </tr>\n" +
    "\n" +
    "                                    </tbody>\n" +
    "                                </table>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!-- Validation errors -->\n" +
    "                            <uib-alert type=\"danger\" ng-show=\"vm.showHistoryError()\" data-qe-id=\"partnerHistory-error\">{{vm.partnerHistoryValidationMessage()}}</uib-alert>\n" +
    "\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail-ws-compat.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail-ws-compat.html",
    "<!-- translate=\"Bluemoon.Core.Setup.Project.Tabs.General\" -->\n" +
    "<!-- translate=\"Bluemoon.Core.Setup.Project.Tabs.Documents\" -->\n" +
    "<bmp-tabset vertical=\"{{::!vm.detailContext}}\">\n" +
    "    <bmp-tab id=\"general\" title=\"Bluemoon.Core.Setup.Project.Tabs.General\" on-closing=\"vm.detail.save(false)\" src=\"core-setup/schedule-items/schedule-item-detail-general.html\"></bmp-tab>\n" +
    "    <bmp-tab id=\"documents\" title=\"Bluemoon.Core.Setup.Project.Tabs.Documents\" src=\"core-setup/schedule-items/schedule-item-detail-documents.html\"\n" +
    "        disabled=\"!vm.domainModel.canViewDocuments(vm.data)\" bm-if-perm-some=\"['Onvio.DocumentStorage', 'OnvioDrive.ClientDocuments']\"></bmp-tab>\n" +
    "</bmp-tabset>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/schedule-item-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-detail.html",
    "<!-- translate=\"Bluemoon.Core.Setup.Project.Tabs.General\" -->\n" +
    "<!-- translate=\"Bluemoon.Core.Setup.Project.Tabs.Documents\" -->\n" +
    "<bmp-tabset vertical=\"{{::!vm.detailContext}}\">\n" +
    "    <bmp-tab id=\"general\" title=\"Bluemoon.Core.Setup.Project.Tabs.General\" on-closing=\"vm.detail.save(false)\" src=\"core-setup/schedule-items/schedule-item-detail-general.html\"></bmp-tab>\n" +
    "    <bmp-tab id=\"documents\" title=\"Bluemoon.Core.Setup.Project.Tabs.Documents\" src=\"core-setup/schedule-items/schedule-item-detail-documents.html\" disabled=\"!vm.domainModel.canViewDocuments(vm.data)\" bm-if-perm-some=\"['Onvio.DocumentStorage', 'OnvioDrive.ClientDocuments']\"></bmp-tab>\n" +
    "</bmp-tabset>\n" +
    "");
}]);

angular.module("core-setup/schedule-items/schedule-item-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-list.html",
    "<!-- /* i18nextract */'Bluemoon.Core.Setup.ProjectsAndTasks.Header' -->\n" +
    "<bmp-project-list bmp-project-list-name=\"'ProjectList'\"\n" +
    "                  bmp-project-list-projects-and-tasks-title=\"'Bluemoon.Core.Setup.ProjectsAndTasks.Header'\"\n" +
    "                  bmp-project-list-projects-title=\"'Core.Captions.Project.ClassOther'\"\n" +
    "                  bmp-project-list-tasks-title=\"'Core.Captions.Task.ClassOther'\"\n" +
    "                  bmp-project-list-analytics-context=\"'setup_project'\"\n" +
    "                  bmp-project-list-style=\"'core'\"\n" +
    "                  bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\"\n" +
    "                  modalUiView = \"$modalUiView\"\n" +
    "                  ></bmp-project-list>");
}]);

angular.module("core-setup/schedule-items/schedule-item-setup-application-fields-V2/schedule-item-setup-application-fields.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-setup-application-fields-V2/schedule-item-setup-application-fields.html",
    "<div class=\"row\">\n" +
    "    <!-- Project Application -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationType\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationType' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationType')\"\n" +
    "            class=\"col-sm-12 col-xs-12\" style=\"margin-left: 15px\">\n" +
    "        <bmp-enum-combo enum=\"application-types\" name=\"applicationType\"\n" +
    "                        ng-disabled=\"vm.ngDisabled\"\n" +
    "                        ng-model=\"vm.data.applicationType\"\n" +
    "                        ng-readonly=\"vm.data.id && vm.data.$applicationTypeSetWhenLoaded\"\n" +
    "                        on-change=\"vm.domainModel.updateForApplicationType(vm.data)\"\n" +
    "                        ng-required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- CA Tax Year / AU Tax Year -->\n" +
    "    <div ng-if=\"vm.data.applicationType.id === 'CATAX'\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationTaxYear' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationTaxYear\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationTaxYear' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationTaxYear')\"\n" +
    "                class=\"col-sm-12 col-xs-12\" style=\"padding-left: 30px\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationTaxYear\"\n" +
    "                            ng-disabled=\"vm.ngDisabled\"\n" +
    "                            ng-readonly=\"vm.data.id\"\n" +
    "                            required=\"true\"\n" +
    "                            ng-model=\"vm.data.$applicationTaxYear\"\n" +
    "                            custom-items=\"vm.data.$applicationTaxYearOptions\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- UK Tax Year / US Tax Year-->\n" +
    "    <div ng-if=\"vm.data.applicationType.id === 'UKTAX' || vm.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id)\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationTaxYear' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationTaxYear\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationTaxYear' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationTaxYear')\"\n" +
    "                class=\"col-sm-12 col-xs-12\" style=\"padding-left: 30px\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationTaxYear\"\n" +
    "                            ng-disabled=\"vm.ngDisabled\"\n" +
    "                            required=\"true\"\n" +
    "                            ng-model=\"vm.data.$applicationTaxYear\"\n" +
    "                            custom-items=\"vm.data.$applicationTaxYearOptions\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" ng-if=\"vm.data.applicationType.id === 'CATAX'\">\n" +
    "    <!-- Application Form Type CA -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationFormType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationFormType' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "            class=\"col-sm-12 col-xs-12\" style=\"margin-left: 15px\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"applicationFormType\"\n" +
    "                        ng-disabled=\"true\"\n" +
    "                        ng-model=\"vm.data.applicationFormType\"\n" +
    "                        custom-items=\"vm.domainModel.$applicationFormTypeOptions\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" ng-if=\"vm.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id) || vm.data.applicationType.id === 'UKTAX' || vm.data.applicationType.id === 'USADVISORYTOOLS'\" style=\"margin-left: 0px\">\n" +
    "    <!-- Application Form Type US / UK -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormType.UKType' -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormType.USType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "            data-bmp-control-group-label=\"{{ vm.getApplicationFormTypeTitle(vm.data.applicationType.id) | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "            class=\"col-sm-6 col-xs-6\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"applicationFormType\"\n" +
    "                        ng-disabled=\"true\"\n" +
    "                        ng-model=\"vm.data.applicationFormType\"\n" +
    "                        custom-items=\"vm.domainModel.$applicationFormTypeOptions\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- Form Sub Type-->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.UKType' -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.USType' -->\n" +
    "    <!-- <div ng-if=\"vm.data.$applicationFormSubtypeOptions.length > 0\"> -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationFormSubtype\"\n" +
    "                data-bmp-control-group-label=\"{{vm.data.applicationType.id === 'UKTAX' ? 'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.UKType' : 'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.USType' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormSubtype')\"\n" +
    "                class=\"col-sm-6 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationFormSubtype\"\n" +
    "                            ng-disabled=\"true\"\n" +
    "                            ng-model=\"vm.data.applicationFormSubtype\"\n" +
    "                            custom-items=\"vm.domainModel.$applicationFormSubtypeOptions\">\n" +
    "            </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    <!-- </div> -->\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-items/schedule-item-setup-application-fields/schedule-item-setup-application-fields.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-item-setup-application-fields/schedule-item-setup-application-fields.html",
    "<div class=\"row\">\n" +
    "    <!-- Project Application -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationType\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationType' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationType')\"\n" +
    "            class=\"col-sm-12 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"application-types\" name=\"applicationType\"\n" +
    "                        ng-disabled=\"vm.ngDisabled\"\n" +
    "                        ng-model=\"vm.data.applicationType\"\n" +
    "                        ng-readonly=\"vm.data.id && vm.data.$applicationTypeSetWhenLoaded\"\n" +
    "                        on-change=\"vm.updateForApplicationType(vm.data)\"\n" +
    "                        ng-required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "<!-- CA Tax Year -->\n" +
    "<div ng-if=\"vm.data.applicationType.id === 'CATAX'\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationTaxYear' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationTaxYear\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationTaxYear' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationTaxYear')\"\n" +
    "                class=\"col-sm-12 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationTaxYear\"\n" +
    "                            ng-disabled=\"vm.ngDisabled\"\n" +
    "                            ng-readonly=\"vm.data.id\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-model=\"vm.data.$applicationTaxYear\"\n" +
    "                            custom-items=\"vm.data.$applicationTaxYearOptions\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <!-- UK Tax Year / US Tax Year-->\n" +
    "    <div ng-if=\"vm.data.applicationType.id === 'UKTAX' || vm.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id) || vm.data.applicationType.id === 'ARINCOMETAX'\">\n" +
    "        <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationTaxYear' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationTaxYear\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationTaxYear' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationTaxYear')\"\n" +
    "                class=\"col-sm-12 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationTaxYear\"\n" +
    "                            ng-disabled=\"vm.ngDisabled || (vm.data.applicationType.id === 'USTAX' && vm.isUSTaxReadOnlyIACEnabled)\"\n" +
    "                            ng-required=\"true\"\n" +
    "                            ng-model=\"vm.data.$applicationTaxYear\"\n" +
    "                            custom-items=\"vm.data.$applicationTaxYearOptions\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" ng-if=\"vm.data.applicationType.id === 'CATAX'\">\n" +
    "    <!-- Application Form Type CA -->\n" +
    "    <!-- /* i18nextract */'Core.Captions.ScheduleItem.ApplicationFormType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ApplicationFormType' | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "            class=\"col-sm-12 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"applicationFormType\"\n" +
    "                        ng-disabled=\"true\"\n" +
    "                        ng-model=\"vm.data.applicationFormType\"\n" +
    "                        custom-items=\"vm.data.$applicationFormTypeOptions\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row\" ng-if=\"vm.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id) || vm.data.applicationType.id === 'UKTAX' || vm.data.applicationType.id === 'USADVISORYTOOLS' || vm.data.applicationType.id === 'UKSECRETARIAL'\">\n" +
    "    <!-- Application Form Type US / UK/ UKSecretarial -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormType.UKType' -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormType.USType' -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "            data-bmp-control-group-label=\"{{ vm.getApplicationFormTypeTitle(vm.data.applicationType.id) | translate | bmRequiredMark}}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "            class=\"col-sm-12 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"custom\" name=\"applicationFormType\"\n" +
    "                        ng-disabled=\"vm.data.$disableApplicationFormTypeFields\"\n" +
    "                        ng-model=\"vm.data.applicationFormType\"\n" +
    "                        on-change=\"vm.onApplicationFormTypeChanged(vm.data)\"\n" +
    "                        custom-items=\"vm.data.$applicationFormTypeOptions\">\n" +
    "        </bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- Form Sub Type-->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.UKType' -->\n" +
    "    <!-- /* i18nextract */'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.USType' -->\n" +
    "    <div ng-if=\"vm.data.$applicationFormSubtypeOptions.length > 0\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"applicationFormSubtype\"\n" +
    "                data-bmp-control-group-label=\"{{vm.data.applicationType.id === 'UKTAX' ? 'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.UKType' : 'Bluemoon.Core.Setup.ScheduleItem.ApplicationFormSubType.USType' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormSubtype')\"\n" +
    "                class=\"col-sm-12 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"custom\" name=\"applicationFormSubtype\"\n" +
    "                            ng-disabled=\"vm.data.$disableApplicationFormTypeFields\"\n" +
    "                            ng-model=\"vm.data.applicationFormSubtype\"\n" +
    "                            custom-items=\"vm.data.$applicationFormSubtypeOptions\">\n" +
    "            </bmp-enum-combo>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("core-setup/schedule-items/schedule-task-generation-options/schedule-task-generation-options.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/schedule-items/schedule-task-generation-options/schedule-task-generation-options.html",
    "<div class=\"row\"  bm-if-has-license=\"ProjectManagement.Tasks\">\n" +
    "	<fieldset class=\"task-generation-options\">\n" +
    "        <div class=\"col-md-8 col-sm-9\">\n" +
    "            <h3 class=\"no-underline\">{{'Bluemoon.Core.Setup.Recurrence.TaskGenerationOptions' | translate}}</h3>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\">{{'Bluemoon.Core.Setup.Recurrence.GenerateUsingCurrentTask' | translate}}</div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\">\n" +
    "                    <input type=\"checkbox\" name=\"task_options_name\" id=\"task_options_name\"\n" +
    "                    data-qe-id=\"bm-scheduleItemSeriesDetail-taskOptionsName-checkbox\"\n" +
    "                    ng-model=\"data.useTaskDescriptions\"\n" +
    "                    ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || (!domain.doesRecur(data) || !data.useProjectTasks)\"/>\n" +
    "                    <label for=\"task_options_name\" translate=\"Core.Captions.ScheduleItemSeries.UseTaskDescriptions\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\">\n" +
    "                    <input type=\"checkbox\" name=\"task_options_primary_assigned\" id=\"task_options_primary_assigned\"\n" +
    "                    data-qe-id=\"bm-scheduleItemSeriesDetail-taskOptionsPrimaryAssigned-checkbox\"\n" +
    "                    ng-model=\"data.useTaskPrimaryAssigned\"\n" +
    "                    ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || (!domain.doesRecur(data) || !data.useProjectTasks)\"/>\n" +
    "                    <label for=\"task_options_primary_assigned\" translate=\"Core.Captions.ScheduleItemSeries.UseTaskPrimaryAssigned\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\">\n" +
    "                    <input type=\"checkbox\" name=\"task_options_secondary_assigned\" id=\"task_options_secondary_assigned\"\n" +
    "                    data-qe-id=\"bm-scheduleItemSeriesDetail-taskOptionsSecondaryAssigned-checkbox\"\n" +
    "                    ng-model=\"data.useTaskSecondaryAssigned\"\n" +
    "                    ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || (!domain.doesRecur(data) || !data.useProjectTasks)\"/>\n" +
    "                    <label for=\"task_options_secondary_assigned\" translate=\"Core.Captions.ScheduleItemSeries.UseTaskSecondaryAssigned\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-5 col-sm-5\" style=\"white-space: nowrap;\">\n" +
    "                    <input type=\"checkbox\" name=\"task_options_comments\" id=\"task_options_comments\"\n" +
    "                    data-qe-id=\"bm-scheduleItemSeriesDetail-taskOptionsComments-checkbox\"\n" +
    "                    ng-model=\"data.useTaskNotes\"\n" +
    "                    ng-disabled=\"(isProjectScreenRecurrence && data.seriesRecurrenceMethod.id === 'USEPROJECTTEMPLATE') || (!domain.doesRecur(data) || !data.useProjectTasks)\"/>\n" +
    "                    <label for=\"task_options_comments\" translate=\"Core.Captions.ScheduleItemSeries.UseTaskNotes\"></label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </fieldset>\n" +
    "</div>");
}]);

angular.module("core-setup/setup-assistant/setup-assistant-staff.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/setup-assistant/setup-assistant-staff.html",
    "<form name=\"setupForm\">\n" +
    "  <div class=\"modal-header modal-bmWorkspace-header master-view-modal-header\" style=\"overflow:inherit\">\n" +
    "    <button type=\"button\" data-ng-click=\"vm.cancel()\" data-qe-id=\"header-close-button\" class=\"close btn\"\n" +
    "      datadismiss=\"modal\" aria-hidden=\"true\" data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "    <button type=\"button\" id=\"masterView.close\" data-qe-id=\"header-save-button\"\n" +
    "      class=\"btn btn-default save btn-save-close\" data-ng-click=\"vm.saveForm(setupForm)\"\n" +
    "      data-translate=\"Bluemoon.Practice.Common.Actions.SaveAndClose\"></button>\n" +
    "\n" +
    "    <bm-help-dropdown class=\"help-dropdown-on-step help-dropdown-on-step-assistant-staff\"\n" +
    "      location=\"/staff/#/setup/staff\"></bm-help-dropdown>\n" +
    "    <h3 class=\"modal-title\">{{'Bluemoon.Core.Setup.Assistance.Staff.ModalTitle' | translate }}</h3>\n" +
    "    <div class=\"well bm-well\">\n" +
    "      <div class=\"row\">\n" +
    "        <p>{{'Bluemoon.Core.Setup.Assistance.Staff.Description' | translate }}</p>\n" +
    "        <p>{{'Bluemoon.Core.Setup.Assistance.Staff.Description2' | translate }}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row setup-assistant-header\">\n" +
    "      <div class=\"col-md-3\">\n" +
    "        <div class=\"col-md-6\">\n" +
    "          <button type=\"button\" class=\"btn btn-default btn-lg setup-assistant-button\" ng-click=\"vm.openModal()\">\n" +
    "            <span class=\"bento-icon-add\"></span>\n" +
    "            <span>{{'Bluemoon.Core.Setup.Assistance.Staff.AddStaff' | translate }}</span></button><br>\n" +
    "        </div>\n" +
    "        <div class=\"col-md-6\">\n" +
    "          <div bento-multiselect-overlay list-data=\"vm.permissionGroups\" ng-model=\"vm.selectedGroups\"\n" +
    "            revert-selections-on-dismissal=\"true\"\n" +
    "            class=\"setup-bento-multiselect-overlay setup-assistant-multiselect-overlay\"\n" +
    "            select-button-text=\"{{'Bluemoon.Core.Setup.Assistance.Staff.AssignPermissionGroups' | translate}}\"\n" +
    "            edit-button-text=\"{{'Bluemoon.Core.Setup.Assistance.Staff.AssignPermissionGroups' | translate}}\"\n" +
    "            ng-change=\"vm.setSelectedGroups()\" ng-disabled=\"!vm.isAnyItemSelected()\" id=\"assignPermissionOverlay\"></div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "      <div class=\"col-md-1 col-sm-2 col-xs-3 setup-assistant-checkbox-header\">\n" +
    "        <input type=\"checkbox\" class=\"form-input\" ng-model=\"vm.selected\" ng-checked=\"vm.selected\"\n" +
    "          ng-click=\"vm.changeAllSelected(vm.selected)\">\n" +
    "      </div>\n" +
    "      <div class=\"col-md-1 setup-assistant-label\">\n" +
    "        {{'Bluemoon.Core.Setup.Assistance.Staff.OnvioAccess' | translate }}\n" +
    "      </div>\n" +
    "      <div class=\"col-md-3 col-sm-6 col-xs-12 setup-assistant-label\">\n" +
    "        <b>{{'Bluemoon.Core.Setup.Assistance.Staff.FullName' | translate }}</b>\n" +
    "      </div>\n" +
    "      <div class=\"col-md-2 col-sm-3 col-xs-6 setup-assistant-label\">\n" +
    "        <b>{{'Bluemoon.Core.Setup.Assistance.Staff.StaffId' | translate }}</b>\n" +
    "        <span class=\"bento-icon-question\" data-tooltip-placement=\"right\" data-tooltip-trigger=\"mouseenter\"\n" +
    "          data-uib-tooltip=\"{{'Bluemoon.Core.Setup.Assistance.Staff.StaffId.Tooltip' | translate }}\"\n" +
    "          data-tooltip-append-to-body=\"true\">\n" +
    "        </span>\n" +
    "\n" +
    "      </div>\n" +
    "      <div class=\"col-md-3 col-sm-6 col-xs-12 setup-assistant-label\">\n" +
    "        <b>{{'Bluemoon.Core.Setup.Assistance.Staff.EmailAddress' | translate }}</b>\n" +
    "      </div>\n" +
    "\n" +
    "      <hr class=\"bm-section-divider\" />\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"modal-workspace-body master-view-modal-body\">\n" +
    "    <div bento-busy-loader=\"vm.isLoading\">\n" +
    "\n" +
    "      <div ng-repeat=\"item in vm.items\">\n" +
    "        <ng-form name=\"setupItemForm{{$index}}\">\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-md-1 col-sm-2 col-xs-3 setup-assistant-checkbox\">\n" +
    "              <input type=\"checkbox\" class=\"form-input\" ng-model=\"item.selected\" ng-checked=\"item.selected\">\n" +
    "            </div>\n" +
    "            <div class=\"col-md-1 setup-assistant-input\">\n" +
    "              <div bento-toggle ng-model=\"item.isStaffCenterEnabled\" on-change=\"item.edited = true\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-3 col-sm-6 col-xs-12 setup-assistant-input\">\n" +
    "              <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"fullName\">\n" +
    "                <input autocomplete=\"off\" type=\"text\" id=\"fullName\" name=\"fullName\" data-qe-id=\"fullName\"\n" +
    "                  class=\"form-control\" data-ng-model=\"item.name\" ng-focus=\"item.edited = true\"\n" +
    "                  data-bmp-custom-validation=\"vm.isValidFullName(item.name, item.isStaffCenterEnabled, setupItemForm{{$index}})\"\n" +
    "                  data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Assistance.Staff.Validation.FullName' | translate}}\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-2 col-sm-3 col-xs-6 setup-assistant-input\">\n" +
    "              <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"code\">\n" +
    "                <input autocomplete=\"off\" type=\"text\" id=\"code\" name=\"code\" data-qe-id=\"code\" class=\"form-control\"\n" +
    "                  data-ng-model=\"item.code\" ng-focus=\"item.edited = true\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-3 col-sm-6 col-xs-12 setup-assistant-input\">\n" +
    "              <span ng-if=\"item.emailAddress.isTRID\">{{item.emailAddress.email}}</span>\n" +
    "              <div ng-if=\"!item.emailAddress.isTRID\" data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"email\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ContactEmail.EmailAddress' | translate}}\"\n" +
    "                data-bmp-control-group-label-hide=\"true\">\n" +
    "                <input type=\"text\" name=\"email\" class=\"form-control\" data-ng-model=\"item.emailAddress.email\"\n" +
    "                  ng-focus=\"item.edited = true\"\n" +
    "                  data-bmp-custom-validation=\"vm.isValidEmail(item.emailAddress.email, item.isStaffCenterEnabled, setupItemForm{{$index}})\"\n" +
    "                  data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Assistance.Staff.Validation.Email' | translate}}\"\n" +
    "                  blue-moon-email-validation>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"setup-assistant-input\">\n" +
    "              <button type=\"button\" class=\"btn btn-link no-margin\" ng-click=\"vm.deleteStaff(item.id)\">\n" +
    "                <span class=\"bento-icon-remove\"></span>\n" +
    "              </button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\" ng-show=\"item.isStaffCenterEnabled\">\n" +
    "            <div class=\"col-md-2 col-sm-2 col-xs-3 setup-assistant-checkbox\">\n" +
    "            </div>\n" +
    "            <div class=\"col-md-8 setup-assistant-label\">\n" +
    "              <div bento-multiselect-overlay list-data=\"item.permissionGroups\" ng-model=\"item.selectedGroups\"\n" +
    "                revert-selections-on-dismissal=\"true\"\n" +
    "                class=\"setup-bento-multiselect-overlay setup-assistant-multiselect-overlay\"\n" +
    "                select-button-text=\"{{'Bluemoon.Core.Setup.Assistance.Staff.PermissionGroups' | translate }}\"\n" +
    "                edit-button-text=\"{{'Bluemoon.Core.Setup.Assistance.Staff.PermissionGroups' | translate }}\"\n" +
    "                ng-change=\"vm.onGroupsChanged()\"></div>\n" +
    "\n" +
    "              <div class=\"form-control-static setup-assistant-use-for-text\">\n" +
    "                <span class=\"label label-info setup-setup-usage-badge\" data-ng-repeat=\"group in item.selectedGroups\">\n" +
    "                  {{ group.name }}\n" +
    "                  <span class=\"glyphicon glyphicon-remove\"\n" +
    "                    data-ng-click=\"vm.removeSelectedGroup(group.subjectGroupId, item)\"></span>\n" +
    "                </span>\n" +
    "              </div>\n" +
    "              <br>\n" +
    "              <br>\n" +
    "              <div data-bmp-control-group=\"\" data-bmp-control-group-field-id=\"permissionGroups\"\n" +
    "                style=\"margin-left:15px\">\n" +
    "                <input type=\"hidden\" data-ng-model=\"item.selectedGroups\"\n" +
    "                  data-bmp-custom-validation=\"vm.hasPermissionGroups(item.selectedGroups, item.isStaffCenterEnabled, setupItemForm{{$index}})\"\n" +
    "                  data-bmp-custom-validation-message=\"{{'Bluemoon.Core.Setup.Groups.Validation.MustSelectGroups' | translate}}\"\n" +
    "                  name=\"permissionGroups\" class=\"form-control\" value=\"item.selectedGroups\"\n" +
    "                  data-qe-id=\"permissionGroups\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "          <hr class=\"bm-section-divider\" />\n" +
    "        </ng-form>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</form>");
}]);

angular.module("core-setup/task-templates/task-template-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/task-templates/task-template-detail.html",
    "<div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Order -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.TaskTemplate.CompletionOrder' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"completionOrder\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.CompletionOrder' | translate | bmRequiredMark }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'completionOrder')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"number\" min=\"0\" max=\"999999999\" id=\"completionOrder\" name=\"completionOrder\"\n" +
    "                    data-qe-id=\"completionOrder-input\"\n" +
    "                    class=\"form-control\"\n" +
    "                    bmp-integer=\"true\"\n" +
    "                    ng-model=\"vm.data.completionOrder\"\n" +
    "                    ng-required=\"true\"\n" +
    "                    ng-change=\"vm.detail.clearErrorFor(vm.data, 'completionOrder')\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.TaskTemplate.CompletionOrder\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Type of Task -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.TypeOfTask' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"typeOfTask\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TypeOfTask' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'typeOfTask')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "            <div>\n" +
    "                <label>\n" +
    "                    <input type=\"radio\"\n" +
    "                            id=\"staffFacingTask\"\n" +
    "                            name=\"staffFacingTask\"\n" +
    "                            data-qe-id=\"bm-taskTemplateDetail-staffFacingTask\"\n" +
    "                            ng-value=\"true\"\n" +
    "                            ng-model=\"vm.data.$isStaffTask\">\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.TaskTemplate.StaffFacingTask\"></span>\n" +
    "                </label>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <label>\n" +
    "                    <input type=\"radio\"\n" +
    "                            id=\"clientFacingTask\"\n" +
    "                            name=\"clientFacingTask\"\n" +
    "                            data-qe-id=\"bm-taskTemplateDetail-clientFacingTask\"\n" +
    "                            ng-value=\"false\"\n" +
    "                            ng-model=\"vm.data.$isStaffTask\">\n" +
    "                            <span translate=\"Bluemoon.Core.Setup.TaskTemplate.ClientFacingTask\"></span>\n" +
    "                </label>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"!vm.data.$isStaffTask\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Type of Client-Facing Task -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.TypeOfClientFacingTask' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"scheduleItemSubtype\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TypeOfClientFacingTask' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'scheduleItemSubtype')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                    <bmp-enum-combo enum=\"client-schedule-item-subtype\"\n" +
    "                                    name=\"scheduleItemSubtype\"\n" +
    "                                    data-qe-id=\"bm-taskTemplateDetail-client-schedule-item-subtype\"\n" +
    "                                    ng-model=\"vm.data.scheduleItemSubtype\"\n" +
    "                                    ng-required=\"!vm.data.$isStaffTask\"\n" +
    "                                    ng-disabled=\"true\">\n" +
    "                    </bmp-enum-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Activity -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"activity\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.Activity' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activity')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo name=\"activity\"\n" +
    "                                    list=\"activities#active\"\n" +
    "                                    ng-model=\"vm.data.$activity\"\n" +
    "                                    on-change=\"vm.updateLabelName()\"></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Name -->\n" +
    "        <!-- /* i18nextract */'Core.Captions.TaskTemplate.Name' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"name\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.Name' | translate | bmRequiredMark }}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\" id=\"name\" name=\"name\"\n" +
    "                    data-qe-id=\"name-input\"\n" +
    "                    class=\"form-control\"\n" +
    "                    ng-required=\"true\"\n" +
    "                    ng-model=\"vm.data.name\"\n" +
    "                    ng-blur=\"vm.updateLabelName()\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3 data-translate=\"Bluemoon.Core.Setup.TaskTemplate.Assignments\"></h3>\n" +
    "\n" +
    "    <!-- Primary Assignment -->\n" +
    "    <div class=\"row\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"assignEmployeeType\"\n" +
    "            data-bmp-control-group-label=\"{{ 'Bluemoon.Core.Setup.Project.PrimaryAssignmentDefault' | translate }}\"\n" +
    "            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'assignEmployeeType')\"\n" +
    "            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "            <bmp-enum-combo enum=\"employee-grouping-types\" name=\"assignEmployeeType\" required=\"true\"\n" +
    "                            ng-model=\"vm.data.assignEmployeeGroupType\"></bmp-enum-combo>\n" +
    "        </div>\n" +
    "        <div ng-show=\"vm.domainModel.shouldSpecifyAssignedStaff(vm.data)\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"primaryAssignment\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.ProjectTemplateAssignment.Employee' | translate}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(primaryAssignment, 'employee')\"\n" +
    "                 class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"staff#active\"\n" +
    "                                    data-qe-id=\"bm-taskTemplateDetail-primaryAssignment-select-combo\"\n" +
    "                                    ng-model=\"vm.data.primaryAssignment.employee\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- Secondary/Staff Assignment -->\n" +
    "    <div class=\"row\" ng-if=\"!vm.domainModel.singleAssignment\">\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"secondaryAssignments\"\n" +
    "            data-bmp-control-group-label=\"{{ 'Bluemoon.Core.Setup.Project.SecondaryAssignmentDefault' | translate }}\"\n" +
    "            class=\"col-md-8 col-sm-8 col-xs-12\">\n" +
    "            <div bento-multiselect-overlay style=\"padding-right: 10px; float: left;\"\n" +
    "                revert-selections-on-dismissal=\"true\"\n" +
    "                ng-model=\"vm.data.$secondaryAssignmentDataSelected\"\n" +
    "                list-data=\"vm.data.$secondaryAssignmentData\"\n" +
    "                select-button-text=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                edit-button-text=\"{{'Bluemoon.Core.Setup.ProjectTemplate.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                class=\"setup-bento-multiselect-overlay\"\n" +
    "                data-qe-id=\"bm-taskTemplateDetail-secondaryAssignments-multiselect\">\n" +
    "            </div>\n" +
    "            <div class=\"form-control-static\">\n" +
    "                <span ng-repeat=\"assignment in vm.data.secondaryAssignments\">\n" +
    "                    <span class=\"label label-info\" data-qe-id=\"bm-taskTemplateDetail-secondaryAssignments-name_{{assignment.employee.name}}\">\n" +
    "                        {{assignment.employee.name}}\n" +
    "                        <span class=\"glyphicon glyphicon-remove\"\n" +
    "                            data-qe-id=\"bm-taskTemplateDetail-secondaryAssignments-removeButton_{{assignment.employee.name}}\"\n" +
    "                            data-ng-click=\"vm.domainModel.removeSecondaryAssignment(vm.data, assignment, true); vm.setFormDirty();\">\n" +
    "                        </span>\n" +
    "                    </span>&nbsp;\n" +
    "                </span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.domainModel.singleAssignment\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"secondaryAssignEmployeeType\"\n" +
    "                data-bmp-control-group-field-id=\"secondaryAssignEmployeeType_KEY__{{$index}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.secondaryAssignments[0], 'employee')\"\n" +
    "                class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"staff#active\"\n" +
    "                                ng-model=\"vm.data.secondaryAssignments[0].employee\"\n" +
    "                                aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <uib-accordion close-others=\"false\" class=\"bento-accordion\">\n" +
    "            <div uib-accordion-group\n" +
    "                ng-if=\"vm.data.$isStaffTask\"\n" +
    "                class=\"panel-default\"\n" +
    "                heading=\"{{'Core.Captions.ScheduleItem.ApplicationType' | translate}}\"\n" +
    "                data-qe-id=\"bm-taskTemplateDetail-application-accordion\">\n" +
    "\n" +
    "                <div class=\"row\">\n" +
    "                    <!-- Application -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"applicationType\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.ApplicationType' | translate}}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationType')\"\n" +
    "                        class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                        <bmp-enum-combo enum=\"application-types\"\n" +
    "                                        name=\"applicationType\"\n" +
    "                                        on-change=\"vm.domainModel.getApplicationFormTypeOptionsByApplicationType(vm.data)\"\n" +
    "                                        ng-model=\"vm.data.applicationType\"\n" +
    "                                        ng-disabled=\"vm.domainModel.isApplicationTypeDisabled(vm.data)\"\n" +
    "                                        required=\"true\"></bmp-enum-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                        <div ng-if=\"vm.data.applicationType.id == 'CATAX'\"  class=\"row\">\n" +
    "                            <!-- Application Form Type CA -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.ApplicationFormType' | translate | bmRequiredMark }}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "                                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <bmp-enum-combo  ng-readonly =\"!vm.data.$applicationFormTypeOptions || vm.data.$applicationFormTypeOptions.length < 1\"\n" +
    "                                                enum=\"custom\"\n" +
    "                                                name=\"applicationFormType\"\n" +
    "                                                ng-model=\"vm.data.$applicationFormType\"\n" +
    "                                                custom-items=\"vm.data.$applicationFormTypeOptions\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isApplicationFormTypeDisabled(vm.data)\"\n" +
    "                                                ng-required=\"true\"></bmp-enum-combo>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div ng-if=\"vm.domainModel.scheduleItemUtilities.isUsTaxOrUltraTax(vm.data.applicationType.id) || vm.data.applicationType.id == 'UKTAX' || vm.data.applicationType.id === 'AUTAX' || vm.data.applicationType.id === 'USADVISORYTOOLS' || vm.data.applicationType.id === 'UKSECRETARIAL'\"  class=\"row\">\n" +
    "                            <!-- Application Form Type US / UK / AU -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormType.UKType' -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormType.USType' -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"applicationFormType\"\n" +
    "                                    data-bmp-control-group-label=\"{{ vm.domainModel.getApplicationFormTypeTitle(vm.data.applicationType.id) | translate | bmRequiredMark }}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormType')\"\n" +
    "                                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <bmp-enum-combo  ng-readonly =\"!vm.data.$applicationFormTypeOptions || vm.data.$applicationFormTypeOptions.length < 1\"\n" +
    "                                                enum=\"custom\"\n" +
    "                                                name=\"applicationFormType\"\n" +
    "                                                ng-model=\"vm.data.$applicationFormType\"\n" +
    "                                                on-change=\"vm.domainModel.getApplicationFormSubtypeOptionsByFormType(vm.data)\"\n" +
    "                                                custom-items=\"vm.data.$applicationFormTypeOptions\"\n" +
    "                                                ng-disabled=\"vm.domainModel.isApplicationFormTypeDisabled(vm.data)\"\n" +
    "                                                ng-required=\"true\"></bmp-enum-combo>\n" +
    "                            </div>\n" +
    "                            <!-- Application Form Sub Type US / UK / AU -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormSubType.UKType' -->\n" +
    "                            <!-- /* i18nextract */'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormSubType.USType' -->\n" +
    "                            <div ng-if=\"vm.data.$applicationFormSubtypeOptions.length > 0\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"applicationFormSubtype\"\n" +
    "                                    data-bmp-control-group-label=\"{{vm.data.applicationType.id === 'UKTAX' || vm.data.applicationType.id === 'AUTAX' ? 'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormSubType.UKType' : 'Bluemoon.Core.Setup.TaskTemplate.ApplicationFormSubType.USType' | translate | bmRequiredMark }}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'applicationFormSubtype')\"\n" +
    "                                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                    <bmp-enum-combo ng-readonly=\"!vm.data.$applicationFormSubtypeOptions || vm.data.$applicationFormSubtypeOptions.length < 1\"\n" +
    "                                                    enum=\"custom\"\n" +
    "                                                    name=\"applicationFormSubtype\"\n" +
    "                                                    ng-model=\"vm.data.applicationFormSubtype\"\n" +
    "                                                    custom-items=\"vm.data.$applicationFormSubtypeOptions\"\n" +
    "                                                    ng-disabled=\"vm.domainModel.isApplicationFormSubtypeDisabled(vm.data)\"\n" +
    "                                                    ng-required=\"true\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div uib-accordion-group\n" +
    "                class=\"panel-default\"\n" +
    "                heading=\"{{'Bluemoon.Core.Setup.Tasks.StatusAndDates' | translate}}\"\n" +
    "                data-qe-id=\"bm-taskTemplateDetail-statusAndDates-accordion\"\n" +
    "                ng-if=\"vm.data.$isStaffTask\">\n" +
    "                <div class=\"row\" ng-if=\"vm.data.$isStaffTask\">\n" +
    "                    <!-- Tracking Description -->\n" +
    "                    <!-- /* i18nextract */'Core.Captions.TaskTemplate.TrackingDescription' -->\n" +
    "                    <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.TrackingDescription' | translate | bmRequiredMark }}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription')\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                        <bmp-select-combo name=\"trackingDescription\"\n" +
    "                                            list=\"tracking-descriptions\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            ng-model=\"vm.data.trackingDescription\"\n" +
    "                                            required=\"true\" aotf-default></bmp-select-combo>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "                    <div bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "                        <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItemSeries.TargetDates\"></h3>\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Target start dates -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"targetDates\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TargetStartDate' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"controller.detail.errorFor(vm.data, 'targetStartMonth') || controller.detail.errorFor(vm.data, 'targetStartDay')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <div class=\"input-group\">\n" +
    "                                    <span>\n" +
    "                                        <!-- this span is required by IE to valign correctly -->\n" +
    "                                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates' -->\n" +
    "                                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                                            name=\"targetStartMonth\"\n" +
    "                                            data-qe-id=\"targetStartMonth\"\n" +
    "                                            ng-model=\"vm.data.targetStartMonth\"\n" +
    "                                            bmp-integer=\"true\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetStartMonth\" />\n" +
    "                                    </span>\n" +
    "                                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                                    <span>\n" +
    "                                        <!-- this span is required by IE to valign correctly -->\n" +
    "                                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                                            name=\"targetStartDay\"\n" +
    "                                            data-qe-id=\"targetStartDay\"\n" +
    "                                            ng-model=\"vm.data.targetStartDay\"\n" +
    "                                            bmp-integer=\"true\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetStartDay\" />\n" +
    "                                    </span>\n" +
    "                                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                                    <bmp-enum-combo enum=\"target-date-methods\" name=\"startTargetDateMethod\" required=\"true\"\n" +
    "                                                    ng-model=\"vm.data.startTargetDateMethod\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"row\">\n" +
    "                            <!-- Target completion dates -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"targetCompleteDates\"\n" +
    "                                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TargetCompleteDate' | translate}}\"\n" +
    "                                data-bmp-control-group-error=\"controller.detail.errorFor(vm.data, 'targetCompleteMonth') || controller.detail.errorFor(vm.data, 'targetCompleteDay')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <div class=\"input-group\">\n" +
    "                                    <span>\n" +
    "                                        <!-- this span is required by IE to valign correctly -->\n" +
    "                                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates' -->\n" +
    "                                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                                            name=\"targetCompleteMonth\"\n" +
    "                                            data-qe-id=\"targetCompleteMonth\"\n" +
    "                                            ng-model=\"vm.data.targetCompleteMonth\"\n" +
    "                                            bmp-integer=\"true\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                            bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetCompleteMonth\" />\n" +
    "                                    </span>\n" +
    "                                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                                    <span>\n" +
    "                                        <!-- this span is required by IE to valign correctly -->\n" +
    "                                        <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                                            name=\"targetCompleteDay\"\n" +
    "                                            data-qe-id=\"targetCompleteDay\"\n" +
    "                                            ng-model=\"vm.data.targetCompleteDay\"\n" +
    "                                            bmp-integer=\"true\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetCompleteDay\" />\n" +
    "                                    </span>\n" +
    "                                    <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                                    <bmp-enum-combo enum=\"target-date-methods\" name=\"completeDateMethod\" required=\"true\"\n" +
    "                                                    ng-model=\"vm.data.completeTargetDateMethod\"></bmp-enum-combo>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div bm-if-perm=\"Internal.CurrentDevelopment\">\n" +
    "                <div bm-if-has-license=\"Applications.UKTax\">\n" +
    "                    <div uib-accordion-group\n" +
    "                        class=\"panel-default\"\n" +
    "                        heading=\"{{'Bluemoon.Core.Setup.TaskTemplate.Dates' | translate}}\"\n" +
    "                        data-qe-id=\"bm-taskTemplateDetail-dates-accordion\"\n" +
    "                        ng-if=\"!vm.data.$isStaffTask\">\n" +
    "                        <div ng-if=\"!vm.data.$isStaffTask\">\n" +
    "                            <h3 data-translate=\"Bluemoon.Core.Setup.ScheduleItemSeries.TargetDates\"></h3>\n" +
    "                            <div class=\"row\">\n" +
    "                                <!-- Target start dates -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"targetDates\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TargetStartDate' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"controller.detail.errorFor(vm.data, 'targetStartMonth') || controller.detail.errorFor(vm.data, 'targetStartDay')\"\n" +
    "                                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                    <div class=\"input-group\">\n" +
    "                                        <span>\n" +
    "                                            <!-- this span is required by IE to valign correctly -->\n" +
    "                                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates' -->\n" +
    "                                            <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                                                name=\"targetStartMonth\"\n" +
    "                                                data-qe-id=\"targetStartMonth\"\n" +
    "                                                ng-model=\"vm.data.targetStartMonth\"\n" +
    "                                                bmp-integer=\"true\"\n" +
    "                                                bmp-clear-value=\"0\"\n" +
    "                                                bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetStartMonth\" />\n" +
    "                                        </span>\n" +
    "                                        <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                                        <span>\n" +
    "                                            <!-- this span is required by IE to valign correctly -->\n" +
    "                                            <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                                                name=\"targetStartDay\"\n" +
    "                                                data-qe-id=\"targetStartDay\"\n" +
    "                                                ng-model=\"vm.data.targetStartDay\"\n" +
    "                                                bmp-integer=\"true\"\n" +
    "                                                bmp-clear-value=\"0\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetStartDay\" />\n" +
    "                                        </span>\n" +
    "                                        <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                                        <bmp-enum-combo enum=\"target-date-methods\" name=\"startTargetDateMethod\" required=\"true\"\n" +
    "                                                        ng-model=\"vm.data.startTargetDateMethod\"></bmp-enum-combo>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"row\">\n" +
    "                                <!-- Target completion dates -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-field-id=\"targetCompleteDates\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.TaskTemplate.TargetCompleteDate' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"controller.detail.errorFor(vm.data, 'targetCompleteMonth') || controller.detail.errorFor(vm.data, 'targetCompleteDay')\"\n" +
    "                                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                    <div class=\"input-group\">\n" +
    "                                        <span>\n" +
    "                                            <!-- this span is required by IE to valign correctly -->\n" +
    "                                            <!-- /* i18nextract */'Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates' -->\n" +
    "                                            <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"120\"\n" +
    "                                                name=\"targetCompleteMonth\"\n" +
    "                                                data-qe-id=\"targetCompleteMonth\"\n" +
    "                                                ng-model=\"vm.data.targetCompleteMonth\"\n" +
    "                                                bmp-integer=\"true\"\n" +
    "                                                bmp-clear-value=\"0\"\n" +
    "                                                bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.TaskTemplate.TargetDates\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetCompleteMonth\" />\n" +
    "                                        </span>\n" +
    "                                        <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Months\"></span>\n" +
    "                                        <span>\n" +
    "                                            <!-- this span is required by IE to valign correctly -->\n" +
    "                                            <input autocomplete=\"off\" class=\"form-control\" type=\"number\" min=\"0\" max=\"31\"\n" +
    "                                                name=\"targetCompleteDay\"\n" +
    "                                                data-qe-id=\"targetCompleteDay\"\n" +
    "                                                ng-model=\"vm.data.targetCompleteDay\"\n" +
    "                                                bmp-integer=\"true\"\n" +
    "                                                bmp-clear-value=\"0\"\n" +
    "                                                bmp-control-group-field=\"Core.Captions.TaskTemplate.TargetCompleteDay\" />\n" +
    "                                        </span>\n" +
    "                                        <span class=\"input-group-addon input-group-addon-clear\" translate=\"Bluemoon.Core.Setup.Recurrence.InputAddon.Days\"></span>\n" +
    "                                        <bmp-enum-combo enum=\"target-date-methods\" name=\"completeDateMethod\" required=\"true\"\n" +
    "                                                        ng-model=\"vm.data.completeTargetDateMethod\"></bmp-enum-combo>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "                <div bm-if-has-license=\"ProjectManagement.Budget\">\n" +
    "                    <div bm-if-perm=\"ProjectManagement.Budget\" style=\"margin-top: 5px;\">\n" +
    "                    <div ng-show=\"vm.domainModel.budgetedBasedOnTasks\">\n" +
    "                        <div uib-accordion-group\n" +
    "                            class=\"panel-default\"\n" +
    "                            heading=\"{{'Core.Captions.Task.BudgetInfo' | translate}}\"\n" +
    "                            data-qe-id=\"bm-taskDetail-budgetInfo-accordion\">\n" +
    "                            <h3 data-translate=\"Bluemoon.Core.Setup.TaskTemplate.Budgets\"></h3>\n" +
    "\n" +
    "                            <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                <div class=\"col-md-3 col-sm-3 col-xs-12 form-group\">\n" +
    "                                    <label>\n" +
    "                                        <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                                ng-model=\"vm.data.$budgetedAmountIsCalculated\" /> {{'Core.Captions.TaskTemplate.BudgetedAmountIsCalculated' | translate}}\n" +
    "                                    </label>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"row\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.BudgetedHours' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedHours')\"\n" +
    "                                    class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                        <input autocomplete=\"off\" name=\"budgetedHours\" type=\"text\" class=\"form-control\"\n" +
    "                                            ng-model=\"vm.data.budgetedHours\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.BudgetedHours\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-big-number-range-validator=\"\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            bmp-big-number=\"'n2'\"\n" +
    "                                            min=\"0\" max=\"99999.99\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <div class=\"row\">\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                    data-bmp-control-group-label=\"{{'Core.Captions.TaskTemplate.BudgetedAmount' | translate}}\"\n" +
    "                                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedAmount')\"\n" +
    "                                    class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                        <input autocomplete=\"off\" name=\"budgetedAmount\" type=\"text\" class=\"form-control\"\n" +
    "                                            ng-model=\"vm.data.budgetedAmount\"\n" +
    "                                            bmp-control-group-field=\"Core.Captions.TaskTemplate.BudgetedAmount\"\n" +
    "                                            ng-readonly=\"vm.data.budgetedAmountIsCalculated\"\n" +
    "                                            bmp-clear-value=\"0\"\n" +
    "                                            bmp-big-number-range-validator=\"\"\n" +
    "                                            bm-format-on-blur=\"\"\n" +
    "                                            bmp-big-number=\"'c2'\"\n" +
    "                                            min=\"0\" max=\"999999.99\" />\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "    </uib-accordion>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/tasks/task-detail-estimated-hours-grid.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/tasks/task-detail-estimated-hours-grid.html",
    "<bmp-grid ng-if=\"vm.service\" bmp-grid-definition=\"vm.definition\" bmp-grid-service=\"vm.service\"></bmp-grid>");
}]);

angular.module("core-setup/tasks/task-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/tasks/task-detail.html",
    "<!-- Added negative margin to have notes component in header without making major changes to MasterDetailView -->\n" +
    "<!-- <div style=\"height: 48; margin-top: -78px; float: right;\"><bmp-notes entity-id=\"vm.data.id\" entity-name=\"vm.data.name\"></bmp-notes></div> -->\n" +
    "<div ng-class=\"{false : 'task-detail', true : 'task-detailworkspace'}[ (vm.$state.current.name === 'time-and-expense.entry' || vm.$state.current.name === 'time-and-expense.review')|| ( vm.$state.current.name ==='time-and-expense.activity-log')]\" bento-busy-loader=\"!vm.data || vm.data.isLoading\">\n" +
    "    <ng-form name=\"vm.taskDetailForm\" class=\"bmp-form\" ng-init=\"vm.domainModel.setForm(vm)\">\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Client -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.Client' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"client\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Client' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'client')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"clients#active\" name=\"client\"\n" +
    "                                    ng-model=\"vm.data.$client\"\n" +
    "                                    ng-readonly=\"!vm.isNewId(vm.data.id) || vm.data.$clientPreselected\"\n" +
    "                                    ng-required=\"'true'\"\n" +
    "                                    append-to-parent=\".modal-content\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- For Contact -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.ForContact' -->\n" +
    "            <div ng-if=\"!vm.data.parent.id\"\n" +
    "                 data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"forContact\"\n" +
    "                 data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.ForContact' | translate | bmRequiredMark}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'forContact')\"\n" +
    "                 class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo name=\"forContact\"\n" +
    "                                  list=\"related-contacts\"\n" +
    "                                  list-style=\"basic\"\n" +
    "                                  context=\"vm.data.client.contactId\"\n" +
    "                                  custom-items=\"[vm.data.forContact]\"\n" +
    "                                  append-to-parent=\".modal-content\"\n" +
    "                                  ng-required=\"'true'\"\n" +
    "                                  ng-model=\"vm.data.forContact\"\n" +
    "                                  ng-disabled=\"!vm.data.client || !vm.data.client.id\"></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Project -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.Project' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"project\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Project' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'project')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"project-views\" name=\"project\"\n" +
    "                                    ng-model=\"vm.data.$parent\"\n" +
    "                                    ng-readonly=\"!vm.isNewId(vm.data.id) || vm.data.$projectPreselected\"\n" +
    "                                    filter=\"vm.data.$projectComboFilter\"\n" +
    "                                    append-to-parent=\".modal-content\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Order -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.Task.CompletionOrder' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"completionOrder\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Task.CompletionOrder' | translate | bmRequiredMark }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'completionOrder')\"\n" +
    "                    data-bmp-control-group-hide=\"!vm.data.parent\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <input type=\"number\" min=\"0\" max=\"999999999\" id=\"completionOrder\" name=\"completionOrder\"\n" +
    "                        data-qe-id=\"completionOrder-input\"\n" +
    "                        class=\"form-control\"\n" +
    "                        bmp-integer=\"true\"\n" +
    "                        ng-model=\"vm.data.completionOrder\"\n" +
    "                        ng-required=\"true\"\n" +
    "                        ng-change=\"vm.detail.clearErrorFor(vm.data, 'completionOrder')\"\n" +
    "                        bmp-control-group-field=\"Core.Captions.Task.CompletionOrder\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Type of Task -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.Core.Setup.Tasks.TypeOfTask' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"typeOfTask\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Tasks.TypeOfTask' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'typeOfTask')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <div style=\"padding-left: 5px\">\n" +
    "                    <label>\n" +
    "                        <input type=\"radio\"\n" +
    "                                id=\"staffFacingTask\"\n" +
    "                                name=\"staffFacingTask\"\n" +
    "                                data-qe-id=\"bm-taskDetail-staffFacingTask\"\n" +
    "                                ng-value=\"true\"\n" +
    "                                ng-model=\"vm.data.$isStaffTask\"\n" +
    "                                ng-disabled=\"!vm.isNewId(vm.data.id) || !vm.data.client || !vm.data.client.id || vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\">\n" +
    "                                <span translate=\"Bluemoon.Core.Setup.Tasks.StaffFacingTask\"></span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div style=\"padding-left: 5px\">\n" +
    "                    <label>\n" +
    "                        <input type=\"radio\"\n" +
    "                                id=\"clientFacingTask\"\n" +
    "                                name=\"clientFacingTask\"\n" +
    "                                data-qe-id=\"bm-taskDetail-clientFacingTask\"\n" +
    "                                ng-value=\"false\"\n" +
    "                                ng-model=\"vm.data.$isStaffTask\"\n" +
    "                                ng-disabled=\"!vm.isNewId(vm.data.id) || !vm.data.client || !vm.data.client.id || vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\">\n" +
    "                                <span translate=\"Bluemoon.Core.Setup.Tasks.ClientFacingTask\"></span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\" ng-show=\"!vm.data.$isStaffTask\">\n" +
    "            <!-- Type of Client-Facing Task -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.Core.Setup.Tasks.TypeOfClientFacingTask' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"subtype\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Tasks.TypeOfClientFacingTask' | translate | bmRequiredMark}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'subtype')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-enum-combo enum=\"client-schedule-item-subtype\"\n" +
    "                                name=\"subtype\"\n" +
    "                                data-qe-id=\"bm-taskDetail-subtype-combobox\"\n" +
    "                                ng-model=\"vm.data.subtype\"\n" +
    "                                ng-required=\"!vm.data.$isStaffTask\"\n" +
    "                                ng-disabled=\"true\">\n" +
    "                </bmp-enum-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "            <div class=\"row\" bmp-if-firm-permission=\"hasTimeAndBillingApplication\">\n" +
    "                <!-- Activity -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                        data-bmp-control-group-field-id=\"activity\"\n" +
    "                        data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Activity' | translate }}\"\n" +
    "                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activity')\"\n" +
    "                        class=\"col-md-6 col-sm-6 col-sm-12\">\n" +
    "                    <bmp-select-combo name=\"activity\"\n" +
    "                                        list=\"activities#active\"\n" +
    "                                        ng-model=\"vm.data.$activity\"\n" +
    "                                        append-to-parent=\".modal-content\"\n" +
    "                                        on-change=\"vm.updateLabelName();vm.data.$recalculateBudgets();\"\n" +
    "                                        ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Name -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.ScheduleItem.Name' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"name\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Name' | translate | bmRequiredMark }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'name')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-sm-12\">\n" +
    "                <input type=\"text\" id=\"name\" name=\"name\"\n" +
    "                        data-qe-id=\"name-input\"\n" +
    "                        class=\"form-control\"\n" +
    "                        ng-required=\"true\"\n" +
    "                        ng-model=\"vm.data.name\"\n" +
    "                        ng-blur=\"vm.updateLabelName()\"\n" +
    "                        ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <h3 data-translate=\"Bluemoon.Core.Setup.Project.Assignments\"></h3>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Primary/Preparer Assignment -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                 data-bmp-control-group-field-id=\"primary_assignment_employee\"\n" +
    "                 data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.PrimaryAssignmentDefault' | translate}}\"\n" +
    "                 data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.primaryAssignments[0], 'employee')\"\n" +
    "                 class=\"col-md-6 col-sm-6 col-sm-12\">\n" +
    "                <bmp-select-combo list=\"staff#active\"\n" +
    "                name=\"primary_assignment_employee\"\n" +
    "                                    ng-model=\"vm.data.primaryAssignments[0].employee\"\n" +
    "                                    on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                                    ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                    aotf-default></bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div ng-if=\"vm.data.applicationType.id !== 'UKTAX' && !vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "            <!-- Secondary/Staff Assignment -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignmentDefault' | translate}}\"\n" +
    "                class=\"col-md-6 col-sm-6 col-sm-12\" style=\"margin-bottom: 0px;\">\n" +
    "                <div bento-multiselect-overlay style=\"padding-right: 10px; float: left;\"\n" +
    "                    revert-selections-on-dismissal=\"true\"\n" +
    "                    ng-model=\"vm.data.$secondaryAssignmentDataSelected\"\n" +
    "                    list-data=\"vm.data.$secondaryAssignmentData\"\n" +
    "                    select-button-text=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                    edit-button-text=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignment.SelectStaff' | translate}}\"\n" +
    "                    class=\"setup-bento-multiselect-overlay\"\n" +
    "                    ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                    data-qe-id=\"bm-taskDetail-secondaryAssignments-multiselect\">\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-control-static\">\n" +
    "                    <span ng-repeat=\"assignment in vm.data.secondaryAssignments\">\n" +
    "                        <span class=\"label label-info\" data-qe-id=\"bm-taskDetail-secondaryAssignments-name_{{assignment.employee.name}}\">\n" +
    "                            {{assignment.employee.name}}\n" +
    "                            <span class=\"glyphicon glyphicon-remove\"\n" +
    "                                data-qe-id=\"bm-taskDetail-secondaryAssignments-removeButton_{{assignment.employee.name}}\"\n" +
    "                                data-ng-click=\"vm.domainModel.removeSecondaryAssignment(vm.data, assignment, true); vm.setFormDirty();\">\n" +
    "                            </span>\n" +
    "                        </span>&nbsp;\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"vm.domainModel.singleAssignment\" class=\"row\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"secondary_assignment_employee\"\n" +
    "                data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.SecondaryAssignmentDefault' | translate}}\"\n" +
    "                data-bmp-control-group-field-id=\"secondary_assignment_employee_KEY__{{$index}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data.secondaryAssignments[0], 'employee')\"\n" +
    "                class=\"col-md-4 col-sm-6 col-xs-12\">\n" +
    "               <bmp-select-combo list=\"staff#active\"\n" +
    "                                   ng-model=\"vm.data.secondaryAssignments[0].employee\"\n" +
    "                                   on-change=\"vm.data.$recalculateBudgets()\"\n" +
    "                                   ng-disabled=\"vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                   aotf-default></bmp-select-combo>\n" +
    "           </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\" ng-if=\"!vm.isNewId(vm.data.id)\">\n" +
    "            <h3 class=\"task-detail-comments\" data-ng-if=\"vm.data.id\"><span translate=\"Bluemoon.Core.Setup.Notes\"></span>\n" +
    "                <bmcn-notes note-type=\"general\" [entity-id]=\"vm.data.id\" [entity-name]=\"vm.data.name\" class=\"col-md-6 col-sm-6 col-xs-12\"\n" +
    "                    data-qe-id=\"bm-taskDetail-comments-link\"> </bmcn-notes>\n" +
    "            </h3>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <!-- Description -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"details\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.Details' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'details')\"\n" +
    "                    class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <textarea rows=\"3\"\n" +
    "                            id=\"details\"\n" +
    "                            name=\"details\"\n" +
    "                            class=\"form-control\"\n" +
    "                            style=\"height:'auto'\"\n" +
    "                            data-ng-model=\"vm.data.details\"\n" +
    "                            ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                            data-qe-id=\"bm-taskDetail-details-input\"></textarea>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <uib-accordion close-others=\"false\" class=\"bento-accordion\">\n" +
    "            <div uib-accordion-group\n" +
    "                ng-if=\"vm.data.$parent && vm.data.$isStaffTask\"\n" +
    "                class=\"panel-default\"\n" +
    "                heading=\"{{'Core.Captions.ScheduleItem.ApplicationType' | translate}}\"\n" +
    "                name=\"bm-taskDetail-application-accordion\"\n" +
    "                id=\"bm-taskDetail-application-accordion\"\n" +
    "                data-qe-id=\"bm-taskDetail-application-accordion\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                        <schedule-item-setup-application-fields data=\"vm.data\" is-task=\"true\"></schedule-item-setup-application-fields>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div uib-accordion-group\n" +
    "                ng-if=\"vm.data.subtype.id === 'DOCUMENTREQUESTCLIENTTASK'\"\n" +
    "                is-open=\"vm.domainModel.documentRequestAccordionExpand\"\n" +
    "                class=\"panel-default\"\n" +
    "                name=\"bm-taskDetail-documentRequest-accordion\"\n" +
    "                id=\"bm-taskDetail-documentRequest-accordion\"\n" +
    "                heading=\"{{'Bluemoon.Core.Setup.Tasks.DocumentRequest' | translate}}\"\n" +
    "                data-qe-id=\"bm-taskDetail-documentRequest-accordion\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                        <dms-request-add-edit\n" +
    "                            is-edit-mode=\"vm.data.documentRequestId ? true : false\"\n" +
    "                            request-id=\"vm.data.documentRequestId\"\n" +
    "                            client=\"vm.data.$client\"\n" +
    "                            client-id=\"vm.data.$client.id\"\n" +
    "                            prepopulate-data=\"\"\n" +
    "                            is-modal=\"false\"\n" +
    "                            hide-client=\"true\"\n" +
    "                            hide-recipient=\"false\"\n" +
    "                            hide-due-date=\"true\"\n" +
    "                            hide-expiration=\"true\"\n" +
    "                            hide-save-cancel=\"true\"\n" +
    "                            due-date=\"vm.data.currentDueDateExclusive\"\n" +
    "                            expiration-date=\"vm.data.expirationDateUtc\"\n" +
    "                            ignore-validation=\"vm.domainModel.ignoreDocRequestValidation\">\n" +
    "                        </dms-request-add-edit>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div uib-accordion-group\n" +
    "                class=\"panel-default\"\n" +
    "                heading=\"{{'Bluemoon.Core.Setup.Tasks.StatusAndDates' | translate}}\"\n" +
    "                data-qe-id=\"bm-taskDetail-statusAndDates-accordion\"\n" +
    "                name=\"bm-taskDetail-statusAndDates-accordion\"\n" +
    "                id=\"bm-taskDetail-statusAndDates-accordion\">\n" +
    "                <!-- ng-if staff facing task -->\n" +
    "                <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Tracking Description -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.ScheduleItem.TrackingDescription' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TrackingDescription' | translate | bmRequiredMark }}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription')\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo name=\"trackingDescription\"\n" +
    "                                                list=\"tracking-descriptions\"\n" +
    "                                                list-style=\"basic\"\n" +
    "                                                ng-model=\"vm.data.$trackingDescription\"\n" +
    "                                                required=\"true\"\n" +
    "                                                ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                                aotf-default></bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\" bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "                        <div class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                            <div class=\"well bm-well\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <!-- Target start & complete dates -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-field-id=\"targetStartDate\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TargetStartDate' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetStartDate')\"\n" +
    "                                            class=\"col-md-12\">\n" +
    "                                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.TargetDates\"-->\n" +
    "                                        <bmp-bento-datepicker-wrapper name=\"targetStartDate\"\n" +
    "                                                                    ng-model=\"vm.data.targetStartDate\"\n" +
    "                                                                    bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Task.TargetDates\"\n" +
    "                                                                    bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetStartDate\"\n" +
    "                                                                    ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-field-id=\"targetCompleteDate\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TargetCompleteDateExclusive' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'targetCompleteDateExclusive')\"\n" +
    "                                            class=\"col-md-12\">\n" +
    "                                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.TargetDates\"-->\n" +
    "                                        <bmp-bento-datepicker-wrapper name=\"targetCompleteDate\"\n" +
    "                                                                    ng-model=\"vm.data.targetCompleteDateExclusive\"\n" +
    "                                                                    bmp-custom-validation=\"vm.domainModel.areTargetDatesValid(vm.data)\"\n" +
    "                                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Task.TargetDates\"\n" +
    "                                                                    bmp-control-group-field=\"Core.Captions.ScheduleItem.TargetCompleteDateExclusive\"\n" +
    "                                                                    ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                            <div class=\"well bm-well\">\n" +
    "                                <div class=\"row\">\n" +
    "                                    <!-- Actual start & complete dates -->\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-field-id=\"actualStartDate\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.ActualStartDate' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualStartDate')\"\n" +
    "                                            class=\"col-md-12\">\n" +
    "                                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.ActualDates\"-->\n" +
    "                                        <bmp-bento-datepicker-wrapper name=\"actualStartDate\"\n" +
    "                                                                    ng-model=\"vm.data.$actualStartDate\"\n" +
    "                                                                    ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualStartDate')\"\n" +
    "                                                                    bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Task.ActualDates\"\n" +
    "                                                                    bmp-control-group-field=\"Core.Captions.Task.ActualStartDate\"\n" +
    "                                                                    ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <div class=\"row\">\n" +
    "                                    <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-field-id=\"actualCompleteDate\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.ActualCompleteDate' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                                            class=\"col-md-12\">\n" +
    "                                        <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.ActualDates\"-->\n" +
    "                                        <bmp-bento-datepicker-wrapper name=\"actualCompleteDate\"\n" +
    "                                                                    ng-model=\"vm.data.$actualCompleteDate\"\n" +
    "                                                                    ng-change=\"vm.detail.clearErrorFor(vm.data, 'actualCompleteDate')\"\n" +
    "                                                                    bmp-custom-validation=\"vm.domainModel.areActualDatesValid(vm.data)\"\n" +
    "                                                                    bmp-custom-validation-message=\"Bluemoon.Core.Setup.Common.Validation.Task.ActualDates\"\n" +
    "                                                                    bmp-control-group-field=\"Core.Captions.Task.ActualCompleteDate\"\n" +
    "                                                                    ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"!vm.data.$isStaffTask\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Tracking Description -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.ScheduleItem.TrackingDescription' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"trackingDescription\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.ScheduleItem.TrackingDescription' | translate | bmRequiredMark }}\"\n" +
    "                                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'trackingDescription') || vm.data.$trackingDescriptionError\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-sm-12\">\n" +
    "                            <bmp-enum-combo name=\"trackingDescriptionClient\"\n" +
    "                                                enum=\"{{vm.data.documentRequestId ? 'tracking-descriptions-client' : 'tracking-descriptions-client-not-sent'}}\"\n" +
    "                                                list-style=\"basic\"\n" +
    "                                                ng-model=\"vm.data.$trackingDescription\"\n" +
    "                                                required=\"true\"\n" +
    "                                                on-change=\"vm.domainModel.clientTrackingDescriptionChanged(vm.$scope, vm.data)\"\n" +
    "                                                ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"></bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\" bm-if-has-license=\"ProjectManagement.Dates\">\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <div class=\"row\">\n" +
    "                                <!-- Document Due Date -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"currentDueDateExclusive\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Project.DueDate' | translate | bmRequiredMark}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'currentDueDateExclusive')\"\n" +
    "                                        class=\"col-md-6\">\n" +
    "                                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.DueDate\"-->\n" +
    "                                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.DueDateBeforeToday\"-->\n" +
    "                                    <!--\n" +
    "                                        Normally, when we use bmp-custom-validation, we pass a single error message as the param\n" +
    "                                        bmp-custom-validation-message. In this case we have multiple error messages. And instead\n" +
    "                                        of doing more complex custom validation with a different directive, we are using bmp-custom-validation\n" +
    "                                        and doing more work to set additional model properties in the method which is wired up to\n" +
    "                                        bmp-custom-validation. These additional model properties are then used to drive the display\n" +
    "                                        of the multiple error messages.\n" +
    "                                    -->\n" +
    "                                    <bmp-bento-datepicker-wrapper\n" +
    "                                        name=\"currentDueDateExclusive\"\n" +
    "                                        ng-model=\"vm.data.currentDueDateExclusive\"\n" +
    "                                        ng-change=\"vm.detail.clearErrorFor(vm.data, 'currentDueDateExclusive')\"\n" +
    "                                        bmp-custom-validation=\"vm.domainModel.areDueDatesValid(vm.data)\"\n" +
    "                                        bmp-control-group-field=\"Bluemoon.Core.Setup.Project.DueDate\"\n" +
    "                                        ng-required=\"true\"\n" +
    "                                        ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                        ng-class=\"{'has-error': vm.data.$expirationDateBeforeDueDate || vm.data.$dueDateBeforeToday}\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    <div class=\"task-date-error\"\n" +
    "                                        ng-show=\"vm.data.$expirationDateBeforeDueDate\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Common.Validation.Task.DueDate' | translate}}\n" +
    "                                    </div>\n" +
    "                                    <div class=\"task-date-error\"\n" +
    "                                        ng-show=\"vm.data.$dueDateBeforeToday\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Common.Validation.Task.DueDateBeforeToday' | translate}}\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                                <!-- Expiration Date -->\n" +
    "                                <div data-bmp-control-group=\"\"\n" +
    "                                        data-bmp-control-group-field-id=\"expirationDate\"\n" +
    "                                        data-bmp-control-group-label=\"{{'Core.Captions.Task.ExpirationDateUtc' | translate | bmRequiredMark}}\"\n" +
    "                                        data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'expirationDate')\"\n" +
    "                                        class=\"col-md-6\">\n" +
    "                                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.ExpirationDate\"-->\n" +
    "                                    <!--translate=\"Bluemoon.Core.Setup.Common.Validation.Task.ExpirationDateBeforeToday\"-->\n" +
    "                                    <!--\n" +
    "                                        Normally, when we use bmp-custom-validation, we pass a single error message as the param\n" +
    "                                        bmp-custom-validation-message. In this case we have multiple error messages. And instead\n" +
    "                                        of doing more complex custom validation with a different directive, we are using bmp-custom-validation\n" +
    "                                        and doing more work to set additional model properties in the method which is wired up to\n" +
    "                                        bmp-custom-validation. These additional model properties are then used to drive the display\n" +
    "                                        of the multiple error messages.\n" +
    "                                    -->\n" +
    "                                    <bmp-bento-datepicker-wrapper\n" +
    "                                        name=\"expirationDate\"\n" +
    "                                        ng-model=\"vm.data.$expirationDateUtc\"\n" +
    "                                        ng-change=\"vm.detail.clearErrorFor(vm.data, 'expirationDate')\"\n" +
    "                                        bmp-custom-validation=\"vm.domainModel.areExpirationDatesValid(vm.data)\"\n" +
    "                                        ng-change=\"vm.detail.clearErrorFor(vm.data, 'expirationDate')\"\n" +
    "                                        bmp-control-group-field=\"Core.Captions.Task.ExpirationDateUtc\"\n" +
    "                                        ng-required=\"true\"\n" +
    "                                        ng-disabled=\"vm.isLoading || vm.domainModel.isFormDisabled(vm.data)\"\n" +
    "                                        ng-class=\"{'has-error': vm.data.$expirationDateBeforeDueDate || vm.data.$expirationDateBeforeToday}\"></bmp-bento-datepicker-wrapper>\n" +
    "                                    <div class=\"task-date-error\"\n" +
    "                                        ng-show=\"vm.data.$expirationDateBeforeDueDate\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Common.Validation.Task.ExpirationDate' | translate}}\n" +
    "                                    </div>\n" +
    "                                    <div class=\"task-date-error\"\n" +
    "                                        ng-show=\"vm.data.$expirationDateBeforeToday\">\n" +
    "                                        {{'Bluemoon.Core.Setup.Common.Validation.Task.ExpirationDateBeforeToday' | translate}}\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"vm.data.$isStaffTask\">\n" +
    "                <div bm-if-has-license=\"ProjectManagement.Budget\">\n" +
    "                    <div bm-if-perm=\"ProjectManagement.Budget\" style=\"margin-top: 5px;\">\n" +
    "                        <div uib-accordion-group\n" +
    "                            class=\"panel-default\"\n" +
    "                            heading=\"{{'Core.Captions.Task.BudgetInfo' | translate}}\"\n" +
    "                            ng-if=\"vm.data.$parentScheduleItem.budgetInfo.budgetedBasedOnTasks\"\n" +
    "                            data-qe-id=\"bm-taskDetail-budgetInfo-accordion\">\n" +
    "                            <div>\n" +
    "                                <span ng-show=\"vm.data.$recalculatingBudgets\" style=\"padding-left: 10px;\" class=\"small\">\n" +
    "                                    <i class=\"bento-icon-refresh\"></i>\n" +
    "                                    <span style=\"padding-left: 5px;\" data-translate=\"Bluemoon.Core.Setup.Project.RecalculatingBudgets\"></span>\n" +
    "                                </span>\n" +
    "                                <!-- <h3>\n" +
    "                                    <span data-translate=\"Bluemoon.Core.Setup.Project.Budgets\"></span>\n" +
    "                                    <span ng-show=\"vm.data.$recalculatingBudgets\" style=\"padding-left: 10px;\" class=\"small\">\n" +
    "                                        <i class=\"bento-icon-refresh\"></i>\n" +
    "                                        <span style=\"padding-left: 5px;\" data-translate=\"Bluemoon.Core.Setup.Project.RecalculatingBudgets\"></span>\n" +
    "                                    </span>\n" +
    "                                    <!-- <h3>\n" +
    "                                        <span data-translate=\"Bluemoon.Core.Setup.Project.Budgets\"></span>\n" +
    "                                        <span ng-show=\"vm.data.$recalculatingBudgets\" style=\"padding-left: 10px;\" class=\"small\">\n" +
    "                                            <i class=\"bento-icon-refresh\"></i>\n" +
    "                                            <span style=\"padding-left: 5px;\" data-translate=\"Bluemoon.Core.Setup.Project.RecalculatingBudgets\"></span>\n" +
    "                                        </span>\n" +
    "                                    </h3> -->\n" +
    "\n" +
    "                                <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                    <div class=\"row\">\n" +
    "                                        <div class=\"col-md-6 form-group\">\n" +
    "                                            <label>\n" +
    "                                                <input autocomplete=\"off\" type=\"checkbox\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.$budgetedAmountIsCalculated\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-calculateAutomatically-checkBox\"/> {{'Core.Captions.Task.BudgetedAmountIsCalculated' | translate}}\n" +
    "                                            </label>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                    <div class=\"row\">\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.BudgetedHours' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedHours')\"\n" +
    "                                            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                                <input autocomplete=\"off\" name=\"budgetedHours\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.budgetedHours\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Task.BudgetedHours\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                    min=\"0\" max=\"99999.99\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-budgetedHours-input\"/>\n" +
    "                                        </div>\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.BudgetedAmount' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'budgetedAmount')\"\n" +
    "                                            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                                <input autocomplete=\"off\" name=\"budgetedAmount\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.budgetedAmount\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Task.BudgetedAmount\"\n" +
    "                                                    ng-readonly=\"vm.data.budgetInfo.budgetedAmountIsCalculated\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    bmp-big-number=\"'c2'\"\n" +
    "                                                    min=\"0\" max=\"999999.99\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-budgetedAmount-input\"/>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.ActualHours' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualHours')\"\n" +
    "                                            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                                <input autocomplete=\"off\" name=\"actualHours\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.actualHours\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Task.ActualHours\"\n" +
    "                                                    ng-readonly=\"true\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                    min=\"0\" max=\"99999.99\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-actualHours-input\"/>\n" +
    "                                        </div>\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.ActualAmount' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'actualAmount')\"\n" +
    "                                            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                                <input autocomplete=\"off\" name=\"actualAmount\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.actualAmount\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Task.ActualAmount\"\n" +
    "                                                    ng-readonly=\"true\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    bmp-big-number=\"'c2'\"\n" +
    "                                                    min=\"0\" max=\"999999.99\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-actualAmount-input\"/>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <div class=\"row\" bmp-if-firm-permission=\"TimeAndBilling.TimeAndExpense\">\n" +
    "                                        <div data-bmp-control-group=\"\"\n" +
    "                                            data-bmp-control-group-label=\"{{'Core.Captions.Task.EstimatedRemaining' | translate}}\"\n" +
    "                                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'estimatedRemaining')\"\n" +
    "                                            class=\"col-md-3 col-sm-3 col-xs-12\">\n" +
    "                                                <input autocomplete=\"off\" name=\"estimatedRemaining\" type=\"text\" class=\"form-control\"\n" +
    "                                                    ng-model=\"vm.data.budgetInfo.$estimatedRemaining\"\n" +
    "                                                    bmp-control-group-field=\"Core.Captions.Task.EstimatedRemaining\"\n" +
    "                                                    bmp-clear-value=\"0\"\n" +
    "                                                    bmp-big-number-range-validator=\"\"\n" +
    "                                                    bm-format-on-blur=\"\"\n" +
    "                                                    ng-blur=\"vm.data.$recalculateBudgets()\"\n" +
    "                                                    bmp-big-number=\"'n2'\"\n" +
    "                                                    min=\"0\" max=\"99999.99\"\n" +
    "                                                    data-qe-id=\"bm-taskDetail-estimatedRemaining-input\"/>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "\n" +
    "                                    <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                        <!-- /* i18nextract */'Bluemoon.Core.Setup.Tasks.ViewEstimatedBudgetDetails' -->\n" +
    "                                        <bmp-modal bmp-modal-label-key=\"'Bluemoon.Core.Setup.Tasks.ViewEstimatedBudgetDetails'\"\n" +
    "                                                data-qe-id=\"bm-taskDetail-estimatedRemaining-button\">\n" +
    "                                            <bmp-modal-content>\n" +
    "                                                <task-detail-estimated-hours-grid domain-model=\"vm.domainModel\" task=\"vm.data\" form=\"vm.taskDetailForm\"></task-detail-estimated-hours-grid>\n" +
    "                                            </bmp-modal-content>\n" +
    "                                        </bmp-modal>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </uib-accordion>\n" +
    "    </ng-form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/tasks/task-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/tasks/task-list.html",
    "<bmp-project-list bmp-project-list-name=\"'TaskList'\"\n" +
    "                  bmp-project-list-analytics-context=\"'setup_task'\"\n" +
    "                  bmp-project-list-style=\"(vm.inWorkspaceModal ? 'app' : 'setup')\"\n" +
    "                  bmp-project-list-route=\"vm.getDefinition().route\"\n" +
    "                  bmp-project-list-project-filter=\"vm.getContextId()\"\n" +
    "                  bmp-project-list-client-filter=\"vm.detailContext.data.client.id\"\n" +
    "                  bmp-project-list-append-to-parent=\"(vm.inWorkspaceModal ? '.modal-dialog' : 'body')\"></bmp-project-list>");
}]);

angular.module("core-setup/test-aotf/test-aotf-detail.component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/test-aotf/test-aotf-detail.component.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-sm-12\">\n" +
    "        <div class=\"row col-sm-12\">\n" +
    "            <div>{{::vm.text}}</div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <bmp-select-combo list=\"{{::vm.listName}}\" name=\"{{::vm.entityName}}\"\n" +
    "                                  ng-model=\"vm.selectedEntity\" aotf-default context=\"vm.context\"\n" +
    "                                  aotf=\"vm.aotf\" on-change=\"vm.onChange()\"\n" +
    "                                  defer-load=\"true\"></bmp-select-combo>\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-6 align-middle\">\n" +
    "                <a ng-click=\"vm.edit()\">Edit</a>\n" +
    "                <span>Selected {{vm.entityName}} {{vm.selectedEntity.id}}\n" +
    "                    : {{vm.selectedEntity.name}}</span>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div ng-if=\"vm.debug\">\n" +
    "    <pre>{{vm.aotf | json}}</pre>\n" +
    "</div>");
}]);

angular.module("core-setup/test-aotf/test-aotf-master.component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/test-aotf/test-aotf-master.component.html",
    "<h2>Welcome to Add/Edit on the Fly testing page</h2>\n" +
    "<div ng-repeat=\"aotf in vm.aotfs\">\n" +
    "    <div ng-if=\"aotf.show()\">\n" +
    "        <aotf-detail-component text=\"{{::aotf.text}}\" list-name=\"{{::aotf.listName}}\"\n" +
    "            entity-name=\"{{::aotf.params.entityName}}\" selected-entity=\"vm.selectedEntity[aotf.key]\"\n" +
    "            defer-load=\"aotf.deferLoad\" edit=\"aotf.edit()\" aotf=\"aotf.params\"\n" +
    "            on-change=\"vm.entityChanged(aotf.params.entityName)\">\n" +
    "        </aotf-detail-component>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div class=\"row col-sm-12\" ng-if=\"vm.aotfs['firm'] != null\" ng-init=\"aotf=vm.aotfs['firm']\">\n" +
    "    <div class=\"row col-sm-12\">\n" +
    "        <div>{{::aotf.text}}</div>\n" +
    "    </div>\n" +
    "    <div class=\"row col-sm-12 align-middle\">\n" +
    "        <a ng-click=\"aotf.edit()\">Edit</a>\n" +
    "        <span>Selected {{aotf.params.entityName}} {{vm.selectedEntity[aotf.key].id}}\n" +
    "            : {{vm.selectedEntity[aotf.key].name}}</span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core-setup/uk-tax/hmrc-firm-uk-contact-data-component/firm-uk-contact-data-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("core-setup/uk-tax/hmrc-firm-uk-contact-data-component/firm-uk-contact-data-component.html",
    "<div class=\"row\" ng-if=\"$ctrl.showUkTaxContactDataV2Fields()\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"Commencement\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Commencement' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.contactDataV2Json.Commencement, 'Commencement')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-bento-datepicker-wrapper id=\"Commencement\"\n" +
    "                                        name=\"Commencement\"\n" +
    "                                        ng-model=\"$ctrl.contactDataV2Json.Commencement\"\n" +
    "                                        ng-change=\"$ctrl.onChange({data: $ctrl.contactDataV2Json})\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "    </div>\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"Cessation\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.Cessation' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.contactDataV2Json.Cessation, 'Cessation')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-bento-datepicker-wrapper id=\"Cessation\"\n" +
    "                                        name=\"Cessation\"\n" +
    "                                        ng-model=\"$ctrl.contactDataV2Json.Cessation\"\n" +
    "                                        ng-change=\"$ctrl.onChange({data: $ctrl.contactDataV2Json})\">\n" +
    "        </bmp-bento-datepicker-wrapper>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"$ctrl.showUkTaxContactDataPrincipalActivity()\">\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"PrincipalActivity\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.Core.Setup.Common.ContactEditor.PrincipalActivity' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.contactDataV2Json.PrincipalActivity, 'PrincipalActivity')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <input type=\"text\"\n" +
    "                id=\"PrincipalActivity\"\n" +
    "                name=\"PrincipalActivity\"\n" +
    "                class=\"form-control\"\n" +
    "                ng-model=\"$ctrl.contactDataV2Json.PrincipalActivity\"\n" +
    "                ng-change=\"$ctrl.onChange({data: $ctrl.contactDataV2Json})\"/>\n" +
    "    </div>\n" +
    "</div>");
}]);
